/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CheckPointTypeV1: { input: string; output: string; }
  Cursor: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Duration: { input: string; output: string; }
  JSON: { input: unknown; output: unknown; }
  Upload: { input: unknown; output: unknown; }
};

export type AiConversation = Node & {
  aiConversationId: Scalars['ID']['output'];
  aiConversationSession?: Maybe<AiConversationSession>;
  audioAWS?: Maybe<AudioAws>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  learnerProfile: LearnerProfile;
  message: Scalars['String']['output'];
  role: AiConversationRole;
  source: AiConversationSource;
  type: AiConversationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AiConversationConnection = {
  edges: Array<AiConversationEdge>;
  nodes: Array<AiConversation>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AiConversationEdge = {
  cursor: Scalars['Cursor']['output'];
  node: AiConversation;
};

export type AiConversationFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  hasAiConversationSessionWith?: InputMaybe<AiConversationSessionFilter>;
  hasAudioAWSWith?: InputMaybe<AudioAwsFilter>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  role?: InputMaybe<Array<AiConversationRole>>;
  source?: InputMaybe<Array<AiConversationSource>>;
  updatedAt?: InputMaybe<DateTimeRange>;
};

export type AiConversationOrder = {
  key?: InputMaybe<AiConversationOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AiConversationOrderKey {
  CreatedAt = 'CREATED_AT',
  HighestDuration = 'HIGHEST_DURATION'
}

export enum AiConversationRole {
  System = 'SYSTEM',
  User = 'USER'
}

export type AiConversationSession = Node & {
  aiConversationSessionId: Scalars['ID']['output'];
  aiConversations: AiConversationConnection;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  learnerProfile: LearnerProfile;
  messageCount?: Maybe<Scalars['Int']['output']>;
  source: AiConversationSessionSource;
  totalDuration?: Maybe<Scalars['Int']['output']>;
  type: AiConversationSessionType;
  updatedAt: Scalars['DateTime']['output'];
};


export type AiConversationSessionAiConversationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AiConversationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AiConversationOrder>;
};

export type AiConversationSessionConnection = {
  edges: Array<AiConversationSessionEdge>;
  nodes: Array<AiConversationSession>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AiConversationSessionEdge = {
  cursor: Scalars['Cursor']['output'];
  node: AiConversationSession;
};

export type AiConversationSessionFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  hasAiConversationsWith?: InputMaybe<AiConversationFilter>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  source?: InputMaybe<Array<AiConversationSessionSource>>;
  type?: InputMaybe<Array<AiConversationSessionType>>;
};

export type AiConversationSessionOrder = {
  key?: InputMaybe<AiConversationSessionOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AiConversationSessionOrderKey {
  HighestDuration = 'HIGHEST_DURATION'
}

export enum AiConversationSessionSource {
  MobileExam = 'MOBILE_EXAM',
  WebExam = 'WEB_EXAM'
}

export enum AiConversationSessionType {
  Call = 'CALL',
  Chat = 'CHAT',
  Mix = 'MIX'
}

export enum AiConversationSource {
  MobileExam = 'MOBILE_EXAM',
  WebExam = 'WEB_EXAM'
}

export type AiConversationSummary = {
  concatenatedMessages: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  learnerProfile: LearnerProfile;
  messageCount: Scalars['Int']['output'];
  sessionId: Scalars['String']['output'];
  source: AiConversationSummarySource;
  totalDuration: Scalars['Float']['output'];
};

export type AiConversationSummaryConnection = {
  edges: Array<AiConversationSummaryEdge>;
  nodes: Array<AiConversationSummary>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AiConversationSummaryEdge = {
  cursor: Scalars['Cursor']['output'];
  node: AiConversationSummary;
};

export type AiConversationSummaryFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  learnerProfileID?: InputMaybe<Array<Scalars['ID']['input']>>;
  source?: InputMaybe<Array<AiConversationSummarySource>>;
  userStatus?: InputMaybe<AiConversationSummaryUserStatus>;
};

export type AiConversationSummaryOrder = {
  key?: InputMaybe<AiConversationSummaryOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AiConversationSummaryOrderKey {
  HighestDuration = 'HIGHEST_DURATION'
}

export enum AiConversationSummarySource {
  MobileExam = 'MOBILE_EXAM',
  WebExam = 'WEB_EXAM'
}

export enum AiConversationSummaryUserStatus {
  Subscribed = 'SUBSCRIBED',
  UnSubscribed = 'UN_SUBSCRIBED'
}

export enum AiConversationType {
  Call = 'CALL',
  Chat = 'CHAT'
}

export type AiPartnerConversation = Node & {
  aiPartnerConversationAttachments: AiPartnerConversationAttachmentConnection;
  aiPartnerConversationsId: Scalars['ID']['output'];
  aiPartnerThread: AiPartnerThread;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  role: AiPartnerConversationRole;
  source: AiPartnerConversationSource;
  teacherProfile: TeacherProfile;
  updatedAt: Scalars['DateTime']['output'];
};


export type AiPartnerConversationAiPartnerConversationAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AiPartnerConversationAttachment = Node & {
  aiPartnerConversation: AiPartnerConversation;
  aiPartnerConversationAttachmentId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image: Image;
  type: AiPartnerConversationAttachmentType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AiPartnerConversationAttachmentConnection = {
  edges: Array<AiPartnerConversationAttachmentEdge>;
  nodes: Array<AiPartnerConversationAttachment>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AiPartnerConversationAttachmentEdge = {
  cursor: Scalars['Cursor']['output'];
  node: AiPartnerConversationAttachment;
};

export enum AiPartnerConversationAttachmentType {
  Image = 'IMAGE'
}

export type AiPartnerConversationConnection = {
  edges: Array<AiPartnerConversationEdge>;
  nodes: Array<AiPartnerConversation>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AiPartnerConversationEdge = {
  cursor: Scalars['Cursor']['output'];
  node: AiPartnerConversation;
};

export type AiPartnerConversationFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  hasAiPartnerThreadWith?: InputMaybe<AiPartnerThreadFilter>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  role?: InputMaybe<Array<AiPartnerConversationRole>>;
  source?: InputMaybe<Array<AiPartnerConversationSource>>;
  updatedAt?: InputMaybe<DateTimeRange>;
};

export enum AiPartnerConversationRole {
  System = 'SYSTEM',
  User = 'USER'
}

export enum AiPartnerConversationSource {
  MobileTeacher = 'MOBILE_TEACHER',
  WebTeacher = 'WEB_TEACHER'
}

export type AiPartnerThread = Node & {
  aiPartnerThreadsId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  source: AiPartnerThreadSource;
  teacherProfile: TeacherProfile;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AiPartnerThreadConnection = {
  edges: Array<AiPartnerThreadEdge>;
  nodes: Array<AiPartnerThread>;
  pageInfo: PageInfo;
};

export type AiPartnerThreadEdge = {
  cursor: Scalars['Cursor']['output'];
  node: AiPartnerThread;
};

export type AiPartnerThreadFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  source?: InputMaybe<Array<AiPartnerThreadSource>>;
  updatedAt?: InputMaybe<DateTimeRange>;
};

export enum AiPartnerThreadSource {
  MobileTeacher = 'MOBILE_TEACHER',
  WebTeacher = 'WEB_TEACHER'
}

export type AiSpeakingRecord = Node & {
  aiRecordId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  record: Audio;
  recordScore?: Maybe<RecordScore>;
  teacherProfile: TeacherProfile;
  type?: Maybe<AiSpeakingRecordType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AiSpeakingRecordConnection = {
  edges: Array<AiSpeakingRecordEdge>;
  nodes: Array<AiSpeakingRecord>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AiSpeakingRecordEdge = {
  cursor: Scalars['Cursor']['output'];
  node: AiSpeakingRecord;
};

export enum AiSpeakingRecordType {
  General = 'GENERAL',
  Ielts = 'IELTS'
}

export type AiWritingRecord = Node & {
  aiRecordId: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  images: Array<Maybe<Image>>;
  marking: WritingAiMarking;
  name: Scalars['String']['output'];
  task: AiWritingRecordTask;
  teacherProfile?: Maybe<TeacherProfile>;
  topic: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wordsCount: Scalars['Int']['output'];
};

export type AiWritingRecordConnection = {
  edges: Array<AiWritingRecordEdge>;
  nodes: Array<AiWritingRecord>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AiWritingRecordEdge = {
  cursor: Scalars['Cursor']['output'];
  node: AiWritingRecord;
};

export enum AiWritingRecordTask {
  Flyers = 'FLYERS',
  General = 'GENERAL',
  IeltsTask_1 = 'IELTS_TASK_1',
  IeltsTask_2 = 'IELTS_TASK_2',
  KetPart_6 = 'KET_PART_6',
  KetPart_7 = 'KET_PART_7',
  Pet = 'PET'
}

export type AccuracyByDay = {
  accuracy: Scalars['Float']['output'];
  date: Scalars['String']['output'];
};

export enum AchievementName {
  ErrorMechanic = 'ERROR_MECHANIC',
  Explorer = 'EXPLORER',
  LongestChain = 'LONGEST_CHAIN',
  OlympicAthlete = 'OLYMPIC_ATHLETE',
  PerfectLessons = 'PERFECT_LESSONS',
  StarsHunterWarlord = 'STARS_HUNTER_WARLORD',
  TournamentStar = 'TOURNAMENT_STAR',
  Week = 'WEEK',
  YearOfTheDragon = 'YEAR_OF_THE_DRAGON'
}

export type ActivationCode = Node & {
  activationCodeId: Scalars['ID']['output'];
  aiSpeakingCount?: Maybe<Scalars['Int']['output']>;
  aiWritingCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  diamond?: Maybe<Scalars['Int']['output']>;
  discountId?: Maybe<Scalars['Int']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  flyerPackage: FlyerPackage;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isJoinClass: Scalars['Boolean']['output'];
  isRevoke?: Maybe<Scalars['Boolean']['output']>;
  joinClassCode?: Maybe<JoinClassCode>;
  maxUses: Scalars['Int']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  planDay: Scalars['Duration']['output'];
  referralCode?: Maybe<Scalars['String']['output']>;
  revokeDate?: Maybe<Scalars['DateTime']['output']>;
  type: ActivationCodeType;
  updatedAt: Scalars['DateTime']['output'];
  uses: Scalars['Int']['output'];
};

export type ActivationCodeConnection = {
  edges: Array<ActivationCodeEdge>;
  nodes: Array<ActivationCode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ActivationCodeEdge = {
  cursor: Scalars['Cursor']['output'];
  node: ActivationCode;
};

export type ActivationCodeFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum ActivationCodeType {
  Agent = 'agent',
  Giveaway = 'giveaway',
  GiveawayAgent = 'giveaway_agent',
  Iservice = 'iservice',
  MaxTrial = 'max_trial',
  Partner = 'partner',
  Reissue = 'reissue',
  Retail = 'retail',
  RetailManual = 'retail_manual',
  TeacherCode = 'teacher_code',
  Test = 'test',
  Vnpay = 'vnpay'
}

export type ActivationCodeUser = Node & {
  activatedAt: Scalars['DateTime']['output'];
  activationCodeUserId: Scalars['ID']['output'];
  activeCode: ActivationCode;
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
  userIDString?: Maybe<Scalars['String']['output']>;
};

export type ActivationCodeUserConnection = {
  edges: Array<ActivationCodeUserEdge>;
  nodes: Array<ActivationCodeUser>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ActivationCodeUserEdge = {
  cursor: Scalars['Cursor']['output'];
  node: ActivationCodeUser;
};

export type ActivationPlan = Node & {
  activationPlanId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  day: Scalars['Duration']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  priceUsd: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ActivationPlanConnection = {
  edges: Array<ActivationPlanEdge>;
  nodes: Array<ActivationPlan>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ActivationPlanEdge = {
  cursor: Scalars['Cursor']['output'];
  node: ActivationPlan;
};

export enum ActivityStatusChallenge {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Running = 'RUNNING'
}

export type AdditionalInfo = {
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type AdditionalInfoInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AdminActivationCodeUpdateInput = {
  id: Scalars['ID']['input'];
  type?: InputMaybe<ActivationCodeType>;
};

export type AdminActivationCodeUpdatePayload = {
  activationCode?: Maybe<ActivationCode>;
  userErrors: Array<UserError>;
};

export type AdminActiveCodeInput = {
  code: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type AdminActiveCodePayload = {
  userErrors: Array<UserError>;
};

export type AdminAvatarFrameCreatePayload = {
  avatarFrame?: Maybe<AvatarFrame>;
  userErrors: Array<UserError>;
};

export type AdminAvatarFrameDeletePayload = {
  avatarFrameID?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type AdminAvatarFrameUpdatePayload = {
  avatarFrame?: Maybe<AvatarFrame>;
  userErrors: Array<UserError>;
};

export type AdminBookCreateInput = {
  coverImageId: Scalars['String']['input'];
  levels: Array<CefrLevel>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<BookStatus>;
};

export type AdminBookCreatePayload = {
  book?: Maybe<Book>;
  userErrors: Array<UserError>;
};

export type AdminBookDeletePayload = {
  bookId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type AdminBookLessonCreateInput = {
  contentHtml: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  unitId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminBookLessonCreatePayload = {
  bookLesson?: Maybe<BookLesson>;
  userErrors: Array<UserError>;
};

export type AdminBookLessonDeletePayload = {
  bookLessonId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type AdminBookLessonRemoveCheckPointsPayload = {
  bookLesson?: Maybe<BookLesson>;
  userErrors: Array<UserError>;
};

export type AdminBookLessonUpdateCheckPointsPayload = {
  bookLesson?: Maybe<BookLesson>;
  userErrors: Array<UserError>;
};

export type AdminBookLessonUpdateInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  unitId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminBookLessonUpdatePayload = {
  bookLesson?: Maybe<BookLesson>;
  userErrors: Array<UserError>;
};

export type AdminBookUnitCreateInput = {
  bookId?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
  lessonType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  topic: Scalars['String']['input'];
};

export type AdminBookUnitCreatePayload = {
  bookUnit?: Maybe<BookUnit>;
  userErrors: Array<UserError>;
};

export type AdminBookUnitDeletePayload = {
  bookUnitId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type AdminBookUnitUpdateInput = {
  bookId?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lessonType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type AdminBookUnitUpdateLessonsPayload = {
  bookUnit?: Maybe<BookUnit>;
  userErrors: Array<UserError>;
};

export type AdminBookUnitUpdatePayload = {
  bookUnit?: Maybe<BookUnit>;
  userErrors: Array<UserError>;
};

export type AdminBookUpdateInput = {
  coverImageId?: InputMaybe<Scalars['String']['input']>;
  customDomains?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludedCustomDomains?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  levels?: InputMaybe<Array<CefrLevel>>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<BookStatus>;
};

export type AdminBookUpdatePayload = {
  book?: Maybe<Book>;
  userErrors: Array<UserError>;
};

export type AdminBookUpdateUnitsPayload = {
  book?: Maybe<Book>;
  userErrors: Array<UserError>;
};

export type AdminCheckPointCreateInput = {
  adminRank?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed?: InputMaybe<Scalars['Int']['input']>;
  coin?: InputMaybe<Scalars['Int']['input']>;
  cpType?: InputMaybe<CheckPointType>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  diamond?: InputMaybe<Scalars['Int']['input']>;
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isBoss?: InputMaybe<Scalars['Boolean']['input']>;
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  levels: Array<CefrLevel>;
  listeningTime?: InputMaybe<Scalars['Duration']['input']>;
  maxGrade?: InputMaybe<Scalars['Float']['input']>;
  maxScore?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  placementTestGroupId?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  readingTime?: InputMaybe<Scalars['Duration']['input']>;
  skills?: InputMaybe<Array<EnglishSkillV1>>;
  speakingTime?: InputMaybe<Scalars['Duration']['input']>;
  star?: InputMaybe<Scalars['Int']['input']>;
  testCount?: InputMaybe<Scalars['Int']['input']>;
  testLevelId?: InputMaybe<Scalars['ID']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
  type: Scalars['CheckPointTypeV1']['input'];
  writingTime?: InputMaybe<Scalars['Duration']['input']>;
};

export type AdminCheckPointCreatePayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type AdminCheckPointCustomDomainUpdateInput = {
  checkPointId: Scalars['ID']['input'];
  customDomainIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AdminCheckPointCustomDomainUpdatePayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type AdminCheckPointDeletePayload = {
  checkPointId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type AdminCheckPointDuolingoPartInput = {
  partId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type AdminCheckPointRemoveDuolingoPartsPayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type AdminCheckPointRemoveSpeakingPartsPayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type AdminCheckPointRemoveWritingPartsPayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type AdminCheckPointTopicRemoveInput = {
  checkPointId: Scalars['ID']['input'];
  topicId: Array<Scalars['ID']['input']>;
};

export type AdminCheckPointTopicRemovePayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type AdminCheckPointTopicUpdateInput = {
  checkPointId: Scalars['ID']['input'];
  topicId: Array<Scalars['ID']['input']>;
};

export type AdminCheckPointTopicUpdatePayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type AdminCheckPointUpdateDuolingoPartsPayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type AdminCheckPointUpdateInput = {
  adminRank?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed?: InputMaybe<Scalars['Int']['input']>;
  coin?: InputMaybe<Scalars['Int']['input']>;
  cpType?: InputMaybe<CheckPointType>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  diamond?: InputMaybe<Scalars['Int']['input']>;
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isBoss?: InputMaybe<Scalars['Boolean']['input']>;
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  listeningTime?: InputMaybe<Scalars['Duration']['input']>;
  maxGrade?: InputMaybe<Scalars['Float']['input']>;
  maxScore?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  placementTestGroupId?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  readingTime?: InputMaybe<Scalars['Duration']['input']>;
  skills?: InputMaybe<Array<EnglishSkillV1>>;
  speakingTime?: InputMaybe<Scalars['Duration']['input']>;
  star?: InputMaybe<Scalars['Int']['input']>;
  testCount?: InputMaybe<Scalars['Int']['input']>;
  testLevelId?: InputMaybe<Scalars['ID']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
  type?: InputMaybe<Scalars['CheckPointTypeV1']['input']>;
  writingTime?: InputMaybe<Scalars['Duration']['input']>;
};

export type AdminCheckPointUpdatePayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type AdminCheckPointUpdateSpeakingPartsPayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type AdminCheckPointUpdateWritingPartsPayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type AdminCreateDiscountInput = {
  amount: Scalars['Float']['input'];
  campaignMinimumAmount?: InputMaybe<Scalars['Float']['input']>;
  campaignMinimumItem?: InputMaybe<Scalars['Int']['input']>;
  code: Scalars['String']['input'];
  discountType: DiscountDiscountType;
  endDate: Scalars['DateTime']['input'];
  eventType?: InputMaybe<DiscountEventType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxDiscount?: InputMaybe<Scalars['Float']['input']>;
  oneTime?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['DateTime']['input'];
  status?: InputMaybe<DiscountStatus>;
};

export type AdminCreateDiscountPayload = {
  discount?: Maybe<Discount>;
  userErrors: Array<UserError>;
};

export type AdminCreateOrderCodeInput = {
  aiSpeakingCount?: InputMaybe<Scalars['Int']['input']>;
  aiWritingCount?: InputMaybe<Scalars['Int']['input']>;
  codeType: OrderCodeCodeType;
  description: Scalars['String']['input'];
  diamond?: InputMaybe<Scalars['Int']['input']>;
  packageId: Scalars['ID']['input'];
  planDay: Scalars['Duration']['input'];
  quantity: Scalars['Int']['input'];
};

export type AdminCreateOrderCodePayload = {
  orderCode?: Maybe<OrderCode>;
  userErrors: Array<UserError>;
};

export type AdminCreateVersionNotificationInput = {
  appType: AppTypeMobile;
  contentHTML: Scalars['String']['input'];
  contentHTMLEn: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  showDomain?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['DateTime']['input'];
  status: Status;
  style?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['String']['input'];
  videoId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminCreateVersionNotificationPayload = {
  userErrors: Array<UserError>;
  versionNotification?: Maybe<VersionNotification>;
};

export type AdminCustomDomainUpdateInput = {
  disabledStudentChangeName?: InputMaybe<Scalars['Boolean']['input']>;
  disabledStudentLeaveClass?: InputMaybe<Scalars['Boolean']['input']>;
  disabledUpdatePhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  domainName?: InputMaybe<Scalars['String']['input']>;
  enabledStudentManagement?: InputMaybe<Scalars['Boolean']['input']>;
  fullDomainName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  meta?: InputMaybe<DomainDataInput>;
  showDiamond?: InputMaybe<Scalars['Boolean']['input']>;
  showWallet?: InputMaybe<Scalars['Boolean']['input']>;
  teacherID?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminCustomDomainUpdatePayload = {
  customDomain?: Maybe<CustomDomain>;
  userErrors: Array<UserError>;
};

export type AdminDeleteDiscountPayload = {
  discountID?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type AdminDeleteVersionNotificationPayload = {
  userErrors: Array<UserError>;
  versionNotificationID?: Maybe<Scalars['ID']['output']>;
};

export type AdminDuolingoPartCreateInput = {
  challenge?: InputMaybe<DuolingoChallengeInput>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  name: Scalars['String']['input'];
  story?: InputMaybe<DuolingoStoryInput>;
  title: Scalars['String']['input'];
  type: DuolingoPartType;
};

export type AdminDuolingoPartCreatePayload = {
  duolingoPart?: Maybe<DuolingoPart>;
  userErrors: Array<UserError>;
};

export type AdminDuolingoPartDeletePayload = {
  duolingoPartId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type AdminDuolingoPartUpdateInput = {
  challenge?: InputMaybe<DuolingoChallengeInput>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  story?: InputMaybe<DuolingoStoryInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DuolingoPartType>;
};

export type AdminDuolingoPartUpdatePayload = {
  duolingoPart?: Maybe<DuolingoPart>;
  userErrors: Array<UserError>;
};

export type AdminExamPartCreateInput = {
  addQuestions?: InputMaybe<Array<ExamQuestionCreateInput>>;
  answerExplanationHTML?: InputMaybe<Scalars['String']['input']>;
  answerExplanationHTMLEn?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<ExamPartBodyInput>;
  maxScore: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  partType: ExamPartType;
  structureType: ExamStructureType;
  time?: InputMaybe<Scalars['Duration']['input']>;
  title: Scalars['String']['input'];
};

export type AdminExamPartCreatePayload = {
  examPart?: Maybe<ExamPart>;
  userErrors: Array<UserError>;
};

export type AdminExamPartUpdateInput = {
  addQuestions?: InputMaybe<Array<ExamQuestionCreateInput>>;
  answerExplanationHTML?: InputMaybe<Scalars['String']['input']>;
  answerExplanationHTMLEn?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<ExamPartBodyInput>;
  deleteQuestions?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  maxScore?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partType?: InputMaybe<ExamPartType>;
  structureType?: InputMaybe<ExamStructureType>;
  time?: InputMaybe<Scalars['Duration']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateQuestions?: InputMaybe<Array<ExamQuestionUpdateInput>>;
};

export type AdminExamPartUpdatePayload = {
  part?: Maybe<ExamPart>;
  userErrors: Array<UserError>;
};

export type AdminNotificationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  hasPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<NotificationMetaInput>;
  profileID?: InputMaybe<Scalars['ID']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<NotificationSource>;
  teacherID?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
  typeNotification?: InputMaybe<NotificationTypeNotification>;
};

export type AdminNotificationPayload = {
  done?: Maybe<Scalars['Boolean']['output']>;
  userErrors: Array<UserError>;
};

export type AdminPartTopicUpdateInput = {
  partExamReadingId?: InputMaybe<Scalars['ID']['input']>;
  partExamSpeakingId?: InputMaybe<Scalars['ID']['input']>;
  partExamWritingId?: InputMaybe<Scalars['ID']['input']>;
  partIeltsSpeakingId?: InputMaybe<Scalars['ID']['input']>;
  topicId: Array<Scalars['ID']['input']>;
};

export type AdminPartTopicUpdatePayload = {
  topic?: Maybe<Array<Topic>>;
  userErrors: Array<UserError>;
};

export type AdminPartnerAccessTokenCreateInput = {
  teacherProfileId: Scalars['ID']['input'];
};

export type AdminPartnerAccessTokenCreatePayload = {
  token?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
};

export type AdminPartnerSchoolInviteTeachersAcceptAllInput = {
  schoolIds: Array<Scalars['ID']['input']>;
};

export type AdminPartnerSchoolInviteTeachersAcceptAllPayload = {
  userErrors: Array<UserError>;
};

export type AdminPlacementTestGroupCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminPlacementTestGroupCreatePayload = {
  placementTestGroup: PlacementTestGroup;
  userErrors: Array<UserError>;
};

export type AdminPlacementTestGroupDeletePayload = {
  placementTestGroupId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type AdminPlacementTestGroupUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminPlacementTestGroupUpdatePayload = {
  placementTestGroup: PlacementTestGroup;
  userErrors: Array<UserError>;
};

export type AdminSpeakingPartCreateInput = {
  addQuestions?: InputMaybe<Array<SpeakingQuestionCreateInput>>;
  body?: InputMaybe<SpeakingPartBodyInput>;
  name: Scalars['String']['input'];
  partType: SpeakingPartType;
  time?: InputMaybe<Scalars['Duration']['input']>;
  title: Scalars['String']['input'];
};

export type AdminSpeakingPartCreatePayload = {
  speakingPart?: Maybe<SpeakingPart>;
  userErrors: Array<UserError>;
};

export type AdminSpeakingPartDeletePayload = {
  speakingPartId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type AdminSpeakingPartUpdateInput = {
  addQuestions?: InputMaybe<Array<SpeakingQuestionCreateInput>>;
  body?: InputMaybe<SpeakingPartBodyInput>;
  deleteQuestions?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  partType?: InputMaybe<SpeakingPartType>;
  time?: InputMaybe<Scalars['Duration']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateQuestions?: InputMaybe<Array<SpeakingQuestionUpdateInput>>;
};

export type AdminSpeakingPartUpdatePayload = {
  speakingPart?: Maybe<SpeakingPart>;
  userErrors: Array<UserError>;
};

export type AdminStudyCharacterCreateInput = {
  imageId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AdminStudyCharacterCreatePayload = {
  studyCharacter?: Maybe<StudyCharacter>;
  userErrors: Array<UserError>;
};

export type AdminStudyCharacterDeletePayload = {
  studyCharacterId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type AdminStudyCharacterUpdateInput = {
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AdminStudyCharacterUpdatePayload = {
  studyCharacter?: Maybe<StudyCharacter>;
  userErrors: Array<UserError>;
};

export type AdminTopicCreateInput = {
  name: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
};

export type AdminTopicCreatePayload = {
  topic?: Maybe<Topic>;
  userErrors: Array<UserError>;
};

export type AdminTopicDeletePayload = {
  topicId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type AdminTopicUpdateInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
};

export type AdminTopicUpdatePayload = {
  topic?: Maybe<Topic>;
  userErrors: Array<UserError>;
};

export type AdminUpdateDiscountInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  campaignMinimumAmount?: InputMaybe<Scalars['Float']['input']>;
  campaignMinimumItem?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<DiscountDiscountType>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventType?: InputMaybe<DiscountEventType>;
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxDiscount?: InputMaybe<Scalars['Float']['input']>;
  oneTime?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DiscountStatus>;
};

export type AdminUpdateDiscountPayload = {
  discount?: Maybe<Discount>;
  userErrors: Array<UserError>;
};

export type AdminUpdateOrderCodeInput = {
  id: Scalars['ID']['input'];
  status: OrderCodeStatus;
};

export type AdminUpdateOrderCodePayload = {
  orderCode?: Maybe<OrderCode>;
  userErrors: Array<UserError>;
};

export type AdminUpdateTestLevelPackageFlyerInput = {
  packageID: Scalars['ID']['input'];
  testLevelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AdminUpdateTestLevelPackageFlyerPayload = {
  flyerPackage: FlyerPackage;
  userErrors: Array<UserError>;
};

export type AdminUpdateUsernameDataInput = {
  id: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};

export type AdminUpdateUsernameInput = {
  listUser: Array<AdminUpdateUsernameDataInput>;
};

export type AdminUpdateUsernamePayload = {
  done?: Maybe<Scalars['Boolean']['output']>;
  userErrors: Array<UserError>;
};

export type AdminUpdateVersionNotificationInput = {
  appType?: InputMaybe<AppTypeMobile>;
  contentHTML?: InputMaybe<Scalars['String']['input']>;
  contentHTMLEn?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  showDomain?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Status>;
  style?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminUpdateVersionNotificationPayload = {
  userErrors: Array<UserError>;
  versionNotification?: Maybe<VersionNotification>;
};

export type AdminUserAttemptsScoreWithAiInput = {
  attemptIds: Array<Scalars['ID']['input']>;
  forceGetScore?: Scalars['Boolean']['input'];
};

export type AdminUserAttemptsScoreWithAiPayload = {
  userErrors: Array<UserError>;
};

export type AdminUserTeacherReferralUsagePaysInput = {
  date: Scalars['DateTime']['input'];
  ids: Array<Scalars['ID']['input']>;
};

export type AdminUserTeacherReferralUsagePaysPayload = {
  nodes: Array<UserTeacherReferralUsage>;
  userErrors: Array<UserError>;
};

export type AdminViewerActivationCodeCreateInput = {
  aiSpeakingCount?: InputMaybe<Scalars['Int']['input']>;
  aiWritingCount?: InputMaybe<Scalars['Int']['input']>;
  diamond?: InputMaybe<Scalars['Int']['input']>;
  isJoinClass?: InputMaybe<Scalars['Boolean']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  oneTime?: InputMaybe<Scalars['Boolean']['input']>;
  packageID: Scalars['ID']['input'];
  planDay?: InputMaybe<Scalars['Duration']['input']>;
  type: ActivationCodeType;
};

export type AdminViewerActivationCodeCreatePayload = {
  activationCode?: Maybe<ActivationCode>;
  userErrors: Array<UserError>;
};

export type AdminViewerActivationCodeUpdateInput = {
  id: Scalars['ID']['input'];
  isJoinClass?: InputMaybe<Scalars['Boolean']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  oneTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminViewerActivationCodeUpdatePayload = {
  activationCode?: Maybe<ActivationCode>;
  userErrors: Array<UserError>;
};

export type AdminViewerActiveCodeJoinClassInput = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdminViewerActiveCodeJoinClassPayload = {
  success?: Maybe<Scalars['Boolean']['output']>;
  userErrors: Array<UserError>;
};

export type AdminViewerFeaturedPlaylistCheckPointAddInput = {
  checkPointIds: Array<Scalars['ID']['input']>;
  featuredPlaylistId: Scalars['ID']['input'];
};

export type AdminViewerFeaturedPlaylistCheckPointAddPayload = {
  featuredPlaylist?: Maybe<FeaturedPlaylist>;
  userErrors: Array<UserError>;
};

export type AdminViewerFeaturedPlaylistCheckPointRemoveInput = {
  checkPointIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featuredPlaylistId: Scalars['ID']['input'];
};

export type AdminViewerFeaturedPlaylistCheckPointRemovePayload = {
  featuredPlaylist?: Maybe<FeaturedPlaylist>;
  userErrors: Array<UserError>;
};

export type AdminViewerFeaturedPlaylistCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  levels: Array<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishMode?: InputMaybe<FeaturedPlaylistPublishMode>;
  title: Scalars['String']['input'];
  titleEn: Scalars['String']['input'];
};

export type AdminViewerFeaturedPlaylistCreatePayload = {
  featuredPlaylist?: Maybe<FeaturedPlaylist>;
  userErrors: Array<UserError>;
};

export type AdminViewerFeaturedPlaylistDeletePayload = {
  featuredPlaylistId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type AdminViewerFeaturedPlaylistUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  levels?: InputMaybe<Array<Scalars['String']['input']>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishMode?: InputMaybe<FeaturedPlaylistPublishMode>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
};

export type AdminViewerFeaturedPlaylistUpdatePayload = {
  featuredPlaylist?: Maybe<FeaturedPlaylist>;
  userErrors: Array<UserError>;
};

export type AdminViewerMenuNotificationCreateInput = {
  contentEn: Scalars['String']['input'];
  contentVi: Scalars['String']['input'];
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionVi?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  layout?: InputMaybe<MenuNotificationLayout>;
  menuCode: Scalars['String']['input'];
  titleEn?: InputMaybe<Scalars['String']['input']>;
  titleVi?: InputMaybe<Scalars['String']['input']>;
  type: MenuNotificationType;
  version: Scalars['String']['input'];
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminViewerMenuNotificationCreatePayload = {
  menuNotification?: Maybe<MenuNotification>;
  userErrors: Array<UserError>;
};

export type AdminViewerMenuNotificationDeletePayload = {
  id?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type AdminViewerMenuNotificationUpdateInput = {
  contentEn?: InputMaybe<Scalars['String']['input']>;
  contentVi?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionVi?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  layout?: InputMaybe<MenuNotificationLayout>;
  menuCode?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
  titleVi?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MenuNotificationType>;
  version?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminViewerMenuNotificationUpdatePayload = {
  menuNotification?: Maybe<MenuNotification>;
  userErrors: Array<UserError>;
};

export type AdminViewerRevokeActiveCodeInput = {
  codes: Array<Scalars['String']['input']>;
};

export type AdminViewerRevokeActiveCodePayload = {
  userErrors: Array<UserError>;
};

export type AdminViewerThemesCreateInput = {
  backgroundId: Scalars['String']['input'];
  bingoId?: InputMaybe<Scalars['String']['input']>;
  blockLeft?: InputMaybe<Scalars['String']['input']>;
  blockRight?: InputMaybe<Scalars['String']['input']>;
  bookOneId?: InputMaybe<Scalars['String']['input']>;
  bookTwoId?: InputMaybe<Scalars['String']['input']>;
  borderProgress?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  iconLeftId?: InputMaybe<Scalars['String']['input']>;
  iconNextId?: InputMaybe<Scalars['String']['input']>;
  iconPrevId?: InputMaybe<Scalars['String']['input']>;
  iconRightId?: InputMaybe<Scalars['String']['input']>;
  iconZoomId?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['String']['input'];
  imagePreviewId?: InputMaybe<Scalars['String']['input']>;
  imageTitleId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
  progressColor?: InputMaybe<Scalars['String']['input']>;
  progressId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ThemeType>;
};

export type AdminViewerThemesCreatePayload = {
  theme?: Maybe<Theme>;
  userErrors: Array<UserError>;
};

export type AdminViewerThemesDeletePayload = {
  id?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type AdminViewerThemesUpdateInput = {
  backgroundId?: InputMaybe<Scalars['String']['input']>;
  bingoId?: InputMaybe<Scalars['String']['input']>;
  blockLeft?: InputMaybe<Scalars['String']['input']>;
  blockRight?: InputMaybe<Scalars['String']['input']>;
  bookOneId?: InputMaybe<Scalars['String']['input']>;
  bookTwoId?: InputMaybe<Scalars['String']['input']>;
  borderProgress?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  iconLeftId?: InputMaybe<Scalars['String']['input']>;
  iconNextId?: InputMaybe<Scalars['String']['input']>;
  iconPrevId?: InputMaybe<Scalars['String']['input']>;
  iconRightId?: InputMaybe<Scalars['String']['input']>;
  iconZoomId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  imagePreviewId?: InputMaybe<Scalars['String']['input']>;
  imageTitleId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  progressColor?: InputMaybe<Scalars['String']['input']>;
  progressId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ThemeType>;
};

export type AdminViewerThemesUpdatePayload = {
  theme?: Maybe<Theme>;
  userErrors: Array<UserError>;
};

export type AdminViewerUserAttemptDeletePayload = {
  id?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type AdminVocabWordCreateInput = {
  level?: InputMaybe<CefrLevel>;
  phonetics: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type AdminVocabWordCreatePayload = {
  userErrors: Array<UserError>;
  vocabWord?: Maybe<VocabWord>;
};

export type AdminVocabWordDeletePayload = {
  userErrors: Array<UserError>;
  vocabWordId: Scalars['ID']['output'];
};

export type AdminVocabWordUpdateInput = {
  id: Scalars['ID']['input'];
  level?: InputMaybe<CefrLevel>;
  phonetics?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type AdminVocabWordUpdatePayload = {
  userErrors: Array<UserError>;
  vocabWord?: Maybe<VocabWord>;
};

export type AdminWritingPartCreateInput = {
  aiPrompt?: InputMaybe<WritingAiPromptInput>;
  body?: InputMaybe<WritingPartBodyInput>;
  name: Scalars['String']['input'];
  time?: InputMaybe<Scalars['Duration']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminWritingPartCreatePayload = {
  userErrors: Array<UserError>;
  writingPart?: Maybe<WritingPart>;
};

export type AdminWritingPartDeletePayload = {
  userErrors: Array<UserError>;
  writingPartId: Scalars['ID']['output'];
};

export type AdminWritingPartUpdateInput = {
  aiPrompt?: InputMaybe<WritingAiPromptInput>;
  body?: InputMaybe<WritingPartBodyInput>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminWritingPartUpdatePayload = {
  userErrors: Array<UserError>;
  writingPart?: Maybe<WritingPart>;
};

export type Advice = Node & {
  adviceId: Scalars['ID']['output'];
  adviceType?: Maybe<AdviceAdviceType>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated use learnerProfile instead */
  leanerProfile?: Maybe<LearnerProfile>;
  learnerProfile?: Maybe<LearnerProfile>;
  noteAdmin?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<AdviceSource>;
  status?: Maybe<AdviceStatus>;
};

export enum AdviceAdviceType {
  FlyerPackage = 'FLYER_PACKAGE',
  OutCheckout = 'OUT_CHECKOUT'
}

export type AdviceConnection = {
  edges: Array<AdviceEdge>;
  nodes: Array<Advice>;
  pageInfo: PageInfo;
};

export type AdviceEdge = {
  cursor: Scalars['Cursor']['output'];
  node: Advice;
};

export enum AdviceSource {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export enum AdviceStatus {
  Done = 'DONE',
  Hold = 'HOLD',
  New = 'NEW',
  Process = 'PROCESS'
}

export type AnswerAccuracyInfo = {
  accuracy?: Maybe<Scalars['Float']['output']>;
  answerCorrect?: Maybe<Scalars['Int']['output']>;
  answerWrong?: Maybe<Scalars['Int']['output']>;
  totalQuestion?: Maybe<Scalars['Int']['output']>;
  totalStudent?: Maybe<Scalars['Int']['output']>;
};

export enum AppType {
  Exam = 'EXAM',
  Ielts = 'IELTS'
}

export enum AppTypeMobile {
  ExamWeb = 'EXAM_WEB',
  Ielts = 'IELTS',
  IeltsWeb = 'IELTS_WEB',
  Parent = 'PARENT',
  PartnerWeb = 'PARTNER_WEB',
  Student = 'STUDENT',
  Teacher = 'TEACHER'
}

export type AssignTest = Node & {
  assignTestClasses: AssignTestClassConnection;
  assignTestId: Scalars['ID']['output'];
  assignTestProfiles: AssignTestProfileConnection;
  checkPoint: CheckPoint;
  checkpointId: Scalars['ID']['output'];
  classIds?: Maybe<Array<Scalars['String']['output']>>;
  classes?: Maybe<Array<Class>>;
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  infoAssignTest?: Maybe<InfoAssignTest>;
  infoAssignTestStudent?: Maybe<InfoAssignTestStudent>;
  profileCompletedIds?: Maybe<Array<Scalars['String']['output']>>;
  profileIds?: Maybe<Array<Scalars['String']['output']>>;
  school: School;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: StatusAssignTest;
  studentScores?: Maybe<Array<AssignTestStudentScore>>;
  teacherProfile: TeacherProfile;
  testLevel?: Maybe<TestLevel>;
  testLevelId: Scalars['ID']['output'];
  typeExam?: Maybe<TypeExamAssignTest>;
  typeInit?: Maybe<TypeInitAssignTest>;
  updatedAt: Scalars['DateTime']['output'];
};


export type AssignTestAssignTestClassesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AssignTestClassFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignTestAssignTestProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AssignTestProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignTestInfoAssignTestStudentArgs = {
  learnerProfileID?: InputMaybe<Scalars['ID']['input']>;
};


export type AssignTestStudentScoresArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type AssignTestClass = Node & {
  assignTest: AssignTest;
  assignTestClassId: Scalars['ID']['output'];
  class: Class;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AssignTestClassConnection = {
  edges: Array<AssignTestClassEdge>;
  nodes: Array<AssignTestClass>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AssignTestClassEdge = {
  cursor: Scalars['Cursor']['output'];
  node: AssignTestClass;
};

export type AssignTestClassFilter = {
  and?: InputMaybe<Array<AssignTestClassFilter>>;
  assignTestId?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasClassWith?: InputMaybe<ClassFilter>;
  or?: InputMaybe<Array<AssignTestClassFilter>>;
};

export type AssignTestConnection = {
  edges: Array<AssignTestEdge>;
  nodes: Array<AssignTest>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AssignTestEdge = {
  cursor: Scalars['Cursor']['output'];
  node: AssignTest;
};

export type AssignTestFilter = {
  classIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<DateTimeRange>;
  hasAssignTestProfilesWith?: InputMaybe<AssignTestProfileFilter>;
  hasCheckPointWith?: InputMaybe<CheckPointFilter>;
  hasIelts?: InputMaybe<Scalars['Boolean']['input']>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  hasTestLevelWith?: InputMaybe<TestLevelFilter>;
  startDate?: InputMaybe<DateTimeRange>;
  status?: InputMaybe<Array<StatusAssignTest>>;
  studentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignTestOrder = {
  key?: InputMaybe<AssignTestOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AssignTestOrderKey {
  CheckPointNameEn = 'CHECK_POINT_NAME_EN',
  CheckPointNameVi = 'CHECK_POINT_NAME_VI',
  CheckPointType = 'CHECK_POINT_TYPE',
  EndDate = 'END_DATE',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  TestLevelName = 'TEST_LEVEL_NAME'
}

export type AssignTestProfile = Node & {
  assignTest: AssignTest;
  assignTestProfileId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  highestGrade?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  infoAssignTestProfile?: Maybe<InfoAssignTestProfile>;
  learnerProfile: LearnerProfile;
  redoAttempts?: Maybe<Scalars['Int']['output']>;
  redoing: Scalars['Boolean']['output'];
  submitted: Scalars['Boolean']['output'];
};

export type AssignTestProfileConnection = {
  edges: Array<AssignTestProfileEdge>;
  nodes: Array<AssignTestProfile>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AssignTestProfileEdge = {
  cursor: Scalars['Cursor']['output'];
  node: AssignTestProfile;
};

export type AssignTestProfileFilter = {
  and?: InputMaybe<Array<AssignTestProfileFilter>>;
  assignTestID?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignTestId?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  highestGrade?: InputMaybe<FloatRange>;
  learnerProfileId?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<AssignTestProfileFilter>>;
  redoing?: InputMaybe<Scalars['Boolean']['input']>;
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignTestProfileOrder = {
  key?: InputMaybe<AssignTestProfileOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AssignTestProfileOrderKey {
  HighestGrade = 'HIGHEST_GRADE'
}

export type AssignTestStats = {
  highestScoreCount: Scalars['Int']['output'];
  lowestScoreCount: Scalars['Int']['output'];
};

export type AssignTestStudentScore = {
  maxScore: Scalars['Float']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  student: LearnerProfile;
  userAttempt?: Maybe<UserAttempt>;
};

export type AssignTestsStats = {
  accuracy?: Maybe<Scalars['Float']['output']>;
  completed?: Maybe<Scalars['Int']['output']>;
  expired?: Maybe<Scalars['Int']['output']>;
  notDone?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AttemptInfo = {
  answerCorrect?: Maybe<Scalars['Int']['output']>;
  answerWrong?: Maybe<Scalars['Int']['output']>;
  percentAnswer?: Maybe<Scalars['Float']['output']>;
  totalQuestion?: Maybe<Scalars['Int']['output']>;
};

export type AttemptStats = {
  accuracy: Scalars['Float']['output'];
  avgScore: Scalars['Float']['output'];
  completedTest: Scalars['Int']['output'];
  studyTime: Scalars['Duration']['output'];
  totalGrade: Scalars['Float']['output'];
};

export type Audio = Node & {
  id: Scalars['ID']['output'];
  /** @deprecated removed */
  subtitle?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type AudioAws = Node & {
  audioAWSId: Scalars['ID']['output'];
  contentType: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<MetaDataAudio>;
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type AudioAwsFilter = {
  duration?: InputMaybe<IntRange>;
  size?: InputMaybe<IntRange>;
};

export enum AuthOtpFlow {
  RecoverPassword = 'RECOVER_PASSWORD',
  SignUp = 'SIGN_UP'
}

export type AutoTestUserCreatePayload = {
  user?: Maybe<User>;
  userErrors: Array<UserError>;
};

export type AutoTestUserCreatePayloadInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  leanerProfileName?: InputMaybe<Scalars['String']['input']>;
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
  teacherProfileName?: InputMaybe<Scalars['String']['input']>;
  userMaxProfiles?: InputMaybe<Scalars['Int']['input']>;
  userMaxSessions?: InputMaybe<Scalars['Int']['input']>;
  username: Scalars['String']['input'];
};

export type AutoTestUserDeletePayload = {
  id?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type AutoTestUserUpdatePayload = {
  user?: Maybe<User>;
  userErrors: Array<UserError>;
};

export type AutoTestUserUpdatePayloadInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
  userMaxProfiles?: InputMaybe<Scalars['Int']['input']>;
  userMaxSessions?: InputMaybe<Scalars['Int']['input']>;
};

export type AvatarFrame = Node & {
  avatarFrameId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image: Image;
  name?: Maybe<Scalars['String']['output']>;
  nameEn?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  type: AvatarFrameType;
  updatedAt: Scalars['DateTime']['output'];
  userAvatarFrames: UserAvatarFrameConnection;
};


export type AvatarFrameUserAvatarFramesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<UserAvatarFrameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AvatarFrameConnection = {
  edges: Array<AvatarFrameEdge>;
  nodes: Array<AvatarFrame>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AvatarFrameCreateInput = {
  imageId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AvatarFrameType>;
};

export type AvatarFrameEdge = {
  cursor: Scalars['Cursor']['output'];
  node: AvatarFrame;
};

export type AvatarFrameFilter = {
  nameEnQ?: InputMaybe<Array<Scalars['String']['input']>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<AvatarFrameType>>;
};

export enum AvatarFrameType {
  Avatar = 'AVATAR',
  Frame = 'FRAME'
}

export type AvatarFrameUpdateInput = {
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AvatarFrameType>;
};

export type AzureOverallScore = {
  fluencyScore?: Maybe<Scalars['Float']['output']>;
  grammarScore?: Maybe<Scalars['Float']['output']>;
  interactionScore?: Maybe<Scalars['Float']['output']>;
  pronScore?: Maybe<Scalars['Float']['output']>;
  pronunciationScore?: Maybe<Scalars['Float']['output']>;
  prosodyScore?: Maybe<Scalars['Float']['output']>;
  totalScore?: Maybe<Scalars['Float']['output']>;
  vocabularyGrammarScore?: Maybe<Scalars['Float']['output']>;
  vocabularyGrammarTotalScore?: Maybe<Scalars['Float']['output']>;
  vocabularyScore?: Maybe<Scalars['Float']['output']>;
  wordPerMinute?: Maybe<Scalars['Float']['output']>;
};

export type AzureRecordScore = {
  cambridgeAssessment?: Maybe<CambridgeAssessmentOutput>;
  microsoftScore?: Maybe<DataSpeech>;
};

export type BankAccountInfo = {
  accountNumber: Scalars['String']['output'];
  bankCode: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
};

export type BankAccountInfoInput = {
  accountNumber: Scalars['String']['input'];
  bankCode: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
};

export type Book = Node & {
  bookId: Scalars['ID']['output'];
  coverImage: Image;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  domains: Array<CustomDomain>;
  excludedDomains: Array<CustomDomain>;
  id: Scalars['ID']['output'];
  lessonsCount: Scalars['Int']['output'];
  levels: Array<CefrLevel>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  status: BookStatus;
  units: Array<BookUnit>;
  unitsCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type BookConnection = {
  edges: Array<BookEdge>;
  nodes: Array<Book>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BookEdge = {
  cursor: Scalars['Cursor']['output'];
  node: Book;
};

export type BookFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<BookStatus>>;
};

export type BookLesson = Node & {
  checkPoints: Array<CheckPoint>;
  contentHtml: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lessonId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  unit?: Maybe<BookUnit>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type BookLessonCheckPointInput = {
  checkPointId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type BookLessonConnection = {
  edges: Array<BookLessonEdge>;
  nodes: Array<BookLesson>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BookLessonEdge = {
  cursor: Scalars['Cursor']['output'];
  node: BookLesson;
};

export type BookLessonFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum BookStatus {
  Domain = 'DOMAIN',
  Global = 'GLOBAL',
  Private = 'PRIVATE'
}

export type BookUnit = Node & {
  book?: Maybe<Book>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  lessonType: Scalars['String']['output'];
  lessons: Array<BookLesson>;
  lessonsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  topic: Scalars['String']['output'];
  unitId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type BookUnitConnection = {
  edges: Array<BookUnitEdge>;
  nodes: Array<BookUnit>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BookUnitEdge = {
  cursor: Scalars['Cursor']['output'];
  node: BookUnit;
};

export type BookUnitFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BookUnitUpdateLessonInput = {
  lessonId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type BookUpdateUnitInput = {
  position: Scalars['Int']['input'];
  unitId: Scalars['ID']['input'];
};

export type Break = {
  breakLength?: Maybe<Scalars['Int']['output']>;
  errorTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CambridgeAssessmentOutput = {
  grammarScore?: Maybe<Scalars['Float']['output']>;
  mistakesEn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mistakesVi?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  suggestions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  vocabularyScore?: Maybe<Scalars['Float']['output']>;
};

export enum CefrLevel {
  A1 = 'a1',
  A2 = 'a2',
  B1 = 'b1',
  B2 = 'b2',
  C1 = 'c1',
  C2 = 'c2',
  Prea1 = 'prea1'
}

export type CefrLevelInfo = {
  name: Scalars['String']['output'];
  star: Scalars['Int']['output'];
  value: CefrLevel;
};

export type Challenge = Node & {
  challengeId: Scalars['ID']['output'];
  challengeInfo?: Maybe<AnswerAccuracyInfo>;
  checkPoint: CheckPoint;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isEnableSound: Scalars['Boolean']['output'];
  isHiddenName: Scalars['Boolean']['output'];
  isLimit: Scalars['Boolean']['output'];
  isMixed: Scalars['Boolean']['output'];
  learnerProfile?: Maybe<LearnerProfile>;
  name: Scalars['String']['output'];
  players: ChallengePlayerConnection;
  school?: Maybe<School>;
  settings?: Maybe<ChallengeSettings>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  teacherProfile?: Maybe<TeacherProfile>;
  updatedAt: Scalars['DateTime']['output'];
  viewerCanStart: Scalars['Boolean']['output'];
};


export type ChallengePlayersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ChallengeConnection = {
  edges: Array<ChallengeEdge>;
  nodes: Array<Challenge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ChallengeCreateInput = {
  checkPointId: Scalars['ID']['input'];
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  isHiddenName?: InputMaybe<Scalars['Boolean']['input']>;
  isLimit?: InputMaybe<Scalars['Boolean']['input']>;
  isMixed?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  settings?: InputMaybe<ChallengeSettingsInput>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ChallengeCreatePayload = {
  challenge?: Maybe<Challenge>;
  userErrors: Array<UserError>;
};

export type ChallengeEdge = {
  cursor: Scalars['Cursor']['output'];
  node: Challenge;
};

export type ChallengeEndInput = {
  challengeId: Scalars['ID']['input'];
};

export type ChallengeEndPayload = {
  challenge?: Maybe<Challenge>;
  userErrors: Array<UserError>;
};

export type ChallengeFilter = {
  activityStatus?: InputMaybe<Array<ActivityStatusChallenge>>;
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  hasCheckPointWith?: InputMaybe<CheckPointFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ChallengePlayer = Node & {
  attempt?: Maybe<UserAttempt>;
  challenge: Challenge;
  challengePlayerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  joinedAt: Scalars['DateTime']['output'];
  learnerProfile: LearnerProfile;
  updatedAt: Scalars['DateTime']['output'];
};

export type ChallengePlayerConnection = {
  edges: Array<ChallengePlayerEdge>;
  nodes: Array<ChallengePlayer>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ChallengePlayerEdge = {
  cursor: Scalars['Cursor']['output'];
  node: ChallengePlayer;
};

export type ChallengePlayerFilter = {
  hasChallengeWith?: InputMaybe<ChallengeFilter>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
};

export type ChallengePlayerJoinInput = {
  challengeId: Scalars['ID']['input'];
};

export type ChallengePlayerJoinPayload = {
  challengePlayer?: Maybe<ChallengePlayer>;
  userErrors: Array<UserError>;
};

export type ChallengeSettings = {
  sound?: Maybe<Scalars['Boolean']['output']>;
};

export type ChallengeSettingsInput = {
  sound: Scalars['Boolean']['input'];
};

export type CheckPoint = Node & {
  adminRank?: Maybe<Scalars['Int']['output']>;
  attemptsAllowed: Scalars['Int']['output'];
  checkPointCustomDomains: Array<CheckPointCustomDomainEdge>;
  checkPointDuolingoParts: Array<CheckPointDuolingoPartEdge>;
  checkPointExamParts: Array<CheckPointExamPartEdge>;
  checkPointId: Scalars['ID']['output'];
  checkPointIeltsListeningParts: Array<CheckPointIeltsListeningPartEdge>;
  checkPointIeltsReadingParts: Array<CheckPointIeltsReadingPartEdge>;
  checkPointIeltsSpeakingParts: Array<CheckPointIeltsSpeakingPartEdge>;
  checkPointIeltsWritingParts: Array<CheckPointIeltsWritingPartEdge>;
  checkPointSpeakingParts: Array<CheckPointSpeakingPartEdge>;
  checkPointWritingParts: Array<CheckPointWritingPartEdge>;
  coin: Scalars['Int']['output'];
  cpType: CheckPointType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionEn?: Maybe<Scalars['String']['output']>;
  diamond?: Maybe<Scalars['Int']['output']>;
  domains?: Maybe<Array<Scalars['ID']['output']>>;
  duolingoParts: Array<DuolingoPart>;
  examStructures?: Maybe<Array<CheckPointExamStructure>>;
  featuredPlaylistCheckPoints: FeaturedPlaylistCheckPointConnection;
  id: Scalars['ID']['output'];
  ieltsBand?: Maybe<Scalars['Float']['output']>;
  ieltsListeningParts: Array<IeltsListeningPart>;
  ieltsNotes: IeltsNoteConnection;
  ieltsReadingParts: Array<IeltsReadingPart>;
  ieltsSpeakingParts: Array<IeltsSpeakingPart>;
  ieltsWritingParts: Array<IeltsWritingPart>;
  image?: Maybe<Image>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isBoss: Scalars['Boolean']['output'];
  isGenerating: Scalars['Boolean']['output'];
  isPremium: Scalars['Boolean']['output'];
  /** @deprecated use levels */
  level: Array<CefrLevel>;
  levels: Array<CefrLevel>;
  listeningTime?: Maybe<Scalars['Duration']['output']>;
  maxGrade?: Maybe<Scalars['Float']['output']>;
  maxScore?: Maybe<Scalars['Float']['output']>;
  meta?: Maybe<CheckPointMeta>;
  name: Scalars['String']['output'];
  nameEn?: Maybe<Scalars['String']['output']>;
  parentCheckPoint?: Maybe<CheckPoint>;
  parentPartOrder?: Maybe<Scalars['Int']['output']>;
  parentStructureType?: Maybe<ExamStructureType>;
  partTypesInfo: Array<PartTypeInfo>;
  partsCount: Scalars['Int']['output'];
  placementTestGroup?: Maybe<PlacementTestGroup>;
  position: Scalars['Int']['output'];
  practiceParts: Array<PracticePart>;
  publicStatus?: Maybe<CheckPointPublicStatus>;
  readingTime?: Maybe<Scalars['Duration']['output']>;
  schoolIds?: Maybe<Array<Scalars['ID']['output']>>;
  sectionCheckPoints: Array<CheckPoint>;
  skills?: Maybe<Array<EnglishSkillV1>>;
  source?: Maybe<Scalars['String']['output']>;
  speakingParts?: Maybe<Array<SpeakingPart>>;
  /** @deprecated use speakingParts instead */
  speakingPartsAll?: Maybe<Array<SpeakingPart>>;
  speakingTime?: Maybe<Scalars['Duration']['output']>;
  star: Scalars['Int']['output'];
  status: CheckPointStatus;
  testCount: Scalars['Int']['output'];
  testLevel?: Maybe<TestLevel>;
  testLevelId?: Maybe<Scalars['ID']['output']>;
  time?: Maybe<Scalars['Duration']['output']>;
  topics: Array<Topic>;
  type: Scalars['CheckPointTypeV1']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  viewerCanAccess: Scalars['Boolean']['output'];
  viewerCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use viewerCompleted instead */
  viewerIeltsCompleted?: Maybe<Scalars['Boolean']['output']>;
  viewerIeltsStar?: Maybe<Scalars['Int']['output']>;
  viewerIsSubscribing: Scalars['Boolean']['output'];
  viewerLatestResumableAttempt?: Maybe<ResumableExamUserAttempt>;
  writingParts: Array<WritingPart>;
  writingTime?: Maybe<Scalars['Duration']['output']>;
};


export type CheckPointFeaturedPlaylistCheckPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<FeaturedPlaylistCheckPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CheckPointIeltsNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<IeltsNoteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CheckPointViewerLatestResumableAttemptArgs = {
  challengeCode?: InputMaybe<Scalars['String']['input']>;
  challengeId?: InputMaybe<Scalars['ID']['input']>;
};

export type CheckPointConnection = {
  edges: Array<CheckPointEdge>;
  nodes: Array<CheckPoint>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CheckPointCustomDomainEdge = {
  createdAt: Scalars['DateTime']['output'];
  node: CustomDomain;
  updatedAt: Scalars['DateTime']['output'];
};

export type CheckPointCustomDomainFilter = {
  and?: InputMaybe<Array<CheckPointCustomDomainFilter>>;
  domainName?: InputMaybe<Array<Scalars['String']['input']>>;
  domainNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSchoolsWith?: InputMaybe<SchoolFilter>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<CheckPointCustomDomainFilter>;
  or?: InputMaybe<Array<CheckPointCustomDomainFilter>>;
  status?: InputMaybe<Array<CustomDomainStatus>>;
};

export type CheckPointDuolingoPartEdge = {
  node: DuolingoPart;
  position: Scalars['Int']['output'];
};

export type CheckPointEdge = {
  cursor: Scalars['Cursor']['output'];
  node: CheckPoint;
};

export type CheckPointExamPartEdge = {
  miniCheckPointId?: Maybe<Scalars['ID']['output']>;
  node: ExamPart;
  order: Scalars['Int']['output'];
};

export type CheckPointExamPartFilter = {
  not?: InputMaybe<CheckPointExamPartFilter>;
  order?: InputMaybe<IntRange>;
  partType?: InputMaybe<Array<ExamPartType>>;
};

export type CheckPointExamStructure = {
  maxScore: Scalars['Float']['output'];
  parts: Array<CheckPointExamPartEdge>;
  structureType: ExamStructureTypeInfo;
  time: Scalars['Duration']['output'];
  totalMarks: Scalars['Int']['output'];
};

export type CheckPointFeaturedPlaylistEdge = {
  createdAt: Scalars['DateTime']['output'];
  featuredPlaylistCheckPointsId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  node: FeaturedPlaylist;
  updatedAt: Scalars['DateTime']['output'];
};

export type CheckPointFilter = {
  ID?: InputMaybe<Array<Scalars['ID']['input']>>;
  and?: InputMaybe<Array<CheckPointFilter>>;
  cpType?: InputMaybe<Array<CheckPointType>>;
  domains?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasCustomDomainsWith?: InputMaybe<CheckPointCustomDomainFilter>;
  hasDomains?: InputMaybe<Scalars['Boolean']['input']>;
  hasExamPartsWith?: InputMaybe<CheckPointExamPartFilter>;
  hasFeaturedPlaylistCheckPointsWith?: InputMaybe<FeaturedPlaylistCheckPointFilter>;
  hasIeltsNotesWith?: InputMaybe<IeltsNoteFilter>;
  hasSpeakingPartsWith?: InputMaybe<CheckPointSpeakingPartFilter>;
  hasTestLevelWith?: InputMaybe<TestLevelFilter>;
  hasTopicsWith?: InputMaybe<CheckPointTopicFilter>;
  ieltsBand?: InputMaybe<FloatRange>;
  levels?: InputMaybe<Array<CefrLevel>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  nameEn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nameEnQ?: InputMaybe<Array<Scalars['String']['input']>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<CheckPointFilter>;
  or?: InputMaybe<Array<CheckPointFilter>>;
  publicStatus?: InputMaybe<Array<CheckPointPublicStatus>>;
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  skills?: InputMaybe<Array<EnglishSkillV1>>;
  source?: InputMaybe<Array<Scalars['String']['input']>>;
  sourcePlacementTestExam?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceSchool?: InputMaybe<SourceSchool>;
  status?: InputMaybe<Array<CheckPointStatus>>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
  testLevelId?: InputMaybe<Array<Scalars['ID']['input']>>;
  time?: InputMaybe<DurationRange>;
  type?: InputMaybe<Array<Scalars['CheckPointTypeV1']['input']>>;
  viewerCanAccess?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckPointIeltsListeningPartEdge = {
  node: IeltsListeningPart;
  position: Scalars['Int']['output'];
};

export type CheckPointIeltsListeningPartInput = {
  partId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type CheckPointIeltsReadingPartEdge = {
  node: IeltsReadingPart;
  position: Scalars['Int']['output'];
};

export type CheckPointIeltsReadingPartInput = {
  partId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type CheckPointIeltsSpeakingPartEdge = {
  node: IeltsSpeakingPart;
  position: Scalars['Int']['output'];
};

export type CheckPointIeltsSpeakingPartInput = {
  partId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type CheckPointIeltsWritingPartEdge = {
  node: IeltsWritingPart;
  position: Scalars['Int']['output'];
};

export type CheckPointIeltsWritingPartInput = {
  partId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type CheckPointMeta = {
  externalUrl?: Maybe<Scalars['String']['output']>;
};

export type CheckPointOrder = {
  key?: InputMaybe<CheckPointOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CheckPointOrderKey {
  AdminRank = 'ADMIN_RANK',
  TestCount = 'TEST_COUNT',
  TestLevelOrder = 'TEST_LEVEL_ORDER',
  TypePosition = 'TYPE_POSITION'
}

export enum CheckPointPublicStatus {
  Community = 'COMMUNITY'
}

export type CheckPointRemoveIeltsListeningPartsPayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type CheckPointRemoveIeltsReadingPartsPayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type CheckPointRemoveIeltsSpeakingPartsPayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type CheckPointRemoveIeltsWritingPartsPayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type CheckPointSpeakingPartEdge = {
  node: SpeakingPart;
  order: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
};

export type CheckPointSpeakingPartFilter = {
  not?: InputMaybe<CheckPointSpeakingPartFilter>;
  order?: InputMaybe<IntRange>;
  partType?: InputMaybe<Array<SpeakingPartType>>;
};

export type CheckPointSpeakingPartInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  partId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export enum CheckPointStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type CheckPointTimeUpdateInput = {
  checkpointIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  partId?: InputMaybe<Scalars['ID']['input']>;
  typeCheckpoint: TypeCheckPointAdmin;
};

export type CheckPointTimeUpdatePayload = {
  data: Scalars['String']['output'];
  userErrors: Array<UserError>;
};

export type CheckPointTopicEdge = {
  createdAt: Scalars['DateTime']['output'];
  cursor: Scalars['Cursor']['output'];
  node: Topic;
};

export type CheckPointTopicFilter = {
  nameEnQ?: InputMaybe<Array<Scalars['String']['input']>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum CheckPointType {
  Normal = 'NORMAL',
  PlacementTest = 'PLACEMENT_TEST'
}

export type CheckPointUpdateIeltsListeningPartsPayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type CheckPointUpdateIeltsReadingPartsPayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type CheckPointUpdateIeltsSpeakingPartsPayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type CheckPointUpdateIeltsWritingPartsPayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type CheckPointWritingPartEdge = {
  node: WritingPart;
  order: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
};

export type CheckPointWritingPartInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  partId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckPointsByCefrLevel = {
  cefrLevelInfo: CefrLevelInfo;
  checkPoints: Array<CheckPoint>;
  testLevels: Array<TestLevel>;
  totalCount: Scalars['Int']['output'];
};

export type Class = Node & {
  assignedTeachers: ClassAssignedTeacherConnection;
  attemptStats?: Maybe<AttemptStats>;
  classId: Scalars['ID']['output'];
  classLevel: ClassLevel;
  classStudents: ClassStudentConnection;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  onboardStep: Scalars['Int']['output'];
  pin: Scalars['Boolean']['output'];
  school: School;
  studentsCount: Scalars['Int']['output'];
  targetNotification: Scalars['Boolean']['output'];
  teacherCount: Scalars['Int']['output'];
  teacherId: Scalars['ID']['output'];
  teacherProfile: TeacherProfile;
  totalRequestReviewAttemptUnseen: Scalars['Int']['output'];
  type: ClassType;
  updatedAt: Scalars['DateTime']['output'];
  weeklyTimeTarget?: Maybe<Scalars['Duration']['output']>;
};


export type ClassAssignedTeachersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<ClassAssignedTeacherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ClassAttemptStatsArgs = {
  dateRange?: InputMaybe<DateTimeRange>;
};


export type ClassClassStudentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<ClassStudentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ClassTotalRequestReviewAttemptUnseenArgs = {
  testLevelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeAttempt?: InputMaybe<TypeAttempt>;
};

export type ClassAssignedTeacherConnection = {
  edges: Array<ClassAssignedTeacherEdge>;
  nodes: Array<TeacherProfile>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ClassAssignedTeacherEdge = {
  assignedAt: Scalars['DateTime']['output'];
  cursor: Scalars['Cursor']['output'];
  node: TeacherProfile;
};

export type ClassAssignedTeacherFilter = {
  id: Array<Scalars['ID']['input']>;
  q?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClassCompletedTest = {
  class: Class;
  value: Scalars['Int']['output'];
};

export type ClassConnection = {
  edges: Array<ClassEdge>;
  nodes: Array<Class>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ClassEdge = {
  cursor: Scalars['Cursor']['output'];
  node: Class;
};

export type ClassFilter = {
  classLevelId?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<DateTimeRange>;
  hasAssignedTeachersWith?: InputMaybe<ClassAssignedTeacherFilter>;
  hasSchoolWith?: InputMaybe<SchoolFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<ClassType>>;
};

export type ClassLevel = Node & {
  ageRange: Scalars['String']['output'];
  classLevelId: Scalars['ID']['output'];
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  testLevels: Array<TestLevel>;
  type: ClassType;
};

export type ClassOrder = {
  key?: InputMaybe<ClassOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ClassOrderKey {
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  LevelName = 'LEVEL_NAME',
  Name = 'NAME',
  Pin = 'PIN',
  Type = 'TYPE'
}

export type ClassStudent = Node & {
  class?: Maybe<Class>;
  classID: Scalars['ID']['output'];
  classStudentId: Scalars['ID']['output'];
  customName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  joinedDate: Scalars['DateTime']['output'];
  student: LearnerProfile;
  studentID: Scalars['ID']['output'];
  targetScore?: Maybe<Scalars['String']['output']>;
  testLevel?: Maybe<TestLevel>;
};

export type ClassStudentConnection = {
  edges: Array<ClassStudentEdge>;
  nodes: Array<ClassStudent>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ClassStudentEdge = {
  cursor: Scalars['Cursor']['output'];
  node: ClassStudent;
};

export type ClassStudentFilter = {
  classID?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasClassWith?: InputMaybe<ClassFilter>;
  q?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClassStudentOrder = {
  key?: InputMaybe<ClassStudentOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ClassStudentOrderKey {
  ClassName = 'CLASS_NAME',
  JoinedDate = 'JOINED_DATE',
  StudentDateOfBirth = 'STUDENT_DATE_OF_BIRTH',
  StudentDisplayName = 'STUDENT_DISPLAY_NAME'
}

export type ClassStudyTime = {
  class: Class;
  value: Scalars['Duration']['output'];
};

export enum ClassType {
  Classic = 'CLASSIC',
  Ielts = 'IELTS',
  PlacementTest = 'PLACEMENT_TEST'
}

export type ClassesCompletedTestByDay = {
  date: Scalars['String']['output'];
  items: Array<ClassCompletedTest>;
  value: Scalars['Int']['output'];
};

export type ClassesStudyTimeByDay = {
  date: Scalars['String']['output'];
  items: Array<ClassStudyTime>;
  value: Scalars['Duration']['output'];
};

export type ComparedValueDuration = {
  change?: Maybe<Scalars['Float']['output']>;
  comparedValue?: Maybe<Scalars['Duration']['output']>;
  value: Scalars['Duration']['output'];
};

export type ComparedValueFloat = {
  change?: Maybe<Scalars['Float']['output']>;
  comparedValue?: Maybe<Scalars['Float']['output']>;
  value: Scalars['Float']['output'];
};

export type ComparedValueInt = {
  change?: Maybe<Scalars['Float']['output']>;
  comparedValue?: Maybe<Scalars['Int']['output']>;
  value: Scalars['Int']['output'];
};

export type CountryCode = Node & {
  countryCodeId: Scalars['ID']['output'];
  dialCode: Scalars['String']['output'];
  flag: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CreateTeacherProfileAdminInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type CustomDomain = Node & {
  checkPoints: CustomDomainCheckPointConnection;
  createdAt: Scalars['DateTime']['output'];
  customDomainId: Scalars['ID']['output'];
  disabledStudentChangeName?: Maybe<Scalars['Boolean']['output']>;
  disabledStudentLeaveClass: Scalars['Boolean']['output'];
  disabledUpdatePhoneNumber: Scalars['Boolean']['output'];
  domainName?: Maybe<Scalars['String']['output']>;
  enabledStudentManagement: Scalars['Boolean']['output'];
  fullDomainName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  meta?: Maybe<DomainData>;
  rejectedDomainName?: Maybe<Scalars['String']['output']>;
  showDiamond: Scalars['Boolean']['output'];
  showWallet: Scalars['Boolean']['output'];
  status: CustomDomainStatus;
  teacherID: Scalars['Int']['output'];
  teacherProfile: TeacherProfile;
  updatedAt: Scalars['DateTime']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
  userPhoneNumber?: Maybe<Scalars['String']['output']>;
};


export type CustomDomainCheckPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomDomainCheckPointConnection = {
  edges: Array<CustomDomainCheckPointEdge>;
  nodes: Array<CheckPoint>;
  pageInfo: PageInfo;
};

export type CustomDomainCheckPointEdge = {
  createdAt: Scalars['DateTime']['output'];
  cursor: Scalars['Cursor']['output'];
  node: CheckPoint;
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomDomainConnection = {
  edges: Array<CustomDomainEdge>;
  nodes: Array<CustomDomain>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomDomainEdge = {
  cursor: Scalars['Cursor']['output'];
  node: CustomDomain;
};

export type CustomDomainFilter = {
  domainNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSchoolsWith?: InputMaybe<SchoolFilter>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  rejectedDomainNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<CustomDomainStatus>>;
};

export enum CustomDomainStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type DailyReward = Node & {
  coin?: Maybe<Scalars['Int']['output']>;
  dailyRewardId: Scalars['ID']['output'];
  dayNumber: Scalars['Int']['output'];
  diamond?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  viewerClaimed: Scalars['Boolean']['output'];
};

export type DataSpeech = {
  displayText?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  nBest?: Maybe<Array<Maybe<NBest>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  recognitionStatus?: Maybe<Scalars['String']['output']>;
};

export type DateRangeInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type DateTimeRange = {
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum DeviceType {
  Bot = 'bot',
  Desktop = 'desktop',
  Mobile = 'mobile',
  Tablet = 'tablet',
  Tv = 'tv',
  Unknown = 'unknown'
}

export type Dictionary = {
  en?: Maybe<DictionaryData>;
  full?: Maybe<Scalars['String']['output']>;
  vi?: Maybe<DictionaryData>;
};

export type DictionaryData = {
  content?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
};

export type Discount = Node & {
  amount: Scalars['Float']['output'];
  campaignMinimumAmount?: Maybe<Scalars['Float']['output']>;
  campaignMinimumItem?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  diamond?: Maybe<Scalars['Int']['output']>;
  discountId: Scalars['ID']['output'];
  discountType: DiscountDiscountType;
  endDate: Scalars['DateTime']['output'];
  eventType: DiscountEventType;
  id: Scalars['ID']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  maxDiscount?: Maybe<Scalars['Float']['output']>;
  oneTime: Scalars['Boolean']['output'];
  startDate: Scalars['DateTime']['output'];
  status: DiscountStatus;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
  uses: Scalars['Int']['output'];
};

export type DiscountConnection = {
  edges: Array<DiscountEdge>;
  nodes: Array<Discount>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum DiscountDiscountType {
  Amount = 'AMOUNT',
  Percent = 'PERCENT'
}

export type DiscountEdge = {
  cursor: Scalars['Cursor']['output'];
  node: Discount;
};

export enum DiscountEventType {
  Automatic = 'AUTOMATIC',
  CouponCode = 'COUPON_CODE'
}

export type DiscountFilter = {
  codeQ?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<DateTimeRange>;
  eventType?: InputMaybe<Array<DiscountEventType>>;
  startDate?: InputMaybe<DateTimeRange>;
  status?: InputMaybe<Array<DiscountStatus>>;
};

export type DiscountPayload = {
  discount?: Maybe<Discount>;
  price?: Maybe<Scalars['Float']['output']>;
};

export enum DiscountStatus {
  Active = 'ACTIVE',
  InActive = 'IN_ACTIVE'
}

export type DisplayableError = {
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

export type DomainData = {
  examBackgroundImage?: Maybe<Image>;
  examBackgroundImageID?: Maybe<Scalars['String']['output']>;
  examLogoImage?: Maybe<Image>;
  examLogoImageID?: Maybe<Scalars['String']['output']>;
  featureDescription?: Maybe<Scalars['String']['output']>;
  featureImage?: Maybe<Image>;
  featureTitle?: Maybe<Scalars['String']['output']>;
  loginTitle?: Maybe<Scalars['String']['output']>;
  loginTitleEn?: Maybe<Scalars['String']['output']>;
  logoImage?: Maybe<Image>;
  logoImageID?: Maybe<Scalars['String']['output']>;
};

export type DomainDataInput = {
  examBackgroundImageID?: InputMaybe<Scalars['String']['input']>;
  examLogoImageID?: InputMaybe<Scalars['String']['input']>;
  featureDescription?: InputMaybe<Scalars['String']['input']>;
  featureImageID?: InputMaybe<Scalars['String']['input']>;
  featureTitle?: InputMaybe<Scalars['String']['input']>;
  loginTitle?: InputMaybe<Scalars['String']['input']>;
  loginTitleEn?: InputMaybe<Scalars['String']['input']>;
  logoImageID?: InputMaybe<Scalars['String']['input']>;
};

export type DuolingoChallenge = {
  choices?: Maybe<Array<DuolingoOption>>;
  pairs?: Maybe<Array<DuolingoPair>>;
  prompts?: Maybe<Array<DuolingoPrompt>>;
  textSolutions?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<DuolingoChallengeType>;
};

export type DuolingoChallengeAnswer = {
  choice?: Maybe<DuolingoOption>;
  choices?: Maybe<Array<DuolingoOption>>;
  pair?: Maybe<DuolingoPair>;
  record?: Maybe<Audio>;
  recordId?: Maybe<Scalars['String']['output']>;
  recordText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type DuolingoChallengeAnswerInput = {
  choice?: InputMaybe<DuolingoOptionInput>;
  choices?: InputMaybe<Array<DuolingoOptionInput>>;
  pair?: InputMaybe<DuolingoPairInput>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type DuolingoChallengeInput = {
  choices?: InputMaybe<Array<DuolingoOptionInput>>;
  pairs?: InputMaybe<Array<DuolingoPairInput>>;
  prompts?: InputMaybe<Array<DuolingoPromptInput>>;
  textSolutions?: InputMaybe<Array<Scalars['String']['input']>>;
  type: DuolingoChallengeType;
};

export enum DuolingoChallengeType {
  Assist = 'ASSIST',
  Dialogue = 'DIALOGUE',
  DragDrop = 'DRAG_DROP',
  Flashcards = 'FLASHCARDS',
  FlashcardsFill = 'FLASHCARDS_FILL',
  ImageFill = 'IMAGE_FILL',
  ImageMatch = 'IMAGE_MATCH',
  ImageSelect = 'IMAGE_SELECT',
  ImageTap = 'IMAGE_TAP',
  ImageTapComplete = 'IMAGE_TAP_COMPLETE',
  Listen = 'LISTEN',
  ListenIsolation = 'LISTEN_ISOLATION',
  ListenMatch = 'LISTEN_MATCH',
  ListenTap = 'LISTEN_TAP',
  Match = 'MATCH',
  Select = 'SELECT',
  SelectObject = 'SELECT_OBJECT',
  SelectTranscription = 'SELECT_TRANSCRIPTION',
  Speak = 'SPEAK',
  StoryTap = 'STORY_TAP',
  StoryTapComplete = 'STORY_TAP_COMPLETE',
  TapComplete = 'TAP_COMPLETE',
  Translate = 'TRANSLATE',
  TranslateTap = 'TRANSLATE_TAP',
  TrueFalse = 'TRUE_FALSE',
  WordOrdering = 'WORD_ORDERING',
  YesNo = 'YES_NO'
}

export type DuolingoCharacter = {
  image: Image;
  imageId: Scalars['ID']['output'];
};

export type DuolingoCharacterInput = {
  imageId?: InputMaybe<Scalars['ID']['input']>;
};

export type DuolingoEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type DuolingoEndAttemptPayload = {
  userErrors: Array<UserError>;
};

export type DuolingoImagePlaceholder = {
  height?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  left: Scalars['String']['output'];
  top: Scalars['String']['output'];
  width?: Maybe<Scalars['String']['output']>;
};

export type DuolingoImagePlaceholderInput = {
  height?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  left: Scalars['String']['input'];
  top: Scalars['String']['input'];
  width?: InputMaybe<Scalars['String']['input']>;
};

export enum DuolingoLevelType {
  CheckPoints = 'CHECK_POINTS'
}

export type DuolingoOption = {
  audio?: Maybe<Audio>;
  audioId?: Maybe<Scalars['ID']['output']>;
  correctPlaceholderId?: Maybe<Scalars['ID']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
  imageId?: Maybe<Scalars['ID']['output']>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  left?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  top?: Maybe<Scalars['String']['output']>;
  unselectable?: Maybe<Scalars['Boolean']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type DuolingoOptionInput = {
  audioId?: InputMaybe<Scalars['ID']['input']>;
  correctPlaceholderId?: InputMaybe<Scalars['ID']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  top?: InputMaybe<Scalars['String']['input']>;
  unselectable?: InputMaybe<Scalars['Boolean']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type DuolingoPair = {
  from: DuolingoOption;
  to: DuolingoOption;
};

export type DuolingoPairInput = {
  from: DuolingoOptionInput;
  to: DuolingoOptionInput;
};

export type DuolingoPart = Node & {
  challenge?: Maybe<DuolingoChallenge>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  duolingoPartId: Scalars['ID']['output'];
  expiredTime?: Maybe<Scalars['Duration']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  story?: Maybe<DuolingoStory>;
  title: Scalars['String']['output'];
  type: DuolingoPartType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type DuolingoPartAnswer = {
  challenge?: Maybe<DuolingoChallengeAnswer>;
  story?: Maybe<DuolingoStoryAnswer>;
};

export type DuolingoPartAnswerInput = {
  challenge?: InputMaybe<DuolingoChallengeAnswerInput>;
  story?: InputMaybe<DuolingoStoryAnswerInput>;
};

export type DuolingoPartAttempt = Node & {
  challengeAnswer?: Maybe<DuolingoChallengeAnswer>;
  duolingoPartAttemptId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isCorrect: Scalars['Boolean']['output'];
  isFirstScore: Scalars['Boolean']['output'];
  part: DuolingoPart;
  storyAnswer?: Maybe<DuolingoStoryAnswer>;
};

export type DuolingoPartConnection = {
  edges: Array<DuolingoPartEdge>;
  nodes: Array<DuolingoPart>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DuolingoPartEdge = {
  cursor: Scalars['Cursor']['output'];
  node: DuolingoPart;
};

export type DuolingoPartFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum DuolingoPartType {
  DragDrop = 'DRAG_DROP',
  FillInBlank = 'FILL_IN_BLANK',
  Flashcard = 'FLASHCARD',
  GapFill = 'GAP_FILL',
  Matching = 'MATCHING',
  MultipleChoice = 'MULTIPLE_CHOICE',
  ScrambledSentence = 'SCRAMBLED_SENTENCE',
  SelectObject = 'SELECT_OBJECT',
  Speaking = 'SPEAKING',
  Story = 'STORY',
  WordOrdering = 'WORD_ORDERING'
}

export type DuolingoPrompt = {
  audio?: Maybe<Audio>;
  audioId?: Maybe<Scalars['ID']['output']>;
  character?: Maybe<DuolingoCharacter>;
  content?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
  imageAudio?: Maybe<Audio>;
  imageAudioId?: Maybe<Scalars['String']['output']>;
  imageContent?: Maybe<Scalars['String']['output']>;
  imageDescription?: Maybe<Scalars['String']['output']>;
  imageId?: Maybe<Scalars['ID']['output']>;
  imagePlaceholders?: Maybe<Array<DuolingoImagePlaceholder>>;
  showCharacter: Scalars['Boolean']['output'];
  slowAudio?: Maybe<Audio>;
  slowAudioId?: Maybe<Scalars['ID']['output']>;
  tokens?: Maybe<Array<DuolingoToken>>;
  zoomedImage?: Maybe<Image>;
  zoomedImageId?: Maybe<Scalars['ID']['output']>;
};

export type DuolingoPromptInput = {
  audioId?: InputMaybe<Scalars['ID']['input']>;
  character?: InputMaybe<DuolingoCharacterInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  imageAudioId?: InputMaybe<Scalars['ID']['input']>;
  imageContent?: InputMaybe<Scalars['String']['input']>;
  imageDescription?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  imagePlaceholders?: InputMaybe<Array<DuolingoImagePlaceholderInput>>;
  showCharacter?: InputMaybe<Scalars['Boolean']['input']>;
  slowAudioId?: InputMaybe<Scalars['ID']['input']>;
  tokens?: InputMaybe<Array<DuolingoTokenInput>>;
  zoomedImageId?: InputMaybe<Scalars['ID']['input']>;
};

export type DuolingoStartAttemptInput = {
  assignTestID?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
};

export type DuolingoStartAttemptPayload = {
  attemptId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type DuolingoStory = {
  elements: Array<DuolingoStoryElement>;
};

export type DuolingoStoryAnswer = {
  choice?: Maybe<DuolingoOption>;
  elementIndex: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type DuolingoStoryAnswerInput = {
  choice?: InputMaybe<DuolingoOptionInput>;
  elementIndex: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type DuolingoStoryElement = {
  line?: Maybe<DuolingoPrompt>;
  question?: Maybe<DuolingoStoryQuestion>;
  type: DuolingoStoryElementType;
};

export type DuolingoStoryElementInput = {
  line?: InputMaybe<DuolingoPromptInput>;
  question?: InputMaybe<DuolingoStoryQuestionInput>;
  type: DuolingoStoryElementType;
};

export enum DuolingoStoryElementType {
  GapFill = 'GAP_FILL',
  Header = 'HEADER',
  Line = 'LINE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  PointToPhrase = 'POINT_TO_PHRASE',
  SelectPhrase = 'SELECT_PHRASE'
}

export type DuolingoStoryInput = {
  elements: Array<DuolingoStoryElementInput>;
};

export type DuolingoStoryQuestion = {
  choices?: Maybe<Array<DuolingoOption>>;
  textSolutions?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DuolingoStoryQuestionInput = {
  choices?: InputMaybe<Array<DuolingoOptionInput>>;
  textSolutions?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DuolingoSubmitPartAttemptInput = {
  answer: DuolingoPartAnswerInput;
  attemptId: Scalars['ID']['input'];
  partId: Scalars['ID']['input'];
};

export type DuolingoSubmitPartAttemptPayload = {
  answer?: Maybe<DuolingoPartAnswer>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  userErrors: Array<UserError>;
};

export type DuolingoToken = {
  audio?: Maybe<Audio>;
  audioId?: Maybe<Scalars['ID']['output']>;
  isBlank: Scalars['Boolean']['output'];
  rows?: Maybe<Array<DuolingoTokenRow>>;
  token: Scalars['String']['output'];
};

export type DuolingoTokenInput = {
  audioId?: InputMaybe<Scalars['ID']['input']>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<DuolingoTokenRowInput>>;
  token: Scalars['String']['input'];
};

export type DuolingoTokenRow = {
  hint: Scalars['String']['output'];
};

export type DuolingoTokenRowInput = {
  hint: Scalars['String']['input'];
};

export type DurationRange = {
  gt?: InputMaybe<Scalars['Duration']['input']>;
  gte?: InputMaybe<Scalars['Duration']['input']>;
  lt?: InputMaybe<Scalars['Duration']['input']>;
  lte?: InputMaybe<Scalars['Duration']['input']>;
};

export type EmailProviderInfo = {
  associatedPhoneNumber?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  isFirstLogin: Scalars['Boolean']['output'];
  needEmailVerified: Scalars['Boolean']['output'];
  provider: Scalars['String']['output'];
};

export type EmailResendVerificationPayload = {
  userErrors: Array<UserError>;
};

export enum EnglishSkillV1 {
  Listening = 'listening',
  Reading = 'reading',
  Speaking = 'speaking',
  Writing = 'writing'
}

export type ExamEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type ExamEndAttemptPayload = {
  userErrors: Array<UserError>;
};

export type ExamNextStructureInput = {
  attemptId: Scalars['ID']['input'];
};

export type ExamNextStructurePayload = {
  resumableAttempt?: Maybe<ResumableExamUserAttempt>;
  userErrors: Array<UserError>;
};

export type ExamPart = Node & {
  answerExplanationHTML?: Maybe<Scalars['String']['output']>;
  answerExplanationHTMLEn?: Maybe<Scalars['String']['output']>;
  /** @deprecated use answerExplanationHtml instead */
  answerExplanationHtml?: Maybe<Scalars['String']['output']>;
  body?: Maybe<ExamPartBody>;
  contents: Array<ExamPartContent>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  examPartId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  maxScore: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  partType: ExamPartType;
  questions: Array<ExamQuestion>;
  structureType: ExamStructureType;
  time?: Maybe<Scalars['Duration']['output']>;
  title: Scalars['String']['output'];
  totalMarks: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

export type ExamPartAttempt = Node & {
  examPartAttemptId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated use score detail instead */
  maxScore: Scalars['Float']['output'];
  part: ExamPart;
  /** @deprecated removed */
  position: Scalars['Int']['output'];
  questionDetailAttempts: Array<ExamQuestionDetailAttempt>;
  /** @deprecated use score detail instead */
  score: Scalars['Float']['output'];
  scoreDetail: ExamPartAttemptScoreDetail;
};

export type ExamPartAttemptScoreDetail = {
  maxScore: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
};

export type ExamPartBody = {
  contentImage?: Maybe<Image>;
  contentImageId?: Maybe<Scalars['ID']['output']>;
  contentImagePrompt?: Maybe<Scalars['String']['output']>;
};

export type ExamPartBodyInput = {
  contentImageId?: InputMaybe<Scalars['String']['input']>;
  contentImagePrompt?: InputMaybe<Scalars['String']['input']>;
};

export type ExamPartConnection = {
  edges: Array<ExamPartEdge>;
  nodes: Array<ExamPart>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ExamPartContent = Node & {
  body: ExamPartContentBody;
  createdAt: Scalars['DateTime']['output'];
  examPartContentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  part: ExamPart;
  position: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ExamPartContentBody = {
  formattedText?: Maybe<ExamQuestionFormattedText>;
  images?: Maybe<Array<ExamPartContentImage>>;
};

export type ExamPartContentImage = {
  imageId: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
};

export type ExamPartEdge = {
  cursor: Scalars['Cursor']['output'];
  node: ExamPart;
};

export type ExamPartFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  partType?: InputMaybe<Array<ExamPartType>>;
  structureType?: InputMaybe<Array<ExamStructureType>>;
  title?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ExamPartType {
  SceneCardSpeaking = 'SCENE_CARD_SPEAKING',
  Speaking = 'SPEAKING',
  Dragdrop = 'dragdrop',
  Gapfill = 'gapfill',
  Matching = 'matching',
  Multichoice = 'multichoice',
  ScrambledSentence = 'scrambled_sentence',
  WordOrdering = 'word_ordering'
}

export type ExamPartTypeInfo = {
  name: Scalars['String']['output'];
  value: ExamPartType;
};

export type ExamQuestion = Node & {
  answerExplanationHTML?: Maybe<Scalars['String']['output']>;
  answerExplanationHTMLEn?: Maybe<Scalars['String']['output']>;
  /** @deprecated use answerExplanationHtml instead */
  answerExplanationHtml?: Maybe<Scalars['String']['output']>;
  body?: Maybe<ExamQuestionBody>;
  choices?: Maybe<Array<ExamQuestionFormattedText>>;
  content?: Maybe<ExamQuestionFormattedText>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  detailPrefix?: Maybe<ExamQuestionFormattedText>;
  details: Array<ExamQuestionDetail>;
  id: Scalars['ID']['output'];
  isExample: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  titlePrefix?: Maybe<ExamQuestionFormattedText>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

export type ExamQuestionBody = {
  audio?: Maybe<Audio>;
  audioId?: Maybe<Scalars['ID']['output']>;
  audioSubtitle?: Maybe<Scalars['String']['output']>;
  exampleAnswers?: Maybe<Array<Scalars['String']['output']>>;
  point?: Maybe<SpeakingPoint>;
  videoPrompt?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type ExamQuestionBodyInput = {
  audioId?: InputMaybe<Scalars['String']['input']>;
  audioSubtitle?: InputMaybe<Scalars['String']['input']>;
  exampleAnswers?: InputMaybe<Array<Scalars['String']['input']>>;
  point?: InputMaybe<SpeakingPointInput>;
  videoPrompt?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ExamQuestionCreateInput = {
  addDetails?: InputMaybe<Array<ExamQuestionDetailCreateInput>>;
  answerExplanationHTML?: InputMaybe<Scalars['String']['input']>;
  answerExplanationHTMLEn?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<ExamQuestionBodyInput>;
  choices?: InputMaybe<Array<ExamQuestionFormattedTextInput>>;
  content?: InputMaybe<ExamQuestionFormattedTextInput>;
  detailPrefix?: InputMaybe<ExamQuestionFormattedTextInput>;
  isExample?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  titlePrefix?: InputMaybe<ExamQuestionFormattedTextInput>;
};

export type ExamQuestionDetail = Node & {
  detail?: Maybe<ExamQuestionDetailValue>;
  id: Scalars['ID']['output'];
  labelOrder: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  result?: Maybe<ExamQuestionResultValue>;
};

export type ExamQuestionDetailAnswerInput = {
  answer?: InputMaybe<ExamQuestionResultValueInput>;
  detailId: Scalars['ID']['input'];
};

export type ExamQuestionDetailAttempt = Node & {
  answer?: Maybe<ExamQuestionResultValue>;
  examQuestionDetailAttemptId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isCorrect: Scalars['Boolean']['output'];
  questionDetail: ExamQuestionDetail;
  result?: Maybe<ExamQuestionResultValue>;
};

export type ExamQuestionDetailBox = {
  height: Scalars['String']['output'];
  left: Scalars['String']['output'];
  top: Scalars['String']['output'];
  width: Scalars['String']['output'];
};

export type ExamQuestionDetailCreateInput = {
  result?: InputMaybe<ExamQuestionResultValueInput>;
};

export type ExamQuestionDetailTextIndex = {
  index: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type ExamQuestionDetailValue = {
  box?: Maybe<ExamQuestionDetailBox>;
  formattedText?: Maybe<ExamQuestionFormattedText>;
  /** @deprecated use formattedText instead */
  text?: Maybe<Scalars['String']['output']>;
  textIndexes?: Maybe<Array<ExamQuestionDetailTextIndex>>;
  valueType: ExamQuestionDetailValueType;
};

export enum ExamQuestionDetailValueType {
  Box = 'BOX',
  FormattedText = 'FORMATTED_TEXT',
  TextIndexes = 'TEXT_INDEXES'
}

export type ExamQuestionFormattedText = {
  format: ExamQuestionTextFormat;
  label?: Maybe<Scalars['String']['output']>;
  metadataText?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type ExamQuestionFormattedTextInput = {
  format: ExamQuestionTextFormat;
  text: Scalars['String']['input'];
};

export type ExamQuestionResultValue = {
  formattedValue?: Maybe<ExamQuestionFormattedText>;
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  record?: Maybe<Audio>;
  recordId?: Maybe<Scalars['ID']['output']>;
  recordText?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<Scalars['String']['output']>>;
  valueType: ExamQuestionResultValueType;
};

export type ExamQuestionResultValueInput = {
  formattedValue?: InputMaybe<ExamQuestionFormattedTextInput>;
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  recordId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ExamQuestionResultValueType {
  FormattedValue = 'FORMATTED_VALUE',
  IsSelected = 'IS_SELECTED',
  Record = 'RECORD',
  Value = 'VALUE'
}

export enum ExamQuestionTextFormat {
  AudioId = 'AUDIO_ID',
  Color = 'COLOR',
  Html = 'HTML',
  ImageId = 'IMAGE_ID',
  Text = 'TEXT'
}

export type ExamQuestionUpdateInput = {
  answerExplanationHTML?: InputMaybe<Scalars['String']['input']>;
  answerExplanationHTMLEn?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<ExamQuestionBodyInput>;
  choices?: InputMaybe<Array<ExamQuestionFormattedTextInput>>;
  content?: InputMaybe<ExamQuestionFormattedTextInput>;
  detailPrefix?: InputMaybe<ExamQuestionFormattedTextInput>;
  id: Scalars['ID']['input'];
  isExample?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titlePrefix?: InputMaybe<ExamQuestionFormattedTextInput>;
};

export type ExamStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  challengeCode?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  teacherInvitation?: InputMaybe<TeacherInvitationInput>;
};

export type ExamStartAttemptPayload = {
  attemptId?: Maybe<Scalars['ID']['output']>;
  resumableAttempt?: Maybe<ResumableExamUserAttempt>;
  userErrors: Array<UserError>;
};

export type ExamStructureAttempt = {
  certification?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use structureType instead */
  examType: Scalars['String']['output'];
  ketPetScore?: Maybe<KetPetScore>;
  partAttempts: Array<ExamPartAttempt>;
  structureType: ExamStructureTypeInfo;
  totalCorrectMarks: Scalars['Int']['output'];
  totalIncorrectMarks: Scalars['Int']['output'];
  totalMarks: Scalars['Int']['output'];
  totalMaxScore: Scalars['Float']['output'];
  totalScore: Scalars['Float']['output'];
};

export enum ExamStructureType {
  Listening = 'listening',
  ReadingWriting = 'reading_writing',
  Speaking = 'speaking'
}

export type ExamStructureTypeInfo = {
  name: Scalars['String']['output'];
  value: ExamStructureType;
};

export type ExamSubmitPartAttemptInput = {
  attemptId: Scalars['ID']['input'];
  details: Array<ExamQuestionDetailAnswerInput>;
  partId: Scalars['ID']['input'];
};

export type ExamSubmitPartAttemptPayload = {
  userErrors: Array<UserError>;
};

export type FeaturedPlaylist = Node & {
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionEn?: Maybe<Scalars['String']['output']>;
  featuredPlaylistCheckPoints: FeaturedPlaylistCheckPointConnection;
  featuredPlaylistsId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  imageId?: Maybe<Scalars['String']['output']>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  levels: Array<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  publishMode: FeaturedPlaylistPublishMode;
  teacherProfile: TeacherProfile;
  title: Scalars['String']['output'];
  titleEn: Scalars['String']['output'];
  totalView: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type FeaturedPlaylistFeaturedPlaylistCheckPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<FeaturedPlaylistCheckPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FeaturedPlaylistCheckPoint = Node & {
  checkPoint: CheckPoint;
  createdAt: Scalars['DateTime']['output'];
  featuredPlaylist: FeaturedPlaylist;
  featuredPlaylistCheckPointId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FeaturedPlaylistCheckPointConnection = {
  edges: Array<FeaturedPlaylistCheckPointEdge>;
  nodes: Array<FeaturedPlaylistCheckPoint>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FeaturedPlaylistCheckPointEdge = {
  cursor: Scalars['Cursor']['output'];
  node: FeaturedPlaylistCheckPoint;
};

export type FeaturedPlaylistCheckPointFilter = {
  hasCheckPointWith?: InputMaybe<CheckPointFilter>;
  hasFeaturedPlaylistWith?: InputMaybe<FeaturedPlaylistFilter>;
};

export type FeaturedPlaylistConnection = {
  edges: Array<FeaturedPlaylistEdge>;
  nodes: Array<FeaturedPlaylist>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FeaturedPlaylistEdge = {
  cursor: Scalars['Cursor']['output'];
  node: FeaturedPlaylist;
};

export type FeaturedPlaylistFilter = {
  and?: InputMaybe<Array<FeaturedPlaylistFilter>>;
  hasFeaturedPlaylistCheckPointsWith?: InputMaybe<FeaturedPlaylistCheckPointFilter>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  not?: InputMaybe<FeaturedPlaylistFilter>;
  or?: InputMaybe<Array<FeaturedPlaylistFilter>>;
  publishMode?: InputMaybe<Array<FeaturedPlaylistPublishMode>>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
  titleEnQ?: InputMaybe<Array<Scalars['String']['input']>>;
  titleQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum FeaturedPlaylistPublishMode {
  Global = 'GLOBAL',
  Private = 'PRIVATE'
}

export type Feedback = {
  prosody?: Maybe<Prosody>;
};

export type FloatRange = {
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type FlyerPackage = Node & {
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  enabled: Scalars['Boolean']['output'];
  flyerPackageId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isShow: Scalars['Boolean']['output'];
  name: FlyerPackageName;
  testLevels: Array<TestLevel>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type FlyerPackageConnection = {
  edges: Array<FlyerPackageEdge>;
  nodes: Array<FlyerPackage>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FlyerPackageEdge = {
  cursor: Scalars['Cursor']['output'];
  node: FlyerPackage;
};

export enum FlyerPackageName {
  Ielts = 'IELTS',
  Kids = 'KIDS',
  Max = 'MAX',
  Teens = 'TEENS'
}

export type FlyerSubscription = Node & {
  expiredAt: Scalars['DateTime']['output'];
  flyerSubscriptionId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  package: FlyerPackage;
  user: User;
};

export type FlyerSubscriptionConnection = {
  edges: Array<FlyerSubscriptionEdge>;
  nodes: Array<FlyerSubscription>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FlyerSubscriptionEdge = {
  cursor: Scalars['Cursor']['output'];
  node: FlyerSubscription;
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type GradeDistribution = {
  grade: Scalars['Int']['output'];
  percent: Scalars['Float']['output'];
};

export type GrammarItem = {
  endIndex: Scalars['Int']['output'];
  original: Scalars['String']['output'];
  startIndex: Scalars['Int']['output'];
  suggestion: Scalars['String']['output'];
};

export type Identifier = {
  Email?: InputMaybe<Scalars['String']['input']>;
  PhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum IdentifierType {
  Email = 'EMAIL',
  PhoneNumber = 'PHONE_NUMBER',
  UserName = 'USER_NAME'
}

export type IeltsCheckPointCreateInput = {
  attemptsAllowed?: InputMaybe<Scalars['Int']['input']>;
  cpType?: InputMaybe<CheckPointType>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  diamond?: InputMaybe<Scalars['Int']['input']>;
  ieltsBand?: InputMaybe<Scalars['Float']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isBoss?: InputMaybe<Scalars['Boolean']['input']>;
  isPractice: Scalars['Boolean']['input'];
  isPremium: Scalars['Boolean']['input'];
  levels?: InputMaybe<Array<CefrLevel>>;
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  skills: Array<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
};

export type IeltsCheckPointCreatePayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type IeltsCheckPointDeletePayload = {
  checkPointId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type IeltsCheckPointUpdateInput = {
  attemptsAllowed?: InputMaybe<Scalars['Int']['input']>;
  cpType?: InputMaybe<CheckPointType>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  diamond?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  ieltsBand?: InputMaybe<Scalars['Float']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isBoss?: InputMaybe<Scalars['Boolean']['input']>;
  isPractice?: InputMaybe<Scalars['Boolean']['input']>;
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  time?: InputMaybe<Scalars['Duration']['input']>;
};

export type IeltsCheckPointUpdatePayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type IeltsDetail = {
  contentKey: Scalars['String']['output'];
  detailType: IeltsDetailType;
  explainHtml?: Maybe<Scalars['String']['output']>;
  explainHtmlEn?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isExample: Scalars['Boolean']['output'];
  options?: Maybe<Array<IeltsDetailOption>>;
};

export type IeltsDetailAnswer = {
  correctOptionIDs?: Maybe<Array<Scalars['ID']['output']>>;
  detailId: Scalars['ID']['output'];
  optionId?: Maybe<Scalars['ID']['output']>;
  optionIds?: Maybe<Array<Scalars['ID']['output']>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type IeltsDetailAnswerInput = {
  detailId: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsDetailInput = {
  contentKey: Scalars['String']['input'];
  detailType: IeltsDetailType;
  explainHtml?: InputMaybe<Scalars['String']['input']>;
  explainHtmlEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isExample?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<IeltsDetailOptionInput>>;
};

export type IeltsDetailOption = {
  correctAnswer: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  label?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type IeltsDetailOptionInput = {
  correctAnswer: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export enum IeltsDetailType {
  GapFill = 'GAP_FILL',
  Option = 'OPTION',
  Select = 'SELECT'
}

export type IeltsListeningEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type IeltsListeningEndAttemptPayload = {
  userErrors: Array<UserError>;
};

export type IeltsListeningPart = Node & {
  audio?: Maybe<Audio>;
  audioSubtitle?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  expiredTime?: Maybe<Scalars['Duration']['output']>;
  id: Scalars['ID']['output'];
  ieltsListeningPartId: Scalars['ID']['output'];
  ieltsListeningPartQuestions: Array<IeltsListeningPartQuestionEdge>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  questions: Array<IeltsListeningQuestion>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type IeltsListeningPartAddQuestionsInput = {
  partId: Scalars['ID']['input'];
  questionIds: Array<Scalars['ID']['input']>;
};

export type IeltsListeningPartAttempt = Node & {
  id: Scalars['ID']['output'];
  ieltsListeningPartAttemptId: Scalars['ID']['output'];
  part: IeltsListeningPart;
  questionAttempts: Array<IeltsListeningQuestionAttempt>;
};

export type IeltsListeningPartConnection = {
  edges: Array<IeltsListeningPartEdge>;
  nodes: Array<IeltsListeningPart>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type IeltsListeningPartCreateInput = {
  audioId?: InputMaybe<Scalars['String']['input']>;
  audioSubtitle?: InputMaybe<Scalars['String']['input']>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type IeltsListeningPartCreatePayload = {
  ieltsListeningPart?: Maybe<IeltsListeningPart>;
  userErrors: Array<UserError>;
};

export type IeltsListeningPartDeletePayload = {
  ieltsListeningPartId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type IeltsListeningPartEdge = {
  cursor: Scalars['Cursor']['output'];
  node: IeltsListeningPart;
};

export type IeltsListeningPartFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsListeningPartQuestionEdge = {
  node: IeltsListeningQuestion;
  position: Scalars['Int']['output'];
};

export type IeltsListeningPartQuestionInput = {
  position: Scalars['Int']['input'];
  questionId: Scalars['ID']['input'];
};

export type IeltsListeningPartRemoveQuestionsPayload = {
  ieltsListeningPart?: Maybe<IeltsListeningPart>;
  userErrors: Array<UserError>;
};

export type IeltsListeningPartUpdateInput = {
  audioId?: InputMaybe<Scalars['String']['input']>;
  audioSubtitle?: InputMaybe<Scalars['String']['input']>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsListeningPartUpdatePayload = {
  ieltsListeningPart?: Maybe<IeltsListeningPart>;
  userErrors: Array<UserError>;
};

export type IeltsListeningPartUpdateQuestionsPayload = {
  ieltsListeningPart?: Maybe<IeltsListeningPart>;
  userErrors: Array<UserError>;
};

export type IeltsListeningQuestion = Node & {
  contentHtml: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  details: Array<IeltsDetail>;
  id: Scalars['ID']['output'];
  ieltsListeningQuestionId: Scalars['ID']['output'];
  mark: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type IeltsListeningQuestionAttempt = Node & {
  correctMark?: Maybe<Scalars['Int']['output']>;
  detailAnswers: Array<IeltsDetailAnswer>;
  id: Scalars['ID']['output'];
  ieltsListeningQuestionAttemptId: Scalars['ID']['output'];
  question: IeltsListeningQuestion;
};

export type IeltsListeningQuestionConnection = {
  edges: Array<IeltsListeningQuestionEdge>;
  nodes: Array<IeltsListeningQuestion>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type IeltsListeningQuestionCreateInput = {
  contentHtml: Scalars['String']['input'];
  details: Array<IeltsDetailInput>;
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type IeltsListeningQuestionCreatePayload = {
  ieltsListeningQuestion?: Maybe<IeltsListeningQuestion>;
  userErrors: Array<UserError>;
};

export type IeltsListeningQuestionDeletePayload = {
  ieltsListeningQuestionId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type IeltsListeningQuestionEdge = {
  cursor: Scalars['Cursor']['output'];
  node: IeltsListeningQuestion;
};

export type IeltsListeningQuestionFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsListeningQuestionUpdateInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Array<IeltsDetailInput>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsListeningQuestionUpdatePayload = {
  ieltsListeningQuestion?: Maybe<IeltsListeningQuestion>;
  userErrors: Array<UserError>;
};

export type IeltsListeningStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  challengeCode?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  selectPartIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type IeltsListeningStartAttemptPayload = {
  attemptId?: Maybe<Scalars['ID']['output']>;
  checkPointId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type IeltsListeningSubmitPartAttemptInput = {
  attemptId: Scalars['ID']['input'];
  detailAnswers: Array<IeltsDetailAnswerInput>;
  partId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
};

export type IeltsListeningSubmitPartAttemptPayload = {
  userErrors: Array<UserError>;
};

export type IeltsNote = Node & {
  checkPoint: CheckPoint;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ieltsNoteId: Scalars['ID']['output'];
  learnerProfile: LearnerProfile;
  listeningPartId?: Maybe<Scalars['String']['output']>;
  listeningQuestionId?: Maybe<Scalars['String']['output']>;
  readingPartId?: Maybe<Scalars['String']['output']>;
  readingQuestionId?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vocabWord?: Maybe<VocabWord>;
};

export type IeltsNoteConnection = {
  edges: Array<IeltsNoteEdge>;
  nodes: Array<IeltsNote>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type IeltsNoteEdge = {
  cursor: Scalars['Cursor']['output'];
  node: IeltsNote;
};

export type IeltsNoteFilter = {
  hasCheckPointWith?: InputMaybe<CheckPointFilter>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  hasVocabWordWith?: InputMaybe<VocabWordFilter>;
  textQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsReadingEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type IeltsReadingEndAttemptPayload = {
  userErrors: Array<UserError>;
};

export type IeltsReadingPart = Node & {
  contentHtml?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  expiredTime?: Maybe<Scalars['Duration']['output']>;
  id: Scalars['ID']['output'];
  ieltsReadingPartId: Scalars['ID']['output'];
  ieltsReadingPartQuestions: Array<IeltsReadingPartQuestionEdge>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  questions: Array<IeltsReadingQuestion>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type IeltsReadingPartAddQuestionsInput = {
  partId: Scalars['ID']['input'];
  questionIds: Array<Scalars['ID']['input']>;
};

export type IeltsReadingPartAttempt = Node & {
  id: Scalars['ID']['output'];
  ieltsReadingPartAttemptId: Scalars['ID']['output'];
  part: IeltsReadingPart;
  questionAttempts: Array<IeltsReadingQuestionAttempt>;
};

export type IeltsReadingPartConnection = {
  edges: Array<IeltsReadingPartEdge>;
  nodes: Array<IeltsReadingPart>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type IeltsReadingPartCreateInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type IeltsReadingPartCreatePayload = {
  ieltsReadingPart?: Maybe<IeltsReadingPart>;
  userErrors: Array<UserError>;
};

export type IeltsReadingPartDeletePayload = {
  ieltsReadingPartId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type IeltsReadingPartEdge = {
  cursor: Scalars['Cursor']['output'];
  node: IeltsReadingPart;
};

export type IeltsReadingPartFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsReadingPartQuestionEdge = {
  node: IeltsReadingQuestion;
  position: Scalars['Int']['output'];
};

export type IeltsReadingPartQuestionInput = {
  position: Scalars['Int']['input'];
  questionId: Scalars['ID']['input'];
};

export type IeltsReadingPartRemoveQuestionsPayload = {
  ieltsReadingPart?: Maybe<IeltsReadingPart>;
  userErrors: Array<UserError>;
};

export type IeltsReadingPartUpdateInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsReadingPartUpdatePayload = {
  ieltsReadingPart?: Maybe<IeltsReadingPart>;
  userErrors: Array<UserError>;
};

export type IeltsReadingPartUpdateQuestionsPayload = {
  ieltsReadingPart?: Maybe<IeltsReadingPart>;
  userErrors: Array<UserError>;
};

export type IeltsReadingQuestion = Node & {
  contentHtml: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  details: Array<IeltsDetail>;
  id: Scalars['ID']['output'];
  ieltsReadingQuestionId: Scalars['ID']['output'];
  mark: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type IeltsReadingQuestionAttempt = Node & {
  correctMark?: Maybe<Scalars['Int']['output']>;
  detailAnswers: Array<IeltsDetailAnswer>;
  id: Scalars['ID']['output'];
  ieltsReadingQuestionAttemptId: Scalars['ID']['output'];
  question: IeltsReadingQuestion;
};

export type IeltsReadingQuestionConnection = {
  edges: Array<IeltsReadingQuestionEdge>;
  nodes: Array<IeltsReadingQuestion>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type IeltsReadingQuestionCreateInput = {
  contentHtml: Scalars['String']['input'];
  details: Array<IeltsDetailInput>;
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type IeltsReadingQuestionCreatePayload = {
  ieltsReadingQuestion?: Maybe<IeltsReadingQuestion>;
  userErrors: Array<UserError>;
};

export type IeltsReadingQuestionDeletePayload = {
  ieltsReadingQuestionId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type IeltsReadingQuestionEdge = {
  cursor: Scalars['Cursor']['output'];
  node: IeltsReadingQuestion;
};

export type IeltsReadingQuestionFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsReadingQuestionUpdateInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Array<IeltsDetailInput>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsReadingQuestionUpdatePayload = {
  ieltsReadingQuestion?: Maybe<IeltsReadingQuestion>;
  userErrors: Array<UserError>;
};

export type IeltsReadingStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  challengeCode?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  selectPartIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type IeltsReadingStartAttemptPayload = {
  attemptId?: Maybe<Scalars['ID']['output']>;
  checkPointId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type IeltsReadingSubmitPartAttemptInput = {
  attemptId: Scalars['ID']['input'];
  detailAnswers: Array<IeltsDetailAnswerInput>;
  partId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
};

export type IeltsReadingSubmitPartAttemptPayload = {
  userErrors: Array<UserError>;
};

export type IeltsRecordScore = {
  coherence: Scalars['Float']['output'];
  coherenceDecision: WordDecision;
  fluency: Scalars['Float']['output'];
  fluencyDecision: WordDecision;
  grammar: Scalars['Float']['output'];
  grammarDecision: WordDecision;
  highlightWords?: Maybe<Array<PronunciationWord>>;
  overall: Scalars['Float']['output'];
  pronunciation: Scalars['Float']['output'];
  pronunciationDecision: WordDecision;
  transcript?: Maybe<Scalars['String']['output']>;
  vocab: Scalars['Float']['output'];
  vocabDecision: WordDecision;
};

export enum IeltsSkill {
  FUll = 'FUll',
  Listening = 'LISTENING',
  Reading = 'READING',
  Speaking = 'SPEAKING',
  Writing = 'WRITING'
}

export type IeltsSpeakingEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type IeltsSpeakingEndAttemptPayload = {
  userErrors: Array<UserError>;
};

export type IeltsSpeakingPart = Node & {
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  defaultShowQuestionContents: Scalars['Boolean']['output'];
  expiredTime: Scalars['Duration']['output'];
  id: Scalars['ID']['output'];
  ieltsSpeakingPartId: Scalars['ID']['output'];
  ieltsSpeakingPartQuestions: Array<IeltsSpeakingPartQuestionEdge>;
  info: IeltsSpeakingPartInfo;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  questions: Array<IeltsSpeakingQuestion>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type IeltsSpeakingPartAttempt = Node & {
  id: Scalars['ID']['output'];
  ieltsSpeakingPartAttemptId: Scalars['ID']['output'];
  part: IeltsSpeakingPart;
  questionAttempts: Array<IeltsSpeakingQuestionAttempt>;
};

export type IeltsSpeakingPartConnection = {
  edges: Array<IeltsSpeakingPartEdge>;
  nodes: Array<IeltsSpeakingPart>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type IeltsSpeakingPartCreateInput = {
  defaultShowQuestionContents?: InputMaybe<Scalars['Boolean']['input']>;
  expiredTime: Scalars['Duration']['input'];
  infoId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type IeltsSpeakingPartCreatePayload = {
  ieltsSpeakingPart?: Maybe<IeltsSpeakingPart>;
  userErrors: Array<UserError>;
};

export type IeltsSpeakingPartDeletePayload = {
  ieltsSpeakingPartId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type IeltsSpeakingPartEdge = {
  cursor: Scalars['Cursor']['output'];
  node: IeltsSpeakingPart;
};

export type IeltsSpeakingPartFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsSpeakingPartInfo = Node & {
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ieltsSpeakingPartInfoId: Scalars['ID']['output'];
  introductionAudio?: Maybe<Audio>;
  introductionText: Scalars['String']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type IeltsSpeakingPartInfoConnection = {
  edges: Array<IeltsSpeakingPartInfoEdge>;
  nodes: Array<IeltsSpeakingPartInfo>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type IeltsSpeakingPartInfoCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  introductionAudioId?: InputMaybe<Scalars['ID']['input']>;
  introductionText: Scalars['String']['input'];
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type IeltsSpeakingPartInfoCreatePayload = {
  ieltsSpeakingPartInfo?: Maybe<IeltsSpeakingPartInfo>;
  userErrors: Array<UserError>;
};

export type IeltsSpeakingPartInfoDeletePayload = {
  ieltsSpeakingPartInfoId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type IeltsSpeakingPartInfoEdge = {
  cursor: Scalars['Cursor']['output'];
  node: IeltsSpeakingPartInfo;
};

export type IeltsSpeakingPartInfoFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsSpeakingPartInfoUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  introductionAudioId?: InputMaybe<Scalars['ID']['input']>;
  introductionText?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsSpeakingPartInfoUpdatePayload = {
  ieltsSpeakingPartInfo?: Maybe<IeltsSpeakingPartInfo>;
  userErrors: Array<UserError>;
};

export type IeltsSpeakingPartQuestionEdge = {
  node: IeltsSpeakingQuestion;
  position: Scalars['Int']['output'];
};

export type IeltsSpeakingPartQuestionInput = {
  position: Scalars['Int']['input'];
  questionId: Scalars['ID']['input'];
};

export type IeltsSpeakingPartRemoveQuestionsPayload = {
  ieltsSpeakingPart?: Maybe<IeltsSpeakingPart>;
  userErrors: Array<UserError>;
};

export type IeltsSpeakingPartUpdateInput = {
  defaultShowQuestionContents?: InputMaybe<Scalars['Boolean']['input']>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  id: Scalars['ID']['input'];
  infoId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type IeltsSpeakingPartUpdatePayload = {
  ieltsSpeakingPart?: Maybe<IeltsSpeakingPart>;
  userErrors: Array<UserError>;
};

export type IeltsSpeakingPartUpdateQuestionsPayload = {
  ieltsSpeakingPart?: Maybe<IeltsSpeakingPart>;
  userErrors: Array<UserError>;
};

export type IeltsSpeakingQuestion = Node & {
  audio: Audio;
  contentHtml: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  ieltsSpeakingQuestionId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sampleAnswerAudio?: Maybe<Audio>;
  sampleAnswerHtml: Scalars['String']['output'];
  timeToSpeak: Scalars['Duration']['output'];
  timeToThink?: Maybe<Scalars['Duration']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type IeltsSpeakingQuestionAttempt = Node & {
  id: Scalars['ID']['output'];
  ieltsSpeakingQuestionAttemptId: Scalars['ID']['output'];
  question: IeltsSpeakingQuestion;
  record: Audio;
  recordScore?: Maybe<IeltsRecordScore>;
  teacherComment?: Maybe<Scalars['JSON']['output']>;
  teacherCommentAudio?: Maybe<Audio>;
  teacherCommentDetails: Array<TeacherCommentDetail>;
  teacherCommentHtml?: Maybe<Scalars['String']['output']>;
  transcriptionRecord?: Maybe<Scalars['String']['output']>;
};

export type IeltsSpeakingQuestionConnection = {
  edges: Array<IeltsSpeakingQuestionEdge>;
  nodes: Array<IeltsSpeakingQuestion>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type IeltsSpeakingQuestionCreateInput = {
  audioId: Scalars['ID']['input'];
  contentHtml: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sampleAnswerAudioId?: InputMaybe<Scalars['ID']['input']>;
  sampleAnswerHtml: Scalars['String']['input'];
  timeToSpeak: Scalars['Duration']['input'];
  timeToThink?: InputMaybe<Scalars['Duration']['input']>;
  title: Scalars['String']['input'];
};

export type IeltsSpeakingQuestionCreatePayload = {
  ieltsSpeakingQuestion?: Maybe<IeltsSpeakingQuestion>;
  userErrors: Array<UserError>;
};

export type IeltsSpeakingQuestionDeletePayload = {
  ieltsSpeakingQuestionId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type IeltsSpeakingQuestionEdge = {
  cursor: Scalars['Cursor']['output'];
  node: IeltsSpeakingQuestion;
};

export type IeltsSpeakingQuestionFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsSpeakingQuestionUpdateInput = {
  audioId?: InputMaybe<Scalars['ID']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sampleAnswerAudioId?: InputMaybe<Scalars['ID']['input']>;
  sampleAnswerHtml?: InputMaybe<Scalars['String']['input']>;
  timeToSpeak?: InputMaybe<Scalars['Duration']['input']>;
  timeToThink?: InputMaybe<Scalars['Duration']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsSpeakingQuestionUpdatePayload = {
  ieltsSpeakingQuestion?: Maybe<IeltsSpeakingQuestion>;
  userErrors: Array<UserError>;
};

export type IeltsSpeakingStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  challengeCode?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  requestAIReview?: InputMaybe<Scalars['Boolean']['input']>;
  requestReview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IeltsSpeakingStartAttemptPayload = {
  attemptId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type IeltsSpeakingSubmitPartAttemptInput = {
  attemptId: Scalars['ID']['input'];
  partId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  recordId: Scalars['ID']['input'];
};

export type IeltsSpeakingSubmitPartAttemptPayload = {
  userErrors: Array<UserError>;
};

export type IeltsSpeakingSubmitQuestionAttemptInput = {
  attemptId: Scalars['ID']['input'];
  partId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  recordId: Scalars['ID']['input'];
};

export type IeltsSpeakingSubmitQuestionAttemptPayload = {
  userErrors: Array<UserError>;
};

export type IeltsStatsOverview = {
  studyStats: LearnerProfileStudyStatsByPeriod;
};

export type IeltsViewerNoteCreateInput = {
  checkPointId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  listeningPartId?: InputMaybe<Scalars['String']['input']>;
  listeningQuestionId?: InputMaybe<Scalars['String']['input']>;
  readingPartId?: InputMaybe<Scalars['String']['input']>;
  readingQuestionId?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type IeltsViewerNoteCreatePayload = {
  ieltsNote?: Maybe<IeltsNote>;
  userErrors: Array<UserError>;
};

export type IeltsViewerNoteRemovePayload = {
  ieltsNoteId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type IeltsViewerNoteUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type IeltsViewerNoteUpdatePayload = {
  ieltsNote?: Maybe<IeltsNote>;
  userErrors: Array<UserError>;
};

export type IeltsWritingEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type IeltsWritingEndAttemptPayload = {
  userErrors: Array<UserError>;
};

export type IeltsWritingPart = Node & {
  aiPrompt?: Maybe<WritingAiPrompt>;
  audio?: Maybe<Audio>;
  audioSubtitle?: Maybe<Scalars['String']['output']>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  expiredTime?: Maybe<Scalars['Duration']['output']>;
  id: Scalars['ID']['output'];
  ieltsWritingPartId: Scalars['ID']['output'];
  ieltsWritingPartQuestions: Array<IeltsWritingPartQuestionEdge>;
  images: Array<Image>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  sampleAnswerHtml?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type IeltsWritingPartAttempt = Node & {
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ieltsWritingPartAttemptId: Scalars['ID']['output'];
  marking?: Maybe<WritingAiMarking>;
  markingGrade?: Maybe<Scalars['Float']['output']>;
  part: IeltsWritingPart;
  questionAttempts: Array<IeltsWritingQuestionAttempt>;
};

export type IeltsWritingPartConnection = {
  edges: Array<IeltsWritingPartEdge>;
  nodes: Array<IeltsWritingPart>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type IeltsWritingPartCreateInput = {
  aiPrompt?: InputMaybe<WritingAiPromptInput>;
  audioId?: InputMaybe<Scalars['String']['input']>;
  audioSubtitle?: InputMaybe<Scalars['String']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  imageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  sampleAnswerHtml?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type IeltsWritingPartCreatePayload = {
  ieltsWritingPart?: Maybe<IeltsWritingPart>;
  userErrors: Array<UserError>;
};

export type IeltsWritingPartDeletePayload = {
  ieltsWritingPartId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type IeltsWritingPartEdge = {
  cursor: Scalars['Cursor']['output'];
  node: IeltsWritingPart;
};

export type IeltsWritingPartFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsWritingPartQuestionEdge = {
  node: IeltsWritingQuestion;
  position: Scalars['Int']['output'];
};

export type IeltsWritingPartQuestionInput = {
  position: Scalars['Int']['input'];
  questionId: Scalars['ID']['input'];
};

export type IeltsWritingPartRemoveQuestionsPayload = {
  ieltsWritingPart?: Maybe<IeltsWritingPart>;
  userErrors: Array<UserError>;
};

export type IeltsWritingPartUpdateInput = {
  aiPrompt?: InputMaybe<WritingAiPromptInput>;
  audioId?: InputMaybe<Scalars['String']['input']>;
  audioSubtitle?: InputMaybe<Scalars['String']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  id: Scalars['ID']['input'];
  imageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  sampleAnswerHtml?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsWritingPartUpdatePayload = {
  ieltsWritingPart?: Maybe<IeltsWritingPart>;
  userErrors: Array<UserError>;
};

export type IeltsWritingPartUpdateQuestionsPayload = {
  ieltsWritingPart?: Maybe<IeltsWritingPart>;
  userErrors: Array<UserError>;
};

export type IeltsWritingQuestion = Node & {
  contentHtml: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  details: Array<IeltsDetail>;
  id: Scalars['ID']['output'];
  ieltsWritingQuestionId: Scalars['ID']['output'];
  mark: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type IeltsWritingQuestionAttempt = Node & {
  correctMark?: Maybe<Scalars['Int']['output']>;
  detailAnswers: Array<IeltsDetailAnswer>;
  id: Scalars['ID']['output'];
  ieltsWritingQuestionAttemptId: Scalars['ID']['output'];
  question: IeltsWritingQuestion;
};

export type IeltsWritingQuestionConnection = {
  edges: Array<IeltsWritingQuestionEdge>;
  nodes: Array<IeltsWritingQuestion>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type IeltsWritingQuestionCreateInput = {
  contentHtml: Scalars['String']['input'];
  details: Array<IeltsDetailInput>;
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type IeltsWritingQuestionCreatePayload = {
  ieltsWritingQuestion?: Maybe<IeltsWritingQuestion>;
  userErrors: Array<UserError>;
};

export type IeltsWritingQuestionDeletePayload = {
  ieltsWritingQuestionId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type IeltsWritingQuestionEdge = {
  cursor: Scalars['Cursor']['output'];
  node: IeltsWritingQuestion;
};

export type IeltsWritingQuestionFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsWritingQuestionUpdateInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Array<IeltsDetailInput>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsWritingQuestionUpdatePayload = {
  ieltsWritingQuestion?: Maybe<IeltsWritingQuestion>;
  userErrors: Array<UserError>;
};

export type IeltsWritingStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  challengeCode?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  requestAIReview?: InputMaybe<Scalars['Boolean']['input']>;
  requestReview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IeltsWritingStartAttemptPayload = {
  attemptId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type IeltsWritingSubmitPartAttemptInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  attemptId: Scalars['ID']['input'];
  partId: Scalars['ID']['input'];
  questionAnswer?: InputMaybe<IeltsWritingSubmitQuestionAnswerInput>;
};

export type IeltsWritingSubmitPartAttemptPayload = {
  userErrors: Array<UserError>;
};

export type IeltsWritingSubmitQuestionAnswerInput = {
  detailAnswers: Array<IeltsDetailAnswerInput>;
  questionId: Scalars['ID']['input'];
};

export type Image = Node & {
  blurHash: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type InfoAssignTest = {
  accuracy: Scalars['Float']['output'];
  completedTest: Scalars['Int']['output'];
  highestScore: Scalars['Int']['output'];
  lowestScore: Scalars['Int']['output'];
  progress: Scalars['Float']['output'];
  totalTest: Scalars['Int']['output'];
};

export type InfoAssignTestProfile = {
  accuracy?: Maybe<Scalars['Float']['output']>;
  avgTime?: Maybe<Scalars['Duration']['output']>;
  highestScore?: Maybe<Scalars['Float']['output']>;
  lastSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  times?: Maybe<Scalars['Int']['output']>;
  userAttempts?: Maybe<Array<UserAttempt>>;
};

export type InfoAssignTestStudent = {
  highestScore?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<StatusStudent>;
  submitTime?: Maybe<Scalars['Int']['output']>;
  userAttempts?: Maybe<Array<UserAttempt>>;
};

export type IntRange = {
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};

export type InteractionFluency = {
  pauseCount?: Maybe<Scalars['Int']['output']>;
  wordsPerMinute?: Maybe<Scalars['Float']['output']>;
  wordsPerMinuteMax?: Maybe<Scalars['Float']['output']>;
  wordsPerMinuteMin?: Maybe<Scalars['Float']['output']>;
};

export type Intonation = {
  errorTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  monotone?: Maybe<Monotone>;
};

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type IpData = {
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type JoinClassCode = Node & {
  activationCode: ActivationCode;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isUsed: Scalars['Boolean']['output'];
  joinClassCodeId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type JoinClassCodeConnection = {
  edges: Array<JoinClassCodeEdge>;
  nodes: Array<JoinClassCode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type JoinClassCodeEdge = {
  cursor: Scalars['Cursor']['output'];
  node: JoinClassCode;
};

export type JoinClassCodeFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  usedAt?: InputMaybe<DateTimeRange>;
};

export type JoinClassCodeOrder = {
  key?: InputMaybe<JoinClassCodeOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum JoinClassCodeOrderKey {
  UsedAt = 'USED_AT'
}

export enum KetPetGradeCert {
  A = 'A',
  B = 'B',
  C = 'C'
}

export type KetPetScore = {
  certLevelInfo?: Maybe<CefrLevelInfo>;
  gradeCert?: Maybe<KetPetGradeCert>;
  overallScore: Scalars['Int']['output'];
};

export type LearnerAchievement = Node & {
  dateReceived?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  learnerAchievementId: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  maxLevel: Scalars['Int']['output'];
  name: AchievementName;
  nextLevelValue: Scalars['Int']['output'];
  seen: Scalars['Boolean']['output'];
  tier: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type LearnerChallengeRank = {
  attemptInfo?: Maybe<AttemptInfo>;
  grade?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  learnerChallengeRankId: Scalars['ID']['output'];
  learnerProfile: LearnerProfile;
  rank: Scalars['Int']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  userAttempt?: Maybe<UserAttempt>;
};

export type LearnerChallengeRankConnection = {
  edges: Array<LearnerChallengeRankEdge>;
  nodes: Array<LearnerChallengeRank>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type LearnerChallengeRankEdge = {
  cursor: Scalars['Cursor']['output'];
  node: LearnerChallengeRank;
};

export type LearnerChallengeRankFilter = {
  displayNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  learnerProfileId?: InputMaybe<Array<Scalars['ID']['input']>>;
  schoolId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type LearnerChallengeRankOrder = {
  key?: InputMaybe<LearnerChallengeRankOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LearnerChallengeRankOrderKey {
  Rank = 'RANK'
}

export type LearnerDuolingoLevel = {
  completedSessions: Scalars['Int']['output'];
  nextCheckPoint?: Maybe<CheckPoint>;
  state: LearnerDuolingoLevelState;
  totalSessions: Scalars['Int']['output'];
  type: DuolingoLevelType;
};

export enum LearnerDuolingoLevelState {
  Active = 'ACTIVE',
  Locked = 'LOCKED',
  Passed = 'PASSED'
}

export type LearnerDuolingoPath = {
  completedLevels: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  totalLevels: Scalars['Int']['output'];
  units: Array<LearnerDuolingoUnit>;
};

export type LearnerDuolingoUnit = {
  levels: Array<LearnerDuolingoLevel>;
  name: Scalars['String']['output'];
  nameEn?: Maybe<Scalars['String']['output']>;
};

export type LearnerMistakeWord = Node & {
  id: Scalars['ID']['output'];
  isLastScore: Scalars['Boolean']['output'];
  learnerMistakeWordId: Scalars['ID']['output'];
  recordScore?: Maybe<PronunciationWord>;
  recordUrl?: Maybe<Scalars['String']['output']>;
  word: VocabWord;
};

export type LearnerMistakeWordConnection = {
  edges: Array<LearnerMistakeWordEdge>;
  nodes: Array<LearnerMistakeWord>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type LearnerMistakeWordEdge = {
  cursor: Scalars['Cursor']['output'];
  node: LearnerMistakeWord;
};

export type LearnerMistakeWordFilter = {
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  hasWordWith?: InputMaybe<VocabWordFilter>;
  status?: InputMaybe<Array<StatusLearnerMistakeWord>>;
};

export type LearnerMistakeWordOrder = {
  key?: InputMaybe<LearnerMistakeWordOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LearnerMistakeWordOrderKey {
  Word = 'WORD'
}

export type LearnerProfile = Node & {
  achievements: Array<LearnerAchievement>;
  additionalInfo?: Maybe<AdditionalInfo>;
  age?: Maybe<Scalars['Int']['output']>;
  aiConversationQuota: Quota;
  aiSpeakingQuota: Quota;
  assignTestProfiles: AssignTestProfileConnection;
  attemptStats?: Maybe<AttemptStats>;
  /** @deprecated use star */
  attendance?: Maybe<Scalars['Int']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  canClaimDailyReward: Scalars['Boolean']['output'];
  canRequestTeacher: Scalars['Boolean']['output'];
  canUseSpeakingAI: Scalars['Boolean']['output'];
  classStudent?: Maybe<ClassStudent>;
  /** @deprecated use classStudent instead */
  classStudents?: Maybe<ClassStudent>;
  coin: Scalars['Int']['output'];
  completedTestsCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentSchoolAssignTestsStats?: Maybe<AssignTestsStats>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  domains?: Maybe<Array<CustomDomain>>;
  firstName: Scalars['String']['output'];
  frameImage?: Maybe<Image>;
  gender?: Maybe<Gender>;
  id: Scalars['ID']['output'];
  /** @deprecated use star */
  ieltsAttendance?: Maybe<Scalars['Int']['output']>;
  ieltsTargetScore?: Maybe<Scalars['Float']['output']>;
  isAnonymous: Scalars['Boolean']['output'];
  lang?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastPlacementTest?: Maybe<UserAttempt>;
  latestAttempt?: Maybe<UserAttempt>;
  learnerProfileId: Scalars['ID']['output'];
  placementLevel?: Maybe<CefrLevel>;
  placementTests?: Maybe<Array<UserAttempt>>;
  school?: Maybe<School>;
  sourceDomain?: Maybe<Scalars['String']['output']>;
  star: Scalars['Int']['output'];
  starLevel: Scalars['Int']['output'];
  starTarget: Scalars['Int']['output'];
  streakData?: Maybe<StreakData>;
  timeRemainingToCompleteLevel?: Maybe<Scalars['Duration']['output']>;
  unseenReviewAttemptStats?: Maybe<UnseenReviewAttemptStats>;
  user?: Maybe<User>;
  userAttempts: UserAttemptConnection;
  viewerTeacherClassStudent?: Maybe<ClassStudent>;
};


export type LearnerProfileAssignTestProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AssignTestProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerProfileAttemptStatsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  testLevelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeAttempt?: InputMaybe<TypeAttempt>;
};


export type LearnerProfileClassStudentArgs = {
  schoolId?: InputMaybe<Scalars['ID']['input']>;
};


export type LearnerProfileClassStudentsArgs = {
  schoolId?: InputMaybe<Scalars['ID']['input']>;
};


export type LearnerProfileCurrentSchoolAssignTestsStatsArgs = {
  classID?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<DateTimeRange>;
};


export type LearnerProfileLatestAttemptArgs = {
  testLevelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type LearnerProfileUnseenReviewAttemptStatsArgs = {
  testLevelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeAttempt?: InputMaybe<TypeAttempt>;
};


export type LearnerProfileUserAttemptsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<UserAttemptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LearnerProfileConnection = {
  edges: Array<LearnerProfileEdge>;
  nodes: Array<LearnerProfile>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type LearnerProfileEdge = {
  cursor: Scalars['Cursor']['output'];
  node: LearnerProfile;
};

export type LearnerProfileFilter = {
  and?: InputMaybe<Array<LearnerProfileFilter>>;
  displayNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  hasClassStudentsWith?: InputMaybe<ClassStudentFilter>;
  hasUserAttemptsWith?: InputMaybe<UserAttemptFilter>;
  hasUserWith?: InputMaybe<UserFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<LearnerProfileFilter>;
  or?: InputMaybe<Array<LearnerProfileFilter>>;
  subscriptionStatus?: InputMaybe<SubscriptionStatusFilter>;
};

export type LearnerProfileOrder = {
  key?: InputMaybe<LearnerProfileOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LearnerProfileOrderKey {
  DateOfBirth = 'DATE_OF_BIRTH',
  DisplayName = 'DISPLAY_NAME',
  Id = 'ID'
}

export type LearnerProfileStatsOverview = {
  accuracy: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  level?: Maybe<Scalars['String']['output']>;
  nextLevel?: Maybe<Scalars['String']['output']>;
  studyStats: LearnerProfileStudyStatsByPeriod;
  timeRemainingToCompleteLevel?: Maybe<Scalars['Duration']['output']>;
};

export type LearnerProfileStudyStats = {
  completedTests: Scalars['Int']['output'];
  studyTime: Scalars['Duration']['output'];
};

export type LearnerProfileStudyStatsByPeriod = {
  last7days: LearnerProfileStudyStats;
  last30days: LearnerProfileStudyStats;
  today: LearnerProfileStudyStats;
};

export type LearnerStatsUpdateFromAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type LearnerStatsUpdateFromAttemptPayload = {
  userErrors: Array<UserError>;
};

export type LearnerTestLevelRank = {
  avgAccuracy: Scalars['Float']['output'];
  executionTime: Scalars['Duration']['output'];
  grade: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  learnerProfile: LearnerProfile;
  learnerTestLevelRankId: Scalars['ID']['output'];
  rank: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
};

export type LearnerTestLevelRankConnection = {
  edges: Array<LearnerTestLevelRankEdge>;
  nodes: Array<LearnerTestLevelRank>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type LearnerTestLevelRankEdge = {
  cursor: Scalars['Cursor']['output'];
  node: LearnerTestLevelRank;
};

export type LearnerTestLevelRankFilter = {
  displayNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  learnerProfileId?: InputMaybe<Array<Scalars['ID']['input']>>;
  provinceId?: InputMaybe<Array<Scalars['ID']['input']>>;
  schoolId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type LearnerXp = Node & {
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  learnerXpId: Scalars['ID']['output'];
  star?: Maybe<Scalars['Int']['output']>;
};

export type LearnerXpConnection = {
  edges: Array<LearnerXpEdge>;
  nodes: Array<LearnerXp>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type LearnerXpEdge = {
  cursor: Scalars['Cursor']['output'];
  node: LearnerXp;
};

export type LearnerXpFilter = {
  date?: InputMaybe<DateTimeRange>;
};

export type LeaveClassData = {
  classCode?: Maybe<Scalars['String']['output']>;
  classId?: Maybe<Scalars['ID']['output']>;
  className?: Maybe<Scalars['String']['output']>;
};

export type MarkingOverall = {
  commentary?: Maybe<Scalars['String']['output']>;
  mistakes?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  suggestions?: Maybe<Scalars['String']['output']>;
};

export type MenuNotification = Node & {
  contentEn: Scalars['String']['output'];
  contentVi: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  descriptionEn?: Maybe<Scalars['String']['output']>;
  descriptionVi?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  isActive: Scalars['Boolean']['output'];
  layout: MenuNotificationLayout;
  menuCode: Scalars['String']['output'];
  menuNotificationId: Scalars['ID']['output'];
  titleEn?: Maybe<Scalars['String']['output']>;
  titleVi?: Maybe<Scalars['String']['output']>;
  type: MenuNotificationType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
  version: Scalars['String']['output'];
  videoId?: Maybe<Scalars['String']['output']>;
};

export type MenuNotificationConnection = {
  edges: Array<MenuNotificationEdge>;
  nodes: Array<MenuNotification>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MenuNotificationEdge = {
  cursor: Scalars['Cursor']['output'];
  node: MenuNotification;
};

export type MenuNotificationFilter = {
  menuCodeQ?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<MenuNotificationType>>;
};

export enum MenuNotificationLayout {
  L1 = 'L1',
  L2 = 'L2'
}

export enum MenuNotificationType {
  Guideline = 'GUIDELINE',
  Tutorial = 'TUTORIAL'
}

export type MetaDataAudio = {
  kind?: Maybe<MetaDataAudioKind>;
  path?: Maybe<MetaDataAudioPath>;
};

export enum MetaDataAudioKind {
  Record = 'record'
}

export enum MetaDataAudioPath {
  Audio = 'audio',
  Avatar = 'avatar',
  Image = 'image'
}

export type MetaInfo = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MetaInfoInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Monotone = {
  syllablePitchDeltaConfidence?: Maybe<Scalars['Float']['output']>;
};

export type MoveInput = {
  id: Scalars['ID']['input'];
  newPosition: Scalars['Int']['input'];
};

export type Mutation = {
  adminActivationCodeUpdate: AdminActivationCodeUpdatePayload;
  adminActiveCode: AdminActiveCodePayload;
  adminAvatarFrameCreate: AdminAvatarFrameCreatePayload;
  adminAvatarFrameDelete: AdminAvatarFrameDeletePayload;
  adminAvatarFrameUpdate: AdminAvatarFrameUpdatePayload;
  adminBookCreate: AdminBookCreatePayload;
  adminBookDelete: AdminBookDeletePayload;
  adminBookLessonCreate: AdminBookLessonCreatePayload;
  adminBookLessonDelete: AdminBookLessonDeletePayload;
  adminBookLessonRemoveCheckPoints: AdminBookLessonRemoveCheckPointsPayload;
  adminBookLessonUpdate: AdminBookLessonUpdatePayload;
  adminBookLessonUpdateCheckPoints: AdminBookLessonUpdateCheckPointsPayload;
  adminBookUnitCreate: AdminBookUnitCreatePayload;
  adminBookUnitDelete: AdminBookUnitDeletePayload;
  adminBookUnitUpdate: AdminBookUnitUpdatePayload;
  adminBookUnitUpdateLessons: AdminBookUnitUpdateLessonsPayload;
  adminBookUpdate: AdminBookUpdatePayload;
  adminBookUpdateUnits: AdminBookUpdateUnitsPayload;
  adminCheckPointCreate: AdminCheckPointCreatePayload;
  adminCheckPointCustomDomainUpdate: AdminCheckPointCustomDomainUpdatePayload;
  adminCheckPointDelete: AdminCheckPointDeletePayload;
  adminCheckPointRemoveDuolingoParts: AdminCheckPointRemoveDuolingoPartsPayload;
  adminCheckPointRemoveSpeakingParts: AdminCheckPointRemoveSpeakingPartsPayload;
  adminCheckPointRemoveWritingParts: AdminCheckPointRemoveWritingPartsPayload;
  adminCheckPointTopicUpdate: AdminCheckPointTopicUpdatePayload;
  adminCheckPointUpdate: AdminCheckPointUpdatePayload;
  adminCheckPointUpdateDuolingoParts: AdminCheckPointUpdateDuolingoPartsPayload;
  adminCheckPointUpdateSpeakingParts: AdminCheckPointUpdateSpeakingPartsPayload;
  adminCheckPointUpdateWritingParts: AdminCheckPointUpdateWritingPartsPayload;
  adminCreateDiscount: AdminCreateDiscountPayload;
  adminCreateOrderCode: AdminCreateOrderCodePayload;
  adminCreateVersionNotification: AdminCreateVersionNotificationPayload;
  adminCustomDomainUpdate: AdminCustomDomainUpdatePayload;
  adminDeleteDiscount: AdminDeleteDiscountPayload;
  adminDeleteVersionNotification: AdminDeleteVersionNotificationPayload;
  adminDuolingoPartCreate: AdminDuolingoPartCreatePayload;
  adminDuolingoPartDelete: AdminDuolingoPartDeletePayload;
  adminDuolingoPartUpdate: AdminDuolingoPartUpdatePayload;
  adminExamPartCreate: AdminExamPartCreatePayload;
  adminExamPartUpdate: AdminExamPartUpdatePayload;
  adminIeltsCheckPointCreate: IeltsCheckPointCreatePayload;
  adminIeltsCheckPointDelete: IeltsCheckPointDeletePayload;
  adminIeltsCheckPointRemoveListeningParts: CheckPointRemoveIeltsListeningPartsPayload;
  adminIeltsCheckPointRemoveReadingParts: CheckPointRemoveIeltsReadingPartsPayload;
  adminIeltsCheckPointRemoveSpeakingParts: CheckPointRemoveIeltsSpeakingPartsPayload;
  adminIeltsCheckPointRemoveWritingParts: CheckPointRemoveIeltsWritingPartsPayload;
  adminIeltsCheckPointUpdate: IeltsCheckPointUpdatePayload;
  adminIeltsCheckPointUpdateListeningParts: CheckPointUpdateIeltsListeningPartsPayload;
  adminIeltsCheckPointUpdateReadingParts: CheckPointUpdateIeltsReadingPartsPayload;
  adminIeltsCheckPointUpdateSpeakingParts: CheckPointUpdateIeltsSpeakingPartsPayload;
  adminIeltsCheckPointUpdateWritingParts: CheckPointUpdateIeltsWritingPartsPayload;
  adminIeltsListeningPartCreate: IeltsListeningPartCreatePayload;
  adminIeltsListeningPartDelete: IeltsListeningPartDeletePayload;
  adminIeltsListeningPartRemoveQuestions: IeltsListeningPartRemoveQuestionsPayload;
  adminIeltsListeningPartUpdate: IeltsListeningPartUpdatePayload;
  adminIeltsListeningPartUpdateQuestions: IeltsListeningPartUpdateQuestionsPayload;
  adminIeltsListeningQuestionCreate: IeltsListeningQuestionCreatePayload;
  adminIeltsListeningQuestionDelete: IeltsListeningQuestionDeletePayload;
  adminIeltsListeningQuestionUpdate: IeltsListeningQuestionUpdatePayload;
  adminIeltsReadingPartCreate: IeltsReadingPartCreatePayload;
  adminIeltsReadingPartDelete: IeltsReadingPartDeletePayload;
  adminIeltsReadingPartRemoveQuestions: IeltsReadingPartRemoveQuestionsPayload;
  adminIeltsReadingPartUpdate: IeltsReadingPartUpdatePayload;
  adminIeltsReadingPartUpdateQuestions: IeltsReadingPartUpdateQuestionsPayload;
  adminIeltsReadingQuestionCreate: IeltsReadingQuestionCreatePayload;
  adminIeltsReadingQuestionDelete: IeltsReadingQuestionDeletePayload;
  adminIeltsReadingQuestionUpdate: IeltsReadingQuestionUpdatePayload;
  adminIeltsSpeakingPartCreate: IeltsSpeakingPartCreatePayload;
  adminIeltsSpeakingPartDelete: IeltsSpeakingPartDeletePayload;
  adminIeltsSpeakingPartInfoCreate: IeltsSpeakingPartInfoCreatePayload;
  adminIeltsSpeakingPartInfoDelete: IeltsSpeakingPartInfoDeletePayload;
  adminIeltsSpeakingPartInfoUpdate: IeltsSpeakingPartInfoUpdatePayload;
  adminIeltsSpeakingPartRemoveQuestions: IeltsSpeakingPartRemoveQuestionsPayload;
  adminIeltsSpeakingPartUpdate: IeltsSpeakingPartUpdatePayload;
  adminIeltsSpeakingPartUpdateQuestions: IeltsSpeakingPartUpdateQuestionsPayload;
  adminIeltsSpeakingQuestionCreate: IeltsSpeakingQuestionCreatePayload;
  adminIeltsSpeakingQuestionDelete: IeltsSpeakingQuestionDeletePayload;
  adminIeltsSpeakingQuestionUpdate: IeltsSpeakingQuestionUpdatePayload;
  adminIeltsWritingPartCreate: IeltsWritingPartCreatePayload;
  adminIeltsWritingPartDelete: IeltsWritingPartDeletePayload;
  adminIeltsWritingPartRemoveQuestions: IeltsWritingPartRemoveQuestionsPayload;
  adminIeltsWritingPartUpdate: IeltsWritingPartUpdatePayload;
  adminIeltsWritingPartUpdateQuestions: IeltsWritingPartUpdateQuestionsPayload;
  adminIeltsWritingQuestionCreate: IeltsWritingQuestionCreatePayload;
  adminIeltsWritingQuestionDelete: IeltsWritingQuestionDeletePayload;
  adminIeltsWritingQuestionUpdate: IeltsWritingQuestionUpdatePayload;
  adminNotificationCreate: AdminNotificationPayload;
  adminNotificationEventCreate: NotificationEventCreatePayload;
  adminNotificationEventDelete: NotificationEventDeletePayload;
  adminNotificationEventSend: NotificationEventSendPayload;
  adminNotificationEventUpdate: NotificationEventUpdatePayload;
  adminPartTopicUpdate: AdminPartTopicUpdatePayload;
  adminPartnerAccessTokenCreate: AdminPartnerAccessTokenCreatePayload;
  adminPartnerSchoolInviteTeachersAcceptAll: AdminPartnerSchoolInviteTeachersAcceptAllPayload;
  adminPlacementTestGroupCreate: AdminPlacementTestGroupCreatePayload;
  adminPlacementTestGroupDelete: AdminPlacementTestGroupDeletePayload;
  adminPlacementTestGroupUpdate: AdminPlacementTestGroupUpdatePayload;
  adminSpeakingPartCreate: AdminSpeakingPartCreatePayload;
  adminSpeakingPartDelete: AdminSpeakingPartDeletePayload;
  adminSpeakingPartUpdate: AdminSpeakingPartUpdatePayload;
  adminStudyCharacterCreate: AdminStudyCharacterCreatePayload;
  adminStudyCharacterDelete: AdminStudyCharacterDeletePayload;
  adminStudyCharacterUpdate: AdminStudyCharacterUpdatePayload;
  adminTopicCreate: AdminTopicCreatePayload;
  adminTopicDelete: AdminTopicDeletePayload;
  adminTopicUpdate: AdminTopicUpdatePayload;
  adminUpdateDiscount: AdminUpdateDiscountPayload;
  adminUpdateOrderCode: AdminUpdateOrderCodePayload;
  adminUpdateTestLevelPackageFlyer: AdminUpdateTestLevelPackageFlyerPayload;
  adminUpdateUsername?: Maybe<AdminUpdateUsernamePayload>;
  adminUpdateVersionNotification: AdminUpdateVersionNotificationPayload;
  adminUserAttemptsScoreWithAi: AdminUserAttemptsScoreWithAiPayload;
  adminUserTeacherReferralUsagePays: AdminUserTeacherReferralUsagePaysPayload;
  adminViewerActivationCodeCreate: AdminViewerActivationCodeCreatePayload;
  adminViewerActivationCodeUpdate: AdminViewerActivationCodeUpdatePayload;
  adminViewerActiveCodeJoinClass?: Maybe<AdminViewerActiveCodeJoinClassPayload>;
  adminViewerFeaturedPlaylistCheckPointAdd: AdminViewerFeaturedPlaylistCheckPointAddPayload;
  adminViewerFeaturedPlaylistCheckPointRemove: AdminViewerFeaturedPlaylistCheckPointRemovePayload;
  adminViewerFeaturedPlaylistCreate: AdminViewerFeaturedPlaylistCreatePayload;
  adminViewerFeaturedPlaylistDelete: AdminViewerFeaturedPlaylistDeletePayload;
  adminViewerFeaturedPlaylistUpdate: AdminViewerFeaturedPlaylistUpdatePayload;
  adminViewerMenuNotificationCreate: AdminViewerMenuNotificationCreatePayload;
  adminViewerMenuNotificationDelete: AdminViewerMenuNotificationDeletePayload;
  adminViewerMenuNotificationUpdate: AdminViewerMenuNotificationUpdatePayload;
  adminViewerRevokeActiveCode: AdminViewerRevokeActiveCodePayload;
  adminViewerTestSpeechToText?: Maybe<Scalars['String']['output']>;
  adminViewerThemesCreate: AdminViewerThemesCreatePayload;
  adminViewerThemesDelete: AdminViewerThemesDeletePayload;
  adminViewerThemesUpdate: AdminViewerThemesUpdatePayload;
  adminViewerUserAttemptDelete: AdminViewerUserAttemptDeletePayload;
  adminVocabWordCreate: AdminVocabWordCreatePayload;
  adminVocabWordDelete: AdminVocabWordDeletePayload;
  adminVocabWordUpdate: AdminVocabWordUpdatePayload;
  adminWritingPartCreate: AdminWritingPartCreatePayload;
  adminWritingPartDelete: AdminWritingPartDeletePayload;
  adminWritingPartUpdate: AdminWritingPartUpdatePayload;
  autoTestUserCreate: AutoTestUserCreatePayload;
  autoTestUserDelete: AutoTestUserDeletePayload;
  autoTestUserUpdate: AutoTestUserUpdatePayload;
  challengeCreate: ChallengeCreatePayload;
  challengeEnd: ChallengeEndPayload;
  challengePlayerJoin: ChallengePlayerJoinPayload;
  checkPointTimeUpdate: CheckPointTimeUpdatePayload;
  createTeacherProfileAdmin: TeacherProfile;
  duolingoEndAttempt: DuolingoEndAttemptPayload;
  duolingoStartAttempt: DuolingoStartAttemptPayload;
  duolingoSubmitPartAttempt: DuolingoSubmitPartAttemptPayload;
  examEndAttempt: ExamEndAttemptPayload;
  examNextStructure: ExamNextStructurePayload;
  examStartAttempt: ExamStartAttemptPayload;
  examSubmitPartAttempt: ExamSubmitPartAttemptPayload;
  ieltsListeningEndAttempt: IeltsListeningEndAttemptPayload;
  ieltsListeningStartAttempt: IeltsListeningStartAttemptPayload;
  ieltsListeningSubmitPartAttempt: IeltsListeningSubmitPartAttemptPayload;
  ieltsReadingEndAttempt: IeltsReadingEndAttemptPayload;
  ieltsReadingStartAttempt: IeltsReadingStartAttemptPayload;
  ieltsReadingSubmitPartAttempt: IeltsReadingSubmitPartAttemptPayload;
  ieltsSpeakingEndAttempt: IeltsSpeakingEndAttemptPayload;
  ieltsSpeakingStartAttempt: IeltsSpeakingStartAttemptPayload;
  ieltsSpeakingSubmitPartAttempt: IeltsSpeakingSubmitPartAttemptPayload;
  /** @deprecated use ieltsSpeakingSubmitPartAttempt instead */
  ieltsSpeakingSubmitQuestionAttempt: IeltsSpeakingSubmitQuestionAttemptPayload;
  ieltsViewerNoteCreate: IeltsViewerNoteCreatePayload;
  ieltsViewerNoteRemove: IeltsViewerNoteRemovePayload;
  ieltsViewerNoteUpdate: IeltsViewerNoteUpdatePayload;
  ieltsWritingEndAttempt: IeltsWritingEndAttemptPayload;
  ieltsWritingStartAttempt: IeltsWritingStartAttemptPayload;
  ieltsWritingSubmitPartAttempt: IeltsWritingSubmitPartAttemptPayload;
  learnerStatsUpdateFromAttempt: LearnerStatsUpdateFromAttemptPayload;
  parentViewerSeenNotification: ParentViewerSeenNotificationPayload;
  partnerAssignTeachersToClasses: PartnerAssignTeachersToClassesPayload;
  partnerAssignTestCreate: PartnerAssignTestCreatePayload;
  partnerAssignTestSubmitUpdate: PartnerAssignTestSubmitUpdatePayload;
  partnerAssignTestUpdate: PartnerAssignTestUpdatePayload;
  partnerCheckPointReorderPracticeParts: PartnerCheckPointReorderPracticePartsPayload;
  partnerClassUpdate: PartnerClassUpdatePayload;
  partnerIeltsCheckPointCreate: PartnerIeltsCheckPointCreatePayload;
  partnerIeltsCheckPointRemove: PartnerIeltsCheckPointRemovePayload;
  partnerIeltsCheckPointUpdate: PartnerIeltsCheckPointUpdatePayload;
  partnerIeltsPartAddQuestions: PartnerIeltsPartAddQuestionsPayload;
  partnerIeltsPartCreate: PartnerIeltsPartCreatePayload;
  partnerIeltsPartRemove: PartnerIeltsPartRemovePayload;
  partnerIeltsPartUpdate: PartnerIeltsPartUpdatePayload;
  partnerIeltsQuestionCreate: PartnerIeltsQuestionCreatePayload;
  partnerIeltsQuestionRemove: PartnerIeltsQuestionRemovePayload;
  partnerIeltsQuestionUpdate: PartnerIeltsQuestionUpdatePayload;
  partnerIeltsSpeakingAttemptTeacherScore: PartnerIeltsSpeakingAttemptTeacherScorePayload;
  partnerIeltsSpeakingQuestionAttemptTeacherScore: PartnerIeltsSpeakingQuestionAttemptTeacherScorePayload;
  partnerPracticeCheckPointCreate: PartnerPracticeCheckPointCreatePayload;
  partnerPracticeCheckPointGen: PartnerPracticeCheckPointGenPayload;
  partnerPracticeCheckPointUpdate: PartnerPracticeCheckPointUpdatePayload;
  partnerPracticeCheckPointsArchive: PartnerPracticeCheckPointsArchivePayload;
  partnerPracticeCheckPointsDelete: PartnerPracticeCheckPointsDeletePayload;
  partnerPracticeCheckPointsPublish: PartnerPracticeCheckPointsPublishPayload;
  partnerPracticeCheckPointsUnarchive: PartnerPracticeCheckPointsUnarchivePayload;
  partnerPracticeCheckPointsUnpublish: PartnerPracticeCheckPointsUnpublishPayload;
  partnerPracticePartCreate: PartnerPracticePartCreatePayload;
  partnerPracticePartDelete: PartnerPracticePartDeletePayload;
  partnerPracticePartUpdate: PartnerPracticePartUpdatePayload;
  partnerTeacherMarkPointExam: PartnerTeacherMarkPointExamPayload;
  partnerViewerAISpeakingRecordUpdate: PartnerViewerAiSpeakingRecordUpdatePayload;
  partnerViewerAIThreadCreate: PartnerViewerAiThreadCreatePayload;
  partnerViewerAIThreadDelete: PartnerViewerAiThreadDeletePayload;
  partnerViewerAIThreadUpdate: PartnerViewerAiThreadUpdatePayload;
  partnerViewerAIWritingRecordUpdate: PartnerViewerAiWritingRecordUpdatePayload;
  partnerViewerAcceptLeaveClass: PartnerViewerAcceptLeaveClassPayload;
  partnerViewerAssignTestDelete: PartnerViewerAssignTestDeletePayload;
  partnerViewerAssignTestReAssign: PartnerViewerAssignTestReAssignPayload;
  partnerViewerAssignTestRemindParent: PartnerViewerAssignTestRemindParentPayload;
  partnerViewerAssignTestRemindStudent: PartnerViewerAssignTestRemindStudentPayload;
  partnerViewerChallengeCreate: PartnerViewerChallengeCreatePayload;
  partnerViewerChallengeEnd: PartnerViewerChallengeEndPayload;
  partnerViewerChallengeInvite: PartnerViewerChallengeInvitePayload;
  partnerViewerChallengeUpdate: PartnerViewerChallengeUpdatePayload;
  partnerViewerClassDelete: PartnerViewerClassDeletePayload;
  partnerViewerFeaturedPlaylistCheckPointAdd: PartnerViewerFeaturedPlaylistCheckPointAddPayload;
  partnerViewerFeaturedPlaylistCheckPointRemove: PartnerViewerFeaturedPlaylistCheckPointRemovePayload;
  partnerViewerFeaturedPlaylistCheckPointUpdate: PartnerViewerFeaturedPlaylistCheckPointUpdatePayload;
  partnerViewerFeaturedPlaylistCreate: PartnerViewerFeaturedPlaylistCreatePayload;
  partnerViewerFeaturedPlaylistDelete: PartnerViewerFeaturedPlaylistDeletePayload;
  partnerViewerFeaturedPlaylistUpdate: PartnerViewerFeaturedPlaylistUpdatePayload;
  partnerViewerInviteNewStudents: PartnerViewerInviteNewStudentsPayload;
  partnerViewerInviteStudentToClass: PartnerViewerInviteStudentToClassPayload;
  partnerViewerMoveClassStudent: PartnerViewerMoveClassStudentPayload;
  partnerViewerRejectLeaveClass: PartnerViewerRejectLeaveClassPayload;
  partnerViewerResetPasswordStudent: PartnerViewerResetPasswordStudentPayload;
  partnerViewerRolePermissionUpdate: PartnerViewerRolePermissionUpdatePayload;
  partnerViewerScoreSpeakingAI: PartnerViewerScoreSpeakingAiPayload;
  partnerViewerScoreWritingAI: PartnerViewerScoreWritingAiPayload;
  partnerViewerScoreWritingAIImage: PartnerViewerScoreWritingAiImagePayload;
  partnerViewerSendResultChallenge: PartnerViewerSendResultChallengePayload;
  partnerViewerSentEmailStudent: PartnerViewerSentEmailStudentPayload;
  partnerViewerStudentCreate: PartnerViewerStudentCreatePayload;
  partnerViewerStudentUpdate: PartnerViewerStudentUpdatePayload;
  partnerViewerStudentsDelete: PartnerViewerStudentDeletePayload;
  paymentCreateVNPUrl: PaymentCreateVnpUrlPayload;
  practiceEndAttempt: PracticeEndAttemptPayload;
  practiceStartAttempt: PracticeStartAttemptPayload;
  practiceSubmitPartAttempt: PracticeSubmitPartAttemptPayload;
  publicTo: Scalars['String']['output'];
  resultStatementCommentCreate: ResultStatementCommentCreatePayload;
  resultStatementCommentDelete: ResultStatementCommentDeletePayload;
  resultStatementCommentUpdate: ResultStatementCommentUpdatePayload;
  resultStatementCreate: ResultStatementCreatePayload;
  resultStatementDelete: ResultStatementDeletePayload;
  resultStatementUpdate: ResultStatementUpdatePayload;
  schoolRoleUpdate: SchoolRoleUpdatePayload;
  speakingEndAttempt: SpeakingEndAttemptPayload;
  speakingStartAttempt: SpeakingStartAttemptPayload;
  speakingSubmitDiscussionQuestionAttempt: SpeakingSubmitDiscussionQuestionAttemptPayload;
  speakingSubmitQuestionAttempt: SpeakingSubmitQuestionAttemptPayload;
  userActiveCodes: UserActiveCodePayload;
  userGenBulk: UserGenBulkPayload;
  userGenBulkPhone: UserGenBulkPhonePayload;
  userGenBulkUserName: UserGenBulkUserNamePayload;
  viewerAIConversationComplete: ViewerAiConversationCompletePayload;
  viewerAIConversationCreate: ViewerAiConversationCreatePayload;
  viewerAIConversationSessionCreate: ViewerAiConversationSessionPayload;
  viewerAIConversationUpdate: ViewerAiConversationUpdatePayload;
  viewerAIConversational: ViewerAiConversationalPayload;
  viewerAISpeakToText: ViewerAiSpeakToTextPayload;
  viewerActiveCode: ViewerActiveCodePayload;
  viewerAdviceCreate: ViewerAdviceCreatePayload;
  viewerBuyAvatarFrame: ViewerBuyAvatarFramePayload;
  viewerCreateLearnerProfile: ViewerCreateLearnerProfilePayload;
  viewerCreateParentProfile: ViewerCreateParentProfilePayload;
  viewerCreateTeacherProfile: ViewerCreateTeacherProfilePayload;
  viewerDailyRewardClaim?: Maybe<ViewerDailyRewardClaimPayload>;
  viewerDeleteAccount: ViewerDeleteAccountPayload;
  viewerExamSeenNotification: ViewerExamSeenNotificationPayload;
  viewerForceLogInByEmailToken: ViewerForceLogInByEmailTokenPayload;
  viewerJoinClass: ViewerJoinClassPayload;
  viewerLeftClass: ViewerLeftClassPayload;
  viewerLogIn: ViewerLogInPayload;
  viewerLogOut: ViewerLogOutPayload;
  viewerMistakeWordRecordScore: ViewerMistakeWordRecordScorePayload;
  viewerMistakeWordUpdate: ViewerMistakeWordUpdatePayload;
  /** @deprecated use partnerAssignTeachersToClasses instead */
  viewerPartnerClassAssignTeachers: ViewerPartnerClassAssignTeachersPayload;
  viewerPartnerClassRemoveTeachers: ViewerPartnerClassRemoveTeachersPayload;
  /** @deprecated use partnerAssignTestCreate instead */
  viewerPartnerCreateAssignTest: ViewerPartnerCreateAssignTestPayload;
  viewerPartnerCreateClass: ViewerPartnerCreateClassPayload;
  viewerPartnerSchoolInviteTeacher: ViewerPartnerSchoolInviteTeacherPayload;
  viewerPartnerSchoolInviteTeacherAccept: ViewerPartnerSchoolInviteTeacherAcceptPayload;
  viewerPartnerSchoolInviteTeacherDecline: ViewerPartnerSchoolInviteTeacherDeclinePayload;
  viewerPartnerSchoolInvitedTeacherDelete: ViewerPartnerSchoolInvitedTeacherDeletePayload;
  viewerPartnerSchoolInvitedTeacherEdit: ViewerPartnerSchoolInvitedTeacherEditPayload;
  viewerPartnerSeenNotification: ViewerPartnerSeenNotificationPayload;
  viewerRecoverAccount: ViewerRecoverAccountPayload;
  viewerRecoverPassword: ViewerRecoverPasswordPayload;
  viewerResendEmailVerification: EmailResendVerificationPayload;
  viewerRestoreInAppPurchases: ViewerRestoreInAppPurchasesPayload;
  viewerSeenAchievements: ViewerSeenAchievementsPayload;
  viewerSendOtp: ViewerSendOtpPayload;
  viewerSignUp: ViewerSignUpPayload;
  viewerSwitchLearnerProfile: ViewerSwitchLearnerProfilePayload;
  viewerSwitchSchool: ViewerSwitchSchoolPayload;
  viewerTeacherInvitationAccept: ViewerTeacherInvitationAcceptPayload;
  viewerTranscription: ViewerTranscriptionPayload;
  viewerUpdateEmail: ViewerUpdateEmailPayload;
  viewerUpdateFcmToken: ViewerUpdateFcmTokenPayload;
  viewerUpdateLearnerProfile: ViewerUpdateLearnerProfilePayload;
  viewerUpdateParentProfile: ViewerUpdateParentProfilePayload;
  viewerUpdatePassword: ViewerUpdatePasswordPayload;
  viewerUpdatePhoneNumber: ViewerUpdatePhoneNumberPayload;
  viewerUpdateTeacherProfile: ViewerUpdateTeacherProfilePayload;
  viewerUpdateUsername: ViewerUpdateUsernamePayload;
  viewerUserAttemptSeenReward: ViewerUserAttemptSeenRewardPayload;
  viewerVerifyOwnerByEmailToken: ViewerVerifyOwnerByEmailTokenPayload;
  writingEndAttempt: WritingEndAttemptPayload;
  writingStartAttempt: WritingStartAttemptPayload;
  writingSubmitPartAttempt: WritingSubmitPartAttemptPayload;
};


export type MutationAdminActivationCodeUpdateArgs = {
  input: AdminActivationCodeUpdateInput;
};


export type MutationAdminActiveCodeArgs = {
  input: AdminActiveCodeInput;
};


export type MutationAdminAvatarFrameCreateArgs = {
  input: AvatarFrameCreateInput;
};


export type MutationAdminAvatarFrameDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminAvatarFrameUpdateArgs = {
  input: AvatarFrameUpdateInput;
};


export type MutationAdminBookCreateArgs = {
  input: AdminBookCreateInput;
};


export type MutationAdminBookDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminBookLessonCreateArgs = {
  input: AdminBookLessonCreateInput;
};


export type MutationAdminBookLessonDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminBookLessonRemoveCheckPointsArgs = {
  checkPointIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAdminBookLessonUpdateArgs = {
  input: AdminBookLessonUpdateInput;
};


export type MutationAdminBookLessonUpdateCheckPointsArgs = {
  id: Scalars['ID']['input'];
  updates: Array<BookLessonCheckPointInput>;
};


export type MutationAdminBookUnitCreateArgs = {
  input: AdminBookUnitCreateInput;
};


export type MutationAdminBookUnitDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminBookUnitUpdateArgs = {
  input: AdminBookUnitUpdateInput;
};


export type MutationAdminBookUnitUpdateLessonsArgs = {
  id: Scalars['ID']['input'];
  updates: Array<BookUnitUpdateLessonInput>;
};


export type MutationAdminBookUpdateArgs = {
  input: AdminBookUpdateInput;
};


export type MutationAdminBookUpdateUnitsArgs = {
  id: Scalars['ID']['input'];
  updates: Array<BookUpdateUnitInput>;
};


export type MutationAdminCheckPointCreateArgs = {
  input: AdminCheckPointCreateInput;
};


export type MutationAdminCheckPointCustomDomainUpdateArgs = {
  input: AdminCheckPointCustomDomainUpdateInput;
};


export type MutationAdminCheckPointDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminCheckPointRemoveDuolingoPartsArgs = {
  id: Scalars['ID']['input'];
  partIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminCheckPointRemoveSpeakingPartsArgs = {
  id: Scalars['ID']['input'];
  partIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminCheckPointRemoveWritingPartsArgs = {
  id: Scalars['ID']['input'];
  partIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminCheckPointTopicUpdateArgs = {
  input: AdminCheckPointTopicUpdateInput;
};


export type MutationAdminCheckPointUpdateArgs = {
  input: AdminCheckPointUpdateInput;
};


export type MutationAdminCheckPointUpdateDuolingoPartsArgs = {
  id: Scalars['ID']['input'];
  updates: Array<AdminCheckPointDuolingoPartInput>;
};


export type MutationAdminCheckPointUpdateSpeakingPartsArgs = {
  id: Scalars['ID']['input'];
  updates: Array<CheckPointSpeakingPartInput>;
};


export type MutationAdminCheckPointUpdateWritingPartsArgs = {
  id: Scalars['ID']['input'];
  updates: Array<CheckPointWritingPartInput>;
};


export type MutationAdminCreateDiscountArgs = {
  input: AdminCreateDiscountInput;
};


export type MutationAdminCreateOrderCodeArgs = {
  input: AdminCreateOrderCodeInput;
};


export type MutationAdminCreateVersionNotificationArgs = {
  input: AdminCreateVersionNotificationInput;
};


export type MutationAdminCustomDomainUpdateArgs = {
  input: AdminCustomDomainUpdateInput;
};


export type MutationAdminDeleteDiscountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteVersionNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDuolingoPartCreateArgs = {
  input: AdminDuolingoPartCreateInput;
};


export type MutationAdminDuolingoPartDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDuolingoPartUpdateArgs = {
  input: AdminDuolingoPartUpdateInput;
};


export type MutationAdminExamPartCreateArgs = {
  input: AdminExamPartCreateInput;
};


export type MutationAdminExamPartUpdateArgs = {
  input: AdminExamPartUpdateInput;
};


export type MutationAdminIeltsCheckPointCreateArgs = {
  input: IeltsCheckPointCreateInput;
};


export type MutationAdminIeltsCheckPointDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminIeltsCheckPointRemoveListeningPartsArgs = {
  id: Scalars['ID']['input'];
  partIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminIeltsCheckPointRemoveReadingPartsArgs = {
  id: Scalars['ID']['input'];
  partIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminIeltsCheckPointRemoveSpeakingPartsArgs = {
  id: Scalars['ID']['input'];
  partIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminIeltsCheckPointRemoveWritingPartsArgs = {
  id: Scalars['ID']['input'];
  partIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminIeltsCheckPointUpdateArgs = {
  input: IeltsCheckPointUpdateInput;
};


export type MutationAdminIeltsCheckPointUpdateListeningPartsArgs = {
  id: Scalars['ID']['input'];
  updates: Array<CheckPointIeltsListeningPartInput>;
};


export type MutationAdminIeltsCheckPointUpdateReadingPartsArgs = {
  id: Scalars['ID']['input'];
  updates: Array<CheckPointIeltsReadingPartInput>;
};


export type MutationAdminIeltsCheckPointUpdateSpeakingPartsArgs = {
  id: Scalars['ID']['input'];
  updates: Array<CheckPointIeltsSpeakingPartInput>;
};


export type MutationAdminIeltsCheckPointUpdateWritingPartsArgs = {
  id: Scalars['ID']['input'];
  updates: Array<CheckPointIeltsWritingPartInput>;
};


export type MutationAdminIeltsListeningPartCreateArgs = {
  input: IeltsListeningPartCreateInput;
};


export type MutationAdminIeltsListeningPartDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminIeltsListeningPartRemoveQuestionsArgs = {
  id: Scalars['ID']['input'];
  questionIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminIeltsListeningPartUpdateArgs = {
  input: IeltsListeningPartUpdateInput;
};


export type MutationAdminIeltsListeningPartUpdateQuestionsArgs = {
  id: Scalars['ID']['input'];
  updates: Array<IeltsListeningPartQuestionInput>;
};


export type MutationAdminIeltsListeningQuestionCreateArgs = {
  input: IeltsListeningQuestionCreateInput;
};


export type MutationAdminIeltsListeningQuestionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminIeltsListeningQuestionUpdateArgs = {
  input: IeltsListeningQuestionUpdateInput;
};


export type MutationAdminIeltsReadingPartCreateArgs = {
  input: IeltsReadingPartCreateInput;
};


export type MutationAdminIeltsReadingPartDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminIeltsReadingPartRemoveQuestionsArgs = {
  id: Scalars['ID']['input'];
  questionIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminIeltsReadingPartUpdateArgs = {
  input: IeltsReadingPartUpdateInput;
};


export type MutationAdminIeltsReadingPartUpdateQuestionsArgs = {
  id: Scalars['ID']['input'];
  updates: Array<IeltsReadingPartQuestionInput>;
};


export type MutationAdminIeltsReadingQuestionCreateArgs = {
  input: IeltsReadingQuestionCreateInput;
};


export type MutationAdminIeltsReadingQuestionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminIeltsReadingQuestionUpdateArgs = {
  input: IeltsReadingQuestionUpdateInput;
};


export type MutationAdminIeltsSpeakingPartCreateArgs = {
  input: IeltsSpeakingPartCreateInput;
};


export type MutationAdminIeltsSpeakingPartDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminIeltsSpeakingPartInfoCreateArgs = {
  input: IeltsSpeakingPartInfoCreateInput;
};


export type MutationAdminIeltsSpeakingPartInfoDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminIeltsSpeakingPartInfoUpdateArgs = {
  input: IeltsSpeakingPartInfoUpdateInput;
};


export type MutationAdminIeltsSpeakingPartRemoveQuestionsArgs = {
  id: Scalars['ID']['input'];
  questionIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminIeltsSpeakingPartUpdateArgs = {
  input: IeltsSpeakingPartUpdateInput;
};


export type MutationAdminIeltsSpeakingPartUpdateQuestionsArgs = {
  id: Scalars['ID']['input'];
  updates: Array<IeltsSpeakingPartQuestionInput>;
};


export type MutationAdminIeltsSpeakingQuestionCreateArgs = {
  input: IeltsSpeakingQuestionCreateInput;
};


export type MutationAdminIeltsSpeakingQuestionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminIeltsSpeakingQuestionUpdateArgs = {
  input: IeltsSpeakingQuestionUpdateInput;
};


export type MutationAdminIeltsWritingPartCreateArgs = {
  input: IeltsWritingPartCreateInput;
};


export type MutationAdminIeltsWritingPartDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminIeltsWritingPartRemoveQuestionsArgs = {
  id: Scalars['ID']['input'];
  questionIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminIeltsWritingPartUpdateArgs = {
  input: IeltsWritingPartUpdateInput;
};


export type MutationAdminIeltsWritingPartUpdateQuestionsArgs = {
  id: Scalars['ID']['input'];
  updates: Array<IeltsWritingPartQuestionInput>;
};


export type MutationAdminIeltsWritingQuestionCreateArgs = {
  input: IeltsWritingQuestionCreateInput;
};


export type MutationAdminIeltsWritingQuestionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminIeltsWritingQuestionUpdateArgs = {
  input: IeltsWritingQuestionUpdateInput;
};


export type MutationAdminNotificationCreateArgs = {
  input: AdminNotificationInput;
};


export type MutationAdminNotificationEventCreateArgs = {
  input: NotificationEventCreateInput;
};


export type MutationAdminNotificationEventDeleteArgs = {
  input: NotificationEventDeleteInput;
};


export type MutationAdminNotificationEventSendArgs = {
  input: NotificationEventSendInput;
};


export type MutationAdminNotificationEventUpdateArgs = {
  input: NotificationEventUpdateInput;
};


export type MutationAdminPartTopicUpdateArgs = {
  input: AdminPartTopicUpdateInput;
};


export type MutationAdminPartnerAccessTokenCreateArgs = {
  input: AdminPartnerAccessTokenCreateInput;
};


export type MutationAdminPartnerSchoolInviteTeachersAcceptAllArgs = {
  input: AdminPartnerSchoolInviteTeachersAcceptAllInput;
};


export type MutationAdminPlacementTestGroupCreateArgs = {
  input: AdminPlacementTestGroupCreateInput;
};


export type MutationAdminPlacementTestGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminPlacementTestGroupUpdateArgs = {
  input: AdminPlacementTestGroupUpdateInput;
};


export type MutationAdminSpeakingPartCreateArgs = {
  input: AdminSpeakingPartCreateInput;
};


export type MutationAdminSpeakingPartDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminSpeakingPartUpdateArgs = {
  input: AdminSpeakingPartUpdateInput;
};


export type MutationAdminStudyCharacterCreateArgs = {
  input: AdminStudyCharacterCreateInput;
};


export type MutationAdminStudyCharacterDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminStudyCharacterUpdateArgs = {
  input: AdminStudyCharacterUpdateInput;
};


export type MutationAdminTopicCreateArgs = {
  input: AdminTopicCreateInput;
};


export type MutationAdminTopicDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminTopicUpdateArgs = {
  input: AdminTopicUpdateInput;
};


export type MutationAdminUpdateDiscountArgs = {
  input: AdminUpdateDiscountInput;
};


export type MutationAdminUpdateOrderCodeArgs = {
  input: AdminUpdateOrderCodeInput;
};


export type MutationAdminUpdateTestLevelPackageFlyerArgs = {
  input: AdminUpdateTestLevelPackageFlyerInput;
};


export type MutationAdminUpdateUsernameArgs = {
  input: AdminUpdateUsernameInput;
};


export type MutationAdminUpdateVersionNotificationArgs = {
  input: AdminUpdateVersionNotificationInput;
};


export type MutationAdminUserAttemptsScoreWithAiArgs = {
  input: AdminUserAttemptsScoreWithAiInput;
};


export type MutationAdminUserTeacherReferralUsagePaysArgs = {
  input: AdminUserTeacherReferralUsagePaysInput;
};


export type MutationAdminViewerActivationCodeCreateArgs = {
  input: AdminViewerActivationCodeCreateInput;
};


export type MutationAdminViewerActivationCodeUpdateArgs = {
  input: AdminViewerActivationCodeUpdateInput;
};


export type MutationAdminViewerActiveCodeJoinClassArgs = {
  input: AdminViewerActiveCodeJoinClassInput;
};


export type MutationAdminViewerFeaturedPlaylistCheckPointAddArgs = {
  input: AdminViewerFeaturedPlaylistCheckPointAddInput;
};


export type MutationAdminViewerFeaturedPlaylistCheckPointRemoveArgs = {
  input: AdminViewerFeaturedPlaylistCheckPointRemoveInput;
};


export type MutationAdminViewerFeaturedPlaylistCreateArgs = {
  input: AdminViewerFeaturedPlaylistCreateInput;
};


export type MutationAdminViewerFeaturedPlaylistDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminViewerFeaturedPlaylistUpdateArgs = {
  input: AdminViewerFeaturedPlaylistUpdateInput;
};


export type MutationAdminViewerMenuNotificationCreateArgs = {
  input: AdminViewerMenuNotificationCreateInput;
};


export type MutationAdminViewerMenuNotificationDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminViewerMenuNotificationUpdateArgs = {
  input: AdminViewerMenuNotificationUpdateInput;
};


export type MutationAdminViewerRevokeActiveCodeArgs = {
  input: AdminViewerRevokeActiveCodeInput;
};


export type MutationAdminViewerTestSpeechToTextArgs = {
  audioId: Scalars['String']['input'];
  isWhisper?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAdminViewerThemesCreateArgs = {
  input: AdminViewerThemesCreateInput;
};


export type MutationAdminViewerThemesDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminViewerThemesUpdateArgs = {
  input: AdminViewerThemesUpdateInput;
};


export type MutationAdminViewerUserAttemptDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminVocabWordCreateArgs = {
  input: AdminVocabWordCreateInput;
};


export type MutationAdminVocabWordDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminVocabWordUpdateArgs = {
  input: AdminVocabWordUpdateInput;
};


export type MutationAdminWritingPartCreateArgs = {
  input: AdminWritingPartCreateInput;
};


export type MutationAdminWritingPartDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminWritingPartUpdateArgs = {
  input: AdminWritingPartUpdateInput;
};


export type MutationAutoTestUserCreateArgs = {
  input: AutoTestUserCreatePayloadInput;
};


export type MutationAutoTestUserDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAutoTestUserUpdateArgs = {
  input: AutoTestUserUpdatePayloadInput;
};


export type MutationChallengeCreateArgs = {
  input: ChallengeCreateInput;
};


export type MutationChallengeEndArgs = {
  input: ChallengeEndInput;
};


export type MutationChallengePlayerJoinArgs = {
  input: ChallengePlayerJoinInput;
};


export type MutationCheckPointTimeUpdateArgs = {
  input: CheckPointTimeUpdateInput;
};


export type MutationCreateTeacherProfileAdminArgs = {
  input: CreateTeacherProfileAdminInput;
};


export type MutationDuolingoEndAttemptArgs = {
  input: DuolingoEndAttemptInput;
};


export type MutationDuolingoStartAttemptArgs = {
  input: DuolingoStartAttemptInput;
};


export type MutationDuolingoSubmitPartAttemptArgs = {
  input: DuolingoSubmitPartAttemptInput;
};


export type MutationExamEndAttemptArgs = {
  input: ExamEndAttemptInput;
};


export type MutationExamNextStructureArgs = {
  input: ExamNextStructureInput;
};


export type MutationExamStartAttemptArgs = {
  input: ExamStartAttemptInput;
};


export type MutationExamSubmitPartAttemptArgs = {
  input: ExamSubmitPartAttemptInput;
};


export type MutationIeltsListeningEndAttemptArgs = {
  input: IeltsListeningEndAttemptInput;
};


export type MutationIeltsListeningStartAttemptArgs = {
  input: IeltsListeningStartAttemptInput;
};


export type MutationIeltsListeningSubmitPartAttemptArgs = {
  input: IeltsListeningSubmitPartAttemptInput;
};


export type MutationIeltsReadingEndAttemptArgs = {
  input: IeltsReadingEndAttemptInput;
};


export type MutationIeltsReadingStartAttemptArgs = {
  input: IeltsReadingStartAttemptInput;
};


export type MutationIeltsReadingSubmitPartAttemptArgs = {
  input: IeltsReadingSubmitPartAttemptInput;
};


export type MutationIeltsSpeakingEndAttemptArgs = {
  input: IeltsSpeakingEndAttemptInput;
};


export type MutationIeltsSpeakingStartAttemptArgs = {
  input: IeltsSpeakingStartAttemptInput;
};


export type MutationIeltsSpeakingSubmitPartAttemptArgs = {
  input: IeltsSpeakingSubmitPartAttemptInput;
};


export type MutationIeltsSpeakingSubmitQuestionAttemptArgs = {
  input: IeltsSpeakingSubmitQuestionAttemptInput;
};


export type MutationIeltsViewerNoteCreateArgs = {
  input: IeltsViewerNoteCreateInput;
};


export type MutationIeltsViewerNoteRemoveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationIeltsViewerNoteUpdateArgs = {
  input: IeltsViewerNoteUpdateInput;
};


export type MutationIeltsWritingEndAttemptArgs = {
  input: IeltsWritingEndAttemptInput;
};


export type MutationIeltsWritingStartAttemptArgs = {
  input: IeltsWritingStartAttemptInput;
};


export type MutationIeltsWritingSubmitPartAttemptArgs = {
  input: IeltsWritingSubmitPartAttemptInput;
};


export type MutationLearnerStatsUpdateFromAttemptArgs = {
  input: LearnerStatsUpdateFromAttemptInput;
};


export type MutationParentViewerSeenNotificationArgs = {
  input: ParentViewerSeenNotificationInput;
};


export type MutationPartnerAssignTeachersToClassesArgs = {
  input: PartnerAssignTeachersToClassesInput;
};


export type MutationPartnerAssignTestCreateArgs = {
  input: PartnerAssignTestCreateInput;
};


export type MutationPartnerAssignTestSubmitUpdateArgs = {
  input: PartnerAssignTestSubmitUpdateInput;
};


export type MutationPartnerAssignTestUpdateArgs = {
  input: PartnerAssignTestUpdateInput;
};


export type MutationPartnerCheckPointReorderPracticePartsArgs = {
  checkPointId: Scalars['ID']['input'];
  partIds: Array<Scalars['ID']['input']>;
};


export type MutationPartnerClassUpdateArgs = {
  input: PartnerClassUpdateInput;
};


export type MutationPartnerIeltsCheckPointCreateArgs = {
  input: PartnerIeltsCheckPointCreateInput;
};


export type MutationPartnerIeltsCheckPointRemoveArgs = {
  input: PartnerIeltsCheckPointRemoveInput;
};


export type MutationPartnerIeltsCheckPointUpdateArgs = {
  input: PartnerIeltsCheckPointUpdateInput;
};


export type MutationPartnerIeltsPartAddQuestionsArgs = {
  input: PartnerIeltsPartAddQuestionsInput;
};


export type MutationPartnerIeltsPartCreateArgs = {
  input: PartnerIeltsPartCreateInput;
};


export type MutationPartnerIeltsPartRemoveArgs = {
  input: PartnerIeltsPartRemoveInput;
};


export type MutationPartnerIeltsPartUpdateArgs = {
  input: PartnerIeltsPartUpdateInput;
};


export type MutationPartnerIeltsQuestionCreateArgs = {
  input: PartnerIeltsQuestionCreateInput;
};


export type MutationPartnerIeltsQuestionRemoveArgs = {
  input: PartnerIeltsQuestionRemoveInput;
};


export type MutationPartnerIeltsQuestionUpdateArgs = {
  input: PartnerIeltsQuestionUpdateInput;
};


export type MutationPartnerIeltsSpeakingAttemptTeacherScoreArgs = {
  input: PartnerIeltsSpeakingAttemptTeacherScoreInput;
};


export type MutationPartnerIeltsSpeakingQuestionAttemptTeacherScoreArgs = {
  input: PartnerIeltsSpeakingQuestionAttemptTeacherScoreInput;
};


export type MutationPartnerPracticeCheckPointCreateArgs = {
  input?: InputMaybe<PartnerPracticeCheckPointCreateInput>;
};


export type MutationPartnerPracticeCheckPointGenArgs = {
  input?: InputMaybe<PartnerPracticeCheckPointGenInput>;
};


export type MutationPartnerPracticeCheckPointUpdateArgs = {
  input?: InputMaybe<PartnerPracticeCheckPointUpdateInput>;
};


export type MutationPartnerPracticeCheckPointsArchiveArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationPartnerPracticeCheckPointsDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationPartnerPracticeCheckPointsPublishArgs = {
  community?: InputMaybe<Scalars['Boolean']['input']>;
  domainIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids: Array<Scalars['ID']['input']>;
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationPartnerPracticeCheckPointsUnarchiveArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationPartnerPracticeCheckPointsUnpublishArgs = {
  community?: InputMaybe<Scalars['Boolean']['input']>;
  domainIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids: Array<Scalars['ID']['input']>;
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationPartnerPracticePartCreateArgs = {
  input: PartnerPracticePartCreateInput;
};


export type MutationPartnerPracticePartDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPartnerPracticePartUpdateArgs = {
  input: PartnerPracticePartUpdateInput;
};


export type MutationPartnerTeacherMarkPointExamArgs = {
  input: PartnerTeacherMarkPointExamInput;
};


export type MutationPartnerViewerAiSpeakingRecordUpdateArgs = {
  input: PartnerViewerAiSpeakingRecordUpdateInput;
};


export type MutationPartnerViewerAiThreadCreateArgs = {
  input: PartnerViewerAiThreadCreateInput;
};


export type MutationPartnerViewerAiThreadDeleteArgs = {
  input: PartnerViewerAiThreadDeleteInput;
};


export type MutationPartnerViewerAiThreadUpdateArgs = {
  input: PartnerViewerAiThreadUpdateInput;
};


export type MutationPartnerViewerAiWritingRecordUpdateArgs = {
  input: PartnerViewerAiWritingRecordUpdateInput;
};


export type MutationPartnerViewerAcceptLeaveClassArgs = {
  input: PartnerViewerAcceptLeaveClassInput;
};


export type MutationPartnerViewerAssignTestDeleteArgs = {
  input: PartnerViewerAssignTestDeleteInput;
};


export type MutationPartnerViewerAssignTestReAssignArgs = {
  input: PartnerViewerAssignTestReAssignInput;
};


export type MutationPartnerViewerAssignTestRemindParentArgs = {
  input: PartnerViewerAssignTestRemindParentInput;
};


export type MutationPartnerViewerAssignTestRemindStudentArgs = {
  input: PartnerViewerAssignTestRemindStudentInput;
};


export type MutationPartnerViewerChallengeCreateArgs = {
  input: PartnerViewerChallengeCreateInput;
};


export type MutationPartnerViewerChallengeEndArgs = {
  input: PartnerViewerChallengeEndInput;
};


export type MutationPartnerViewerChallengeInviteArgs = {
  input: PartnerViewerChallengeInviteInput;
};


export type MutationPartnerViewerChallengeUpdateArgs = {
  input: PartnerViewerChallengeUpdateInput;
};


export type MutationPartnerViewerClassDeleteArgs = {
  input: PartnerViewerClassDeleteInput;
};


export type MutationPartnerViewerFeaturedPlaylistCheckPointAddArgs = {
  input: PartnerViewerFeaturedPlaylistCheckPointAddInput;
};


export type MutationPartnerViewerFeaturedPlaylistCheckPointRemoveArgs = {
  input: PartnerViewerFeaturedPlaylistCheckPointRemoveInput;
};


export type MutationPartnerViewerFeaturedPlaylistCheckPointUpdateArgs = {
  input: PartnerViewerFeaturedPlaylistCheckPointUpdateInput;
};


export type MutationPartnerViewerFeaturedPlaylistCreateArgs = {
  input: PartnerViewerFeaturedPlaylistCreateInput;
};


export type MutationPartnerViewerFeaturedPlaylistDeleteArgs = {
  input: PartnerViewerFeaturedPlaylistDeleteInput;
};


export type MutationPartnerViewerFeaturedPlaylistUpdateArgs = {
  input: PartnerViewerFeaturedPlaylistUpdateInput;
};


export type MutationPartnerViewerInviteNewStudentsArgs = {
  input: PartnerViewerInviteNewStudentsInput;
};


export type MutationPartnerViewerInviteStudentToClassArgs = {
  input: PartnerViewerInviteStudentToClassInput;
};


export type MutationPartnerViewerMoveClassStudentArgs = {
  input: PartnerViewerMoveClassStudentInput;
};


export type MutationPartnerViewerRejectLeaveClassArgs = {
  input: PartnerViewerRejectLeaveClassInput;
};


export type MutationPartnerViewerResetPasswordStudentArgs = {
  input: PartnerViewerResetPasswordStudentInput;
};


export type MutationPartnerViewerRolePermissionUpdateArgs = {
  input: PartnerViewerRolePermissionUpdateInput;
};


export type MutationPartnerViewerScoreSpeakingAiArgs = {
  input: PartnerViewerScoreSpeakingAiInput;
};


export type MutationPartnerViewerScoreWritingAiArgs = {
  input: PartnerViewerScoreWritingAiInput;
};


export type MutationPartnerViewerScoreWritingAiImageArgs = {
  input: PartnerViewerScoreWritingAiImageInput;
};


export type MutationPartnerViewerSendResultChallengeArgs = {
  input: PartnerViewerSendResultChallengeInput;
};


export type MutationPartnerViewerSentEmailStudentArgs = {
  input: PartnerViewerSentEmailStudentInput;
};


export type MutationPartnerViewerStudentCreateArgs = {
  input: PartnerViewerStudentCreateInput;
};


export type MutationPartnerViewerStudentUpdateArgs = {
  input: PartnerViewerStudentUpdateInput;
};


export type MutationPartnerViewerStudentsDeleteArgs = {
  input: PartnerViewerStudentDeleteInput;
};


export type MutationPaymentCreateVnpUrlArgs = {
  input: PaymentCreateVnpUrlInput;
};


export type MutationPracticeEndAttemptArgs = {
  input: PracticeEndAttemptInput;
};


export type MutationPracticeStartAttemptArgs = {
  input: PracticeStartAttemptInput;
};


export type MutationPracticeSubmitPartAttemptArgs = {
  input: PracticeSubmitPartAttemptInput;
};


export type MutationPublicToArgs = {
  event: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationResultStatementCommentCreateArgs = {
  input: ResultStatementCommentCreateInput;
};


export type MutationResultStatementCommentDeleteArgs = {
  input: ResultStatementCommentDeleteInput;
};


export type MutationResultStatementCommentUpdateArgs = {
  input: ResultStatementCommentUpdateInput;
};


export type MutationResultStatementCreateArgs = {
  input: ResultStatementCreateInput;
};


export type MutationResultStatementDeleteArgs = {
  input: ResultStatementDeleteInput;
};


export type MutationResultStatementUpdateArgs = {
  input: ResultStatementUpdateInput;
};


export type MutationSchoolRoleUpdateArgs = {
  input: SchoolRoleUpdateInput;
};


export type MutationSpeakingEndAttemptArgs = {
  input: SpeakingEndAttemptInput;
};


export type MutationSpeakingStartAttemptArgs = {
  input: SpeakingStartAttemptInput;
};


export type MutationSpeakingSubmitDiscussionQuestionAttemptArgs = {
  input: SpeakingSubmitDiscussionQuestionAttemptInput;
};


export type MutationSpeakingSubmitQuestionAttemptArgs = {
  input: SpeakingSubmitQuestionAttemptInput;
};


export type MutationUserActiveCodesArgs = {
  input: Array<UserActiveCodeInput>;
};


export type MutationUserGenBulkArgs = {
  input: UserGenBulkInput;
};


export type MutationUserGenBulkPhoneArgs = {
  input: UserGenBulkPhoneInput;
};


export type MutationUserGenBulkUserNameArgs = {
  input: Array<UserGenBulkUserNameInput>;
};


export type MutationViewerAiConversationCompleteArgs = {
  input: ViewerAiConversationCompleteInput;
};


export type MutationViewerAiConversationCreateArgs = {
  input: ViewerAiConversationCreateInput;
};


export type MutationViewerAiConversationSessionCreateArgs = {
  input?: InputMaybe<ViewerAiConversationSessionCreateInput>;
};


export type MutationViewerAiConversationUpdateArgs = {
  input: ViewerAiConversationUpdateInput;
};


export type MutationViewerAiSpeakToTextArgs = {
  audioBase64Url: Scalars['String']['input'];
};


export type MutationViewerActiveCodeArgs = {
  input: ViewerActiveCodeInput;
};


export type MutationViewerAdviceCreateArgs = {
  input: ViewerAdviceCreateInput;
};


export type MutationViewerBuyAvatarFrameArgs = {
  input: ViewerBuyAvatarFrameInput;
};


export type MutationViewerCreateLearnerProfileArgs = {
  input: ViewerCreateLearnerProfileInput;
  switchProfile?: Scalars['Boolean']['input'];
};


export type MutationViewerCreateParentProfileArgs = {
  input: ViewerCreateParentProfileInput;
};


export type MutationViewerCreateTeacherProfileArgs = {
  input: ViewerCreateTeacherProfileInput;
};


export type MutationViewerExamSeenNotificationArgs = {
  input: ViewerExamSeenNotificationInput;
};


export type MutationViewerForceLogInByEmailTokenArgs = {
  input: ViewerForceLogInByEmailTokenInput;
};


export type MutationViewerJoinClassArgs = {
  input: ViewerJoinClassInput;
};


export type MutationViewerLeftClassArgs = {
  classId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationViewerLogInArgs = {
  input: ViewerLogInInput;
};


export type MutationViewerMistakeWordRecordScoreArgs = {
  input: ViewerMistakeWordRecordScoreInput;
};


export type MutationViewerMistakeWordUpdateArgs = {
  input: ViewerMistakeWordUpdateInput;
};


export type MutationViewerPartnerClassAssignTeachersArgs = {
  input: ViewerPartnerClassAssignTeachersInput;
};


export type MutationViewerPartnerClassRemoveTeachersArgs = {
  input: ViewerPartnerClassRemoveTeachersInput;
};


export type MutationViewerPartnerCreateAssignTestArgs = {
  input: ViewerPartnerCreateAssignTestInput;
};


export type MutationViewerPartnerCreateClassArgs = {
  input: ViewerPartnerCreateClassInput;
};


export type MutationViewerPartnerSchoolInviteTeacherArgs = {
  input: ViewerPartnerSchoolInviteTeacherInput;
};


export type MutationViewerPartnerSchoolInviteTeacherAcceptArgs = {
  input: ViewerPartnerSchoolInviteTeacherAcceptInput;
};


export type MutationViewerPartnerSchoolInviteTeacherDeclineArgs = {
  input: ViewerPartnerSchoolInviteTeacherDeclineInput;
};


export type MutationViewerPartnerSchoolInvitedTeacherDeleteArgs = {
  input: ViewerPartnerSchoolInvitedTeacherDeleteInput;
};


export type MutationViewerPartnerSchoolInvitedTeacherEditArgs = {
  input: ViewerPartnerSchoolInvitedTeacherEditInput;
};


export type MutationViewerPartnerSeenNotificationArgs = {
  input: ViewerPartnerSeenNotificationInput;
};


export type MutationViewerRecoverPasswordArgs = {
  input: ViewerRecoverPasswordInput;
};


export type MutationViewerRestoreInAppPurchasesArgs = {
  input?: InputMaybe<ViewerRestoreInAppPurchasesInput>;
};


export type MutationViewerSeenAchievementsArgs = {
  inputs: Array<ViewerSeenAchievementInput>;
};


export type MutationViewerSendOtpArgs = {
  input: ViewerSendOtpInput;
};


export type MutationViewerSignUpArgs = {
  input: ViewerSignUpInput;
};


export type MutationViewerSwitchLearnerProfileArgs = {
  input: ViewerSwitchLearnerProfileInput;
};


export type MutationViewerSwitchSchoolArgs = {
  input: ViewerSwitchSchoolInput;
};


export type MutationViewerTeacherInvitationAcceptArgs = {
  input: ViewerTeacherInvitationAcceptInput;
};


export type MutationViewerTranscriptionArgs = {
  input: ViewerTranscriptionInput;
};


export type MutationViewerUpdateEmailArgs = {
  input: ViewerUpdateEmailInput;
};


export type MutationViewerUpdateFcmTokenArgs = {
  input: ViewerUpdateFcmTokenInput;
};


export type MutationViewerUpdateLearnerProfileArgs = {
  input: ViewerUpdateLearnerProfileInput;
};


export type MutationViewerUpdateParentProfileArgs = {
  input: ViewerUpdateParentProfileInput;
};


export type MutationViewerUpdatePasswordArgs = {
  input: ViewerUpdatePasswordInput;
};


export type MutationViewerUpdatePhoneNumberArgs = {
  input: ViewerUpdatePhoneNumberInput;
};


export type MutationViewerUpdateTeacherProfileArgs = {
  input: ViewerUpdateTeacherProfileInput;
};


export type MutationViewerUpdateUsernameArgs = {
  input: ViewerUpdateUsernameInput;
};


export type MutationViewerUserAttemptSeenRewardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationViewerVerifyOwnerByEmailTokenArgs = {
  input: ViewerVerifyOwnerByEmailTokenInput;
};


export type MutationWritingEndAttemptArgs = {
  input: WritingEndAttemptInput;
};


export type MutationWritingStartAttemptArgs = {
  input: WritingStartAttemptInput;
};


export type MutationWritingSubmitPartAttemptArgs = {
  input: WritingSubmitPartAttemptInput;
};

export type NBest = {
  confidence?: Maybe<Scalars['Float']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  itn?: Maybe<Scalars['String']['output']>;
  lexical?: Maybe<Scalars['String']['output']>;
  maskedITN?: Maybe<Scalars['String']['output']>;
  pronunciationAssessment?: Maybe<PronunciationAssessment>;
  words?: Maybe<Array<Maybe<Word>>>;
};

export type NBestPhonemes = {
  phoneme?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type Notification = Node & {
  assignTest?: Maybe<AssignTest>;
  checkPoint?: Maybe<CheckPoint>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionEn?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  learnerProfile?: Maybe<LearnerProfile>;
  meta: NotificationMeta;
  notificationId: Scalars['ID']['output'];
  parentProfile?: Maybe<ParentProfile>;
  school?: Maybe<School>;
  seen: Scalars['Boolean']['output'];
  sendLearnerProfile?: Maybe<LearnerProfile>;
  source: NotificationSource;
  statusLeaveClass?: Maybe<NotificationStatusLeaveClass>;
  teacherProfile?: Maybe<TeacherProfile>;
  title?: Maybe<Scalars['String']['output']>;
  titleEn?: Maybe<Scalars['String']['output']>;
  type: NotificationType;
  typeNotification: NotificationTypeNotification;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationConnection = {
  edges: Array<NotificationEdge>;
  nodes: Array<Notification>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type NotificationEdge = {
  cursor: Scalars['Cursor']['output'];
  node: Notification;
};

export type NotificationEvent = {
  appType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  eventNParam?: Maybe<Scalars['Int']['output']>;
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  notificationEventId: Scalars['ID']['output'];
  notifyAfter: Scalars['Int']['output'];
  notifyCondition?: Maybe<Scalars['String']['output']>;
  notifyContent?: Maybe<NotificationEventContent>;
  notifyData?: Maybe<NotificationEventData>;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationEventConnection = {
  edges: Array<NotificationEventEdge>;
  nodes: Array<NotificationEvent>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type NotificationEventContent = {
  action: Scalars['String']['output'];
  bodyTemplate: NotificationEventTemplate;
  link?: Maybe<Scalars['String']['output']>;
  linkEn?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  titleTemplate: NotificationEventTemplate;
};

export type NotificationEventContentInput = {
  action: Scalars['String']['input'];
  bodyTemplate: NotificationEventTemplateInput;
  link?: InputMaybe<Scalars['String']['input']>;
  linkEn?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  titleTemplate: NotificationEventTemplateInput;
};

export type NotificationEventCreateInput = {
  appType: Scalars['String']['input'];
  eventNParam?: InputMaybe<Scalars['Int']['input']>;
  eventType: Scalars['String']['input'];
  notifyAfter: Scalars['Int']['input'];
  notifyCondition?: InputMaybe<Scalars['String']['input']>;
  notifyContent?: InputMaybe<NotificationEventContentInput>;
  notifyData?: InputMaybe<NotificationEventDataInput>;
};

export type NotificationEventCreatePayload = {
  notificationEvent?: Maybe<NotificationEvent>;
  userError: Array<UserError>;
};

export type NotificationEventData = {
  voucherCode?: Maybe<Scalars['String']['output']>;
  voucherCondition?: Maybe<Scalars['String']['output']>;
  voucherEndDate?: Maybe<Scalars['DateTime']['output']>;
  voucherName?: Maybe<Scalars['String']['output']>;
  voucherStartDate?: Maybe<Scalars['DateTime']['output']>;
};

export type NotificationEventDataInput = {
  voucherCode?: InputMaybe<Scalars['String']['input']>;
  voucherCondition?: InputMaybe<Scalars['String']['input']>;
  voucherEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  voucherName?: InputMaybe<Scalars['String']['input']>;
  voucherStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationEventDeleteInput = {
  id: Scalars['ID']['input'];
};

export type NotificationEventDeletePayload = {
  notificationEventID?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type NotificationEventEdge = {
  cursor: Scalars['Cursor']['output'];
  node: NotificationEvent;
};

export type NotificationEventOrder = {
  key?: InputMaybe<NotificationEventOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NotificationEventOrderKey {
  Id = 'ID'
}

export type NotificationEventSendInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  body: Scalars['String']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};

export type NotificationEventSendPayload = {
  userError: Array<UserError>;
};

export type NotificationEventTemplate = {
  text: Scalars['String']['output'];
  textEn: Scalars['String']['output'];
};

export type NotificationEventTemplateInput = {
  text: Scalars['String']['input'];
  textEn: Scalars['String']['input'];
};

export type NotificationEventUpdateInput = {
  eventNParam?: InputMaybe<Scalars['Int']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notifyAfter?: InputMaybe<Scalars['Int']['input']>;
  notifyCondition?: InputMaybe<Scalars['String']['input']>;
  notifyContent?: InputMaybe<NotificationEventContentInput>;
  notifyData?: InputMaybe<NotificationEventDataInput>;
};

export type NotificationEventUpdatePayload = {
  notificationEvent?: Maybe<NotificationEvent>;
  userErrors: Array<UserError>;
};

export type NotificationEventValue = {
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type NotificationFilter = {
  and?: InputMaybe<Array<NotificationFilter>>;
  floatSeen?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<NotificationFilter>>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Array<NotificationSource>>;
  type?: InputMaybe<Array<NotificationType>>;
  typeNotification?: InputMaybe<Array<NotificationTypeNotification>>;
};

export type NotificationMeta = {
  attemptID?: Maybe<Scalars['ID']['output']>;
  challengeCode?: Maybe<Scalars['String']['output']>;
  checkPointId?: Maybe<Scalars['ID']['output']>;
  leaveClassData?: Maybe<LeaveClassData>;
  linkExam?: Maybe<Scalars['String']['output']>;
  schoolInvitation?: Maybe<NotificationSchoolInvitation>;
  submitAttemptData?: Maybe<SubmitAttemptData>;
  teacherInvitation?: Maybe<NotificationTeacherInvitation>;
  teacherProfileIdAccept?: Maybe<Scalars['ID']['output']>;
};

export type NotificationMetaInput = {
  attemptID?: InputMaybe<Scalars['ID']['input']>;
  challengeCode?: InputMaybe<Scalars['String']['input']>;
  linkExam?: InputMaybe<Scalars['String']['input']>;
  schoolInvitation?: InputMaybe<NotificationSchoolInvitationInput>;
};

export type NotificationSchoolInvitation = {
  code: Scalars['String']['output'];
  status: InvitationStatus;
};

export type NotificationSchoolInvitationInput = {
  code: Scalars['String']['input'];
  status: InvitationStatus;
};

export enum NotificationSource {
  Flyer = 'FLYER',
  Partner = 'PARTNER'
}

export enum NotificationStatusLeaveClass {
  Accept = 'ACCEPT',
  Reject = 'REJECT'
}

export type NotificationTeacherInvitation = {
  invitationId: Scalars['ID']['output'];
};

export enum NotificationType {
  ChallengeInvite = 'CHALLENGE_INVITE',
  LeaveClass = 'LEAVE_CLASS',
  LookBack = 'LOOK_BACK',
  NewFeature = 'NEW_FEATURE',
  NewMission = 'NEW_MISSION',
  NewScoreSpeaking = 'NEW_SCORE_SPEAKING',
  NewScoreWriting = 'NEW_SCORE_WRITING',
  SchoolInvite = 'SCHOOL_INVITE',
  SubmitAttempt = 'SUBMIT_ATTEMPT',
  TeacherInvite = 'TEACHER_INVITE',
  UpdatePhoneNumber = 'UPDATE_PHONE_NUMBER',
  UpdateSchool = 'UPDATE_SCHOOL',
  WeeklyStudyTimeRemaining = 'WEEKLY_STUDY_TIME_REMAINING'
}

export enum NotificationTypeNotification {
  Global = 'GLOBAL',
  GlobalParent = 'GLOBAL_PARENT',
  GlobalPartner = 'GLOBAL_PARTNER',
  Ielts = 'IELTS',
  Parent = 'PARENT',
  Partner = 'PARTNER',
  User = 'USER'
}

export type OrderCode = Node & {
  aiSpeakingCount?: Maybe<Scalars['Int']['output']>;
  aiWritingCount?: Maybe<Scalars['Int']['output']>;
  codeType: OrderCodeCodeType;
  description: Scalars['String']['output'];
  diamond?: Maybe<Scalars['Int']['output']>;
  flyerPackage: FlyerPackage;
  id: Scalars['ID']['output'];
  orderBy: User;
  orderCodeId: Scalars['ID']['output'];
  planDay: Scalars['Duration']['output'];
  quantity: Scalars['Int']['output'];
  status: OrderCodeStatus;
};

/** OrderCodeCodeType is enum for the field codeType */
export enum OrderCodeCodeType {
  Agent = 'agent',
  Giveaway = 'giveaway',
  GiveawayAgent = 'giveaway_agent',
  Iservice = 'iservice',
  MaxTrial = 'max_trial',
  Partner = 'partner',
  Reissue = 'reissue',
  Retail = 'retail',
  RetailManual = 'retail_manual',
  TeacherCode = 'teacher_code',
  Vnpay = 'vnpay'
}

export type OrderCodeConnection = {
  edges: Array<OrderCodeEdge>;
  nodes: Array<OrderCode>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OrderCodeEdge = {
  cursor: Scalars['Cursor']['output'];
  node: OrderCode;
};

export type OrderCodeFilter = {
  codeType?: InputMaybe<Array<OrderCodeCodeType>>;
  descriptionQ?: InputMaybe<Array<Scalars['String']['input']>>;
  planDay?: InputMaybe<DurationRange>;
  status?: InputMaybe<Array<OrderCodeStatus>>;
};

/** OrderCodeStatus is enum for the field status */
export enum OrderCodeStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PageInfo = {
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type Pagination = {
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginationData = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ParentAccuracyRankingData = {
  class: Scalars['String']['output'];
  classId: Scalars['ID']['output'];
  type: ClassType;
  value: Scalars['Float']['output'];
};

export type ParentAccuracyRankingPayload = {
  data?: Maybe<Array<Maybe<ParentAccuracyRankingData>>>;
  userErrors: Array<UserError>;
};

export type ParentClassRankingData = {
  class: Scalars['String']['output'];
  classId: Scalars['ID']['output'];
  type: ClassType;
  value: Scalars['Int']['output'];
};

export type ParentClassRankingPayload = {
  data?: Maybe<Array<Maybe<ParentClassRankingData>>>;
  userErrors: Array<UserError>;
};

export type ParentCompletedTestChartPayload = {
  date: Scalars['String']['output'];
  items: Array<ParentCompletedTestChartValueData>;
  total: Scalars['Int']['output'];
};

export type ParentCompletedTestChartValueData = {
  testLevel: TestLevel;
  value: Scalars['Int']['output'];
};

export type ParentDetailCompletedTestItem = {
  percentage: Scalars['Float']['output'];
  testLevel: TestLevel;
  total: Scalars['Int']['output'];
};

export type ParentDetailCompletedTestPayload = {
  items?: Maybe<Array<ParentDetailCompletedTestItem>>;
  total: Scalars['Int']['output'];
};

export type ParentDetailStudyTimeItem = {
  percentage: Scalars['Float']['output'];
  testLevel: TestLevel;
  total: Scalars['Float']['output'];
};

export type ParentDetailStudyTimePayload = {
  items?: Maybe<Array<ParentDetailStudyTimeItem>>;
  total: Scalars['Float']['output'];
};

export type ParentInfoAssignTestData = {
  totalAssignTest: Scalars['Int']['output'];
  totalStudyTime: Scalars['Float']['output'];
};

export type ParentInfoAssignTestPayload = {
  data?: Maybe<ParentInfoAssignTestData>;
  userErrors: Array<UserError>;
};

export type ParentListAssignTestData = {
  totalAssignTest: Scalars['Int']['output'];
  totalStudyTime: Scalars['Float']['output'];
};

export type ParentListAssignTestPagination = {
  nodes?: Maybe<Array<Maybe<AssignTest>>>;
  pagination?: Maybe<PaginationData>;
};

export type ParentListAssignTestPayload = {
  data?: Maybe<ParentListAssignTestPagination>;
  userErrors: Array<UserError>;
};

export type ParentOverviewAssignTestPayload = {
  accuracy?: Maybe<Scalars['Float']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ParentOverviewPayload = {
  accuracy?: Maybe<Scalars['Float']['output']>;
  progressAssignTest?: Maybe<Scalars['Float']['output']>;
  totalAssignTest?: Maybe<Scalars['Int']['output']>;
  totalStudyTime?: Maybe<Scalars['Duration']['output']>;
};

export type ParentProfile = Node & {
  about?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fcmToken?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  id: Scalars['ID']['output'];
  lang?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  parentProfileId: Scalars['ID']['output'];
  sourceDomain?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type ParentProfileConnection = {
  edges: Array<ParentProfileEdge>;
  nodes: Array<ParentProfile>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ParentProfileEdge = {
  cursor: Scalars['Cursor']['output'];
  node: ParentProfile;
};

export type ParentStudentChartData = {
  date: Scalars['DateTime']['output'];
  value: Scalars['Int']['output'];
};

export type ParentStudentChartPayload = {
  data?: Maybe<Array<Maybe<ParentStudentChartData>>>;
  userErrors: Array<UserError>;
};

export type ParentStudyTimeChartPayload = {
  date: Scalars['String']['output'];
  items: Array<ParentStudyTimeChartValueData>;
  total: Scalars['Float']['output'];
};

export type ParentStudyTimeChartValueData = {
  testLevel: TestLevel;
  value: Scalars['Float']['output'];
};

export type ParentViewerSeenNotificationInput = {
  all?: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ParentViewerSeenNotificationPayload = {
  notification?: Maybe<Notification>;
  userErrors: Array<UserError>;
};

export type ParentViewerUnreadNotificationsCount = {
  flyer: Scalars['Int']['output'];
  partner: Scalars['Int']['output'];
};

export type PartTypeInfo = ExamPartTypeInfo | SpeakingPartTypeInfo;

export type PartnerAccuracyRankingData = {
  class: Scalars['String']['output'];
  classId: Scalars['ID']['output'];
  type: ClassType;
  value: Scalars['Float']['output'];
};

export type PartnerAccuracyRankingInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerAccuracyRankingPayload = {
  data?: Maybe<Array<Maybe<PartnerAccuracyRankingData>>>;
  userErrors: Array<UserError>;
};

export type PartnerActivities = Node & {
  class?: Maybe<Class>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  learnerProfile: LearnerProfile;
  partnerActivitiesId: Scalars['ID']['output'];
  school?: Maybe<School>;
  teacherProfile?: Maybe<TeacherProfile>;
  type: PartnerActivitiesType;
  updatedAt: Scalars['DateTime']['output'];
  userAttempt?: Maybe<UserAttempt>;
};

export type PartnerActivitiesConnection = {
  edges: Array<PartnerActivitiesEdge>;
  nodes: Array<PartnerActivities>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PartnerActivitiesEdge = {
  cursor: Scalars['Cursor']['output'];
  node: PartnerActivities;
};

export type PartnerActivitiesFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  hasClassWith?: InputMaybe<ClassFilter>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  hasSchoolWith?: InputMaybe<SchoolFilter>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  hasUserAttemptWith?: InputMaybe<UserAttemptFilter>;
};

export enum PartnerActivitiesType {
  StudentSubmitAttempt = 'STUDENT_SUBMIT_ATTEMPT'
}

export type PartnerAssignTeachersToClassesInput = {
  classIds: Array<Scalars['ID']['input']>;
  teacherProfileIds: Array<Scalars['ID']['input']>;
};

export type PartnerAssignTeachersToClassesPayload = {
  userErrors: Array<UserError>;
};

export type PartnerAssignTestCreateInput = {
  checkPointIds: Array<Scalars['ID']['input']>;
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  profileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  testLevelId?: InputMaybe<Scalars['ID']['input']>;
  typeExam?: InputMaybe<TypeExamAssignTest>;
  typeInit?: InputMaybe<TypeInitAssignTest>;
};

export type PartnerAssignTestCreatePayload = {
  assignTest?: Maybe<Array<AssignTest>>;
  userErrors: Array<UserError>;
};

export type PartnerAssignTestSubmitUpdateInput = {
  userAttemptID: Scalars['ID']['input'];
};

export type PartnerAssignTestSubmitUpdatePayload = {
  userErrors: Array<UserError>;
};

export type PartnerAssignTestUpdateInput = {
  assignTestID: Scalars['ID']['input'];
  classIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  profileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  typeInit?: InputMaybe<TypeInitAssignTest>;
};

export type PartnerAssignTestUpdatePayload = {
  assignTest?: Maybe<AssignTest>;
  userErrors: Array<UserError>;
};

export type PartnerBillingHistories = Node & {
  action: PartnerBillingHistoriesAction;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  partnerBillingHistoriesId: Scalars['ID']['output'];
  teacherProfile: TeacherProfile;
  transaction: WalletTransaction;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export enum PartnerBillingHistoriesAction {
  CreateAccount = 'CREATE_ACCOUNT',
  Deposit = 'DEPOSIT',
  ExtendAccount = 'EXTEND_ACCOUNT',
  RollBackAccount = 'ROLL_BACK_ACCOUNT'
}

export type PartnerBillingHistoriesConnection = {
  edges: Array<PartnerBillingHistoriesEdge>;
  nodes: Array<PartnerBillingHistories>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PartnerBillingHistoriesEdge = {
  cursor: Scalars['Cursor']['output'];
  node: PartnerBillingHistories;
};

export type PartnerBillingHistoriesFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
};

export type PartnerCheckPointReorderPracticePartsPayload = {
  userErrors?: Maybe<Array<UserError>>;
};

export type PartnerClassRankingData = {
  class: Scalars['String']['output'];
  classId: Scalars['ID']['output'];
  type: ClassType;
  value: Scalars['Int']['output'];
};

export type PartnerClassRankingInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerClassRankingPayload = {
  data?: Maybe<Array<Maybe<PartnerClassRankingData>>>;
  userErrors: Array<UserError>;
};

export type PartnerClassUpdateInput = {
  classLevelId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  onboardStep?: InputMaybe<Scalars['Int']['input']>;
  pin?: InputMaybe<Scalars['Boolean']['input']>;
  targetNotification?: InputMaybe<Scalars['Boolean']['input']>;
  weeklyTimeTarget?: InputMaybe<Scalars['Duration']['input']>;
};

export type PartnerClassUpdatePayload = {
  class?: Maybe<Class>;
  userErrors: Array<UserError>;
};

export type PartnerCompletedTestChartData = {
  date: Scalars['String']['output'];
  items: Array<PartnerCompletedTestChartValueData>;
  total: Scalars['Int']['output'];
};

export type PartnerCompletedTestChartInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  skills?: InputMaybe<Array<InputMaybe<EnglishSkillV1>>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  studentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
  testLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeAttempt?: InputMaybe<TypeAttempt>;
  typeAttempts?: InputMaybe<Array<TypeAttempt>>;
};

export type PartnerCompletedTestChartPayload = {
  data?: Maybe<Array<Maybe<PartnerCompletedTestChartData>>>;
  userErrors: Array<UserError>;
};

export type PartnerCompletedTestChartValueData = {
  testLevel?: Maybe<TestLevel>;
  value: Scalars['Int']['output'];
};

export type PartnerDetailCompletedTestData = {
  items?: Maybe<Array<PartnerDetailCompletedTestItem>>;
  total: Scalars['Int']['output'];
};

export type PartnerDetailCompletedTestInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  studentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
  testLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeAttempt?: InputMaybe<TypeAttempt>;
  typeAttempts?: InputMaybe<Array<TypeAttempt>>;
};

export type PartnerDetailCompletedTestItem = {
  percentage: Scalars['Float']['output'];
  testLevel: TestLevel;
  total: Scalars['Int']['output'];
};

export type PartnerDetailCompletedTestPayload = {
  data?: Maybe<PartnerDetailCompletedTestData>;
  userErrors: Array<UserError>;
};

export type PartnerDetailStudyTimeData = {
  items?: Maybe<Array<PartnerDetailStudyTimeItem>>;
  total: Scalars['Float']['output'];
};

export type PartnerDetailStudyTimeInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  studentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
  testLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeAttempt?: InputMaybe<TypeAttempt>;
  typeAttempts?: InputMaybe<Array<TypeAttempt>>;
};

export type PartnerDetailStudyTimeItem = {
  percentage: Scalars['Float']['output'];
  testLevel: TestLevel;
  total: Scalars['Float']['output'];
};

export type PartnerDetailStudyTimePayload = {
  data?: Maybe<PartnerDetailStudyTimeData>;
  userErrors: Array<UserError>;
};

export type PartnerIeltsCheckPointCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  ieltsSkill: IeltsSkill;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
};

export type PartnerIeltsCheckPointCreatePayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type PartnerIeltsCheckPointRemoveInput = {
  id: Scalars['ID']['input'];
};

export type PartnerIeltsCheckPointRemovePayload = {
  checkPointId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type PartnerIeltsCheckPointUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
};

export type PartnerIeltsCheckPointUpdatePayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type PartnerIeltsPartAddQuestionsInput = {
  listening?: InputMaybe<IeltsListeningPartAddQuestionsInput>;
  reading?: InputMaybe<IeltsReadingPartAddQuestionsInput>;
};

export type PartnerIeltsPartAddQuestionsPayload = {
  ieltsListeningPart?: Maybe<IeltsListeningPart>;
  ieltsReadingPart?: Maybe<IeltsReadingPart>;
  userErrors: Array<UserError>;
};

export type PartnerIeltsPartCreateInput = {
  listening?: InputMaybe<IeltsListeningPartCreateInput>;
  reading?: InputMaybe<IeltsReadingPartCreateInput>;
  writing?: InputMaybe<IeltsWritingPartCreateInput>;
};

export type PartnerIeltsPartCreatePayload = {
  ieltsListeningPart?: Maybe<IeltsListeningPart>;
  ieltsReadingPart?: Maybe<IeltsReadingPart>;
  ieltsWritingPart?: Maybe<IeltsWritingPart>;
  userErrors: Array<UserError>;
};

export type PartnerIeltsPartRemoveInput = {
  ieltsListeningPartId?: InputMaybe<Scalars['ID']['input']>;
  ieltsReadingPartId?: InputMaybe<Scalars['ID']['input']>;
  ieltsWritingPartId?: InputMaybe<Scalars['ID']['input']>;
};

export type PartnerIeltsPartRemovePayload = {
  ieltsListeningPartId?: Maybe<Scalars['ID']['output']>;
  ieltsReadingPartId?: Maybe<Scalars['ID']['output']>;
  ieltsWritingPartId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type PartnerIeltsPartUpdateInput = {
  listening?: InputMaybe<IeltsListeningPartUpdateInput>;
  reading?: InputMaybe<IeltsReadingPartUpdateInput>;
  writing?: InputMaybe<IeltsWritingPartUpdateInput>;
};

export type PartnerIeltsPartUpdatePayload = {
  ieltsListeningPart?: Maybe<IeltsListeningPart>;
  ieltsReadingPart?: Maybe<IeltsReadingPart>;
  ieltsWritingPart?: Maybe<IeltsWritingPart>;
  userErrors: Array<UserError>;
};

export type PartnerIeltsQuestionCreateInput = {
  listening?: InputMaybe<IeltsListeningQuestionCreateInput>;
  reading?: InputMaybe<IeltsReadingQuestionCreateInput>;
};

export type PartnerIeltsQuestionCreatePayload = {
  ieltsListeningQuestion?: Maybe<IeltsListeningQuestion>;
  ieltsReadingQuestion?: Maybe<IeltsReadingQuestion>;
  userErrors: Array<UserError>;
};

export type PartnerIeltsQuestionRemoveInput = {
  ieltsListeningQuestionId?: InputMaybe<Scalars['ID']['input']>;
  ieltsReadingQuestionId?: InputMaybe<Scalars['ID']['input']>;
};

export type PartnerIeltsQuestionRemovePayload = {
  ieltsListeningQuestionId?: Maybe<Scalars['ID']['output']>;
  ieltsReadingQuestionId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type PartnerIeltsQuestionUpdateInput = {
  listening?: InputMaybe<IeltsListeningQuestionUpdateInput>;
  reading?: InputMaybe<IeltsReadingQuestionUpdateInput>;
};

export type PartnerIeltsQuestionUpdatePayload = {
  ieltsListeningQuestion?: Maybe<IeltsListeningQuestion>;
  ieltsReadingQuestion?: Maybe<IeltsReadingQuestion>;
  userErrors: Array<UserError>;
};

export type PartnerIeltsSpeakingAttemptTeacherScoreInput = {
  id: Scalars['ID']['input'];
  teacherComment?: InputMaybe<Scalars['String']['input']>;
  teacherCommentAudioId?: InputMaybe<Scalars['ID']['input']>;
  teacherGrade?: InputMaybe<Scalars['Float']['input']>;
  teacherSeenRequest?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartnerIeltsSpeakingAttemptTeacherScorePayload = {
  userAttempt?: Maybe<UserAttempt>;
  userErrors: Array<UserError>;
};

export type PartnerIeltsSpeakingQuestionAttemptTeacherScoreInput = {
  id: Scalars['ID']['input'];
  teacherComment?: InputMaybe<Scalars['JSON']['input']>;
  teacherCommentAudioId?: InputMaybe<Scalars['ID']['input']>;
  teacherCommentDetails?: InputMaybe<Array<TeacherCommentDetailInput>>;
  teacherCommentHtml?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerIeltsSpeakingQuestionAttemptTeacherScorePayload = {
  ieltsSpeakingQuestionAttempt?: Maybe<IeltsSpeakingQuestionAttempt>;
  userErrors: Array<UserError>;
};

export type PartnerInfoAssignTestData = {
  totalAssignTest: Scalars['Int']['output'];
  totalStudyTime: Scalars['Float']['output'];
};

export type PartnerInfoAssignTestInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  levels?: InputMaybe<Array<Scalars['String']['input']>>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PartnerInfoAssignTestPayload = {
  data?: Maybe<PartnerInfoAssignTestData>;
  userErrors: Array<UserError>;
};

export type PartnerListAssignTestData = {
  totalAssignTest: Scalars['Int']['output'];
  totalStudyTime: Scalars['Float']['output'];
};

export type PartnerListAssignTestInput = {
  endDate?: InputMaybe<DateTimeRange>;
  levels?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<EnglishSkillV1>>;
  startDate?: InputMaybe<DateTimeRange>;
  statuses?: InputMaybe<Array<PartnerListAssignTestStatusEnum>>;
  teacherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerListAssignTestPagination = {
  nodes?: Maybe<Array<Maybe<AssignTest>>>;
  pagination?: Maybe<PaginationData>;
};

export type PartnerListAssignTestPayload = {
  data?: Maybe<PartnerListAssignTestPagination>;
  userErrors: Array<UserError>;
};

export enum PartnerListAssignTestStatusEnum {
  Done = 'DONE',
  NoneStarted = 'NONE_STARTED',
  Progress = 'PROGRESS'
}

export type PartnerOverviewClassAssignTestData = {
  progress?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PartnerOverviewData = {
  accuracy?: Maybe<Scalars['Float']['output']>;
  averageScore?: Maybe<Scalars['Float']['output']>;
  averageTestTime?: Maybe<Scalars['Duration']['output']>;
  classAssignTest?: Maybe<PartnerOverviewClassAssignTestData>;
  highestScore?: Maybe<Scalars['Float']['output']>;
  studentAssignTest?: Maybe<PartnerOverviewStudentAssignTestData>;
  totalClasses: Scalars['Int']['output'];
  totalCompletedTests: Scalars['Int']['output'];
  totalStudents: Scalars['Int']['output'];
  totalStudyTime: Scalars['Float']['output'];
  totalTestTime?: Maybe<Scalars['Duration']['output']>;
};

export type PartnerOverviewInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  skills?: InputMaybe<Array<InputMaybe<EnglishSkillV1>>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  studentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
  testLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeAttempt?: InputMaybe<TypeAttempt>;
  typeAttempts?: InputMaybe<Array<TypeAttempt>>;
};

export type PartnerOverviewPayload = {
  data?: Maybe<PartnerOverviewData>;
  userErrors: Array<UserError>;
};

export type PartnerOverviewStudentAssignTestData = {
  completed?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  unCompleted?: Maybe<Scalars['Int']['output']>;
};

export type PartnerPackage = Node & {
  amount: Scalars['Float']['output'];
  amountDeposit: Scalars['Float']['output'];
  amountDepositUsd: Scalars['Float']['output'];
  amountUsd: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isShowing: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  partnerPackageId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  titleEn: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnerPackageConnection = {
  edges: Array<PartnerPackageEdge>;
  nodes: Array<PartnerPackage>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PartnerPackageEdge = {
  cursor: Scalars['Cursor']['output'];
  node: PartnerPackage;
};

export type PartnerPackageFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerPermission = Node & {
  description?: Maybe<Scalars['String']['output']>;
  descriptionEn?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nameEn: Scalars['String']['output'];
  permissionId: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type PartnerPermissionConnection = {
  edges: Array<PartnerPermissionEdge>;
  nodes: Array<PartnerPermission>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PartnerPermissionEdge = {
  cursor: Scalars['Cursor']['output'];
  node: PartnerPermission;
};

export type PartnerPracticeCheckPointCreateInput = {
  imageId?: InputMaybe<Scalars['ID']['input']>;
  levels: Array<CefrLevel>;
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  skills: Array<EnglishSkillV1>;
  time: Scalars['Duration']['input'];
};

export type PartnerPracticeCheckPointCreatePayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type PartnerPracticeCheckPointGenInput = {
  checkPointId?: InputMaybe<Scalars['ID']['input']>;
  level: CefrLevel;
  noParts: Scalars['Int']['input'];
  partTypes: Array<PracticePartType>;
  prompt: PartnerPracticeCheckPointGenPromptInput;
};

export type PartnerPracticeCheckPointGenPayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type PartnerPracticeCheckPointGenPromptInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerPracticeCheckPointUpdateInput = {
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<EnglishSkillV1>>;
  time?: InputMaybe<Scalars['Duration']['input']>;
};

export type PartnerPracticeCheckPointUpdatePayload = {
  checkPoint?: Maybe<CheckPoint>;
  userErrors: Array<UserError>;
};

export type PartnerPracticeCheckPointsArchivePayload = {
  userErrors: Array<UserError>;
};

export type PartnerPracticeCheckPointsDeletePayload = {
  userErrors: Array<UserError>;
};

export type PartnerPracticeCheckPointsInfo = {
  archivedCheckPointsCount: Scalars['Int']['output'];
  checkPointsCount: Scalars['Int']['output'];
  publishedCheckPointsCount: Scalars['Int']['output'];
};

export type PartnerPracticeCheckPointsPublishPayload = {
  userErrors: Array<UserError>;
};

export type PartnerPracticeCheckPointsUnarchivePayload = {
  userErrors: Array<UserError>;
};

export type PartnerPracticeCheckPointsUnpublishPayload = {
  userErrors: Array<UserError>;
};

export type PartnerPracticePartCreateInput = {
  answerExplanationHtml?: InputMaybe<Scalars['String']['input']>;
  answerExplanationHtmlEn?: InputMaybe<Scalars['String']['input']>;
  body: PracticePartBodyInput;
  checkPointId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
  score: Scalars['Float']['input'];
  time?: InputMaybe<Scalars['Duration']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: PracticePartType;
};

export type PartnerPracticePartCreatePayload = {
  checkPoint?: Maybe<CheckPoint>;
  practicePart?: Maybe<PracticePart>;
  userErrors: Array<UserError>;
};

export type PartnerPracticePartDeletePayload = {
  checkPoint?: Maybe<CheckPoint>;
  practicePartId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type PartnerPracticePartUpdateInput = {
  answerExplanationHtml?: InputMaybe<Scalars['String']['input']>;
  answerExplanationHtmlEn?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<PracticePartBodyInput>;
  id: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PracticePartType>;
};

export type PartnerPracticePartUpdatePayload = {
  checkPoint?: Maybe<CheckPoint>;
  practicePart?: Maybe<PracticePart>;
  userErrors: Array<UserError>;
};

export type PartnerRole = Node & {
  description?: Maybe<Scalars['String']['output']>;
  descriptionEn?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nameEn: Scalars['String']['output'];
  partnerRoleId: Scalars['ID']['output'];
  partnerRolePermissions: Array<PartnerRolePermissionEdge>;
  permissions: Array<PartnerPermission>;
  value: Scalars['String']['output'];
};

export type PartnerRoleConnection = {
  edges: Array<PartnerRoleEdge>;
  nodes: Array<PartnerRole>;
  pageInfo: PageInfo;
};

export type PartnerRoleEdge = {
  cursor: Scalars['Cursor']['output'];
  node: PartnerRole;
};

export type PartnerRolePermissionEdge = {
  active: Scalars['Boolean']['output'];
  node: PartnerPermission;
};

export type PartnerRollupAssignTest = {
  accuracy?: Maybe<Scalars['Float']['output']>;
  assignTest: AssignTest;
  assignees: Scalars['Int']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
};

export type PartnerRollupAssignTestFilter = {
  endDate?: InputMaybe<DateRangeInput>;
  levels?: InputMaybe<Array<CefrLevel>>;
  skills?: InputMaybe<Array<EnglishSkillV1>>;
  startDate?: InputMaybe<DateRangeInput>;
  statuses?: InputMaybe<Array<StatusAssignTest>>;
};

export type PartnerRollupAssignTestOrder = {
  direction: OrderDirection;
  key: PartnerRollupAssignTestOrderKey;
};

export enum PartnerRollupAssignTestOrderKey {
  Accuracy = 'ACCURACY',
  Assignees = 'ASSIGNEES',
  CheckPointName = 'CHECK_POINT_NAME',
  CheckPointNameEn = 'CHECK_POINT_NAME_EN',
  EndDate = 'END_DATE',
  Progress = 'PROGRESS',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  TeacherDisplayName = 'TEACHER_DISPLAY_NAME',
  TestLevelName = 'TEST_LEVEL_NAME'
}

export type PartnerRollupAssignTestPagination = {
  data: Array<PartnerRollupAssignTest>;
  pagination: Pagination;
};

export type PartnerRollupClass = {
  avgAccuracy?: Maybe<Scalars['Float']['output']>;
  class: Class;
  comparedAvgAccuracy?: Maybe<Scalars['Float']['output']>;
  comparedStudyTime?: Maybe<Scalars['Duration']['output']>;
  completedTests?: Maybe<Scalars['Int']['output']>;
  conversationTime?: Maybe<Scalars['Int']['output']>;
  studentCount: Scalars['Int']['output'];
  studyTime?: Maybe<Scalars['Duration']['output']>;
};

export type PartnerRollupClassFilter = {
  classNameQ?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerRollupClassOrder = {
  direction: OrderDirection;
  key: PartnerRollupClassOrderKey;
};

export enum PartnerRollupClassOrderKey {
  AvgAccuracy = 'AVG_ACCURACY',
  ClassName = 'CLASS_NAME',
  ClassPin = 'CLASS_PIN',
  CompletedTests = 'COMPLETED_TESTS',
  ConversationTime = 'CONVERSATION_TIME',
  StudentCount = 'STUDENT_COUNT',
  StudyTime = 'STUDY_TIME'
}

export type PartnerRollupClassPagination = {
  data: Array<PartnerRollupClass>;
  pagination: Pagination;
};

export type PartnerRollupConversationStudent = {
  classStudent: ClassStudent;
  learnerProfile: LearnerProfile;
  totalCallTime: Scalars['Int']['output'];
  totalCalls: Scalars['Int']['output'];
};

export type PartnerRollupConversationStudentFilter = {
  displayNameQ?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerRollupConversationStudentOrder = {
  direction: OrderDirection;
  key: PartnerRollupConversationStudentOrderKey;
};

export enum PartnerRollupConversationStudentOrderKey {
  DisplayName = 'DISPLAY_NAME',
  TotalCalls = 'TOTAL_CALLS',
  TotalCallTime = 'TOTAL_CALL_TIME'
}

export type PartnerRollupConversationStudentPagination = {
  data: Array<PartnerRollupConversationStudent>;
  pagination: Pagination;
};

export type PartnerRollupNewStudent = {
  lastSubmittedAttempt?: Maybe<UserAttempt>;
  learnerProfile: LearnerProfile;
  submittedAttempts: Array<UserAttempt>;
};

export type PartnerRollupNewStudentFilter = {
  displayNameQ?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  subscriptionStatus?: InputMaybe<SubscriptionStatus>;
};

export type PartnerRollupNewStudentOrder = {
  direction: OrderDirection;
  key: PartnerRollupNewStudentOrderKey;
};

export enum PartnerRollupNewStudentOrderKey {
  DisplayName = 'DISPLAY_NAME',
  LastSubmittedAttempt = 'LAST_SUBMITTED_ATTEMPT'
}

export type PartnerRollupNewStudentPagination = {
  data: Array<PartnerRollupNewStudent>;
  pagination: Pagination;
};

export type PartnerRollupStudent = {
  avgTestAccuracy?: Maybe<Scalars['Float']['output']>;
  avgTestScore?: Maybe<Scalars['Float']['output']>;
  classStudent: ClassStudent;
  learnerProfile: LearnerProfile;
  listeningTestAccuracy?: Maybe<Scalars['Float']['output']>;
  readingTestAccuracy?: Maybe<Scalars['Float']['output']>;
  speakingTestAccuracy?: Maybe<Scalars['Float']['output']>;
  totalAssignTests?: Maybe<Scalars['Int']['output']>;
  totalCompletedAssignTests?: Maybe<Scalars['Int']['output']>;
  totalCompletedTests?: Maybe<Scalars['Int']['output']>;
  totalExpiredAssignTests?: Maybe<Scalars['Int']['output']>;
  totalStudyTime?: Maybe<Scalars['Duration']['output']>;
  totalUncompletedAssignTests?: Maybe<Scalars['Int']['output']>;
  writingTestAccuracy?: Maybe<Scalars['Float']['output']>;
};

export type PartnerRollupStudentFilter = {
  displayNameQ?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerRollupStudentOrder = {
  direction: OrderDirection;
  key: PartnerRollupStudentOrderKey;
};

export enum PartnerRollupStudentOrderKey {
  AvgTestAccuracy = 'AVG_TEST_ACCURACY',
  AvgTestScore = 'AVG_TEST_SCORE',
  ClassName = 'CLASS_NAME',
  DisplayName = 'DISPLAY_NAME',
  Email = 'EMAIL',
  JoinedDate = 'JOINED_DATE',
  PhoneNumber = 'PHONE_NUMBER',
  SubscriptionExpiresAt = 'SUBSCRIPTION_EXPIRES_AT',
  TotalAssignTests = 'TOTAL_ASSIGN_TESTS',
  TotalCompletedAssignTests = 'TOTAL_COMPLETED_ASSIGN_TESTS',
  TotalCompletedTests = 'TOTAL_COMPLETED_TESTS',
  TotalExpiredAssignTests = 'TOTAL_EXPIRED_ASSIGN_TESTS',
  TotalStudyTime = 'TOTAL_STUDY_TIME',
  TotalUncompletedAssignTests = 'TOTAL_UNCOMPLETED_ASSIGN_TESTS'
}

export type PartnerRollupStudentPagination = {
  data: Array<PartnerRollupStudent>;
  pagination: Pagination;
};

export type PartnerRollupTeacher = {
  assignTests?: Maybe<Scalars['Int']['output']>;
  avgAccuracy?: Maybe<Scalars['Float']['output']>;
  comparedPerformanceScore?: Maybe<Scalars['Float']['output']>;
  completedAssignTests?: Maybe<Scalars['Int']['output']>;
  completedTests?: Maybe<Scalars['Int']['output']>;
  growthRate?: Maybe<Scalars['Float']['output']>;
  performanceScore?: Maybe<Scalars['Float']['output']>;
  studentCount: Scalars['Int']['output'];
  studyTime?: Maybe<Scalars['Duration']['output']>;
  teacherProfile: TeacherProfile;
};

export type PartnerRollupTeacherFilter = {
  displayNameQ?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerRollupTeacherOrder = {
  direction: OrderDirection;
  key: PartnerRollupTeacherOrderKey;
};

export enum PartnerRollupTeacherOrderKey {
  AssignTests = 'ASSIGN_TESTS',
  AvgAccuracy = 'AVG_ACCURACY',
  CompletedAssignTests = 'COMPLETED_ASSIGN_TESTS',
  CompletedTests = 'COMPLETED_TESTS',
  DisplayName = 'DISPLAY_NAME',
  GrowthRate = 'GROWTH_RATE',
  PerformanceScore = 'PERFORMANCE_SCORE',
  StudentCount = 'STUDENT_COUNT',
  StudyTime = 'STUDY_TIME'
}

export type PartnerRollupTeacherPagination = {
  data: Array<PartnerRollupTeacher>;
  pagination: Pagination;
};

export type PartnerSchoolsOverviewPayload = {
  totalClasses: Scalars['Int']['output'];
  totalCompletedTests: Scalars['Int']['output'];
  totalStudents: Scalars['Int']['output'];
  totalStudyTime?: Maybe<Scalars['Duration']['output']>;
  totalTeachers: Scalars['Int']['output'];
};

export type PartnerStudentChartData = {
  date: Scalars['DateTime']['output'];
  value: Scalars['Int']['output'];
};

export type PartnerStudentChartInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PartnerStudentChartPayload = {
  data?: Maybe<Array<Maybe<PartnerStudentChartData>>>;
  userErrors: Array<UserError>;
};

export type PartnerStudentListData = {
  accuracy?: Maybe<Scalars['Float']['output']>;
  avatarId?: Maybe<Scalars['String']['output']>;
  classId: Scalars['ID']['output'];
  className?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  joinedDate?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastTestTime?: Maybe<Scalars['DateTime']['output']>;
  latestName?: Maybe<Scalars['String']['output']>;
  latestNameEn?: Maybe<Scalars['String']['output']>;
  learnerProfileId: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  totalCompletedTest?: Maybe<Scalars['Int']['output']>;
  totalDoingTestTime?: Maybe<Scalars['String']['output']>;
  typeClass?: Maybe<ClassType>;
};

export type PartnerStudentListInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PartnerStudentListPayload = {
  data?: Maybe<PartnerStudentPagination>;
  userErrors: Array<UserError>;
};

export type PartnerStudentPagination = {
  nodes?: Maybe<Array<Maybe<PartnerStudentListData>>>;
  pagination?: Maybe<PaginationData>;
};

export type PartnerStudyTimeChartData = {
  date: Scalars['String']['output'];
  items: Array<PartnerStudyTimeChartValueData>;
  total: Scalars['Float']['output'];
};

export type PartnerStudyTimeChartInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  skills?: InputMaybe<Array<InputMaybe<EnglishSkillV1>>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  studentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
  testLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeAttempt?: InputMaybe<TypeAttempt>;
  typeAttempts?: InputMaybe<Array<TypeAttempt>>;
};

export type PartnerStudyTimeChartPayload = {
  data?: Maybe<Array<Maybe<PartnerStudyTimeChartData>>>;
  userErrors: Array<UserError>;
};

export type PartnerStudyTimeChartValueData = {
  testLevel?: Maybe<TestLevel>;
  value: Scalars['Float']['output'];
};

export type PartnerStudyTimeRankingData = {
  class: Scalars['String']['output'];
  classId: Scalars['ID']['output'];
  type: ClassType;
  value?: Maybe<Scalars['Duration']['output']>;
};

export type PartnerStudyTimeRankingInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerStudyTimeRankingPayload = {
  data?: Maybe<Array<Maybe<PartnerStudyTimeRankingData>>>;
  userErrors: Array<UserError>;
};

export type PartnerSubscription = Node & {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  partnerPackage: PartnerPackage;
  partnerSubscriptionId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type PartnerSubscriptionConnection = {
  edges: Array<PartnerSubscriptionEdge>;
  nodes: Array<PartnerSubscription>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PartnerSubscriptionEdge = {
  cursor: Scalars['Cursor']['output'];
  node: PartnerSubscription;
};

export type PartnerSubscriptionFilter = {
  hasPartnerPackageWith?: InputMaybe<PartnerPackageFilter>;
  hasUserWith?: InputMaybe<UserFilter>;
};

export type PartnerTeacherMarkPointExamInput = {
  speakingInput?: InputMaybe<SpeakingUpdateInput>;
  teacherAudioAnswerID?: InputMaybe<Scalars['String']['input']>;
  teacherComment?: InputMaybe<Scalars['String']['input']>;
  teacherGrade?: InputMaybe<Scalars['Float']['input']>;
  typeMark: TypeMark;
  userAttemptID: Scalars['ID']['input'];
  writingInput?: InputMaybe<Array<WritingUpdateInput>>;
};

export type PartnerTeacherMarkPointExamPayload = {
  userAttempt?: Maybe<UserAttempt>;
  userErrors: Array<UserError>;
};

export type PartnerTeacherSchoolStudent = Node & {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  avgTestAccuracy?: Maybe<Scalars['Float']['output']>;
  avgTestScore?: Maybe<Scalars['Float']['output']>;
  classId: Scalars['ID']['output'];
  className: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  joinedDate: Scalars['DateTime']['output'];
  partnerTeacherSchoolStudentId: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  schoolId: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
  subscriptionExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  totalAssignTests: Scalars['Int']['output'];
  totalCompletedAssignTests: Scalars['Int']['output'];
  totalCompletedTests: Scalars['Int']['output'];
  totalExpiredAssignTests: Scalars['Int']['output'];
  totalStudyTime: Scalars['Duration']['output'];
  totalUncompletedAssignTests: Scalars['Int']['output'];
};

export type PartnerTeacherSchoolStudentConnection = {
  edges: Array<PartnerTeacherSchoolStudentEdge>;
  nodes: Array<PartnerTeacherSchoolStudent>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PartnerTeacherSchoolStudentEdge = {
  cursor: Scalars['Cursor']['output'];
  node: PartnerTeacherSchoolStudent;
};

export type PartnerTeacherSchoolStudentFilter = {
  classId?: InputMaybe<Array<Scalars['ID']['input']>>;
  classNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  displayNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  teacherProfileId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerTeacherSchoolStudentOrder = {
  key?: InputMaybe<PartnerTeacherSchoolStudentOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PartnerTeacherSchoolStudentOrderKey {
  AvgTestAccuracy = 'AVG_TEST_ACCURACY',
  AvgTestScore = 'AVG_TEST_SCORE',
  ClassName = 'CLASS_NAME',
  DisplayName = 'DISPLAY_NAME',
  Email = 'EMAIL',
  JoinedDate = 'JOINED_DATE',
  PhoneNumber = 'PHONE_NUMBER',
  SubscriptionExpiresAt = 'SUBSCRIPTION_EXPIRES_AT',
  TotalAssignTests = 'TOTAL_ASSIGN_TESTS',
  TotalCompletedAssignTests = 'TOTAL_COMPLETED_ASSIGN_TESTS',
  TotalCompletedTests = 'TOTAL_COMPLETED_TESTS',
  TotalExpiredAssignTests = 'TOTAL_EXPIRED_ASSIGN_TESTS',
  TotalStudyTime = 'TOTAL_STUDY_TIME',
  TotalUncompletedAssignTests = 'TOTAL_UNCOMPLETED_ASSIGN_TESTS'
}

export type PartnerTeacherStudyTimeChartData = {
  teacherDisplayName: Scalars['String']['output'];
  teacherID: Scalars['ID']['output'];
  value?: Maybe<Scalars['Duration']['output']>;
};

export type PartnerViewerAiSpeakingRecordUpdateInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type PartnerViewerAiSpeakingRecordUpdatePayload = {
  aiSpeakingRecord?: Maybe<AiSpeakingRecord>;
  userErrors: Array<UserError>;
};

export type PartnerViewerAiThreadCreateInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerAiThreadCreatePayload = {
  aiThread?: Maybe<AiPartnerThread>;
  userErrors: Array<UserError>;
};

export type PartnerViewerAiThreadDeleteInput = {
  threadId: Scalars['ID']['input'];
};

export type PartnerViewerAiThreadDeletePayload = {
  aiThreadId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type PartnerViewerAiThreadUpdateInput = {
  threadId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerAiThreadUpdatePayload = {
  aiThread?: Maybe<AiPartnerThread>;
  userErrors: Array<UserError>;
};

export type PartnerViewerAiWritingRecordUpdateInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type PartnerViewerAiWritingRecordUpdatePayload = {
  aiWritingRecord?: Maybe<AiWritingRecord>;
  userErrors: Array<UserError>;
};

export type PartnerViewerAcceptLeaveClassInput = {
  notificationId: Scalars['ID']['input'];
};

export type PartnerViewerAcceptLeaveClassPayload = {
  notification?: Maybe<Notification>;
  userErrors: Array<UserError>;
};

export type PartnerViewerAssignTestDeleteInput = {
  assignTestID: Scalars['ID']['input'];
};

export type PartnerViewerAssignTestDeletePayload = {
  assignTestID?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type PartnerViewerAssignTestReAssignInput = {
  assignTestId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type PartnerViewerAssignTestReAssignPayload = {
  userErrors: Array<UserError>;
};

export type PartnerViewerAssignTestRemindParentInput = {
  assignTestId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type PartnerViewerAssignTestRemindParentPayload = {
  userErrors: Array<UserError>;
};

export type PartnerViewerAssignTestRemindStudentInput = {
  assignTestId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type PartnerViewerAssignTestRemindStudentPayload = {
  userErrors: Array<UserError>;
};

export type PartnerViewerChallengeCreateInput = {
  checkPointId: Scalars['ID']['input'];
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  isHiddenName?: InputMaybe<Scalars['Boolean']['input']>;
  isLimit?: InputMaybe<Scalars['Boolean']['input']>;
  isMixed?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  settings?: InputMaybe<ChallengeSettingsInput>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PartnerViewerChallengeCreatePayload = {
  challenge?: Maybe<Challenge>;
  userErrors: Array<UserError>;
};

export type PartnerViewerChallengeEndInput = {
  challengeId: Scalars['ID']['input'];
};

export type PartnerViewerChallengeEndPayload = {
  challenge?: Maybe<Challenge>;
  userErrors: Array<UserError>;
};

export type PartnerViewerChallengeInviteInput = {
  challengeId: Scalars['ID']['input'];
  classIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  studentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerViewerChallengeInvitePayload = {
  challenge?: Maybe<Challenge>;
  userErrors: Array<UserError>;
};

export type PartnerViewerChallengeUpdateInput = {
  challengeId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerChallengeUpdatePayload = {
  challenge?: Maybe<Challenge>;
  userErrors: Array<UserError>;
};

export type PartnerViewerClassDeleteInput = {
  id: Scalars['ID']['input'];
};

export type PartnerViewerClassDeletePayload = {
  classId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type PartnerViewerFeaturedPlaylistCheckPointAddInput = {
  checkPointId: Array<Scalars['ID']['input']>;
  featuredPlaylistIds: Array<Scalars['ID']['input']>;
};

export type PartnerViewerFeaturedPlaylistCheckPointAddPayload = {
  featuredPlaylists?: Maybe<Array<FeaturedPlaylist>>;
  userErrors: Array<UserError>;
};

export type PartnerViewerFeaturedPlaylistCheckPointRemoveInput = {
  checkPointIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featuredPlaylistId: Scalars['ID']['input'];
};

export type PartnerViewerFeaturedPlaylistCheckPointRemovePayload = {
  featuredPlaylist?: Maybe<FeaturedPlaylist>;
  userErrors: Array<UserError>;
};

export type PartnerViewerFeaturedPlaylistCheckPointUpdateInput = {
  featuredPlaylistId: Scalars['ID']['input'];
  updateOrders: Array<PartnerViewerFeaturedPlaylistCheckPointUpdateOrder>;
};

export type PartnerViewerFeaturedPlaylistCheckPointUpdateOrder = {
  checkPointId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type PartnerViewerFeaturedPlaylistCheckPointUpdatePayload = {
  featuredPlaylist?: Maybe<FeaturedPlaylist>;
  userErrors: Array<UserError>;
};

export type PartnerViewerFeaturedPlaylistCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  levels: Array<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishMode?: InputMaybe<FeaturedPlaylistPublishMode>;
  title: Scalars['String']['input'];
  titleEn: Scalars['String']['input'];
};

export type PartnerViewerFeaturedPlaylistCreatePayload = {
  featuredPlaylist?: Maybe<FeaturedPlaylist>;
  userErrors: Array<UserError>;
};

export type PartnerViewerFeaturedPlaylistDeleteInput = {
  id: Scalars['ID']['input'];
};

export type PartnerViewerFeaturedPlaylistDeletePayload = {
  featuredPlaylistId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type PartnerViewerFeaturedPlaylistUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  levels?: InputMaybe<Array<Scalars['String']['input']>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishMode?: InputMaybe<FeaturedPlaylistPublishMode>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerFeaturedPlaylistUpdatePayload = {
  featuredPlaylist?: Maybe<FeaturedPlaylist>;
  userErrors: Array<UserError>;
};

export type PartnerViewerInviteNewStudentsInput = {
  classId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
};

export type PartnerViewerInviteNewStudentsPayload = {
  userErrors: Array<UserError>;
};

export type PartnerViewerInviteStudentToClassInput = {
  classCode: Scalars['String']['input'];
  listEmails: Array<Scalars['String']['input']>;
};

export type PartnerViewerInviteStudentToClassPayload = {
  emails?: Maybe<Array<Scalars['String']['output']>>;
  userErrors: Array<UserError>;
};

export type PartnerViewerMoveClassStudentInput = {
  classId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
};

export type PartnerViewerMoveClassStudentPayload = {
  class?: Maybe<Class>;
  student?: Maybe<Array<ClassStudent>>;
  userErrors: Array<UserError>;
};

export type PartnerViewerOverviewBillingData = {
  totalUserPaying?: Maybe<Scalars['Int']['output']>;
  wallet?: Maybe<Wallet>;
};

export type PartnerViewerRejectLeaveClassInput = {
  notificationId: Scalars['ID']['input'];
};

export type PartnerViewerRejectLeaveClassPayload = {
  notification?: Maybe<Notification>;
  userErrors: Array<UserError>;
};

export type PartnerViewerResetPasswordStudentInput = {
  password: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type PartnerViewerResetPasswordStudentPayload = {
  user?: Maybe<User>;
};

export type PartnerViewerRolePermissionUpdateInput = {
  active: Scalars['Boolean']['input'];
  permissionId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};

export type PartnerViewerRolePermissionUpdatePayload = {
  permissionId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type PartnerViewerScoreSpeakingAiInput = {
  name: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
  type?: InputMaybe<AiSpeakingRecordType>;
};

export type PartnerViewerScoreSpeakingAiPayload = {
  aiSpeakingRecordId?: Maybe<Scalars['ID']['output']>;
  teacherProfile?: Maybe<TeacherProfile>;
  userErrors: Array<UserError>;
};

export type PartnerViewerScoreWritingAiImageInput = {
  imageIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  task: AiWritingRecordTask;
};

export type PartnerViewerScoreWritingAiImagePayload = {
  aiWritingRecord?: Maybe<AiWritingRecord>;
  teacherProfile?: Maybe<TeacherProfile>;
  userErrors: Array<UserError>;
};

export type PartnerViewerScoreWritingAiInput = {
  content: Scalars['String']['input'];
  imageIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  task: AiWritingRecordTask;
  topic: Scalars['String']['input'];
};

export type PartnerViewerScoreWritingAiPayload = {
  aiWritingRecord?: Maybe<AiWritingRecord>;
  teacherProfile?: Maybe<TeacherProfile>;
  userErrors: Array<UserError>;
};

export type PartnerViewerSendResultChallengeInput = {
  studentId: Scalars['ID']['input'];
  userAttemptId: Scalars['ID']['input'];
};

export type PartnerViewerSendResultChallengePayload = {
  status?: Maybe<Scalars['Boolean']['output']>;
  userErrors: Array<UserError>;
};

export type PartnerViewerSentEmailStudentInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type PartnerViewerSentEmailStudentPayload = {
  email?: Maybe<Scalars['String']['output']>;
};

export type PartnerViewerStudentCreateInput = {
  classId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  planId?: InputMaybe<Scalars['ID']['input']>;
  username: Scalars['String']['input'];
};

export type PartnerViewerStudentCreatePayload = {
  user?: Maybe<User>;
  userErrors: Array<UserError>;
};

export type PartnerViewerStudentDeleteInput = {
  classId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
};

export type PartnerViewerStudentDeletePayload = {
  studentIds?: Maybe<Array<Scalars['ID']['output']>>;
  userErrors: Array<UserError>;
};

export type PartnerViewerStudentTestScoreFilter = {
  testLevelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerViewerStudentTestScoreItem = {
  accuracy?: Maybe<Scalars['Float']['output']>;
  skill: EnglishSkillV1;
};

export type PartnerViewerStudentUpdateInput = {
  classId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  learnerProfileId: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
  removeClassId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerStudentUpdatePayload = {
  user?: Maybe<User>;
  userErrors: Array<UserError>;
};

export type PartnerViewerUnreadNotificationsCount = {
  flyer: Scalars['Int']['output'];
  partner: Scalars['Int']['output'];
};

export type PartnerWeeklyClassAssignTestWeakFilter = {
  className?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerWeeklyClassStudyWeakFilter = {
  className?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerWeeklyStudentAssignTestWeakFilter = {
  classId?: InputMaybe<Array<Scalars['ID']['input']>>;
  studentName?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerWeeklyTeacherAssignTestWeakFilter = {
  classId?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherName?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentBankData = {
  bankCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bankType?: Maybe<Scalars['Int']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  logoLink?: Maybe<Scalars['String']['output']>;
};

export type PaymentCreateVnpLinkPayload = {
  url?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
};

export enum PaymentCreateVnpPackageInput {
  DiamondBasic = 'DIAMOND_BASIC',
  DiamondTrial = 'DIAMOND_TRIAL',
  DiamondWell = 'DIAMOND_WELL',
  FlyerIeltsOneYear = 'FLYER_IELTS_ONE_YEAR',
  FlyerIeltsSixMonths = 'FLYER_IELTS_SIX_MONTHS',
  FlyerIeltsThreeMonths = 'FLYER_IELTS_THREE_MONTHS',
  FlyerKidsFourYears = 'FLYER_KIDS_FOUR_YEARS',
  FlyerKidsOneYear = 'FLYER_KIDS_ONE_YEAR',
  FlyerKidsTwoYears = 'FLYER_KIDS_TWO_YEARS',
  FlyerMaxFourYears = 'FLYER_MAX_FOUR_YEARS',
  FlyerMaxOneYear = 'FLYER_MAX_ONE_YEAR',
  FlyerMaxTwoYears = 'FLYER_MAX_TWO_YEARS',
  FlyerTeensFourYears = 'FLYER_TEENS_FOUR_YEARS',
  FlyerTeensOneYear = 'FLYER_TEENS_ONE_YEAR',
  FlyerTeensTwoYears = 'FLYER_TEENS_TWO_YEARS',
  OneDay = 'ONE_DAY',
  PartnerDepositWallet = 'PARTNER_DEPOSIT_WALLET',
  PartnerSpeakingAi = 'PARTNER_SPEAKING_AI'
}

export enum PaymentCreateVnpSourceInput {
  Exam = 'EXAM',
  Ielts = 'IELTS',
  Mobile = 'MOBILE',
  Partner = 'PARTNER',
  Web = 'WEB'
}

export type PaymentCreateVnpUrlInput = {
  bankCode?: InputMaybe<Scalars['String']['input']>;
  callback: Scalars['String']['input'];
  discountCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  learnerProfileId?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<PaymentLocaleVnp>;
  orderInfo: Scalars['String']['input'];
  package: PaymentCreateVnpPackageInput;
  partnerPackageId?: InputMaybe<Scalars['ID']['input']>;
  partnerTotalSpeakingAi?: InputMaybe<Scalars['Int']['input']>;
  partnerTotalStudent?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  source: PaymentCreateVnpSourceInput;
  teacherProfileId?: InputMaybe<Scalars['ID']['input']>;
  userAddress?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userIdentityCard?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCreateVnpUrlPayload = {
  url?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
};

export type PaymentGetStatusPayload = {
  data?: Maybe<Scalars['Boolean']['output']>;
  userErrors: Array<UserError>;
};

export type PaymentGetStatusVnpInput = {
  txnRef: Scalars['String']['input'];
};

export type PaymentListBankVnpPayload = {
  data?: Maybe<Array<Maybe<PaymentBankData>>>;
  userErrors: Array<UserError>;
};

export enum PaymentLocaleVnp {
  En = 'EN',
  Vn = 'VN'
}

export type PaymentStudentActivities = Node & {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  learnerProfile: LearnerProfile;
  paymentStudentActivitiesId: Scalars['ID']['output'];
  status: PaymentStudentActivitiesStatus;
  teacherProfile: TeacherProfile;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PaymentStudentActivitiesBillingStatus {
  Expired = 'EXPIRED',
  Free = 'FREE',
  Upgraded = 'UPGRADED'
}

export type PaymentStudentActivitiesConnection = {
  edges: Array<PaymentStudentActivitiesEdge>;
  nodes: Array<PaymentStudentActivities>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaymentStudentActivitiesEdge = {
  cursor: Scalars['Cursor']['output'];
  node: PaymentStudentActivities;
};

export type PaymentStudentActivitiesFilter = {
  billingStatus?: InputMaybe<Array<PaymentStudentActivitiesBillingStatus>>;
  classes?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  q?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum PaymentStudentActivitiesStatus {
  Create = 'CREATE',
  Extend = 'EXTEND'
}

export type PhoneNumberProviderInfo = {
  phoneNumber: Scalars['String']['output'];
  provider: Scalars['String']['output'];
};

export type Phoneme = {
  accuracyScore?: Maybe<Scalars['Float']['output']>;
  decision?: Maybe<WordDecision>;
  duration?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  phoneme?: Maybe<Scalars['String']['output']>;
  pronunciationAssessment?: Maybe<PronunciationAssessment>;
};

export type PlacementTestGroup = Node & {
  checkPoints: Array<CheckPoint>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  descriptionEn?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nameEn?: Maybe<Scalars['String']['output']>;
  placementTestGroupId: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type PracticeDetailAnswer = {
  correctOptionIDs?: Maybe<Array<Scalars['ID']['output']>>;
  detailId: Scalars['ID']['output'];
  optionIds?: Maybe<Array<Scalars['ID']['output']>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PracticeDetailAnswerInput = {
  detailId: Scalars['ID']['input'];
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PracticeEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type PracticeEndAttemptPayload = {
  userErrors: Array<UserError>;
};

export type PracticePart = Node & {
  answerExplanationHtml?: Maybe<Scalars['String']['output']>;
  answerExplanationHtmlEn?: Maybe<Scalars['String']['output']>;
  body: PracticePartBody;
  checkPoint: CheckPoint;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  mark: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  practicePartId: Scalars['ID']['output'];
  score: Scalars['Float']['output'];
  time?: Maybe<Scalars['Duration']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: PracticePartType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type PracticePartAttempt = Node & {
  correctMark: Scalars['Int']['output'];
  detailAnswers: Array<PracticeDetailAnswer>;
  id: Scalars['ID']['output'];
  part: PracticePart;
  practicePartAttemptId: Scalars['ID']['output'];
  score: Scalars['Float']['output'];
};

export type PracticePartBody = {
  details: Array<PracticePartDetail>;
  query: PracticePartQuery;
};

export type PracticePartBodyInput = {
  details: Array<PracticePartDetailInput>;
  query: PracticePartQueryInput;
};

export type PracticePartDetail = {
  id: Scalars['ID']['output'];
  multipleCorrectAnswers: Scalars['Boolean']['output'];
  options: Array<PracticePartOption>;
};

export type PracticePartDetailInput = {
  id: Scalars['ID']['input'];
  multipleCorrectAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  options: Array<PracticePartOptionInput>;
};

export type PracticePartOption = {
  correctAnswer: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PracticePartOptionInput = {
  correctAnswer: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PracticePartQuery = {
  audio?: Maybe<Audio>;
  contentHtml: Scalars['String']['output'];
  image?: Maybe<Image>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type PracticePartQueryInput = {
  audioId?: InputMaybe<Scalars['ID']['input']>;
  contentHtml: Scalars['String']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum PracticePartType {
  Dropdown = 'DROPDOWN',
  Gapfill = 'GAPFILL',
  Multichoice = 'MULTICHOICE'
}

export type PracticeStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
};

export type PracticeStartAttemptPayload = {
  attemptId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type PracticeSubmitPartAttemptInput = {
  answers: Array<PracticeDetailAnswerInput>;
  attemptId: Scalars['ID']['input'];
  partId: Scalars['ID']['input'];
};

export type PracticeSubmitPartAttemptPayload = {
  answers?: Maybe<Array<PracticeDetailAnswer>>;
  userErrors: Array<UserError>;
};

export type PronunciationAssessment = {
  accuracyScore?: Maybe<Scalars['Float']['output']>;
  completenessScore?: Maybe<Scalars['Float']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<Feedback>;
  fluencyScore?: Maybe<Scalars['Float']['output']>;
  nBestPhonemes?: Maybe<Array<Maybe<NBestPhonemes>>>;
  pronScore?: Maybe<Scalars['Float']['output']>;
  prosodyScore?: Maybe<Scalars['Float']['output']>;
};

export type PronunciationWord = {
  audioUrl?: Maybe<Scalars['String']['output']>;
  decision: WordDecision;
  endIndex?: Maybe<Scalars['Int']['output']>;
  ipa: Scalars['String']['output'];
  nativenessScore: Scalars['Float']['output'];
  phonemes: Array<PronunciationWord>;
  startIndex?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
};

export type Prosody = {
  break?: Maybe<Break>;
  intonation?: Maybe<Intonation>;
};

export type Province = Node & {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  provinceId: Scalars['ID']['output'];
};

export type Query = {
  activationPlans: ActivationPlanConnection;
  adminAvatarFrame?: Maybe<AvatarFrame>;
  adminAvatarFrames: AvatarFrameConnection;
  adminBook?: Maybe<Book>;
  adminBookLesson?: Maybe<BookLesson>;
  adminBookLessons: BookLessonConnection;
  adminBookUnit?: Maybe<BookUnit>;
  adminBookUnits: BookUnitConnection;
  adminBooks: BookConnection;
  adminCheckPoint?: Maybe<CheckPoint>;
  adminCheckPoints: CheckPointConnection;
  adminCustomDomain?: Maybe<CustomDomain>;
  adminCustomDomains: CustomDomainConnection;
  adminDiscount?: Maybe<Discount>;
  adminDiscounts: DiscountConnection;
  adminDuolingoPart?: Maybe<DuolingoPart>;
  adminDuolingoParts: DuolingoPartConnection;
  adminExamPart?: Maybe<ExamPart>;
  adminExamParts: ExamPartConnection;
  adminIeltsListeningPart?: Maybe<IeltsListeningPart>;
  adminIeltsListeningParts: IeltsListeningPartConnection;
  adminIeltsListeningQuestion?: Maybe<IeltsListeningQuestion>;
  adminIeltsListeningQuestions: IeltsListeningQuestionConnection;
  adminIeltsReadingPart?: Maybe<IeltsReadingPart>;
  adminIeltsReadingParts: IeltsReadingPartConnection;
  adminIeltsReadingQuestion?: Maybe<IeltsReadingQuestion>;
  adminIeltsReadingQuestions: IeltsReadingQuestionConnection;
  adminIeltsSpeakingPart?: Maybe<IeltsSpeakingPart>;
  adminIeltsSpeakingPartInfo?: Maybe<IeltsSpeakingPartInfo>;
  adminIeltsSpeakingParts: IeltsSpeakingPartConnection;
  adminIeltsSpeakingPartsInfo: IeltsSpeakingPartInfoConnection;
  adminIeltsSpeakingQuestion?: Maybe<IeltsSpeakingQuestion>;
  adminIeltsSpeakingQuestions: IeltsSpeakingQuestionConnection;
  adminIeltsWritingPart?: Maybe<IeltsWritingPart>;
  adminIeltsWritingParts: IeltsWritingPartConnection;
  adminIeltsWritingQuestion?: Maybe<IeltsWritingQuestion>;
  adminIeltsWritingQuestions: IeltsWritingQuestionConnection;
  adminLearnerProfiles: LearnerProfileConnection;
  adminNotificationEventActions: Array<NotificationEventValue>;
  adminNotificationEventAppTypes: Array<NotificationEventValue>;
  adminNotificationEventConditions: Array<NotificationEventValue>;
  adminNotificationEventTopics: Array<NotificationEventValue>;
  adminNotificationEventTypes: Array<NotificationEventValue>;
  adminNotificationEvents: NotificationEventConnection;
  adminPackageFlyer?: Maybe<FlyerPackage>;
  adminPackageFlyers: FlyerPackageConnection;
  adminSchools: SchoolConnection;
  adminSpeakingPart?: Maybe<SpeakingPart>;
  adminSpeakingParts: SpeakingPartConnection;
  adminStudyCharacter?: Maybe<StudyCharacter>;
  adminStudyCharacters: StudyCharacterConnection;
  adminTeacherByDays: Array<TeacherByDay>;
  adminTeacherInfo: TeacherOverviewData;
  adminTopic?: Maybe<Topic>;
  adminTopics: TopicConnection;
  adminUserAttempts: UserAttemptConnection;
  adminUserTeacherReferralUsage: UserTeacherReferralUsageConnection;
  adminVersionNotification: VersionNotification;
  adminVersionNotifications: VersionNotificationConnection;
  adminViewerAiConversation: AiConversationConnection;
  adminViewerAiConversationSession?: Maybe<AiConversationSession>;
  adminViewerAiConversationSessions: AiConversationSessionConnection;
  adminViewerAiConversationSummary: AiConversationSummaryConnection;
  adminViewerAiConversationSummaryAudio?: Maybe<Scalars['String']['output']>;
  adminViewerFeaturePlaylist?: Maybe<FeaturedPlaylist>;
  adminViewerFeaturePlaylists: FeaturedPlaylistConnection;
  adminViewerMenuNotification?: Maybe<MenuNotification>;
  adminViewerMenuNotifications: MenuNotificationConnection;
  adminViewerTheme?: Maybe<Theme>;
  adminViewerThemes: ThemeConnection;
  adminVocabWord?: Maybe<VocabWord>;
  adminVocabWords: VocabWordConnection;
  adminWritingPart?: Maybe<WritingPart>;
  adminWritingParts: WritingPartConnection;
  aiSpeakingRecord?: Maybe<AiSpeakingRecord>;
  aiWritingRecord?: Maybe<AiWritingRecord>;
  authTokenValid: Scalars['Boolean']['output'];
  avatarFrames: AvatarFrameConnection;
  challenge?: Maybe<Challenge>;
  /** @deprecated use challengeInfo in challenge */
  challengeAnswerAccuracy?: Maybe<AnswerAccuracyInfo>;
  challengeByCode?: Maybe<Challenge>;
  checkIp?: Maybe<IpData>;
  checkPoint?: Maybe<CheckPoint>;
  checkPoints: CheckPointConnection;
  checkPointsByCefrLevelOverview: Array<CheckPointsByCefrLevel>;
  /** @deprecated use checkPoints instead */
  checkPointsFull: CheckPointConnection;
  checkPointsPartner: CheckPointConnection;
  checkPointsViewerPartner: CheckPointConnection;
  classLevels: Array<ClassLevel>;
  countryCodes: Array<CountryCode>;
  dailyRewards: Array<DailyReward>;
  dictionary?: Maybe<Dictionary>;
  discount?: Maybe<DiscountPayload>;
  identifierExists: Scalars['Boolean']['output'];
  ieltsCheckPoints: CheckPointConnection;
  ieltsCurrentPlacementTestCheckPoint?: Maybe<CheckPoint>;
  ieltsPracticeCheckPoints: CheckPointConnection;
  ieltsSpeakingCheckPoints: CheckPointConnection;
  ieltsViewerCurrentPlacementTestAttemptResult?: Maybe<UserAttempt>;
  ieltsViewerNotes: IeltsNoteConnection;
  ieltsViewerStatsOverview?: Maybe<IeltsStatsOverview>;
  learnerChallengeRanks: LearnerChallengeRankConnection;
  learnerProfile?: Maybe<LearnerProfile>;
  learnerProfileStats?: Maybe<LearnerProfileStatsOverview>;
  learnerTestLevelRanks: LearnerTestLevelRankConnection;
  node?: Maybe<Node>;
  nodes: Array<Maybe<Node>>;
  orderCodes: OrderCodeConnection;
  orderedActivationCodes: Array<Scalars['String']['output']>;
  otpCodeValid: Scalars['Boolean']['output'];
  parentViewerCompletedTestChart: Array<ParentCompletedTestChartPayload>;
  parentViewerDetailCompletedTest: ParentDetailCompletedTestPayload;
  parentViewerDetailStudyTime: ParentDetailStudyTimePayload;
  parentViewerNotifications: NotificationConnection;
  parentViewerOverview: ParentOverviewPayload;
  parentViewerOverviewAssignTest: ParentOverviewAssignTestPayload;
  parentViewerStudentAssignTest: AssignTestConnection;
  parentViewerStudentUserAttempts: UserAttemptConnection;
  parentViewerStudyTimeChart: Array<ParentStudyTimeChartPayload>;
  parentViewerUnreadNotificationsCount?: Maybe<ParentViewerUnreadNotificationsCount>;
  partnerAccuracyRanking: PartnerAccuracyRankingPayload;
  partnerAssignTest?: Maybe<AssignTest>;
  partnerAssignTestProfiles: AssignTestProfileConnection;
  partnerAssignTests: AssignTestConnection;
  partnerBook?: Maybe<Book>;
  partnerBooks: BookConnection;
  partnerClassRanking: PartnerClassRankingPayload;
  /** @deprecated use partnerViewerSchoolClasses instead */
  partnerClasses: ClassConnection;
  partnerCompletedTestChart: PartnerCompletedTestChartPayload;
  partnerDetailCompletedTest: PartnerDetailCompletedTestPayload;
  partnerDetailStudyTime: PartnerDetailStudyTimePayload;
  partnerDomain?: Maybe<CustomDomain>;
  partnerFeaturePlaylist?: Maybe<FeaturedPlaylist>;
  partnerFeaturePlaylists: FeaturedPlaylistConnection;
  partnerIeltsCheckPoint?: Maybe<CheckPoint>;
  partnerIeltsCheckPoints: CheckPointConnection;
  partnerInfoAssignTest: PartnerInfoAssignTestPayload;
  partnerListAssignTest: PartnerListAssignTestPayload;
  partnerNewStudents: LearnerProfileConnection;
  partnerOverview: PartnerOverviewPayload;
  partnerPackages: PartnerPackageConnection;
  partnerPracticeArchivedCheckPoints: CheckPointConnection;
  partnerPracticeCheckPoints: CheckPointConnection;
  partnerPracticeCheckPointsInfo: PartnerPracticeCheckPointsInfo;
  partnerStudentChart: PartnerStudentChartPayload;
  partnerStudentList: PartnerStudentListPayload;
  partnerStudentMistakeWord?: Maybe<LearnerMistakeWordConnection>;
  partnerStudyTimeChart: PartnerStudyTimeChartPayload;
  partnerStudyTimeRanking: PartnerStudyTimeRankingPayload;
  /** @deprecated use partnerViewerTeacher instead */
  partnerTeacher?: Maybe<TeacherProfile>;
  partnerTeacherStudyTimeChart?: Maybe<Array<PartnerTeacherStudyTimeChartData>>;
  partnerViewerAIConversations: AiPartnerConversationConnection;
  partnerViewerAISpeakingRecords: AiSpeakingRecordConnection;
  partnerViewerAIThread?: Maybe<AiPartnerThread>;
  partnerViewerAIThreads: AiPartnerThreadConnection;
  partnerViewerAIWritingRecords: AiWritingRecordConnection;
  partnerViewerActivities: PartnerActivitiesConnection;
  partnerViewerAiConversationSession?: Maybe<AiConversationSession>;
  partnerViewerAiConversationSessions: AiConversationSessionConnection;
  partnerViewerAiConversationStudent: AiConversationConnection;
  partnerViewerAiConversationStudentSession: AiConversationSummaryConnection;
  partnerViewerAiConversationStudentSessionAudio?: Maybe<Scalars['String']['output']>;
  partnerViewerAssignTestStats?: Maybe<AssignTestStats>;
  partnerViewerAverageAccuracyByDay: Array<AccuracyByDay>;
  partnerViewerBillingHistories: PartnerBillingHistoriesConnection;
  partnerViewerChallenge?: Maybe<Challenge>;
  partnerViewerChallenges: ChallengeConnection;
  partnerViewerClass?: Maybe<Class>;
  partnerViewerClassesCompletedTestByDay: Array<ClassesCompletedTestByDay>;
  partnerViewerClassesStudyTimeByDay: Array<ClassesStudyTimeByDay>;
  /** @deprecated use partnerFeaturePlaylists instead */
  partnerViewerFeaturePlaylist?: Maybe<FeaturedPlaylist>;
  /** @deprecated use partnerFeaturePlaylists instead */
  partnerViewerFeaturePlaylists: FeaturedPlaylistConnection;
  partnerViewerGradeDistribution: Array<GradeDistribution>;
  partnerViewerMenuNotifications: MenuNotificationConnection;
  partnerViewerNotifications: NotificationConnection;
  partnerViewerOverviewBilling?: Maybe<PartnerViewerOverviewBillingData>;
  partnerViewerPaymentStudentActivities: PaymentStudentActivitiesConnection;
  partnerViewerRollupAssignTests: PartnerRollupAssignTestPagination;
  partnerViewerRollupClasses: PartnerRollupClassPagination;
  partnerViewerRollupConversationStudents: PartnerRollupConversationStudentPagination;
  partnerViewerRollupNewStudents: PartnerRollupNewStudentPagination;
  partnerViewerRollupStudents: PartnerRollupStudentPagination;
  partnerViewerRollupTeachers: PartnerRollupTeacherPagination;
  partnerViewerSchoolClasses: ClassConnection;
  partnerViewerSchoolStudents: LearnerProfileConnection;
  partnerViewerSchoolStudentsV2: PartnerTeacherSchoolStudentConnection;
  partnerViewerSchoolTeachers: TeacherProfileConnection;
  partnerViewerSchoolsOverview?: Maybe<PartnerSchoolsOverviewPayload>;
  /** @deprecated use partnerViewerTeachers instead */
  partnerViewerSchoolsTeachers: TeacherProfileConnection;
  partnerViewerSkillTestScore: Array<SkillTestScore>;
  partnerViewerStudent?: Maybe<LearnerProfile>;
  partnerViewerStudentAccuracy: Array<StudentAccuracy>;
  partnerViewerStudentAssignTestStats?: Maybe<StudentAssignTestStats>;
  partnerViewerStudentStudyTime: Array<StudentStudyTime>;
  partnerViewerStudentTestScore?: Maybe<Array<PartnerViewerStudentTestScoreItem>>;
  partnerViewerStudents: LearnerProfileConnection;
  partnerViewerTeacher?: Maybe<TeacherProfile>;
  partnerViewerTeacherStudyTime: Array<TeacherStudyTime>;
  partnerViewerTeachers: TeacherProfileConnection;
  partnerViewerUnreadNotificationsCount?: Maybe<PartnerViewerUnreadNotificationsCount>;
  partnerViewerUserAttempts: UserAttemptConnection;
  partnerViewerWeeklyClassAssignTestWeak: WeeklyClassAssignTestWeakConnection;
  partnerViewerWeeklyClassStudyTimeWeak: WeeklyClassStudyTimeWeakConnection;
  partnerViewerWeeklyStudentAssignTestWeak: WeeklyStudentAssignTestWeakConnection;
  partnerViewerWeeklyTeacherAssignTestWeak: WeeklyTeacherAssignTestWeakConnection;
  paymentGetStatusVNP: PaymentGetStatusPayload;
  paymentListBankVNP: PaymentListBankVnpPayload;
  ping?: Maybe<Scalars['String']['output']>;
  placementTestGroups: Array<PlacementTestGroup>;
  provinces: Array<Province>;
  resultStatementComments: ResultStatementCommentConnection;
  resultStatements: ResultStatementConnection;
  school?: Maybe<School>;
  schoolTestLevelRanks: SchoolTestLevelRankConnection;
  schools: SchoolConnection;
  teacherInvitedLearner?: Maybe<TeacherInvitedLearner>;
  teacherProfile?: Maybe<TeacherProfile>;
  teacherReferralCodeExists: Scalars['Boolean']['output'];
  testLevel?: Maybe<TestLevel>;
  testLevelBySlug?: Maybe<TestLevel>;
  testLevels: TestLevelConnection;
  textToSpeak: TextToSpeakPayload;
  themes: ThemeConnection;
  userAttempt?: Maybe<UserAttempt>;
  versionNotification?: Maybe<VersionNotification>;
  viewer?: Maybe<User>;
  viewerAIConversations: AiConversationConnection;
  viewerAchievements?: Maybe<Array<LearnerAchievement>>;
  viewerAdvices?: Maybe<AdviceConnection>;
  viewerAiConversationSession?: Maybe<AiConversationSession>;
  viewerAiConversationSessions: AiConversationSessionConnection;
  viewerAssignedTestUserAttempts: UserAttemptConnection;
  viewerCurrentSchool?: Maybe<School>;
  viewerCurrentSchoolRole?: Maybe<PartnerRole>;
  viewerDuolingoPaths: Array<LearnerDuolingoPath>;
  viewerExamNotifications: NotificationConnection;
  viewerExamUnreadNotificationsCount: Scalars['Int']['output'];
  viewerGetClassName?: Maybe<Scalars['String']['output']>;
  viewerIeltsNotifications: NotificationConnection;
  viewerIeltsUnreadNotificationsCount?: Maybe<ViewerUnreadNotificationsCount>;
  viewerInProgressAssignedTests: AssignTestConnection;
  viewerInProgressAssignedTestsV2: AssignTestProfileConnection;
  viewerLearnerProfileStats?: Maybe<LearnerProfileStatsOverview>;
  viewerMistakeWords: LearnerMistakeWordConnection;
  viewerPartnerAdminTeachers: TeacherProfileConnection;
  /** @deprecated use partnerViewerClass instead */
  viewerPartnerClass?: Maybe<Class>;
  /** @deprecated use partnerViewerSchoolClasses instead */
  viewerPartnerClasses: ClassConnection;
  viewerPartnerIsInClassTeacher?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use partnerViewerNotifications instead */
  viewerPartnerNotifications: NotificationConnection;
  viewerPartnerRoles: Array<PartnerRole>;
  viewerPartnerSchoolInvitedTeachers: SchoolInvitedTeacherConnection;
  /** @deprecated use partnerViewerSchoolTeachers instead */
  viewerPartnerTeachers: TeacherProfileConnection;
  /** @deprecated use partnerViewerUnreadNotificationsCount instead */
  viewerPartnerUnreadNotificationsCount: Scalars['Int']['output'];
  /** @deprecated use partnerViewerUserAttempts instead */
  viewerPartnerUserAttempts: UserAttemptConnection;
  viewerRemindTask?: Maybe<RemindTask>;
  viewerScoreMistakeWordQuota: Quota;
  viewerSession: ViewerSessionPayload;
  viewerUnreadNotificationsCount?: Maybe<ViewerUnreadNotificationsCount>;
  viewerUserAttempts: UserAttemptConnection;
  viewerXpSummaries: LearnerXpConnection;
  vnpayPayment?: Maybe<VnpayPayment>;
};


export type QueryActivationPlansArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminAvatarFrameArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminAvatarFramesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AvatarFrameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminBookArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminBookLessonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminBookLessonsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<BookLessonFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminBookUnitArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminBookUnitsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<BookUnitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminBooksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<BookFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminCheckPointArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminCheckPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CheckPointOrder>;
};


export type QueryAdminCustomDomainArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminCustomDomainsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CustomDomainFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminDiscountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminDiscountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<DiscountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminDuolingoPartArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminDuolingoPartsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<DuolingoPartFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminExamPartArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminExamPartsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<ExamPartFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminIeltsListeningPartArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminIeltsListeningPartsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<IeltsListeningPartFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminIeltsListeningQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminIeltsListeningQuestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<IeltsListeningQuestionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminIeltsReadingPartArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminIeltsReadingPartsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<IeltsReadingPartFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminIeltsReadingQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminIeltsReadingQuestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<IeltsReadingQuestionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminIeltsSpeakingPartArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminIeltsSpeakingPartInfoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminIeltsSpeakingPartsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<IeltsSpeakingPartFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminIeltsSpeakingPartsInfoArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<IeltsSpeakingPartInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminIeltsSpeakingQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminIeltsSpeakingQuestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<IeltsSpeakingQuestionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminIeltsWritingPartArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminIeltsWritingPartsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<IeltsWritingPartFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminIeltsWritingQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminIeltsWritingQuestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<IeltsWritingQuestionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminLearnerProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<LearnerProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminNotificationEventActionsArgs = {
  appType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminNotificationEventConditionsArgs = {
  appType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminNotificationEventTypesArgs = {
  appType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminNotificationEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NotificationEventOrder>;
};


export type QueryAdminPackageFlyerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminPackageFlyersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminSchoolsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<SchoolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminSpeakingPartArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminSpeakingPartsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<SpeakingPartFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminStudyCharacterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminStudyCharactersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<StudyCharacterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminTeacherByDaysArgs = {
  filterBy: TeacherByDayFilter;
};


export type QueryAdminTeacherInfoArgs = {
  input: TeacherOverviewInput;
};


export type QueryAdminTopicArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminTopicsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<TopicFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminUserAttemptsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<UserAttemptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminUserTeacherReferralUsageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<UserTeacherReferralUsageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminVersionNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminVersionNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<VersionNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminViewerAiConversationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AiConversationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AiConversationOrder>;
};


export type QueryAdminViewerAiConversationSessionArgs = {
  aiConversationSessionId: Scalars['ID']['input'];
};


export type QueryAdminViewerAiConversationSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AiConversationSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AiConversationSessionOrder>;
};


export type QueryAdminViewerAiConversationSummaryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AiConversationSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AiConversationSummaryOrder>;
};


export type QueryAdminViewerAiConversationSummaryAudioArgs = {
  sessionId: Scalars['ID']['input'];
};


export type QueryAdminViewerFeaturePlaylistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminViewerFeaturePlaylistsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<FeaturedPlaylistFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminViewerMenuNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminViewerMenuNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<MenuNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminViewerThemeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminViewerThemesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<ThemeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminVocabWordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminVocabWordsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<VocabWordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VocabWordOrder>;
};


export type QueryAdminWritingPartArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminWritingPartsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<WritingPartFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAiSpeakingRecordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAiWritingRecordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuthTokenValidArgs = {
  identifierType: IdentifierType;
  token: Scalars['String']['input'];
  tokenType?: TokenType;
};


export type QueryAvatarFramesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AvatarFrameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChallengeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChallengeAnswerAccuracyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChallengeByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryCheckPointArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCheckPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CheckPointOrder>;
};


export type QueryCheckPointsByCefrLevelOverviewArgs = {
  filterBy?: InputMaybe<CheckPointFilter>;
  limitPerLevel?: Scalars['Int']['input'];
  orderBy?: InputMaybe<CheckPointOrder>;
  testLevelFilterBy?: InputMaybe<TestLevelFilter>;
};


export type QueryCheckPointsFullArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CheckPointOrder>;
};


export type QueryCheckPointsPartnerArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CheckPointOrder>;
};


export type QueryCheckPointsViewerPartnerArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CheckPointOrder>;
};


export type QueryClassLevelsArgs = {
  classType?: InputMaybe<ClassType>;
};


export type QueryDictionaryArgs = {
  word: Scalars['String']['input'];
};


export type QueryDiscountArgs = {
  amount: Scalars['Float']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIdentifierExistsArgs = {
  identifier: Scalars['String']['input'];
};


export type QueryIeltsCheckPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includedPractice?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIeltsPracticeCheckPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIeltsSpeakingCheckPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIeltsViewerNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<IeltsNoteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLearnerChallengeRanksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  challengeCode: Scalars['String']['input'];
  filterBy?: InputMaybe<LearnerChallengeRankFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LearnerChallengeRankOrder>;
};


export type QueryLearnerProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLearnerProfileStatsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLearnerTestLevelRanksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  classCode?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<LearnerTestLevelRankFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  frequency: RankFrequency;
  last?: InputMaybe<Scalars['Int']['input']>;
  testLevelId: Scalars['ID']['input'];
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryOrderCodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<OrderCodeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderedActivationCodesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOtpCodeValidArgs = {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type QueryParentViewerCompletedTestChartArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerProfileId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  testLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryParentViewerDetailCompletedTestArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerProfileId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryParentViewerDetailStudyTimeArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerProfileId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryParentViewerNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryParentViewerOverviewArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerProfileId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryParentViewerOverviewAssignTestArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerProfileId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryParentViewerStudentAssignTestArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AssignTestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learnerProfileId: Scalars['ID']['input'];
  orderBy?: InputMaybe<AssignTestOrder>;
};


export type QueryParentViewerStudentUserAttemptsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<UserAttemptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learnerProfileId: Scalars['ID']['input'];
};


export type QueryParentViewerStudyTimeChartArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerProfileId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  testLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerAccuracyRankingArgs = {
  input?: InputMaybe<PartnerAccuracyRankingInput>;
};


export type QueryPartnerAssignTestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartnerAssignTestProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AssignTestProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssignTestProfileOrder>;
};


export type QueryPartnerAssignTestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AssignTestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssignTestOrder>;
};


export type QueryPartnerBookArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartnerBooksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerClassRankingArgs = {
  input?: InputMaybe<PartnerClassRankingInput>;
};


export type QueryPartnerClassesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<ClassFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClassOrder>;
};


export type QueryPartnerCompletedTestChartArgs = {
  input?: InputMaybe<PartnerCompletedTestChartInput>;
};


export type QueryPartnerDetailCompletedTestArgs = {
  input?: InputMaybe<PartnerDetailCompletedTestInput>;
};


export type QueryPartnerDetailStudyTimeArgs = {
  input?: InputMaybe<PartnerDetailStudyTimeInput>;
};


export type QueryPartnerDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryPartnerFeaturePlaylistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartnerFeaturePlaylistsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<FeaturedPlaylistFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerIeltsCheckPointArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartnerIeltsCheckPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skill: IeltsSkill;
};


export type QueryPartnerInfoAssignTestArgs = {
  input?: InputMaybe<PartnerInfoAssignTestInput>;
};


export type QueryPartnerListAssignTestArgs = {
  input?: InputMaybe<PartnerListAssignTestInput>;
};


export type QueryPartnerNewStudentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<LearnerProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerOverviewArgs = {
  input?: InputMaybe<PartnerOverviewInput>;
};


export type QueryPartnerPackagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerPracticeArchivedCheckPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerPracticeCheckPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerStudentChartArgs = {
  input?: InputMaybe<PartnerStudentChartInput>;
};


export type QueryPartnerStudentListArgs = {
  input?: InputMaybe<PartnerStudentListInput>;
};


export type QueryPartnerStudentMistakeWordArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<LearnerMistakeWordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerStudyTimeChartArgs = {
  input?: InputMaybe<PartnerStudyTimeChartInput>;
};


export type QueryPartnerStudyTimeRankingArgs = {
  input?: InputMaybe<PartnerStudyTimeRankingInput>;
};


export type QueryPartnerTeacherArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartnerTeacherStudyTimeChartArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryPartnerViewerAiConversationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AiPartnerConversationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  threadId: Scalars['ID']['input'];
};


export type QueryPartnerViewerAiSpeakingRecordsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerViewerAiThreadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartnerViewerAiThreadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AiPartnerThreadFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerViewerAiWritingRecordsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerViewerActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<PartnerActivitiesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerViewerAiConversationSessionArgs = {
  aiConversationSessionId: Scalars['ID']['input'];
};


export type QueryPartnerViewerAiConversationSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AiConversationSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AiConversationSessionOrder>;
};


export type QueryPartnerViewerAiConversationStudentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AiConversationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AiConversationOrder>;
  sessionId: Scalars['ID']['input'];
};


export type QueryPartnerViewerAiConversationStudentSessionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AiConversationSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AiConversationSummaryOrder>;
};


export type QueryPartnerViewerAiConversationStudentSessionAudioArgs = {
  sessionId: Scalars['ID']['input'];
};


export type QueryPartnerViewerAssignTestStatsArgs = {
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange: DateRangeInput;
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerAverageAccuracyByDayArgs = {
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange: DateRangeInput;
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerBillingHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<PartnerBillingHistoriesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerViewerChallengeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartnerViewerChallengesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<ChallengeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerViewerClassArgs = {
  classId: Scalars['ID']['input'];
};


export type QueryPartnerViewerClassesCompletedTestByDayArgs = {
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange: DateRangeInput;
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerClassesStudyTimeByDayArgs = {
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange: DateRangeInput;
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerFeaturePlaylistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartnerViewerFeaturePlaylistsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<FeaturedPlaylistFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerViewerGradeDistributionArgs = {
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange: DateRangeInput;
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerMenuNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<MenuNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerViewerNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerViewerPaymentStudentActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<PaymentStudentActivitiesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerViewerRollupAssignTestsArgs = {
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterBy?: InputMaybe<PartnerRollupAssignTestFilter>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<PartnerRollupAssignTestOrder>;
  page?: Scalars['Int']['input'];
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  studentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerRollupClassesArgs = {
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  comparedDateRange?: InputMaybe<DateRangeInput>;
  dateRange?: InputMaybe<DateRangeInput>;
  filterBy?: InputMaybe<PartnerRollupClassFilter>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<PartnerRollupClassOrder>;
  page?: Scalars['Int']['input'];
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerRollupConversationStudentsArgs = {
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  filterBy?: InputMaybe<PartnerRollupConversationStudentFilter>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<PartnerRollupConversationStudentOrder>;
  page?: Scalars['Int']['input'];
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerRollupNewStudentsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  filterBy?: InputMaybe<PartnerRollupNewStudentFilter>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<PartnerRollupNewStudentOrder>;
  page?: Scalars['Int']['input'];
};


export type QueryPartnerViewerRollupStudentsArgs = {
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  filterBy?: InputMaybe<PartnerRollupStudentFilter>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<PartnerRollupStudentOrder>;
  page?: Scalars['Int']['input'];
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerRollupTeachersArgs = {
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  comparedDateRange?: InputMaybe<DateRangeInput>;
  dateRange?: InputMaybe<DateRangeInput>;
  filterBy?: InputMaybe<PartnerRollupTeacherFilter>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<PartnerRollupTeacherOrder>;
  page?: Scalars['Int']['input'];
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerSchoolClassesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<ClassFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClassOrder>;
};


export type QueryPartnerViewerSchoolStudentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<LearnerProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LearnerProfileOrder>;
};


export type QueryPartnerViewerSchoolStudentsV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<PartnerTeacherSchoolStudentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PartnerTeacherSchoolStudentOrder>;
};


export type QueryPartnerViewerSchoolTeachersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<TeacherProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TeacherProfileOrder>;
};


export type QueryPartnerViewerSchoolsOverviewArgs = {
  dateRange?: InputMaybe<DateTimeRange>;
};


export type QueryPartnerViewerSchoolsTeachersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<TeacherProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TeacherProfileOrder>;
  schoolID?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerSkillTestScoreArgs = {
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange: DateRangeInput;
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerStudentArgs = {
  studentId: Scalars['ID']['input'];
};


export type QueryPartnerViewerStudentAccuracyArgs = {
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  comparedDateRange?: InputMaybe<DateRangeInput>;
  dateRange: DateRangeInput;
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerStudentAssignTestStatsArgs = {
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerStudentStudyTimeArgs = {
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  comparedDateRange?: InputMaybe<DateRangeInput>;
  dateRange: DateRangeInput;
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerStudentTestScoreArgs = {
  filterBy?: InputMaybe<PartnerViewerStudentTestScoreFilter>;
  studentId: Scalars['ID']['input'];
};


export type QueryPartnerViewerStudentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<LearnerProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LearnerProfileOrder>;
};


export type QueryPartnerViewerTeacherArgs = {
  teacherId: Scalars['ID']['input'];
};


export type QueryPartnerViewerTeacherStudyTimeArgs = {
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  comparedDateRange?: InputMaybe<DateRangeInput>;
  dateRange: DateRangeInput;
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerTeachersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<TeacherProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TeacherProfileOrder>;
  schoolID?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerViewerUserAttemptsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  classID?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterBy?: InputMaybe<UserAttemptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerViewerWeeklyClassAssignTestWeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<PartnerWeeklyClassAssignTestWeakFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerViewerWeeklyClassStudyTimeWeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<PartnerWeeklyClassStudyWeakFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerViewerWeeklyStudentAssignTestWeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<PartnerWeeklyStudentAssignTestWeakFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WeeklyStudentAssignTestWeakOrder>;
};


export type QueryPartnerViewerWeeklyTeacherAssignTestWeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<PartnerWeeklyTeacherAssignTestWeakFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaymentGetStatusVnpArgs = {
  input: PaymentGetStatusVnpInput;
};


export type QueryResultStatementCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResultStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySchoolArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySchoolTestLevelRanksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<SchoolTestLevelRankFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  frequency: RankFrequency;
  last?: InputMaybe<Scalars['Int']['input']>;
  testLevelId: Scalars['ID']['input'];
};


export type QuerySchoolsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<SchoolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTeacherInvitedLearnerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeacherProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeacherReferralCodeExistsArgs = {
  code: Scalars['String']['input'];
};


export type QueryTestLevelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTestLevelBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryTestLevelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<TestLevelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TestLevelOrder>;
};


export type QueryTextToSpeakArgs = {
  input?: InputMaybe<TextToSpeakInput>;
};


export type QueryThemesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<ThemeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserAttemptArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVersionNotificationArgs = {
  appType: AppTypeMobile;
};


export type QueryViewerAiConversationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryViewerAdvicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryViewerAiConversationSessionArgs = {
  aiConversationSessionId: Scalars['ID']['input'];
};


export type QueryViewerAiConversationSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AiConversationSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AiConversationSessionOrder>;
};


export type QueryViewerAssignedTestUserAttemptsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<UserAttemptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIelts?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryViewerExamNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryViewerGetClassNameArgs = {
  classCode: Scalars['String']['input'];
};


export type QueryViewerIeltsNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryViewerInProgressAssignedTestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AssignTestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIelts?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryViewerInProgressAssignedTestsV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AssignTestProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ielts?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryViewerMistakeWordsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<LearnerMistakeWordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LearnerMistakeWordOrder>;
};


export type QueryViewerPartnerAdminTeachersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<ViewerPartnerAdminTeacherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryViewerPartnerClassArgs = {
  id: Scalars['ID']['input'];
};


export type QueryViewerPartnerClassesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<ClassFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClassOrder>;
};


export type QueryViewerPartnerIsInClassTeacherArgs = {
  classId: Scalars['ID']['input'];
};


export type QueryViewerPartnerNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryViewerPartnerSchoolInvitedTeachersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<SchoolInvitedTeacherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SchoolInvitedTeacherOrder>;
};


export type QueryViewerPartnerTeachersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<ViewerPartnerTeacherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TeacherProfileOrder>;
};


export type QueryViewerPartnerUserAttemptsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<UserAttemptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  studentId: Scalars['ID']['input'];
};


export type QueryViewerUserAttemptsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<UserAttemptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryViewerXpSummariesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<LearnerXpFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVnpayPaymentArgs = {
  txnRef: Scalars['ID']['input'];
};

export type Quota = {
  remaining: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

export enum RankFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type RecordScore = {
  cefrScore?: Maybe<SpeakingCefrScore>;
  coherence?: Maybe<RecordScoreCoherence>;
  coherenceScore: Scalars['Float']['output'];
  grammar: RecordScoreGrammar;
  ieltsScore?: Maybe<SpeakingScore>;
  interaction: RecordScoreInteraction;
  interactionDecision: WordDecision;
  interactionScore: Scalars['Float']['output'];
  interactionScorePercent: Scalars['Float']['output'];
  overall?: Maybe<RecordScoreOverall>;
  overallScore: Scalars['Float']['output'];
  pronunciation: RecordScorePronunciation;
  pronunciationScore: Scalars['Float']['output'];
  pteScore?: Maybe<SpeakingScore>;
  suggestions?: Maybe<Array<SpeakingQuestionRecommendSentence>>;
  toeicScore?: Maybe<SpeakingScore>;
  transcript?: Maybe<Scalars['String']['output']>;
  vocabulary: RecordScoreVocabulary;
  vocabularyGrammarDecision: WordDecision;
  vocabularyGrammarScore: Scalars['Float']['output'];
  vocabularyGrammarScorePercent: Scalars['Float']['output'];
};

export type RecordScoreCoherence = {
  decision: WordDecision;
  messages?: Maybe<Array<Scalars['String']['output']>>;
  score: Scalars['Float']['output'];
};

export type RecordScoreGrammar = {
  decision: WordDecision;
  highlightItems?: Maybe<Array<GrammarItem>>;
  messages?: Maybe<Array<Scalars['String']['output']>>;
  score: Scalars['Float']['output'];
};

export type RecordScoreInteraction = {
  fluency: InteractionFluency;
  fluencyDecision: WordDecision;
  fluencyPromptness: Scalars['Float']['output'];
  receptionDecision: WordDecision;
  receptionResponding: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
};

export type RecordScoreOverall = {
  decision: WordDecision;
  score: Scalars['Float']['output'];
};

export type RecordScorePronunciation = {
  decision: WordDecision;
  generalScore?: Maybe<Scalars['Float']['output']>;
  highlightWords?: Maybe<Array<PronunciationWord>>;
  intonationScore?: Maybe<Scalars['Float']['output']>;
  score: Scalars['Float']['output'];
};

export type RecordScoreVocabulary = {
  answerKeyScore: Scalars['Float']['output'];
  /** @deprecated removed */
  cefrDistribution?: Maybe<Array<VocabularyCefrDistribution>>;
  /** @deprecated removed */
  cefrScore?: Maybe<Scalars['Float']['output']>;
  decision: WordDecision;
  highlightKeywords?: Maybe<Array<VocabularyKeywordItem>>;
  levelScore: Scalars['Float']['output'];
  messages?: Maybe<Array<Scalars['String']['output']>>;
  score: Scalars['Float']['output'];
};

export type RemindTask = {
  assignTest?: Maybe<AssignTest>;
  checkPoint?: Maybe<CheckPoint>;
  totalRedoTask: Scalars['Int']['output'];
  totalUnfinishTask: Scalars['Int']['output'];
};

export enum RequestReview {
  Ai = 'AI',
  Teacher = 'TEACHER'
}

export type ResultStatement = Node & {
  comment: ResultStatementComment;
  createdAt: Scalars['DateTime']['output'];
  examStructureType: ExamStructureTypeInfo;
  from: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  resultStatementId: Scalars['ID']['output'];
  testLevel: TestLevel;
  titleType: ResultStatementTitleTypeInfo;
  to: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ResultStatementComment = Node & {
  content: Scalars['String']['output'];
  contentEn: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  resultStatementCommentId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ResultStatementCommentConnection = {
  edges: Array<ResultStatementCommentEdge>;
  nodes: Array<ResultStatementComment>;
  pageInfo?: Maybe<PageInfo>;
};

export type ResultStatementCommentCreateInput = {
  content: Scalars['String']['input'];
  contentEn: Scalars['String']['input'];
};

export type ResultStatementCommentCreatePayload = {
  resultStatementComment?: Maybe<ResultStatementComment>;
  userErrors: Array<UserError>;
};

export type ResultStatementCommentDeleteInput = {
  id: Scalars['ID']['input'];
};

export type ResultStatementCommentDeletePayload = {
  resultStatementCommentId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type ResultStatementCommentEdge = {
  cursor: Scalars['Cursor']['output'];
  node: ResultStatementComment;
};

export type ResultStatementCommentUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  contentEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type ResultStatementCommentUpdatePayload = {
  resultStatementComment?: Maybe<ResultStatementComment>;
  userErrors: Array<UserError>;
};

export type ResultStatementConnection = {
  edges: Array<ResultStatementEdge>;
  nodes: Array<ResultStatement>;
  pageInfo?: Maybe<PageInfo>;
};

export type ResultStatementCreateInput = {
  commentId: Scalars['ID']['input'];
  examStructureType: ExamStructureType;
  from: Scalars['Int']['input'];
  order: Scalars['Int']['input'];
  testLevelId: Scalars['ID']['input'];
  titleType: ResultStatementTitleType;
  to: Scalars['Int']['input'];
};

export type ResultStatementCreatePayload = {
  resultStatement?: Maybe<ResultStatement>;
  userErrors: Array<UserError>;
};

export type ResultStatementDeleteInput = {
  id: Scalars['ID']['input'];
};

export type ResultStatementDeletePayload = {
  resultStatementId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type ResultStatementEdge = {
  cursor: Scalars['Cursor']['output'];
  node: ResultStatement;
};

export type ResultStatementStructure = {
  statements: Array<ResultStatement>;
  titleType: ResultStatementTitleTypeInfo;
};

export enum ResultStatementTitleType {
  ImprovementActions = 'IMPROVEMENT_ACTIONS',
  ImprovementAreas = 'IMPROVEMENT_AREAS',
  StrengthsInEnglish = 'STRENGTHS_IN_ENGLISH'
}

export type ResultStatementTitleTypeInfo = {
  title: Scalars['String']['output'];
  value: ResultStatementTitleType;
};

export type ResultStatementUpdateInput = {
  commentId?: InputMaybe<Scalars['ID']['input']>;
  examStructureType?: InputMaybe<ExamStructureType>;
  from?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  testLevelId?: InputMaybe<Scalars['ID']['input']>;
  titleType?: InputMaybe<ResultStatementTitleType>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export type ResultStatementUpdatePayload = {
  resultStatement?: Maybe<ResultStatement>;
  userErrors: Array<UserError>;
};

export type ResumableExamUserAttempt = {
  currentExamPart: ExamPart;
  currentSectionExpiresAt: Scalars['DateTime']['output'];
  currentStructure: ExamStructureType;
  userAttempt: UserAttempt;
};

export type School = Node & {
  description?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<CustomDomain>;
  id: Scalars['ID']['output'];
  info?: Maybe<SchoolInfo>;
  name: Scalars['String']['output'];
  partnerRoles: Array<PartnerRole>;
  province?: Maybe<Province>;
  schoolId: Scalars['ID']['output'];
  schoolInvitedTeachers: SchoolInvitedTeacherConnection;
  status: SchoolStatus;
  studentsLimit?: Maybe<Scalars['Int']['output']>;
  teacherProfiles: SchoolTeacherProfileConnection;
  verified: Scalars['Boolean']['output'];
};


export type SchoolSchoolInvitedTeachersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SchoolTeacherProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolConnection = {
  edges: Array<SchoolEdge>;
  nodes: Array<School>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SchoolEdge = {
  cursor: Scalars['Cursor']['output'];
  node: School;
};

export enum SchoolEducationType {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type SchoolFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  provinceId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SchoolInfo = {
  adminProfiles: Array<TeacherProfile>;
  totalAdmin: Scalars['Int']['output'];
  totalClass: Scalars['Int']['output'];
  totalStudent: Scalars['Int']['output'];
  totalTeacher: Scalars['Int']['output'];
};

export type SchoolInvitedTeacher = Node & {
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role: PartnerRole;
  school: School;
  schoolInvitedTeacherId: Scalars['ID']['output'];
  status: SchoolInvitedTeacherStatus;
  teacherProfile: TeacherProfile;
};

export type SchoolInvitedTeacherConnection = {
  edges: Array<SchoolInvitedTeacherEdge>;
  nodes: Array<SchoolInvitedTeacher>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SchoolInvitedTeacherEdge = {
  cursor: Scalars['Cursor']['output'];
  node: SchoolInvitedTeacher;
};

export type SchoolInvitedTeacherFilter = {
  q?: InputMaybe<Array<Scalars['String']['input']>>;
  roleId?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<SchoolInvitedTeacherStatus>>;
};

export type SchoolInvitedTeacherOrder = {
  key: SchoolInvitedTeacherOrderKey;
  reverse?: Scalars['Boolean']['input'];
};

export enum SchoolInvitedTeacherOrderKey {
  Status = 'STATUS'
}

export enum SchoolInvitedTeacherStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING'
}

export type SchoolRoleUpdateInput = {
  admin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  teacher?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SchoolRoleUpdatePayload = {
  data?: Maybe<Scalars['Boolean']['output']>;
  userErrors: Array<UserError>;
};

export enum SchoolStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type SchoolTeacherProfileConnection = {
  edges: Array<SchoolTeacherProfileEdge>;
  nodes: Array<TeacherProfile>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SchoolTeacherProfileEdge = {
  createdAt: Scalars['DateTime']['output'];
  cursor: Scalars['Cursor']['output'];
  node: TeacherProfile;
};

export type SchoolTestLevelRank = {
  avgAccuracy: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  rank: Scalars['Int']['output'];
  school: School;
  schoolTestLevelRankId: Scalars['ID']['output'];
  totalGrade: Scalars['Float']['output'];
  totalScore: Scalars['Float']['output'];
};

export type SchoolTestLevelRankConnection = {
  edges: Array<SchoolTestLevelRankEdge>;
  nodes: Array<SchoolTestLevelRank>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SchoolTestLevelRankEdge = {
  cursor: Scalars['Cursor']['output'];
  node: SchoolTestLevelRank;
};

export type SchoolTestLevelRankFilter = {
  provinceId?: InputMaybe<Array<Scalars['ID']['input']>>;
  schoolId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SkillTestScore = {
  accuracy?: Maybe<Scalars['Float']['output']>;
  skill: EnglishSkillV1;
};

export enum SourceSchool {
  Domain = 'DOMAIN',
  Flyer = 'FLYER'
}

export type SpeakingCefrScore = {
  coherence: Scalars['String']['output'];
  fluency: Scalars['String']['output'];
  grammar: Scalars['String']['output'];
  overall?: Maybe<Scalars['String']['output']>;
  pronunciation: Scalars['String']['output'];
  vocab: Scalars['String']['output'];
};

export type SpeakingDiscussionAttemptPayload = {
  bingoAudio?: Maybe<Audio>;
  isEnd: Scalars['Boolean']['output'];
};

export type SpeakingEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type SpeakingEndAttemptPayload = {
  userErrors: Array<UserError>;
};

export type SpeakingImage = {
  height?: Maybe<Scalars['String']['output']>;
  imageId: Scalars['ID']['output'];
  left?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  top?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type SpeakingImageInput = {
  height?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['ID']['input'];
  left?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  top?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type SpeakingPart = Node & {
  body?: Maybe<SpeakingPartBody>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  partType: SpeakingPartType;
  position: Scalars['Int']['output'];
  questions: Array<SpeakingQuestion>;
  /** @deprecated use questions instead */
  questionsAll: Array<SpeakingQuestion>;
  speakingPartId: Scalars['ID']['output'];
  time?: Maybe<Scalars['Duration']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

export type SpeakingPartBody = {
  candidateImageId?: Maybe<Scalars['ID']['output']>;
  candidateSheet?: Maybe<SpeakingSheet>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  contentImageId?: Maybe<Scalars['ID']['output']>;
  contentImagePrompt?: Maybe<Scalars['String']['output']>;
  examinerImageId?: Maybe<Scalars['ID']['output']>;
  examinerSheet?: Maybe<SpeakingSheet>;
  images?: Maybe<Array<SpeakingImage>>;
  placeholders?: Maybe<Array<SpeakingPlaceholder>>;
  points?: Maybe<Array<SpeakingPoint>>;
};

export type SpeakingPartBodyInput = {
  candidateImageId?: InputMaybe<Scalars['ID']['input']>;
  candidateSheet?: InputMaybe<SpeakingSheetInput>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  contentImageId?: InputMaybe<Scalars['ID']['input']>;
  contentImagePrompt?: InputMaybe<Scalars['String']['input']>;
  examinerImageId?: InputMaybe<Scalars['ID']['input']>;
  examinerSheet?: InputMaybe<SpeakingSheetInput>;
  images?: InputMaybe<Array<SpeakingImageInput>>;
  placeholders?: InputMaybe<Array<SpeakingPlaceholderInput>>;
  points?: InputMaybe<Array<SpeakingPointInput>>;
};

export type SpeakingPartConnection = {
  edges: Array<SpeakingPartEdge>;
  nodes: Array<SpeakingPart>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SpeakingPartEdge = {
  cursor: Scalars['Cursor']['output'];
  node: SpeakingPart;
};

export type SpeakingPartFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  partType?: InputMaybe<Array<SpeakingPartType>>;
};

export enum SpeakingPartType {
  Discussion = 'discussion',
  FindDifferences = 'find_differences',
  FindObject_1 = 'find_object_1',
  FindObject_2 = 'find_object_2',
  InfoExchange = 'info_exchange',
  InterviewOpinion = 'interview_opinion',
  MoveObject = 'move_object',
  ObjectCard = 'object_card',
  OddOneOut = 'odd_one_out',
  PersonalQuestions = 'personal_questions',
  PicStory = 'pic_story',
  PictureDescription = 'picture_description',
  SceneCard = 'scene_card'
}

export type SpeakingPartTypeInfo = {
  name: Scalars['String']['output'];
  value: SpeakingPartType;
};

export type SpeakingPlaceholder = {
  height: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageId?: Maybe<Scalars['ID']['output']>;
  left: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  top: Scalars['String']['output'];
  width: Scalars['String']['output'];
};

export type SpeakingPlaceholderInput = {
  height: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  left: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  top: Scalars['String']['input'];
  width: Scalars['String']['input'];
};

export type SpeakingPoint = {
  id: Scalars['ID']['output'];
  left: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  top: Scalars['String']['output'];
};

export type SpeakingPointInput = {
  id: Scalars['ID']['input'];
  left: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  top: Scalars['String']['input'];
};

export type SpeakingQuestion = Node & {
  answerImageId?: Maybe<Scalars['ID']['output']>;
  answerPlaceholderId?: Maybe<Scalars['ID']['output']>;
  audio: Audio;
  audioId: Scalars['ID']['output'];
  audioSubtitle?: Maybe<Scalars['String']['output']>;
  bingoAudio?: Maybe<Audio>;
  bingoAudioId?: Maybe<Scalars['ID']['output']>;
  bingoAudioSubtitle?: Maybe<Scalars['String']['output']>;
  body?: Maybe<SpeakingQuestionBody>;
  contextPrompt?: Maybe<Scalars['String']['output']>;
  groupPosition?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  maxScore: Scalars['Float']['output'];
  needsRecordAnswer: Scalars['Boolean']['output'];
  needsScore: Scalars['Boolean']['output'];
  numberCorrectKey?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  recommendSentences?: Maybe<Array<Maybe<SpeakingQuestionRecommendSentence>>>;
  timeToSpeak?: Maybe<Scalars['Duration']['output']>;
  turnCountDiscussion?: Maybe<Scalars['Int']['output']>;
};

export type SpeakingQuestionAttempt = Node & {
  azureRecordScore?: Maybe<AzureRecordScore>;
  discussions: Array<SpeakingQuestionDiscussionAttempt>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  /** @deprecated use image instead */
  imageId?: Maybe<Scalars['ID']['output']>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  part: SpeakingPart;
  /** @deprecated use part instead */
  partId: Scalars['ID']['output'];
  placeholderId?: Maybe<Scalars['ID']['output']>;
  question: SpeakingQuestion;
  /** @deprecated use question instead */
  questionId: Scalars['ID']['output'];
  record?: Maybe<Audio>;
  /** @deprecated use record instead */
  recordId?: Maybe<Scalars['ID']['output']>;
  recordScore?: Maybe<RecordScore>;
  teacherAudioAnswer?: Maybe<Audio>;
  teacherAudioAnswerId?: Maybe<Scalars['String']['output']>;
  teacherComment?: Maybe<Scalars['String']['output']>;
  transcriptionRecord?: Maybe<Scalars['String']['output']>;
};

export enum SpeakingQuestionAttemptDiscussionRole {
  Bingo = 'BINGO',
  User = 'USER'
}

export type SpeakingQuestionBody = {
  contentHtml?: Maybe<Scalars['String']['output']>;
  contentImageId?: Maybe<Scalars['ID']['output']>;
  images?: Maybe<Array<SpeakingImage>>;
};

export type SpeakingQuestionBodyInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  contentImageId?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<SpeakingImageInput>>;
};

export type SpeakingQuestionCreateInput = {
  answerImageId?: InputMaybe<Scalars['ID']['input']>;
  answerPlaceholderId?: InputMaybe<Scalars['ID']['input']>;
  audioId: Scalars['ID']['input'];
  audioSubtitle?: InputMaybe<Scalars['String']['input']>;
  bingoAudioId?: InputMaybe<Scalars['String']['input']>;
  bingoAudioSubtitle?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<SpeakingQuestionBodyInput>;
  contextPrompt?: InputMaybe<Scalars['String']['input']>;
  groupPosition?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxScore: Scalars['Float']['input'];
  needsRecordAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  needsScore?: InputMaybe<Scalars['Boolean']['input']>;
  numberCorrectKey?: InputMaybe<Scalars['Int']['input']>;
  position: Scalars['Int']['input'];
  recommendSentences?: InputMaybe<Array<InputMaybe<SpeakingQuestionRecommendSentenceInput>>>;
  timeToSpeak?: InputMaybe<Scalars['Duration']['input']>;
  turnCountDiscussion?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakingQuestionDiscussionAttempt = Node & {
  audio: Audio;
  audioSubtitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  recordScore?: Maybe<RecordScore>;
  role: SpeakingQuestionDiscussionAttemptRole;
  /** @deprecated use speakingQuestionDiscussionAttemptId instead */
  speakingQuestionAttemptDiscussionId: Scalars['ID']['output'];
  speakingQuestionDiscussionAttemptId: Scalars['ID']['output'];
};

export enum SpeakingQuestionDiscussionAttemptRole {
  Bingo = 'BINGO',
  User = 'USER'
}

export type SpeakingQuestionRecommendSentence = {
  audioId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type SpeakingQuestionRecommendSentenceInput = {
  audioId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type SpeakingQuestionUpdateInput = {
  answerImageId?: InputMaybe<Scalars['ID']['input']>;
  answerPlaceholderId?: InputMaybe<Scalars['ID']['input']>;
  audioId?: InputMaybe<Scalars['ID']['input']>;
  audioSubtitle?: InputMaybe<Scalars['String']['input']>;
  bingoAudioId?: InputMaybe<Scalars['String']['input']>;
  bingoAudioSubtitle?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<SpeakingQuestionBodyInput>;
  contextPrompt?: InputMaybe<Scalars['String']['input']>;
  groupPosition?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxScore?: InputMaybe<Scalars['Float']['input']>;
  needsRecordAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  needsScore?: InputMaybe<Scalars['Boolean']['input']>;
  numberCorrectKey?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  recommendSentences?: InputMaybe<Array<InputMaybe<SpeakingQuestionRecommendSentenceInput>>>;
  timeToSpeak?: InputMaybe<Scalars['Duration']['input']>;
  turnCountDiscussion?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakingScore = {
  coherence: Scalars['Float']['output'];
  fluency: Scalars['Float']['output'];
  grammar: Scalars['Float']['output'];
  overall?: Maybe<Scalars['Float']['output']>;
  pronunciation: Scalars['Float']['output'];
  vocab: Scalars['Float']['output'];
};

export type SpeakingSheet = {
  sheets: Array<SpeakingSheetContent>;
  title: Scalars['String']['output'];
};

export type SpeakingSheetContent = {
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SpeakingSheetContentInput = {
  id: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SpeakingSheetInput = {
  sheets: Array<SpeakingSheetContentInput>;
  title: Scalars['String']['input'];
};

export type SpeakingStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  device?: InputMaybe<UserAttemptDevice>;
  requestAIAzure?: InputMaybe<Scalars['Boolean']['input']>;
  requestAIReview?: InputMaybe<Scalars['Boolean']['input']>;
  requestReview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpeakingStartAttemptPayload = {
  attemptId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type SpeakingSubmitDiscussionQuestionAttemptInput = {
  attemptId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  recordId?: InputMaybe<Scalars['ID']['input']>;
};

export type SpeakingSubmitDiscussionQuestionAttemptPayload = {
  data?: Maybe<SpeakingDiscussionAttemptPayload>;
  userErrors: Array<UserError>;
};

export type SpeakingSubmitQuestionAttemptInput = {
  attemptId: Scalars['ID']['input'];
  audioReplayCount?: InputMaybe<Scalars['Int']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  placeholderId?: InputMaybe<Scalars['ID']['input']>;
  questionId: Scalars['ID']['input'];
  recordId?: InputMaybe<Scalars['ID']['input']>;
  transcriptionRecord?: InputMaybe<Scalars['String']['input']>;
};

export type SpeakingSubmitQuestionAttemptPayload = {
  userErrors: Array<UserError>;
};

export type SpeakingUpdateInput = {
  questionAttemptID: Scalars['ID']['input'];
  teacherAudioAnswerQuestionAttemptID?: InputMaybe<Scalars['String']['input']>;
  teacherComment?: InputMaybe<Scalars['String']['input']>;
};

export enum Status {
  Active = 'ACTIVE',
  InActive = 'IN_ACTIVE'
}

export enum StatusAssignTest {
  Done = 'DONE',
  NoneStarted = 'NONE_STARTED',
  Progress = 'PROGRESS'
}

export enum StatusAttempt {
  GotScore = 'GOT_SCORE',
  NewScore = 'NEW_SCORE',
  NoScore = 'NO_SCORE'
}

export enum StatusLearnerMistakeWord {
  Completed = 'COMPLETED',
  Correct = 'CORRECT',
  Incorrect = 'INCORRECT',
  ReMark = 'RE_MARK',
  UnCompleted = 'UN_COMPLETED',
  Warning = 'WARNING'
}

export enum StatusStudent {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotSubmit = 'NOT_SUBMIT'
}

export type StreakData = {
  currentStreak?: Maybe<StreakInfo>;
  longestStreak: StreakInfo;
};

export type StreakInfo = {
  count: Scalars['Int']['output'];
  endDate: Scalars['DateTime']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type StudentAccuracy = {
  accuracy: ComparedValueFloat;
  student: LearnerProfile;
};

export type StudentAssignTestStats = {
  totalCompletedAssignTests: Scalars['Int']['output'];
  totalExpiredAssignTests: Scalars['Int']['output'];
  totalUncompletedAssignTests: Scalars['Int']['output'];
};

export type StudentStudyTime = {
  student: LearnerProfile;
  studyTime: ComparedValueDuration;
};

export type StudyCharacter = Node & {
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  image: Image;
  imageId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  studyCharacterId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type StudyCharacterConnection = {
  edges: Array<StudyCharacterEdge>;
  nodes: Array<StudyCharacter>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StudyCharacterEdge = {
  cursor: Scalars['Cursor']['output'];
  node: StudyCharacter;
};

export type StudyCharacterFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubmitAttemptData = {
  assignTestId?: Maybe<Scalars['ID']['output']>;
  checkPointName?: Maybe<Scalars['String']['output']>;
  checkPointNameEn?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  node?: Maybe<Node>;
  subscribeTo: Scalars['String']['output'];
  viewerAIConversationSubscription?: Maybe<ViewerAiConversationCompletePayload>;
  viewerPartner: ViewerPartnerPayload;
  viewerPartnerNotification: ViewerPartnerNotificationPayload;
  viewerSessionEvent: ViewerSessionEventPayload;
};


export type SubscriptionNodeArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionSubscribeToArgs = {
  event: Scalars['String']['input'];
};


export type SubscriptionViewerAiConversationSubscriptionArgs = {
  input: ViewerAiConversationCompleteInput;
};

export enum SubscriptionStatus {
  Expire = 'EXPIRE',
  NotSubscription = 'NOT_SUBSCRIPTION',
  Subscription = 'SUBSCRIPTION'
}

export enum SubscriptionStatusFilter {
  Expire = 'EXPIRE',
  NotSubscription = 'NOT_SUBSCRIPTION',
  Subscription = 'SUBSCRIPTION'
}

export type Syllable = {
  duration?: Maybe<Scalars['Int']['output']>;
  grapheme?: Maybe<Scalars['String']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  pronunciationAssessment?: Maybe<PronunciationAssessment>;
  syllable?: Maybe<Scalars['String']['output']>;
};

export type TeacherAssignTestInfo = {
  progress?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type TeacherByDay = {
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  total: Scalars['Int']['output'];
};

export type TeacherByDayFilter = {
  date?: InputMaybe<DateTimeRange>;
};

export type TeacherCommentDetail = {
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  quote: Scalars['String']['output'];
};

export type TeacherCommentDetailInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  quote: Scalars['String']['input'];
};

export type TeacherInvitationInput = {
  teacherId: Scalars['ID']['input'];
};

export type TeacherInvitedLearner = Node & {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invitedClass?: Maybe<Class>;
  learner: LearnerProfile;
  learnerAcceptedInvitation: Scalars['Boolean']['output'];
  teacher: TeacherProfile;
  teacherInvitedLearnerId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TeacherOverviewData = {
  assignTest?: Maybe<TeacherAssignTestInfo>;
  totalClasses: Scalars['Int']['output'];
  totalCompletedTests: Scalars['Int']['output'];
  totalStudents: Scalars['Int']['output'];
  totalStudyTime: Scalars['Float']['output'];
};

export type TeacherOverviewInput = {
  crypto: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type TeacherProfile = Node & {
  about?: Maybe<Scalars['String']['output']>;
  aiSpeakingRecordCount?: Maybe<Scalars['Int']['output']>;
  aiSpeakingRecordQuota: Quota;
  aiWritingRecordCount?: Maybe<Scalars['Int']['output']>;
  aiWritingRecordQuota: Quota;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bankAccountInfo?: Maybe<BankAccountInfo>;
  classCreateLimit?: Maybe<Scalars['Int']['output']>;
  currentSchoolAssignTestsCount: Scalars['Int']['output'];
  currentSchoolAssignedClasses: Array<Class>;
  currentSchoolClassesCount: Scalars['Int']['output'];
  currentSchoolCompletedAssignTestsCount: Scalars['Int']['output'];
  currentSchoolStudentsCount: Scalars['Int']['output'];
  currentSchoolStudentsScoreCount?: Maybe<TeacherStudentsScoreCount>;
  currentSchoolStudentsStudyTime?: Maybe<Scalars['Duration']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  domain?: Maybe<CustomDomain>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  id: Scalars['ID']['output'];
  isCurriculumManager?: Maybe<Scalars['Boolean']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  onboardingInfo?: Maybe<Array<MetaInfo>>;
  partnerRoles: Array<PartnerRole>;
  referralCode: Scalars['String']['output'];
  referralLink: Scalars['String']['output'];
  referralUsers: UserTeacherReferralUsageConnection;
  school?: Maybe<School>;
  schools: TeacherProfileSchoolConnection;
  schoolsAssignTestsCount: Scalars['Int']['output'];
  schoolsClassesCount: Scalars['Int']['output'];
  schoolsStudentsCount: Scalars['Int']['output'];
  sourceDomain?: Maybe<Scalars['String']['output']>;
  teacherProfileId: Scalars['ID']['output'];
  totalReferralUsers: Scalars['Int']['output'];
  totalUnpaidReferralRewards: Scalars['Float']['output'];
  user: User;
};


export type TeacherProfileCurrentSchoolStudentsStudyTimeArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type TeacherProfileReferralUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TeacherProfileSchoolsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<TeacherProfileSchoolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TeacherProfileConnection = {
  edges: Array<TeacherProfileEdge>;
  nodes: Array<TeacherProfile>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TeacherProfileEdge = {
  cursor: Scalars['Cursor']['output'];
  node: TeacherProfile;
};

export type TeacherProfileFilter = {
  canAssignToClassId?: InputMaybe<Array<Scalars['ID']['input']>>;
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasSchoolsWith?: InputMaybe<TeacherProfileSchoolFilter>;
  hasUserWith?: InputMaybe<UserFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TeacherProfileOrder = {
  key?: InputMaybe<TeacherProfileOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TeacherProfileOrderKey {
  DisplayName = 'DISPLAY_NAME'
}

export type TeacherProfileSchoolConnection = {
  edges: Array<TeacherProfileSchoolEdge>;
  nodes: Array<School>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TeacherProfileSchoolEdge = {
  createdAt: Scalars['DateTime']['output'];
  cursor: Scalars['Cursor']['output'];
  node: School;
};

export type TeacherProfileSchoolFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TeacherStudentsScoreCount = {
  highest: Scalars['Int']['output'];
  lowest: Scalars['Int']['output'];
};

export type TeacherStudyTime = {
  studyTime: ComparedValueDuration;
  teacher: TeacherProfile;
};

export type TestLevel = Node & {
  checkPoints: CheckPointConnection;
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionEn?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  levels: Array<CefrLevel>;
  metadata?: Maybe<TestLevelMeta>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  playlistId?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  testLevelId: Scalars['ID']['output'];
  typeTestLevel?: Maybe<TypeExamTestLevel>;
};


export type TestLevelCheckPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CheckPointOrder>;
};

export type TestLevelConnection = {
  edges: Array<TestLevelEdge>;
  nodes: Array<TestLevel>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TestLevelEdge = {
  cursor: Scalars['Cursor']['output'];
  node: TestLevel;
};

export type TestLevelFilter = {
  and?: InputMaybe<Array<TestLevelFilter>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  isSpeaking?: InputMaybe<Scalars['Boolean']['input']>;
  isVocabulary?: InputMaybe<Scalars['Boolean']['input']>;
  isWriting?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  not?: InputMaybe<TestLevelFilter>;
  or?: InputMaybe<Array<TestLevelFilter>>;
  slug?: InputMaybe<Array<Scalars['String']['input']>>;
  slugQ?: InputMaybe<Array<Scalars['String']['input']>>;
  typeTestLevel?: InputMaybe<Array<TypeExamTestLevel>>;
};

export type TestLevelMeta = {
  externalLink?: Maybe<Scalars['String']['output']>;
  seo?: Maybe<TestLevelMetaSeo>;
};

export type TestLevelMetaSeo = {
  description?: Maybe<Scalars['String']['output']>;
  descriptionEn?: Maybe<Scalars['String']['output']>;
  featureImage?: Maybe<Image>;
  title?: Maybe<Scalars['String']['output']>;
  titleEn?: Maybe<Scalars['String']['output']>;
};

export type TestLevelOrder = {
  key?: InputMaybe<TestLevelOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TestLevelOrderKey {
  TestLevelOrder = 'TEST_LEVEL_ORDER'
}

export type TestLevelPackageConnection = {
  edges: Array<TestLevelPackageEdge>;
  nodes: Array<FlyerPackage>;
  pageInfo: PageInfo;
};

export type TestLevelPackageEdge = {
  cursor: Scalars['Cursor']['output'];
  node: FlyerPackage;
};

export type TextToSpeakInput = {
  text: Scalars['String']['input'];
};

export type TextToSpeakPayload = {
  url?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
};

export type Theme = Node & {
  backgroundId: Scalars['String']['output'];
  bingoId?: Maybe<Scalars['String']['output']>;
  blockLeft?: Maybe<Scalars['String']['output']>;
  blockRight?: Maybe<Scalars['String']['output']>;
  bookOneId?: Maybe<Scalars['String']['output']>;
  bookTwoId?: Maybe<Scalars['String']['output']>;
  borderProgress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  disabled?: Maybe<Scalars['Boolean']['output']>;
  iconLeftId?: Maybe<Scalars['String']['output']>;
  iconNextId?: Maybe<Scalars['String']['output']>;
  iconPrevId?: Maybe<Scalars['String']['output']>;
  iconRightId?: Maybe<Scalars['String']['output']>;
  iconZoomId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageId: Scalars['String']['output'];
  imagePreviewId?: Maybe<Scalars['String']['output']>;
  imageTitleId?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  nameEn: Scalars['String']['output'];
  progressColor?: Maybe<Scalars['String']['output']>;
  progressId?: Maybe<Scalars['String']['output']>;
  themeId: Scalars['ID']['output'];
  type: ThemeType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ThemeConnection = {
  edges: Array<ThemeEdge>;
  nodes: Array<Theme>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ThemeEdge = {
  cursor: Scalars['Cursor']['output'];
  node: Theme;
};

export type ThemeFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameEnQ?: InputMaybe<Array<Scalars['String']['input']>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<ThemeType>>;
};

export enum ThemeType {
  Challenge = 'challenge'
}

export enum TokenType {
  Firebase = 'FIREBASE'
}

export type Topic = Node & {
  checkPoints: TopicCheckPointConnection;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nameEn: Scalars['String']['output'];
  topicId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};


export type TopicCheckPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TopicCheckPointConnection = {
  edges: Array<TopicCheckPointEdge>;
  nodes: Array<CheckPoint>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TopicCheckPointEdge = {
  createdAt: Scalars['DateTime']['output'];
  cursor: Scalars['Cursor']['output'];
  node: CheckPoint;
};

export type TopicConnection = {
  edges: Array<TopicEdge>;
  nodes: Array<Topic>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TopicEdge = {
  cursor: Scalars['Cursor']['output'];
  node: Topic;
};

export type TopicFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum TypeAttempt {
  Exam = 'EXAM',
  Ielts = 'IELTS',
  IeltsSpeaking = 'IELTS_SPEAKING',
  PlacementTest = 'PLACEMENT_TEST',
  Practice = 'PRACTICE',
  Speaking = 'SPEAKING',
  Study = 'STUDY',
  Writing = 'WRITING'
}

export enum TypeCheckPointAdmin {
  Exam = 'EXAM',
  Speaking = 'SPEAKING'
}

export enum TypeExamAssignTest {
  Exam = 'exam',
  Mini = 'mini',
  Practice = 'practice',
  Speaking = 'speaking',
  Writing = 'writing'
}

export enum TypeExamTestLevel {
  Classic = 'CLASSIC',
  Ielts = 'IELTS',
  Phadao = 'PHADAO',
  PlacementTest = 'PLACEMENT_TEST',
  Practice = 'PRACTICE'
}

export enum TypeInitAssignTest {
  Class = 'class',
  Student = 'student'
}

export enum TypeMark {
  Speaking = 'SPEAKING',
  Writing = 'WRITING'
}

export type UnseenReviewAttemptStats = {
  speaking: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  writing: Scalars['Int']['output'];
};

export type User = Node & {
  activationCodeUsers: ActivationCodeUserConnection;
  adminRole?: Maybe<UserAdminRole>;
  canCreateLearnerProfile: Scalars['Boolean']['output'];
  countryCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentLearnerProfile?: Maybe<LearnerProfile>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  diamond: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailMarketing?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isSubscribing: Scalars['Boolean']['output'];
  learnerProfiles: LearnerProfileConnection;
  learnerProfilesCount: Scalars['Int']['output'];
  parentProfile?: Maybe<ParentProfile>;
  partnerSubscriptions: PartnerSubscriptionConnection;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  subscriptionExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  subscriptions: FlyerSubscriptionConnection;
  teacherProfile?: Maybe<TeacherProfile>;
  teacherVerified: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
  username?: Maybe<Scalars['String']['output']>;
  wallet?: Maybe<Wallet>;
};


export type UserActivationCodeUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserLearnerProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LearnerProfileOrder>;
};


export type UserPartnerSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserActiveCodeInput = {
  code: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type UserActiveCodePayload = {
  userErrors: Array<UserError>;
  users?: Maybe<Array<User>>;
};

export enum UserAdminRole {
  Admin = 'ADMIN',
  ContentEditor = 'CONTENT_EDITOR',
  Manager = 'MANAGER',
  SuperManager = 'SUPER_MANAGER',
  Tester = 'TESTER',
  Viewer = 'VIEWER'
}

export type UserAgent = {
  device?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceType: DeviceType;
  name: Scalars['String']['output'];
  os: Scalars['String']['output'];
  osVersion: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type UserAttempt = Node & {
  accuracy?: Maybe<Scalars['Float']['output']>;
  aiGrade?: Maybe<Scalars['Float']['output']>;
  assignTest?: Maybe<AssignTest>;
  cefrLevelInfo?: Maybe<CefrLevelInfo>;
  challenge?: Maybe<Challenge>;
  checkPoint?: Maybe<CheckPoint>;
  coinsEarned?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  duolingoPartAttempts?: Maybe<Array<DuolingoPartAttempt>>;
  examStructureAttempts: Array<ExamStructureAttempt>;
  /** @deprecated use examStructureAttempts instead */
  examTypeScores?: Maybe<Array<ExamStructureAttempt>>;
  executionTime?: Maybe<Scalars['Duration']['output']>;
  /** @deprecated use executionTime */
  executionTimeRaw?: Maybe<Scalars['Duration']['output']>;
  grade?: Maybe<Scalars['Float']['output']>;
  higherScorePercent: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  ieltsListeningPartAttempts?: Maybe<Array<IeltsListeningPartAttempt>>;
  ieltsReadingPartAttempts?: Maybe<Array<IeltsReadingPartAttempt>>;
  ieltsSpeakingPartAttempts?: Maybe<Array<IeltsSpeakingPartAttempt>>;
  ieltsSpeakingRecordScore?: Maybe<IeltsRecordScore>;
  ieltsWritingPartAttempts?: Maybe<Array<IeltsWritingPartAttempt>>;
  ketPetScore?: Maybe<KetPetScore>;
  learnerProfile?: Maybe<LearnerProfile>;
  learnerSeenReward: Scalars['Boolean']['output'];
  maxGrade?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use other fields instead */
  meta?: Maybe<UserAttemptMeta>;
  partAttemptsCount: Scalars['Int']['output'];
  practicePartAttempts: Array<PracticePartAttempt>;
  redoAttemptNumber?: Maybe<Scalars['Int']['output']>;
  requestAIAzure?: Maybe<Scalars['Boolean']['output']>;
  requestReview?: Maybe<RequestReview>;
  resultStatementStructures: Array<ResultStatementStructure>;
  skills?: Maybe<Array<EnglishSkillV1>>;
  speakingAzureScore?: Maybe<AzureOverallScore>;
  speakingCertification?: Maybe<Scalars['Float']['output']>;
  speakingQuestionAttempts: Array<SpeakingQuestionAttempt>;
  speakingRecordScore?: Maybe<RecordScore>;
  starsEarned?: Maybe<Scalars['Int']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  teacherComment?: Maybe<Scalars['String']['output']>;
  teacherCommentAudio?: Maybe<Audio>;
  teacherGrade?: Maybe<Scalars['Float']['output']>;
  testLevel?: Maybe<TestLevel>;
  totalMaxScore?: Maybe<Scalars['Float']['output']>;
  totalScore?: Maybe<Scalars['Float']['output']>;
  typeAttempt: TypeAttempt;
  userAttemptId: Scalars['ID']['output'];
  vocabMistakeResults: Array<Scalars['String']['output']>;
  /** @deprecated use ketPetScore instead */
  writingKetPetScore?: Maybe<KetPetScore>;
  writingPartAttempts: Array<WritingPartAttempt>;
};

export type UserAttemptConnection = {
  edges: Array<UserAttemptEdge>;
  nodes: Array<UserAttempt>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum UserAttemptDevice {
  Mobile = 'mobile',
  Web = 'web'
}

export type UserAttemptEdge = {
  cursor: Scalars['Cursor']['output'];
  node: UserAttempt;
};

export type UserAttemptFilter = {
  checkPointId?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<DateTimeRange>;
  hasAssignTestWith?: InputMaybe<AssignTestFilter>;
  hasChallengeWith?: InputMaybe<ChallengeFilter>;
  hasCheckPointWith?: InputMaybe<CheckPointFilter>;
  hasIelts?: InputMaybe<Scalars['Boolean']['input']>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  hasTestLevelWith?: InputMaybe<TestLevelFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  isNeedReview?: InputMaybe<Scalars['Boolean']['input']>;
  requestReview?: InputMaybe<Array<RequestReview>>;
  skills?: InputMaybe<Array<EnglishSkillV1>>;
  statusAttempt?: InputMaybe<StatusAttempt>;
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
  submittedAt?: InputMaybe<DateTimeRange>;
  testLevelID?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeAttempt?: InputMaybe<Array<TypeAttempt>>;
};

export type UserAttemptMeta = {
  placementTestLevel?: Maybe<CefrLevel>;
  speakingKetPetScore?: Maybe<KetPetScore>;
};

export type UserAvatarFrame = Node & {
  avatarFrame: AvatarFrame;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  learnerProfileId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAvatarFrameId: Scalars['ID']['output'];
};

export type UserAvatarFrameConnection = {
  edges: Array<UserAvatarFrameEdge>;
  nodes: Array<UserAvatarFrame>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserAvatarFrameEdge = {
  cursor: Scalars['Cursor']['output'];
  node: UserAvatarFrame;
};

export type UserAvatarFrameFilter = {
  hasAvatarFrameWith?: InputMaybe<AvatarFrameFilter>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
};

export type UserError = DisplayableError & {
  code: UserErrorCode;
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
  param: UserErrorParam;
};

export enum UserErrorCode {
  AlreadyExist = 'ALREADY_EXIST',
  AlreadyUsed = 'ALREADY_USED',
  ContainsInvalidCharacters = 'CONTAINS_INVALID_CHARACTERS',
  ContainsWhiteSpace = 'CONTAINS_WHITE_SPACE',
  Disabled = 'DISABLED',
  Empty = 'EMPTY',
  Expired = 'EXPIRED',
  GreaterThan = 'GREATER_THAN',
  Invalid = 'INVALID',
  InvalidFormat = 'INVALID_FORMAT',
  LessThan = 'LESS_THAN',
  NotFound = 'NOT_FOUND',
  ReachLimit = 'REACH_LIMIT',
  TooLong = 'TOO_LONG',
  TooShort = 'TOO_SHORT',
  TryAgainIn = 'TRY_AGAIN_IN'
}

export type UserErrorParam = {
  value?: Maybe<Scalars['String']['output']>;
};

export type UserFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  emailQ?: InputMaybe<Array<Scalars['String']['input']>>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  hasLearnerProfilesWith?: InputMaybe<LearnerProfileFilter>;
  hasTeacherProfilesWith?: InputMaybe<TeacherProfileFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  phoneNumberQ?: InputMaybe<Array<Scalars['String']['input']>>;
  subscriptionExpiresAt?: InputMaybe<DateTimeRange>;
};

export type UserGenBulkData = {
  password: Scalars['String']['output'];
  users: Array<User>;
};

export type UserGenBulkInput = {
  activationPlan?: InputMaybe<Scalars['String']['input']>;
  addTeacherProfile?: InputMaybe<Scalars['Boolean']['input']>;
  diamond?: InputMaybe<Scalars['Int']['input']>;
  packageID?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  teacherFirstName?: InputMaybe<Scalars['String']['input']>;
  teacherVerified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserGenBulkPayload = {
  data?: Maybe<UserGenBulkData>;
  userErrors: Array<UserError>;
};

export type UserGenBulkPhoneInput = {
  activationPlan?: InputMaybe<Scalars['String']['input']>;
  diamond?: InputMaybe<Scalars['Int']['input']>;
  packageID?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers: Array<Scalars['String']['input']>;
};

export type UserGenBulkPhonePayload = {
  data?: Maybe<UserGenBulkData>;
  userErrors: Array<UserError>;
};

export type UserGenBulkUserNameInput = {
  classCode?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameTeacher?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};

export type UserGenBulkUserNamePayload = {
  data?: Maybe<UserGenBulkData>;
  userErrors: Array<UserError>;
};

export type UserSession = Node & {
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deactivatedBySession?: Maybe<UserSession>;
  id: Scalars['ID']['output'];
  userAgent: UserAgent;
  userSessionId: Scalars['ID']['output'];
};

export type UserTeacherReferralUsage = Node & {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isPaid: Scalars['Boolean']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  teacher: TeacherProfile;
  user: User;
  userTeacherReferralUsageId: Scalars['ID']['output'];
};

export type UserTeacherReferralUsageConnection = {
  edges: Array<UserTeacherReferralUsageEdge>;
  nodes: Array<UserTeacherReferralUsage>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserTeacherReferralUsageEdge = {
  cursor: Scalars['Cursor']['output'];
  node: UserTeacherReferralUsage;
};

export type UserTeacherReferralUsageFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  hasUserWith?: InputMaybe<UserFilter>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  paidAt?: InputMaybe<DateTimeRange>;
};

export type VersionNotification = Node & {
  appType: AppTypeMobile;
  contentHTML: Scalars['String']['output'];
  contentHTMLEn: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  showDomain: Scalars['Boolean']['output'];
  startDate: Scalars['DateTime']['output'];
  status: Status;
  style?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
  version: Scalars['String']['output'];
  versionNotificationId: Scalars['ID']['output'];
  videoId?: Maybe<Scalars['String']['output']>;
};

export type VersionNotificationConnection = {
  edges: Array<VersionNotificationEdge>;
  nodes: Array<VersionNotification>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type VersionNotificationEdge = {
  cursor: Scalars['Cursor']['output'];
  node: VersionNotification;
};

export type VersionNotificationFilter = {
  appType?: InputMaybe<Array<AppTypeMobile>>;
  status?: InputMaybe<Array<Status>>;
  versionQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ViewerAiConversationCompleteInput = {
  audioBase64Url?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  userText?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerAiConversationCompletePayload = {
  systemAudio?: Maybe<Scalars['String']['output']>;
  systemText?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
  userMessageId?: Maybe<Scalars['ID']['output']>;
  visemes?: Maybe<Array<Maybe<Viseme>>>;
};

export type ViewerAiConversationCreateInput = {
  message: Scalars['String']['input'];
  role: AiConversationRole;
  sessionId: Scalars['ID']['input'];
};

export type ViewerAiConversationCreatePayload = {
  aiConversation?: Maybe<AiConversation>;
  userErrors: Array<UserError>;
};

export type ViewerAiConversationSessionCreateInput = {
  type?: InputMaybe<AiConversationSessionType>;
};

export type ViewerAiConversationSessionPayload = {
  sessionId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
};

export type ViewerAiConversationUpdateInput = {
  audioId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type ViewerAiConversationUpdatePayload = {
  aiConversation?: Maybe<AiConversation>;
  userErrors: Array<UserError>;
};

export type ViewerAiConversationalPayload = {
  learnerProfile?: Maybe<LearnerProfile>;
  signedUrl?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
};

export type ViewerActiveCodeInput = {
  code: Scalars['String']['input'];
};

export type ViewerActiveCodePayload = {
  userErrors: Array<UserError>;
};

export type ViewerAdviceCreateInput = {
  adviceType: AdviceAdviceType;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  source?: InputMaybe<AdviceSource>;
};

export type ViewerAdviceCreatePayload = {
  advice?: Maybe<Advice>;
  userErrors: Array<UserError>;
};

export type ViewerBuyAvatarFrameInput = {
  avatarFrameID: Scalars['ID']['input'];
};

export type ViewerBuyAvatarFramePayload = {
  avatarFrame?: Maybe<AvatarFrame>;
  userErrors: Array<UserError>;
};

export type ViewerCreateLearnerProfileInput = {
  additionalInfo?: InputMaybe<AdditionalInfoInput>;
  avatarId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  ieltsTargetScore?: InputMaybe<Scalars['Float']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerCreateLearnerProfilePayload = {
  learnerProfile?: Maybe<LearnerProfile>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerCreateParentProfileInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerCreateParentProfilePayload = {
  parentProfile?: Maybe<ParentProfile>;
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerCreateTeacherProfileInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  avatarId?: InputMaybe<Scalars['String']['input']>;
  bankAccountInfo?: InputMaybe<BankAccountInfoInput>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  isCurriculumManager?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onboardingInfo?: InputMaybe<Array<MetaInfoInput>>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerCreateTeacherProfilePayload = {
  teacherProfile?: Maybe<TeacherProfile>;
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerDailyRewardClaimPayload = {
  dailyReward?: Maybe<DailyReward>;
  learnerProfile?: Maybe<LearnerProfile>;
  user?: Maybe<User>;
  userErrors: Array<UserError>;
};

export type ViewerDeleteAccountPayload = {
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerExamSeenNotificationInput = {
  all?: Scalars['Boolean']['input'];
  floatSeen?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerExamSeenNotificationPayload = {
  notification?: Maybe<Notification>;
  userErrors: Array<UserError>;
};

export type ViewerForceLogInByEmailTokenInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  tokenType: TokenType;
};

export type ViewerForceLogInByEmailTokenPayload = {
  providerInfo?: Maybe<EmailProviderInfo>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerJoinClassInput = {
  classCode: Scalars['String']['input'];
  learnerProfileID?: InputMaybe<Scalars['ID']['input']>;
  leftClassID?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerJoinClassPayload = {
  classStudent?: Maybe<ClassStudent>;
  userErrors: Array<UserError>;
};

export type ViewerLeftClassPayload = {
  classStudentId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type ViewerLogInInput = {
  withFirebaseEmail?: InputMaybe<ViewerLogInWithFirebaseEmailInput>;
  withPassword?: InputMaybe<ViewerLogInWithPasswordInput>;
};

export type ViewerLogInPayload = {
  providerInfo?: Maybe<EmailProviderInfo>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerLogInWithFirebaseEmailInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type ViewerLogInWithPasswordInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ViewerLogOutPayload = {
  userErrors: Array<UserError>;
};

export type ViewerMistakeWordRecordScoreInput = {
  mistakeWordId: Scalars['ID']['input'];
};

export type ViewerMistakeWordRecordScorePayload = {
  learnerMistakeWord?: Maybe<LearnerMistakeWord>;
  userErrors: Array<UserError>;
};

export type ViewerMistakeWordUpdateInput = {
  id: Scalars['ID']['input'];
  recordId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerMistakeWordUpdatePayload = {
  learnerMistakeWord?: Maybe<LearnerMistakeWord>;
  userErrors: Array<UserError>;
};

export type ViewerPartnerAdminTeacherFilter = {
  q?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ViewerPartnerClassAssignTeachersInput = {
  classID: Scalars['ID']['input'];
  teacherProfileIDs: Array<Scalars['ID']['input']>;
};

export type ViewerPartnerClassAssignTeachersPayload = {
  class?: Maybe<Class>;
  userErrors: Array<UserError>;
};

export type ViewerPartnerClassRemoveTeachersInput = {
  classID: Scalars['ID']['input'];
  teacherProfileIDs: Array<Scalars['ID']['input']>;
};

export type ViewerPartnerClassRemoveTeachersPayload = {
  class?: Maybe<Class>;
  userErrors: Array<UserError>;
};

export type ViewerPartnerCreateAssignTestInput = {
  checkPointId: Scalars['ID']['input'];
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  testLevelId: Scalars['ID']['input'];
  typeExam?: InputMaybe<TypeExamAssignTest>;
  typeInit?: InputMaybe<TypeInitAssignTest>;
};

export type ViewerPartnerCreateAssignTestPayload = {
  assignTest?: Maybe<AssignTest>;
  userErrors: Array<UserError>;
};

export type ViewerPartnerCreateClassInput = {
  classLevelId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  onboardStep?: InputMaybe<Scalars['Int']['input']>;
  pin: Scalars['Boolean']['input'];
  targetNotification?: InputMaybe<Scalars['Boolean']['input']>;
  type: ClassType;
  weeklyTimeTarget?: InputMaybe<Scalars['Duration']['input']>;
};

export type ViewerPartnerCreateClassPayload = {
  class?: Maybe<Class>;
  userErrors: Array<UserError>;
};

export type ViewerPartnerNotificationPayload = {
  isNew: Scalars['Boolean']['output'];
  notification: Notification;
};

export type ViewerPartnerPayload = {
  type: ViewerPartnerTypeSubscription;
};

export type ViewerPartnerSchoolInviteTeacherAcceptInput = {
  code: Scalars['String']['input'];
};

export type ViewerPartnerSchoolInviteTeacherAcceptPayload = {
  userErrors: Array<UserError>;
};

export type ViewerPartnerSchoolInviteTeacherDeclineInput = {
  code: Scalars['String']['input'];
};

export type ViewerPartnerSchoolInviteTeacherDeclinePayload = {
  userErrors: Array<UserError>;
};

export type ViewerPartnerSchoolInviteTeacherInput = {
  identifier: Scalars['String']['input'];
  roleId: Scalars['ID']['input'];
};

export type ViewerPartnerSchoolInviteTeacherPayload = {
  userErrors: Array<UserError>;
};

export type ViewerPartnerSchoolInvitedTeacherDeleteInput = {
  id: Scalars['ID']['input'];
};

export type ViewerPartnerSchoolInvitedTeacherDeletePayload = {
  schoolInvitedTeacherId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type ViewerPartnerSchoolInvitedTeacherEditInput = {
  id: Scalars['ID']['input'];
  roleId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerPartnerSchoolInvitedTeacherEditPayload = {
  schoolInvitedTeacher?: Maybe<SchoolInvitedTeacher>;
  userErrors: Array<UserError>;
};

export type ViewerPartnerSeenNotificationInput = {
  all?: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerPartnerSeenNotificationPayload = {
  notification?: Maybe<Notification>;
  userErrors: Array<UserError>;
};

export type ViewerPartnerTeacherFilter = {
  canAssignToClassId?: InputMaybe<Array<Scalars['ID']['input']>>;
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ViewerPartnerTypeSubscription {
  DeleteSchool = 'DELETE_SCHOOL'
}

export type ViewerRecoverAccountPayload = {
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerRecoverPasswordInput = {
  withFirebaseEmail?: InputMaybe<ViewerRecoverPasswordWithFirebaseEmailInput>;
  withFirebasePhoneNumber?: InputMaybe<ViewerRecoverPasswordWithFirebasePhoneNumberInput>;
  withPhoneNumber?: InputMaybe<ViewerRecoverPasswordWithPhoneNumberInput>;
};

export type ViewerRecoverPasswordPayload = {
  sessionToken?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerRecoverPasswordWithFirebaseEmailInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ViewerRecoverPasswordWithFirebasePhoneNumberInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ViewerRecoverPasswordWithPhoneNumberInput = {
  newPassword: Scalars['String']['input'];
  otpCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type ViewerRestoreInAppPurchasesInput = {
  appType?: AppTypeMobile;
};

export type ViewerRestoreInAppPurchasesPayload = {
  userErrors: Array<UserError>;
};

export type ViewerSeenAchievementInput = {
  name: AchievementName;
  tier: Scalars['Int']['input'];
};

export type ViewerSeenAchievementsPayload = {
  userErrors: Array<UserError>;
};

export type ViewerSendOtpInput = {
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  otpFlow: AuthOtpFlow;
  phoneNumber: Scalars['String']['input'];
};

export type ViewerSendOtpPayload = {
  userErrors: Array<UserError>;
};

export type ViewerSessionEventPayload = {
  event: ViewerSessionEventType;
};

export enum ViewerSessionEventType {
  LearnerProfileUpdated = 'LEARNER_PROFILE_UPDATED',
  NewSession = 'NEW_SESSION',
  RestoredDiamondInAppPurchases = 'RESTORED_DIAMOND_IN_APP_PURCHASES',
  RestoredInAppPurchases = 'RESTORED_IN_APP_PURCHASES'
}

export type ViewerSessionPayload = {
  anonymousLearnerProfile?: Maybe<LearnerProfile>;
  loginSession?: Maybe<UserSession>;
  viewer?: Maybe<User>;
};

export type ViewerSignUpInput = {
  withFirebasePhoneNumber?: InputMaybe<ViewerSignUpWithFirebasePhoneNumberInput>;
  withPhoneNumber?: InputMaybe<ViewerSignUpWithPhoneNumberInput>;
};

export type ViewerSignUpPayload = {
  providerInfo?: Maybe<PhoneNumberProviderInfo>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerSignUpWithFirebasePhoneNumberInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type ViewerSignUpWithPhoneNumberInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  otpCode: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerSwitchLearnerProfileInput = {
  learnerProfileId: Scalars['ID']['input'];
};

export type ViewerSwitchLearnerProfilePayload = {
  learnerProfile?: Maybe<LearnerProfile>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerSwitchSchoolInput = {
  schoolId: Scalars['ID']['input'];
};

export type ViewerSwitchSchoolPayload = {
  school?: Maybe<School>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerTeacherInvitationAcceptInput = {
  invitationId: Scalars['ID']['input'];
};

export type ViewerTeacherInvitationAcceptPayload = {
  userErrors: Array<UserError>;
};

export type ViewerTranscriptionInput = {
  url: Scalars['String']['input'];
};

export type ViewerTranscriptionPayload = {
  data?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
};

export type ViewerUnreadNotificationsCount = {
  floatSeen?: Maybe<Scalars['Int']['output']>;
  flyer: Scalars['Int']['output'];
  partner: Scalars['Int']['output'];
};

export type ViewerUpdateEmailInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ViewerUpdateEmailPayload = {
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerUpdateFcmTokenInput = {
  appType?: AppTypeMobile;
  lang: Scalars['String']['input'];
  token: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type ViewerUpdateFcmTokenPayload = {
  userErrors: Array<UserError>;
};

export type ViewerUpdateLearnerProfileInput = {
  additionalInfo?: InputMaybe<AdditionalInfoInput>;
  avatarId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  frameID?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['ID']['input'];
  ieltsTargetScore?: InputMaybe<Scalars['Float']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerUpdateLearnerProfilePayload = {
  learnerProfile?: Maybe<LearnerProfile>;
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerUpdateParentProfileInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  avatarId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['ID']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerUpdateParentProfilePayload = {
  parentProfile?: Maybe<ParentProfile>;
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerUpdatePasswordInput = {
  newPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ViewerUpdatePhoneNumberInput = {
  otpCode?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerUpdatePhoneNumberPayload = {
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerUpdateTeacherProfileInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  avatarId?: InputMaybe<Scalars['String']['input']>;
  bankAccountInfo?: InputMaybe<BankAccountInfoInput>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['ID']['input'];
  isCurriculumManager?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onboardingInfo?: InputMaybe<Array<MetaInfoInput>>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerUpdateTeacherProfilePayload = {
  teacherProfile?: Maybe<TeacherProfile>;
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerUpdateUsernameInput = {
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerUpdateUsernamePayload = {
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type ViewerUserAttemptSeenRewardPayload = {
  userAttempt?: Maybe<UserAttempt>;
  userErrors: Array<UserError>;
};

export type ViewerVerifyOwnerByEmailTokenInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
  tokenType: TokenType;
};

export type ViewerVerifyOwnerByEmailTokenPayload = {
  providerInfo?: Maybe<EmailProviderInfo>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type Viseme = {
  endTime?: Maybe<Scalars['Float']['output']>;
  phoneme?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['Float']['output']>;
  types?: Maybe<Array<Scalars['Int']['output']>>;
};

export type VnpayPayment = Node & {
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  packageActive?: Maybe<VnpayPaymentPackageActive>;
  partnerPackage?: Maybe<PartnerPackage>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  status: VnpayPaymentStatus;
  txnRef: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAddress?: Maybe<Scalars['String']['output']>;
  userIdentityCard?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  vnpayPaymentId: Scalars['ID']['output'];
};

export type VnpayPaymentConnection = {
  edges: Array<VnpayPaymentEdge>;
  nodes: Array<VnpayPayment>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type VnpayPaymentEdge = {
  cursor: Scalars['Cursor']['output'];
  node: VnpayPayment;
};

export enum VnpayPaymentPackageActive {
  DiamondBasic = 'DIAMOND_BASIC',
  DiamondTrial = 'DIAMOND_TRIAL',
  DiamondWell = 'DIAMOND_WELL',
  FlyerIeltsOneYear = 'FLYER_IELTS_ONE_YEAR',
  FlyerIeltsSixMonths = 'FLYER_IELTS_SIX_MONTHS',
  FlyerIeltsThreeMonths = 'FLYER_IELTS_THREE_MONTHS',
  FlyerKidsFourYears = 'FLYER_KIDS_FOUR_YEARS',
  FlyerKidsOneYear = 'FLYER_KIDS_ONE_YEAR',
  FlyerKidsTwoYears = 'FLYER_KIDS_TWO_YEARS',
  FlyerMaxFourYears = 'FLYER_MAX_FOUR_YEARS',
  FlyerMaxOneYear = 'FLYER_MAX_ONE_YEAR',
  FlyerMaxTwoYears = 'FLYER_MAX_TWO_YEARS',
  FlyerTeensFourYears = 'FLYER_TEENS_FOUR_YEARS',
  FlyerTeensOneYear = 'FLYER_TEENS_ONE_YEAR',
  FlyerTeensTwoYears = 'FLYER_TEENS_TWO_YEARS',
  OneDay = 'ONE_DAY',
  PartnerDepositWallet = 'PARTNER_DEPOSIT_WALLET',
  PartnerSpeakingAi = 'PARTNER_SPEAKING_AI'
}

export enum VnpayPaymentSource {
  Exam = 'EXAM',
  Ielts = 'IELTS',
  Mobile = 'MOBILE',
  Partner = 'PARTNER',
  Web = 'WEB'
}

export enum VnpayPaymentStatus {
  Cancel = 'CANCEL',
  Create = 'CREATE',
  Error = 'ERROR',
  NotFound = 'NOT_FOUND',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum VnpayPaymentVnpLocale {
  En = 'en',
  Vn = 'vn'
}

export type VocabWord = Node & {
  id: Scalars['ID']['output'];
  level?: Maybe<CefrLevel>;
  phonetics: Scalars['String']['output'];
  text: Scalars['String']['output'];
  vocabWordId: Scalars['ID']['output'];
};

export type VocabWordConnection = {
  edges: Array<VocabWordEdge>;
  nodes: Array<VocabWord>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type VocabWordEdge = {
  cursor: Scalars['Cursor']['output'];
  node: VocabWord;
};

export type VocabWordFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  isNullLevel?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Array<CefrLevel>>;
  text?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VocabWordOrder = {
  key?: InputMaybe<VocabWordOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum VocabWordOrderKey {
  Word = 'WORD'
}

export type VocabularyCefrDistribution = {
  cefrLevel: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type VocabularyKeywordItem = {
  endIndex: Scalars['Int']['output'];
  keyword: Scalars['String']['output'];
  startIndex: Scalars['Int']['output'];
};

export type Wallet = Node & {
  balance: Scalars['Float']['output'];
  currency: WalletCurrency;
  id: Scalars['ID']['output'];
  userId: Scalars['Int']['output'];
  walletId: Scalars['ID']['output'];
  walletTransactions: WalletTransactionConnection;
};


export type WalletWalletTransactionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type WalletConnection = {
  edges: Array<WalletEdge>;
  nodes: Array<Wallet>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum WalletCurrency {
  Usd = 'USD',
  Vnd = 'VND'
}

export type WalletEdge = {
  cursor: Scalars['Cursor']['output'];
  node: Wallet;
};

export type WalletTransaction = Node & {
  activationCode?: Maybe<ActivationCode>;
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  partnerPackage?: Maybe<PartnerPackage>;
  status: WalletTransactionStatus;
  transactionType: WalletTransactionTransactionType;
  userItem?: Maybe<User>;
  vnpayPayment?: Maybe<VnpayPayment>;
  wallet: Wallet;
  walletTransactionId: Scalars['ID']['output'];
};

export type WalletTransactionConnection = {
  edges: Array<WalletTransactionEdge>;
  nodes: Array<WalletTransaction>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type WalletTransactionEdge = {
  cursor: Scalars['Cursor']['output'];
  node: WalletTransaction;
};

export enum WalletTransactionStatus {
  Cancel = 'CANCEL',
  Create = 'CREATE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum WalletTransactionTransactionType {
  Deposit = 'DEPOSIT',
  Payment = 'PAYMENT'
}

export type WeeklyClassAssignTestWeak = {
  class: Class;
  completionRateLastWeek?: Maybe<Scalars['Float']['output']>;
  completionRatePreviousWeek?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  percentChange?: Maybe<Scalars['Float']['output']>;
  schoolId?: Maybe<Scalars['ID']['output']>;
  totalAssignments?: Maybe<Scalars['Int']['output']>;
  totalStudentsAssigned?: Maybe<Scalars['Int']['output']>;
  totalStudentsCompleted?: Maybe<Scalars['Int']['output']>;
  totalStudentsNotCompleted?: Maybe<Scalars['Int']['output']>;
  weeklyClassAssignTestWeakId: Scalars['ID']['output'];
};

export type WeeklyClassAssignTestWeakConnection = {
  edges: Array<WeeklyClassAssignTestWeakEdge>;
  nodes: Array<WeeklyClassAssignTestWeak>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type WeeklyClassAssignTestWeakEdge = {
  cursor: Scalars['Cursor']['output'];
  node: WeeklyClassAssignTestWeak;
};

export type WeeklyClassStudyTimeWeak = {
  class: Class;
  id: Scalars['ID']['output'];
  lastWeekStudyTime?: Maybe<Scalars['Duration']['output']>;
  percentChange?: Maybe<Scalars['Float']['output']>;
  previousWeekStudyTime?: Maybe<Scalars['Duration']['output']>;
  schoolId?: Maybe<Scalars['ID']['output']>;
  totalCompletedTest?: Maybe<Scalars['Int']['output']>;
  weeklyClassStudyTimeWeakId: Scalars['ID']['output'];
};

export type WeeklyClassStudyTimeWeakConnection = {
  edges: Array<WeeklyClassStudyTimeWeakEdge>;
  nodes: Array<WeeklyClassStudyTimeWeak>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type WeeklyClassStudyTimeWeakEdge = {
  cursor: Scalars['Cursor']['output'];
  node: WeeklyClassStudyTimeWeak;
};

export type WeeklyStudentAssignTestWeak = {
  accuracyLastWeek?: Maybe<Scalars['Float']['output']>;
  accuracyPreviousWeek?: Maybe<Scalars['Float']['output']>;
  assignmentsCompleted?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  notCompletedLastWeek?: Maybe<Scalars['Int']['output']>;
  notCompletedPreviousWeek?: Maybe<Scalars['Int']['output']>;
  percentChangeAccuracy?: Maybe<Scalars['Float']['output']>;
  percentChangeNotCompleted?: Maybe<Scalars['Float']['output']>;
  schoolId?: Maybe<Scalars['ID']['output']>;
  student: LearnerProfile;
  totalAssignments?: Maybe<Scalars['Int']['output']>;
  weeklyStudentAssignTestWeakId: Scalars['ID']['output'];
};

export type WeeklyStudentAssignTestWeakConnection = {
  edges: Array<WeeklyStudentAssignTestWeakEdge>;
  nodes: Array<WeeklyStudentAssignTestWeak>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type WeeklyStudentAssignTestWeakEdge = {
  cursor: Scalars['Cursor']['output'];
  node: WeeklyStudentAssignTestWeak;
};

export type WeeklyStudentAssignTestWeakOrder = {
  key?: InputMaybe<WeeklyStudentAssignTestWeakOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WeeklyStudentAssignTestWeakOrderKey {
  AccuracyLastWeek = 'ACCURACY_LAST_WEEK',
  NotCompletedLastWeek = 'NOT_COMPLETED_LAST_WEEK'
}

export type WeeklyTeacherAssignTestWeak = {
  completionRateLastWeek?: Maybe<Scalars['Float']['output']>;
  completionRatePreviousWeek?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  percentChange?: Maybe<Scalars['Float']['output']>;
  schoolId?: Maybe<Scalars['ID']['output']>;
  teacher: TeacherProfile;
  totalAssignments?: Maybe<Scalars['Int']['output']>;
  totalStudentsAssigned?: Maybe<Scalars['Int']['output']>;
  totalStudentsCompleted?: Maybe<Scalars['Int']['output']>;
  totalStudentsNotCompleted?: Maybe<Scalars['Int']['output']>;
  weeklyTeacherAssignTestWeakId: Scalars['ID']['output'];
};

export type WeeklyTeacherAssignTestWeakConnection = {
  edges: Array<WeeklyTeacherAssignTestWeakEdge>;
  nodes: Array<WeeklyTeacherAssignTestWeak>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type WeeklyTeacherAssignTestWeakEdge = {
  cursor: Scalars['Cursor']['output'];
  node: WeeklyTeacherAssignTestWeak;
};

export type Word = {
  confidence?: Maybe<Scalars['Float']['output']>;
  decision?: Maybe<WordDecision>;
  duration?: Maybe<Scalars['Int']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  phonemes?: Maybe<Array<Maybe<Phoneme>>>;
  pronunciationAssessment?: Maybe<PronunciationAssessment>;
  syllables?: Maybe<Array<Maybe<Syllable>>>;
  word?: Maybe<Scalars['String']['output']>;
};

export enum WordDecision {
  Correct = 'correct',
  Incorrect = 'incorrect',
  Warning = 'warning'
}

export type WritingAiMarking = {
  criteria: Array<WritingAiMarkingCriteria>;
  info?: Maybe<WritingAiMarkingInfo>;
  overview?: Maybe<Scalars['String']['output']>;
  sample?: Maybe<WritingAiMarkingSampleAnswer>;
  score?: Maybe<Scalars['Float']['output']>;
  suggestions?: Maybe<Array<WritingAiMarkingSuggestion>>;
};

export type WritingAiMarkingCriteria = {
  commentary?: Maybe<Scalars['String']['output']>;
  criterion?: Maybe<Scalars['String']['output']>;
  detailScores: Array<WritingAiMarkingDetailScore>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type WritingAiMarkingDetailScore = {
  criterion?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type WritingAiMarkingInfo = {
  answer: Scalars['String']['output'];
  topic: Scalars['String']['output'];
};

export type WritingAiMarkingSampleAnswer = {
  content: Scalars['String']['output'];
  vocabEnhancements: Array<WritingAiMarkingVocab>;
};

export type WritingAiMarkingSuggestion = {
  explanation: Scalars['String']['output'];
  originalSentence: Scalars['String']['output'];
  suggestedCorrection: Scalars['String']['output'];
};

export type WritingAiMarkingVocab = {
  meaning: Scalars['String']['output'];
  partsOfSpeech: Scalars['String']['output'];
  phrase: Scalars['String']['output'];
};

export type WritingAiPrompt = {
  system?: Maybe<Scalars['String']['output']>;
};

export type WritingAiPromptInput = {
  system: Scalars['String']['input'];
};

export enum WritingCriteria {
  Communicative = 'Communicative',
  Content = 'Content',
  Language = 'Language',
  Organisation = 'Organisation'
}

export type WritingEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type WritingEndAttemptPayload = {
  userErrors: Array<UserError>;
};

export type WritingImage = {
  imageId: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
};

export type WritingImageInput = {
  imageId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type WritingMarkingCriteria = {
  band?: Maybe<Scalars['Int']['output']>;
  commentary?: Maybe<Scalars['String']['output']>;
  criteria?: Maybe<WritingCriteria>;
};

export type WritingMarkingCriteriaInput = {
  band: Scalars['Int']['input'];
  commentary?: InputMaybe<Scalars['String']['input']>;
  criteria: WritingCriteria;
};

export type WritingPart = Node & {
  aiPrompt?: Maybe<WritingAiPrompt>;
  body?: Maybe<WritingPartBody>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  time?: Maybe<Scalars['Duration']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  writingPartId: Scalars['ID']['output'];
};

export type WritingPartAttempt = Node & {
  answer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  markingCriteria?: Maybe<Array<WritingMarkingCriteria>>;
  markingOverall?: Maybe<MarkingOverall>;
  part: WritingPart;
  questionChoiceId?: Maybe<Scalars['String']['output']>;
  teacherCommentsAnswer?: Maybe<Array<TeacherCommentDetail>>;
  teacherFixedAnswer?: Maybe<Scalars['JSON']['output']>;
  teacherWordCount?: Maybe<Scalars['Int']['output']>;
  wordCount: Scalars['Int']['output'];
  writingPartAttemptId: Scalars['ID']['output'];
};

export type WritingPartBody = {
  questionChoices: Array<WritingQuestion>;
};

export type WritingPartBodyInput = {
  questionChoices: Array<WritingQuestionInput>;
};

export type WritingPartConnection = {
  edges: Array<WritingPartEdge>;
  nodes: Array<WritingPart>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type WritingPartEdge = {
  cursor: Scalars['Cursor']['output'];
  node: WritingPart;
};

export type WritingPartFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WritingQuestion = {
  aiPrompt?: Maybe<WritingAiPrompt>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  highlightText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<WritingImage>>;
  position: Scalars['Int']['output'];
  sampleAnswerHtml?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  titleContentHtml?: Maybe<Scalars['String']['output']>;
};

export type WritingQuestionInput = {
  aiPrompt?: InputMaybe<WritingAiPromptInput>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  highlightText?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<WritingImageInput>>;
  position: Scalars['Int']['input'];
  sampleAnswerHtml?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleContentHtml?: InputMaybe<Scalars['String']['input']>;
};

export type WritingStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  requestAIReview?: InputMaybe<Scalars['Boolean']['input']>;
  requestReview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WritingStartAttemptPayload = {
  attemptId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

export type WritingSubmitPartAttemptInput = {
  answer: Scalars['String']['input'];
  attemptId: Scalars['ID']['input'];
  partId: Scalars['ID']['input'];
  questionChoiceId?: InputMaybe<Scalars['String']['input']>;
};

export type WritingSubmitPartAttemptPayload = {
  userErrors: Array<UserError>;
};

export type WritingUpdateInput = {
  markingCriteria?: InputMaybe<Array<WritingMarkingCriteriaInput>>;
  partID: Scalars['ID']['input'];
  teacherCommentsAnswers?: InputMaybe<Array<TeacherCommentDetailInput>>;
  teacherFixedAnswer?: InputMaybe<Scalars['JSON']['input']>;
  teacherWordCount?: InputMaybe<Scalars['Int']['input']>;
};

export type ViewerAiSpeakToTextPayload = {
  text?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
};

export type ViewerUpdatePasswordPayload = {
  userErrors: Array<UserError>;
  viewer?: Maybe<User>;
};

export type TestLevelBySlugQueryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type TestLevelBySlugQueryQuery = { testLevelBySlug?: { slug: string, name: string, playlistId?: string | null, typeTestLevel?: TypeExamTestLevel | null, description?: string | null, descriptionEn?: string | null, id: string, metadata?: { externalLink?: string | null, seo?: { title?: string | null, titleEn?: string | null, descriptionEn?: string | null, description?: string | null, featureImage?: { id: string, url: string } | null } | null } | null } | null };

export type TestLevelQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TestLevelQueryQuery = { testLevel?: { slug: string, name: string, playlistId?: string | null, description?: string | null, descriptionEn?: string | null, id: string } | null };

export type GetListThemesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  filterBy?: InputMaybe<ThemeFilter>;
}>;


export type GetListThemesQuery = { themes: { totalCount?: number | null, edges: Array<{ cursor: string, node: { id: string, themeId: string, createdAt: string, updatedAt: string, name: string, nameEn: string, imageId: string, type: ThemeType, bookOneId?: string | null, bookTwoId?: string | null, backgroundId: string, bingoId?: string | null, progressId?: string | null, iconLeftId?: string | null, iconRightId?: string | null, blockLeft?: string | null, blockRight?: string | null, progressColor?: string | null, iconPrevId?: string | null, iconNextId?: string | null, borderProgress?: string | null, isDefault?: boolean | null, disabled?: boolean | null, imagePreviewId?: string | null, imageTitleId?: string | null, iconZoomId?: string | null } }> } };

export type CheckPointsFullQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
}>;


export type CheckPointsFullQueryQuery = { checkPoints: { edges: Array<{ cursor: string, node: { name: string, nameEn?: string | null, type: string, viewerCompleted?: boolean | null, isPremium: boolean, partsCount: number, testCount: number, time?: string | null, viewerCanAccess: boolean, viewerIsSubscribing: boolean, id: string, meta?: { externalUrl?: string | null } | null, speakingParts?: Array<{ id: string, speakingPartId: string, partType: SpeakingPartType }> | null, testLevel?: { id: string, name: string, slug: string } | null } }>, pageInfo: { endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type TestLevelFragment = { slug: string, name: string, playlistId?: string | null, typeTestLevel?: TypeExamTestLevel | null, description?: string | null, descriptionEn?: string | null, id: string, metadata?: { externalLink?: string | null, seo?: { title?: string | null, titleEn?: string | null, descriptionEn?: string | null, description?: string | null, featureImage?: { id: string, url: string } | null } | null } | null };

export type UserErrorFragment = { message: string, code: UserErrorCode, field?: Array<string> | null, param: { value?: string | null } };

export type TestLevelCheckPointFragment = { name: string, nameEn?: string | null, type: string, viewerCompleted?: boolean | null, isPremium: boolean, partsCount: number, testCount: number, time?: string | null, viewerCanAccess: boolean, viewerIsSubscribing: boolean, id: string, meta?: { externalUrl?: string | null } | null, speakingParts?: Array<{ id: string, speakingPartId: string, partType: SpeakingPartType }> | null, testLevel?: { id: string, name: string, slug: string } | null };

export type MoreInfoCheckPointQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MoreInfoCheckPointQueryQuery = { checkPoint?: { id: string, viewerCanAccess: boolean, name: string, nameEn?: string | null, checkPointId: string, cpType: CheckPointType, type: string, examStructures?: Array<{ structureType: { name: string, value: ExamStructureType } }> | null, sectionCheckPoints: Array<{ id: string, parentStructureType?: ExamStructureType | null, checkPointId: string, parentPartOrder?: number | null }> } | null };

export type RecordScorePronunciationFragment = { generalScore?: number | null, intonationScore?: number | null, score: number, decision: WordDecision, highlightWords?: Array<{ startIndex?: number | null, endIndex?: number | null, text: string, ipa: string, nativenessScore: number, decision: WordDecision, audioUrl?: string | null, phonemes: Array<{ startIndex?: number | null, endIndex?: number | null, text: string, ipa: string, nativenessScore: number, decision: WordDecision }> }> | null };

export type RecordScoreGrammarFragment = { messages?: Array<string> | null, score: number, decision: WordDecision, highlightItems?: Array<{ suggestion: string, startIndex: number, original: string, endIndex: number }> | null };

export type RecordScoreVocabularyFragment = { answerKeyScore: number, score: number, decision: WordDecision, cefrScore?: number | null, cefrDistribution?: Array<{ cefrLevel: string, score: number }> | null, highlightKeywords?: Array<{ startIndex: number, endIndex: number, keyword: string }> | null };

export type RecordScoreAttemptFragmentFragment = { transcript?: string | null, vocabularyGrammarScore: number, pronunciationScore: number, interactionScore: number, vocabularyGrammarScorePercent: number, vocabularyGrammarDecision: WordDecision, interactionScorePercent: number, overallScore: number, coherenceScore: number, suggestions?: Array<{ audioId?: string | null, id: string, text: string }> | null, coherence?: { decision: WordDecision, score: number } | null, vocabulary: { answerKeyScore: number, score: number, decision: WordDecision, cefrScore?: number | null, cefrDistribution?: Array<{ cefrLevel: string, score: number }> | null, highlightKeywords?: Array<{ startIndex: number, endIndex: number, keyword: string }> | null }, grammar: { score: number, decision: WordDecision, highlightItems?: Array<{ startIndex: number, endIndex: number, original: string, suggestion: string }> | null }, pronunciation: { generalScore?: number | null, intonationScore?: number | null, score: number, decision: WordDecision, highlightWords?: Array<{ startIndex?: number | null, endIndex?: number | null, text: string, ipa: string, nativenessScore: number, decision: WordDecision, audioUrl?: string | null, phonemes: Array<{ startIndex?: number | null, endIndex?: number | null, text: string, ipa: string, nativenessScore: number, decision: WordDecision }> }> | null }, interaction: { receptionResponding: number, fluencyPromptness: number, receptionDecision: WordDecision, fluencyDecision: WordDecision, fluency: { wordsPerMinute?: number | null } } };

export type AzureRecordScoreFragmentFragment = { microsoftScore?: { displayText?: string | null, duration?: number | null, recognitionStatus?: string | null, offset?: number | null, nBest?: Array<{ itn?: string | null, lexical?: string | null, pronunciationAssessment?: { accuracyScore?: number | null, pronScore?: number | null, prosodyScore?: number | null, fluencyScore?: number | null } | null, words?: Array<{ word?: string | null, confidence?: number | null, duration?: number | null, decision?: WordDecision | null, phonemes?: Array<{ duration?: number | null, decision?: WordDecision | null, phoneme?: string | null, pronunciationAssessment?: { accuracyScore?: number | null } | null } | null> | null } | null> | null } | null> | null } | null, cambridgeAssessment?: { grammarScore?: number | null, vocabularyScore?: number | null, mistakesEn?: Array<string | null> | null, mistakesVi?: Array<string | null> | null, suggestions?: Array<string | null> | null } | null };

export type IeltsSpeakingQuestionFragment = { id: string, title: string, sampleAnswerHtml: string, timeToSpeak: string, timeToThink?: string | null, contentHtml: string, ieltsSpeakingQuestionId: string, name: string, sampleAnswerAudio?: { id: string, url: string, subtitle?: string | null } | null, audio: { id: string, url: string } };

export type CheckPointIeltsQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CheckPointIeltsQueryQuery = { checkPoint?: { id: string, name: string, nameEn?: string | null, description?: string | null, descriptionEn?: string | null, diamond?: number | null, cpType: CheckPointType, viewerCanAccess: boolean, sectionCheckPoints: Array<{ id: string, parentStructureType?: ExamStructureType | null, checkPointId: string, parentPartOrder?: number | null }>, checkPointIeltsSpeakingParts: Array<{ node: { id: string, expiredTime: string, order: number, defaultShowQuestionContents: boolean, info: { id: string, title: string, description?: string | null, introductionText: string, introductionAudio?: { id: string, url: string } | null }, ieltsSpeakingPartQuestions: Array<{ node: { id: string, title: string, sampleAnswerHtml: string, timeToSpeak: string, timeToThink?: string | null, contentHtml: string, ieltsSpeakingQuestionId: string, name: string, sampleAnswerAudio?: { id: string, url: string, subtitle?: string | null } | null, audio: { id: string, url: string } } }> } }> } | null };

export type ExamCheckPointFullFragment = { id: string, viewerCanAccess: boolean, name: string, nameEn?: string | null, checkPointId: string, cpType: CheckPointType, type: string, listeningTime?: string | null, speakingTime?: string | null, writingTime?: string | null, readingTime?: string | null, testLevel?: { slug: string, name: string, playlistId?: string | null, typeTestLevel?: TypeExamTestLevel | null, description?: string | null, descriptionEn?: string | null, id: string, metadata?: { externalLink?: string | null, seo?: { title?: string | null, titleEn?: string | null, descriptionEn?: string | null, description?: string | null, featureImage?: { id: string, url: string } | null } | null } | null } | null, examStructures?: Array<{ totalMarks: number, time: string, maxScore: number, structureType: { name: string, value: ExamStructureType }, parts: Array<{ order: number, miniCheckPointId?: string | null, node: { examPartId: string, totalMarks: number, id: string, maxScore: number, answerExplanationHTML?: string | null, answerExplanationHTMLEn?: string | null, partType: ExamPartType, time?: string | null, title: string, structureType: ExamStructureType, body?: { contentImageId?: string | null, contentImagePrompt?: string | null } | null, contents: Array<{ id: string, body: { formattedText?: { text: string, format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null } | null, images?: Array<{ imageId: string, label?: string | null, position: number }> | null } }>, questions: Array<{ isExample: boolean, id: string, order: number, title: string, answerExplanationHTML?: string | null, answerExplanationHTMLEn?: string | null, body?: { videoUrl?: string | null, audioId?: string | null, audioSubtitle?: string | null, videoPrompt?: string | null, exampleAnswers?: Array<string> | null, point?: { id: string, left: string, position: number, top: string } | null } | null, details: Array<{ id: string, labelOrder: string, order: number, prefix?: string | null, detail?: { valueType: ExamQuestionDetailValueType, formattedText?: { format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null, text: string } | null, textIndexes?: Array<{ text: string, index: string }> | null, box?: { height: string, left: string, top: string, width: string } | null } | null, result?: { isSelected?: boolean | null, value?: Array<string> | null, formattedValue?: { format: ExamQuestionTextFormat, text: string } | null } | null }>, titlePrefix?: { format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null, text: string } | null, detailPrefix?: { format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null, text: string } | null, content?: { format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null, text: string } | null, choices?: Array<{ format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null, text: string }> | null }> } }> }> | null, sectionCheckPoints: Array<{ id: string, parentStructureType?: ExamStructureType | null, checkPointId: string, parentPartOrder?: number | null }> };

export type ExamPartAttemptFragment = { id: string, examPartAttemptId: string, score: number, maxScore: number, position: number, part: { id: string, examPartId: string, title: string, partType: ExamPartType, structureType: ExamStructureType, maxScore: number, time?: string | null, questions: Array<{ id: string, title: string, order: number }> }, questionDetailAttempts: Array<{ id: string, examQuestionDetailAttemptId: string, isCorrect: boolean, answer?: { value?: Array<string> | null, isSelected?: boolean | null, valueType: ExamQuestionResultValueType, recordId?: string | null, formattedValue?: { text: string, format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null } | null } | null, result?: { value?: Array<string> | null, recordId?: string | null, isSelected?: boolean | null, valueType: ExamQuestionResultValueType, formattedValue?: { text: string, format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null } | null } | null, questionDetail: { id: string, prefix?: string | null } }> };

export type ExamStructureAttemptsFragment = { totalCorrectMarks: number, structureType: { value: ExamStructureType, name: string }, partAttempts: Array<{ id: string, examPartAttemptId: string, score: number, maxScore: number, position: number, part: { id: string, examPartId: string, title: string, partType: ExamPartType, structureType: ExamStructureType, maxScore: number, time?: string | null, questions: Array<{ id: string, title: string, order: number }> }, questionDetailAttempts: Array<{ id: string, examQuestionDetailAttemptId: string, isCorrect: boolean, answer?: { value?: Array<string> | null, isSelected?: boolean | null, valueType: ExamQuestionResultValueType, recordId?: string | null, formattedValue?: { text: string, format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null } | null } | null, result?: { value?: Array<string> | null, recordId?: string | null, isSelected?: boolean | null, valueType: ExamQuestionResultValueType, formattedValue?: { text: string, format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null } | null } | null, questionDetail: { id: string, prefix?: string | null } }> }> };

export type TestLevelsWithFilterQueryVariables = Exact<{
  filterBy?: InputMaybe<TestLevelFilter>;
}>;


export type TestLevelsWithFilterQuery = { testLevels: { nodes: Array<{ slug: string, name: string, playlistId?: string | null, typeTestLevel?: TypeExamTestLevel | null, description?: string | null, descriptionEn?: string | null, id: string, metadata?: { externalLink?: string | null, seo?: { title?: string | null, titleEn?: string | null, descriptionEn?: string | null, description?: string | null, featureImage?: { id: string, url: string } | null } | null } | null }> } };

export type SubmitExamQuestionDetailMutationMutationVariables = Exact<{
  input: ExamSubmitPartAttemptInput;
}>;


export type SubmitExamQuestionDetailMutationMutation = { examSubmitPartAttempt: { userErrors: Array<{ message: string, code: UserErrorCode, field?: Array<string> | null, param: { value?: string | null } }> } };

export type SignUpViewSignUpMutationMutationVariables = Exact<{
  input: ViewerSignUpInput;
}>;


export type SignUpViewSignUpMutationMutation = { viewerSignUp: { viewer?: { email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, countryCode: string, adminRole?: UserAdminRole | null, id: string, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, id: string, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type ViewerXpSummariesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<LearnerXpFilter>;
}>;


export type ViewerXpSummariesQuery = { viewerXpSummaries: { nodes: Array<{ date: string, id: string, learnerXpId: string }> } };

export type GetPlayersInfoChallengeByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetPlayersInfoChallengeByCodeQuery = { challengeByCode?: { code: string, id: string, learnerProfile?: { id: string, learnerProfileId: string, displayName: string } | null, players: { totalCount?: number | null, edges: Array<{ node: { id: string, challengePlayerId: string, joinedAt: string, updatedAt: string, learnerProfile: { learnerProfileId: string, displayName: string, avatarUrl?: string | null, id: string, frameImage?: { id: string, url: string } | null }, attempt?: { id: string, grade?: number | null, totalScore?: number | null } | null } }> } } | null };

export type ViewerAchievementsQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerAchievementsQuery = { viewerAchievements?: Array<{ id: string, learnerAchievementId: string, level: number, name: AchievementName, seen: boolean, tier: number, value: number, dateReceived?: string | null, nextLevelValue: number, maxLevel: number }> | null };

export type ViewerSeenAchievementsMutationVariables = Exact<{
  inputs: Array<ViewerSeenAchievementInput>;
}>;


export type ViewerSeenAchievementsMutation = { viewerSeenAchievements: { userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null }> } };

export type ExamDomainQueryVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type ExamDomainQuery = { partnerDomain?: { domainName?: string | null, id: string, meta?: { featureTitle?: string | null, featureDescription?: string | null, loginTitle?: string | null, featureImage?: { id: string, url: string } | null, logoImage?: { id: string, url: string } | null, examBackgroundImage?: { url: string, id: string } | null, examLogoImage?: { url: string, id: string } | null } | null } | null };

export type ChallengeEndMutationVariables = Exact<{
  input: ChallengeEndInput;
}>;


export type ChallengeEndMutation = { challengeEnd: { userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type GetInfoCheckpointDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  challengeCode: Scalars['String']['input'];
  challengeCodeResume?: InputMaybe<Scalars['String']['input']>;
  isChallengeMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetInfoCheckpointDetailQuery = { checkPoint?: { id: string, viewerCanAccess: boolean, name: string, nameEn?: string | null, checkPointId: string, cpType: CheckPointType, type: string, listeningTime?: string | null, speakingTime?: string | null, writingTime?: string | null, readingTime?: string | null, viewerLatestResumableAttempt?: { currentStructure: ExamStructureType, currentSectionExpiresAt: string, currentExamPart: { id: string, examPartId: string }, userAttempt: { id: string, userAttemptId: string, createdAt: string, submittedAt?: string | null, examStructureAttempts: Array<{ totalCorrectMarks: number, structureType: { value: ExamStructureType, name: string }, partAttempts: Array<{ id: string, examPartAttemptId: string, score: number, maxScore: number, position: number, part: { id: string, examPartId: string, title: string, partType: ExamPartType, structureType: ExamStructureType, maxScore: number, time?: string | null, questions: Array<{ id: string, title: string, order: number }> }, questionDetailAttempts: Array<{ id: string, examQuestionDetailAttemptId: string, isCorrect: boolean, answer?: { value?: Array<string> | null, isSelected?: boolean | null, valueType: ExamQuestionResultValueType, recordId?: string | null, formattedValue?: { text: string, format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null } | null } | null, result?: { value?: Array<string> | null, recordId?: string | null, isSelected?: boolean | null, valueType: ExamQuestionResultValueType, formattedValue?: { text: string, format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null } | null } | null, questionDetail: { id: string, prefix?: string | null } }> }> }> } } | null, testLevel?: { slug: string, name: string, playlistId?: string | null, typeTestLevel?: TypeExamTestLevel | null, description?: string | null, descriptionEn?: string | null, id: string, metadata?: { externalLink?: string | null, seo?: { title?: string | null, titleEn?: string | null, descriptionEn?: string | null, description?: string | null, featureImage?: { id: string, url: string } | null } | null } | null } | null, examStructures?: Array<{ totalMarks: number, time: string, maxScore: number, structureType: { name: string, value: ExamStructureType }, parts: Array<{ order: number, miniCheckPointId?: string | null, node: { examPartId: string, totalMarks: number, id: string, maxScore: number, answerExplanationHTML?: string | null, answerExplanationHTMLEn?: string | null, partType: ExamPartType, time?: string | null, title: string, structureType: ExamStructureType, body?: { contentImageId?: string | null, contentImagePrompt?: string | null } | null, contents: Array<{ id: string, body: { formattedText?: { text: string, format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null } | null, images?: Array<{ imageId: string, label?: string | null, position: number }> | null } }>, questions: Array<{ isExample: boolean, id: string, order: number, title: string, answerExplanationHTML?: string | null, answerExplanationHTMLEn?: string | null, body?: { videoUrl?: string | null, audioId?: string | null, audioSubtitle?: string | null, videoPrompt?: string | null, exampleAnswers?: Array<string> | null, point?: { id: string, left: string, position: number, top: string } | null } | null, details: Array<{ id: string, labelOrder: string, order: number, prefix?: string | null, detail?: { valueType: ExamQuestionDetailValueType, formattedText?: { format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null, text: string } | null, textIndexes?: Array<{ text: string, index: string }> | null, box?: { height: string, left: string, top: string, width: string } | null } | null, result?: { isSelected?: boolean | null, value?: Array<string> | null, formattedValue?: { format: ExamQuestionTextFormat, text: string } | null } | null }>, titlePrefix?: { format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null, text: string } | null, detailPrefix?: { format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null, text: string } | null, content?: { format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null, text: string } | null, choices?: Array<{ format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null, text: string }> | null }> } }> }> | null, sectionCheckPoints: Array<{ id: string, parentStructureType?: ExamStructureType | null, checkPointId: string, parentPartOrder?: number | null }> } | null, challengeByCode?: { code: string, createdAt: string, isLimit: boolean, isHiddenName: boolean, endAt?: string | null, name: string, id: string, checkPoint: { name: string, nameEn?: string | null, id: string } } | null };

export type GetResultUserAttemptQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetResultUserAttemptQuery = { userAttempt?: { id: string, createdAt: string, submittedAt?: string | null, userAttemptId: string, checkPoint?: { id: string, viewerCanAccess: boolean, name: string, nameEn?: string | null, checkPointId: string, cpType: CheckPointType, type: string, listeningTime?: string | null, speakingTime?: string | null, writingTime?: string | null, readingTime?: string | null, testLevel?: { slug: string, name: string, playlistId?: string | null, typeTestLevel?: TypeExamTestLevel | null, description?: string | null, descriptionEn?: string | null, id: string, metadata?: { externalLink?: string | null, seo?: { title?: string | null, titleEn?: string | null, descriptionEn?: string | null, description?: string | null, featureImage?: { id: string, url: string } | null } | null } | null } | null, examStructures?: Array<{ totalMarks: number, time: string, maxScore: number, structureType: { name: string, value: ExamStructureType }, parts: Array<{ order: number, miniCheckPointId?: string | null, node: { examPartId: string, totalMarks: number, id: string, maxScore: number, answerExplanationHTML?: string | null, answerExplanationHTMLEn?: string | null, partType: ExamPartType, time?: string | null, title: string, structureType: ExamStructureType, body?: { contentImageId?: string | null, contentImagePrompt?: string | null } | null, contents: Array<{ id: string, body: { formattedText?: { text: string, format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null } | null, images?: Array<{ imageId: string, label?: string | null, position: number }> | null } }>, questions: Array<{ isExample: boolean, id: string, order: number, title: string, answerExplanationHTML?: string | null, answerExplanationHTMLEn?: string | null, body?: { videoUrl?: string | null, audioId?: string | null, audioSubtitle?: string | null, videoPrompt?: string | null, exampleAnswers?: Array<string> | null, point?: { id: string, left: string, position: number, top: string } | null } | null, details: Array<{ id: string, labelOrder: string, order: number, prefix?: string | null, detail?: { valueType: ExamQuestionDetailValueType, formattedText?: { format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null, text: string } | null, textIndexes?: Array<{ text: string, index: string }> | null, box?: { height: string, left: string, top: string, width: string } | null } | null, result?: { isSelected?: boolean | null, value?: Array<string> | null, formattedValue?: { format: ExamQuestionTextFormat, text: string } | null } | null }>, titlePrefix?: { format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null, text: string } | null, detailPrefix?: { format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null, text: string } | null, content?: { format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null, text: string } | null, choices?: Array<{ format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null, text: string }> | null }> } }> }> | null, sectionCheckPoints: Array<{ id: string, parentStructureType?: ExamStructureType | null, checkPointId: string, parentPartOrder?: number | null }> } | null, examStructureAttempts: Array<{ totalCorrectMarks: number, structureType: { value: ExamStructureType, name: string }, partAttempts: Array<{ id: string, examPartAttemptId: string, score: number, maxScore: number, position: number, part: { id: string, examPartId: string, title: string, partType: ExamPartType, structureType: ExamStructureType, maxScore: number, time?: string | null, questions: Array<{ id: string, title: string, order: number }> }, questionDetailAttempts: Array<{ id: string, examQuestionDetailAttemptId: string, isCorrect: boolean, answer?: { value?: Array<string> | null, isSelected?: boolean | null, valueType: ExamQuestionResultValueType, recordId?: string | null, formattedValue?: { text: string, format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null } | null } | null, result?: { value?: Array<string> | null, recordId?: string | null, isSelected?: boolean | null, valueType: ExamQuestionResultValueType, formattedValue?: { text: string, format: ExamQuestionTextFormat, label?: string | null, metadataText?: string | null } | null } | null, questionDetail: { id: string, prefix?: string | null } }> }> }> } | null };

export type ExamEndMobilePlacementestMutationMutationVariables = Exact<{
  input: ExamEndAttemptInput;
}>;


export type ExamEndMobilePlacementestMutationMutation = { examEndAttempt: { userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type PracticePartFragmentFragment = { id: string, practicePartId: string, position: number, time?: string | null, title?: string | null, type: PracticePartType, answerExplanationHtml?: string | null, answerExplanationHtmlEn?: string | null, score: number, body: { query: { videoUrl?: string | null, imageUrl?: string | null, contentHtml: string, image?: { id: string, url: string, label?: string | null } | null, audio?: { id: string, url: string } | null }, details: Array<{ id: string, multipleCorrectAnswers: boolean, options: Array<{ id: string, correctAnswer: boolean, text?: string | null, image?: { id: string, url: string, label?: string | null } | null }> }> } };

export type PracticeCheckPointQueryVariables = Exact<{
  checkPointId: Scalars['ID']['input'];
}>;


export type PracticeCheckPointQuery = { checkPoint?: { id: string, checkPointId: string, skills?: Array<EnglishSkillV1> | null, time?: string | null, maxScore?: number | null, name: string, nameEn?: string | null, viewerCanAccess: boolean, status: CheckPointStatus, practiceParts: Array<{ id: string, practicePartId: string, position: number, time?: string | null, title?: string | null, type: PracticePartType, answerExplanationHtml?: string | null, answerExplanationHtmlEn?: string | null, score: number, body: { query: { videoUrl?: string | null, imageUrl?: string | null, contentHtml: string, image?: { id: string, url: string, label?: string | null } | null, audio?: { id: string, url: string } | null }, details: Array<{ id: string, multipleCorrectAnswers: boolean, options: Array<{ id: string, correctAnswer: boolean, text?: string | null, image?: { id: string, url: string, label?: string | null } | null }> }> } }> } | null };

export type PracticeAttemptReviewQueryVariables = Exact<{
  userAttemptId: Scalars['ID']['input'];
}>;


export type PracticeAttemptReviewQuery = { userAttempt?: { id: string, userAttemptId: string, totalMaxScore?: number | null, totalScore?: number | null, checkPoint?: { id: string, checkPointId: string, skills?: Array<EnglishSkillV1> | null, time?: string | null, maxScore?: number | null, name: string, nameEn?: string | null, viewerCanAccess: boolean, practiceParts: Array<{ id: string, practicePartId: string, position: number, time?: string | null, title?: string | null, type: PracticePartType, answerExplanationHtml?: string | null, answerExplanationHtmlEn?: string | null, score: number, body: { query: { videoUrl?: string | null, imageUrl?: string | null, contentHtml: string, image?: { id: string, url: string, label?: string | null } | null, audio?: { id: string, url: string } | null }, details: Array<{ id: string, multipleCorrectAnswers: boolean, options: Array<{ id: string, correctAnswer: boolean, text?: string | null, image?: { id: string, url: string, label?: string | null } | null }> }> } }> } | null, practicePartAttempts: Array<{ id: string, practicePartAttemptId: string, correctMark: number, part: { id: string, practicePartId: string }, detailAnswers: Array<{ text?: string | null, optionIds?: Array<string> | null, detailId: string, correctOptionIDs?: Array<string> | null }> }> } | null };

export type ViewerAiConversationSessionDetailQueryVariables = Exact<{
  aiConversationSessionId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AiConversationFilter>;
  orderBy?: InputMaybe<AiConversationOrder>;
}>;


export type ViewerAiConversationSessionDetailQuery = { viewerAiConversationSession?: { aiConversationSessionId: string, id: string, createdAt: string, messageCount?: number | null, learnerProfile: { displayName: string, id: string }, aiConversations: { totalCount?: number | null, pageInfo: { hasNextPage?: boolean | null, endCursor?: string | null, hasPreviousPage?: boolean | null, startCursor?: string | null }, edges: Array<{ cursor: string, node: { aiConversationId: string, id: string, message: string, updatedAt: string, role: AiConversationRole } }> } } | null };

export type GetInfoCheckpointDetailSeoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInfoCheckpointDetailSeoQuery = { checkPoint?: { imageUrl?: string | null, name: string, nameEn?: string | null, description?: string | null, descriptionEn?: string | null, testLevel?: { id: string, slug: string, name: string } | null } | null };

export type LearnerProfileCreateLearnerProfileMutationMutationVariables = Exact<{
  input: ViewerCreateLearnerProfileInput;
}>;


export type LearnerProfileCreateLearnerProfileMutationMutation = { viewerCreateLearnerProfile: { viewer?: { email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, countryCode: string, adminRole?: UserAdminRole | null, id: string, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, id: string, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type ChangePasswordModalUpdatePasswordMutationVariables = Exact<{
  input: ViewerUpdatePasswordInput;
}>;


export type ChangePasswordModalUpdatePasswordMutation = { viewerUpdatePassword: { viewer?: { id: string } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type ViewerRecoverPasswordMutationMutationVariables = Exact<{
  input: ViewerRecoverPasswordInput;
}>;


export type ViewerRecoverPasswordMutationMutation = { viewerRecoverPassword: { sessionToken?: string | null, viewer?: { id: string } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type AuthTokenValidQueryQueryVariables = Exact<{
  token: Scalars['String']['input'];
  identifierType: IdentifierType;
}>;


export type AuthTokenValidQueryQuery = { authTokenValid: boolean };

export type ViewerUpdateEmailMutationVariables = Exact<{
  input: ViewerUpdateEmailInput;
}>;


export type ViewerUpdateEmailMutation = { viewerUpdateEmail: { viewer?: { email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, countryCode: string, adminRole?: UserAdminRole | null, id: string, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, id: string, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type ProfileFormUpdateLearnerProfileMutationMutationVariables = Exact<{
  input: ViewerUpdateLearnerProfileInput;
}>;


export type ProfileFormUpdateLearnerProfileMutationMutation = { viewerUpdateLearnerProfile: { viewer?: { email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, countryCode: string, adminRole?: UserAdminRole | null, id: string, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, id: string, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type ViewerLearnerProfileStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerLearnerProfileStatsQuery = { viewerLearnerProfileStats?: { accuracy: number, level?: string | null, timeRemainingToCompleteLevel?: string | null, studyStats: { today: { completedTests: number, studyTime: string }, last7days: { completedTests: number, studyTime: string }, last30days: { completedTests: number, studyTime: string } } } | null };

export type LearnerProfileFormViewCreateLearnerProfileMutationMutationVariables = Exact<{
  input: ViewerCreateLearnerProfileInput;
}>;


export type LearnerProfileFormViewCreateLearnerProfileMutationMutation = { viewerCreateLearnerProfile: { viewer?: { email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, countryCode: string, adminRole?: UserAdminRole | null, id: string, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, id: string, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type LearnerProfileFormViewUpdateLearnerProfileMutationMutationVariables = Exact<{
  input: ViewerUpdateLearnerProfileInput;
}>;


export type LearnerProfileFormViewUpdateLearnerProfileMutationMutation = { viewerUpdateLearnerProfile: { viewer?: { email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, countryCode: string, adminRole?: UserAdminRole | null, id: string, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, id: string, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type ViewerJoinClassMutationVariables = Exact<{
  input: ViewerJoinClassInput;
}>;


export type ViewerJoinClassMutation = { viewerJoinClass: { classStudent?: { class?: { classId: string } | null } | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type ViewerLeftClassMutationVariables = Exact<{
  classId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ViewerLeftClassMutation = { viewerLeftClass: { classStudentId?: string | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type LoginViewLogInWithPasswordMutationMutationVariables = Exact<{
  input: ViewerLogInWithPasswordInput;
}>;


export type LoginViewLogInWithPasswordMutationMutation = { viewerLogIn: { viewer?: { email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, countryCode: string, adminRole?: UserAdminRole | null, id: string, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, id: string, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type RecoverViewRecoverPasswordMutationMutationVariables = Exact<{
  input: ViewerRecoverPasswordInput;
}>;


export type RecoverViewRecoverPasswordMutationMutation = { viewerRecoverPassword: { viewer?: { email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, countryCode: string, adminRole?: UserAdminRole | null, id: string, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, id: string, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type VerifyAccountViewVerifyOwnerByEmailTokenMutationMutationVariables = Exact<{
  token: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type VerifyAccountViewVerifyOwnerByEmailTokenMutationMutation = { viewerVerifyOwnerByEmailToken: { viewer?: { email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, countryCode: string, adminRole?: UserAdminRole | null, id: string, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, id: string, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type VerifyAccountViewForceLogInByEmailTokenMutationMutationVariables = Exact<{
  input: ViewerForceLogInByEmailTokenInput;
}>;


export type VerifyAccountViewForceLogInByEmailTokenMutationMutation = { viewerForceLogInByEmailToken: { viewer?: { email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, countryCode: string, adminRole?: UserAdminRole | null, id: string, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, id: string, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type GoogleLoginButtonLoginMutationMutationVariables = Exact<{
  input: ViewerLogInWithFirebaseEmailInput;
}>;


export type GoogleLoginButtonLoginMutationMutation = { viewerLogIn: { viewer?: { email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, countryCode: string, adminRole?: UserAdminRole | null, id: string, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, id: string, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } } | null, providerInfo?: { provider: string, email: string, isFirstLogin: boolean, needEmailVerified: boolean, associatedPhoneNumber?: string | null } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type OtpInputSendOtpMutationMutationVariables = Exact<{
  input: ViewerSendOtpInput;
}>;


export type OtpInputSendOtpMutationMutation = { viewerSendOtp: { userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type OtpInputIdentifierExistsQueryQueryVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;


export type OtpInputIdentifierExistsQueryQuery = { identifierExists: boolean };

export type PhoneInputCountryCodesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PhoneInputCountryCodesQueryQuery = { countryCodes: Array<{ dialCode: string, isoCode: string, countryCodeId: string }> };

export type PartnerAssignTestSubmitUpdateMutationVariables = Exact<{
  input: PartnerAssignTestSubmitUpdateInput;
}>;


export type PartnerAssignTestSubmitUpdateMutation = { partnerAssignTestSubmitUpdate: { userErrors: Array<{ code: UserErrorCode }> } };

export type AvatarFramesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  filterBy?: InputMaybe<AvatarFrameFilter>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  userAvatarFramesFirst2?: InputMaybe<Scalars['Int']['input']>;
  userAvatarFramesFilterBy2?: InputMaybe<UserAvatarFrameFilter>;
}>;


export type AvatarFramesQuery = { avatarFrames: { totalCount?: number | null, nodes: Array<{ id: string, name?: string | null, nameEn?: string | null, price: number, type: AvatarFrameType, avatarFrameId: string, order: number, image: { id: string, url: string }, userAvatarFrames: { totalCount?: number | null, nodes: Array<{ id: string, learnerProfileId: number, avatarFrame: { id: string, price: number } }> } }> } };

export type AvatarFrameUpdateLearnerProfileMutationMutationVariables = Exact<{
  input: ViewerUpdateLearnerProfileInput;
}>;


export type AvatarFrameUpdateLearnerProfileMutationMutation = { viewerUpdateLearnerProfile: { learnerProfile?: { avatarUrl?: string | null, id: string, frameImage?: { id: string, url: string } | null } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type ViewerBuyAvatarFrameMutationVariables = Exact<{
  input: ViewerBuyAvatarFrameInput;
}>;


export type ViewerBuyAvatarFrameMutation = { viewerBuyAvatarFrame: { avatarFrame?: { id: string, avatarFrameId: string, image: { id: string, url: string } } | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type ViewerTeacherInvitationAcceptMutationVariables = Exact<{
  input: ViewerTeacherInvitationAcceptInput;
}>;


export type ViewerTeacherInvitationAcceptMutation = { viewerTeacherInvitationAccept: { userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type TeacherInvitedLearnerQueryVariables = Exact<{
  teacherInvitedLearnerId: Scalars['ID']['input'];
}>;


export type TeacherInvitedLearnerQuery = { teacherInvitedLearner?: { id: string, learnerAcceptedInvitation: boolean, invitedClass?: { id: string, classId: string, name: string, code: string } | null, teacher: { id: string, displayName: string }, learner: { id: string, displayName: string, learnerProfileId: string, avatarUrl?: string | null, frameImage?: { id: string, url: string } | null } } | null };

export type ViewerJoinClassModalMutationVariables = Exact<{
  input: ViewerJoinClassInput;
}>;


export type ViewerJoinClassModalMutation = { viewerJoinClass: { classStudent?: { class?: { code: string, classId: string, name: string } | null } | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type ViewerGetClassNameQueryVariables = Exact<{
  classCode: Scalars['String']['input'];
}>;


export type ViewerGetClassNameQuery = { viewerGetClassName?: string | null };

export type CheckPointsPlacementTestQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
  orderBy?: InputMaybe<CheckPointOrder>;
}>;


export type CheckPointsPlacementTestQuery = { checkPoints: { edges: Array<{ node: { coin: number, diamond?: number | null, id: string, checkPointId: string, name: string, domains?: Array<string> | null, nameEn?: string | null, description?: string | null, descriptionEn?: string | null, source?: string | null } }> } };

export type PlacementTestGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlacementTestGroupsQuery = { placementTestGroups: Array<{ id: string, name: string, nameEn?: string | null, position: number, descriptionEn?: string | null, description?: string | null, checkPoints: Array<{ coin: number, diamond?: number | null, id: string, checkPointId: string, name: string, domains?: Array<string> | null, nameEn?: string | null, description?: string | null, descriptionEn?: string | null, source?: string | null }> }> };

export type LessonCheckPointQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LessonCheckPointQueryQuery = { checkPoint?: { id: string, checkPointDuolingoParts: Array<{ position: number, node: { id: string, duolingoPartId: string, name: string, type: DuolingoPartType, title: string, expiredTime?: string | null, challenge?: { textSolutions?: Array<string> | null, type?: DuolingoChallengeType | null, choices?: Array<{ text?: string | null, imageId?: string | null, isCorrect?: boolean | null, audioId?: string | null, correctPlaceholderId?: string | null, unselectable?: boolean | null, top?: string | null, left?: string | null, width?: string | null, height?: string | null, audio?: { id: string, url: string } | null, image?: { url: string, id: string } | null }> | null, pairs?: Array<{ from: { imageId?: string | null, text?: string | null, audio?: { id: string, url: string } | null }, to: { imageId?: string | null, text?: string | null, audio?: { id: string, url: string } | null } }> | null, prompts?: Array<{ showCharacter: boolean, imageId?: string | null, zoomedImageId?: string | null, imageAudioId?: string | null, imageContent?: string | null, imageDescription?: string | null, audio?: { id: string, url: string } | null, slowAudio?: { id: string, url: string } | null, tokens?: Array<{ token: string, isBlank: boolean, audio?: { id: string, url: string } | null, rows?: Array<{ hint: string }> | null }> | null, imagePlaceholders?: Array<{ id: string, top: string, left: string, width?: string | null, height?: string | null }> | null, image?: { id: string, url: string } | null, character?: { image: { id: string, url: string } } | null }> | null } | null, story?: { elements: Array<{ type: DuolingoStoryElementType, line?: { showCharacter: boolean, imageId?: string | null, audio?: { id: string, url: string } | null, character?: { image: { id: string, url: string } } | null, image?: { id: string, url: string } | null, tokens?: Array<{ isBlank: boolean, token: string, rows?: Array<{ hint: string }> | null, audio?: { id: string, url: string } | null }> | null } | null, question?: { title?: string | null, textSolutions?: Array<string> | null, choices?: Array<{ isCorrect?: boolean | null, text?: string | null, unselectable?: boolean | null, image?: { id: string, url: string } | null, audio?: { id: string, url: string } | null }> | null } | null }> } | null } }> } | null };

export type DuolingoSubmitPartAttemptMutationVariables = Exact<{
  input: DuolingoSubmitPartAttemptInput;
}>;


export type DuolingoSubmitPartAttemptMutation = { duolingoSubmitPartAttempt: { isCorrect?: boolean | null, answer?: { challenge?: { choice?: { correctPlaceholderId?: string | null, isCorrect?: boolean | null, text?: string | null } | null, choices?: Array<{ correctPlaceholderId?: string | null, isCorrect?: boolean | null, text?: string | null }> | null } | null } | null, userErrors: Array<{ code: UserErrorCode, message: string, field?: Array<string> | null, param: { value?: string | null } }> } };

export type DuolingoEndAttemptMutationVariables = Exact<{
  input: DuolingoEndAttemptInput;
}>;


export type DuolingoEndAttemptMutation = { duolingoEndAttempt: { userErrors: Array<{ code: UserErrorCode, message: string, field?: Array<string> | null, param: { value?: string | null } }> } };

export type ViewerDuolingoPathsQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerDuolingoPathsQuery = { viewerDuolingoPaths: Array<{ name: string, totalLevels: number, completedLevels: number, slug: string, units: Array<{ name: string, nameEn?: string | null, levels: Array<{ type: DuolingoLevelType, state: LearnerDuolingoLevelState, totalSessions: number, completedSessions: number, nextCheckPoint?: { id: string, checkPointId: string, name: string, nameEn?: string | null } | null }> }> }> };

export type UserAttemptLessonQueryVariables = Exact<{
  userAttemptId: Scalars['ID']['input'];
}>;


export type UserAttemptLessonQuery = { userAttempt?: { id: string, userAttemptId: string, accuracy?: number | null, starsEarned?: number | null, testLevel?: { id: string, testLevelId: string } | null, checkPoint?: { id: string, nameEn?: string | null, name: string, cpType: CheckPointType, type: string } | null, duolingoPartAttempts?: Array<{ id: string, duolingoPartAttemptId: string, isCorrect: boolean, isFirstScore: boolean, part: { id: string, name: string, title: string, type: DuolingoPartType, duolingoPartId: string, challenge?: { textSolutions?: Array<string> | null, type?: DuolingoChallengeType | null, pairs?: Array<{ from: { text?: string | null, imageId?: string | null, audio?: { id: string, url: string } | null }, to: { imageId?: string | null, text?: string | null, audio?: { id: string, url: string } | null } }> | null, choices?: Array<{ isCorrect?: boolean | null, text?: string | null, image?: { id: string, url: string } | null, audio?: { id: string, url: string } | null }> | null, prompts?: Array<{ showCharacter: boolean, imageId?: string | null, audio?: { id: string, url: string } | null, tokens?: Array<{ token: string, isBlank: boolean, audio?: { id: string, url: string } | null, rows?: Array<{ hint: string }> | null }> | null, image?: { id: string, url: string } | null }> | null } | null }, challengeAnswer?: { text?: string | null, recordId?: string | null, pair?: { to: { audioId?: string | null, text?: string | null, imageId?: string | null, audio?: { id: string, url: string } | null }, from: { audioId?: string | null, text?: string | null, imageId?: string | null, audio?: { id: string, url: string } | null } } | null, choice?: { isCorrect?: boolean | null, text?: string | null, image?: { id: string, url: string } | null, audio?: { id: string, url: string } | null } | null } | null }> | null } | null };

export type GetAttemptLessonStudyModeQueryVariables = Exact<{
  userAttemptId: Scalars['ID']['input'];
}>;


export type GetAttemptLessonStudyModeQuery = { userAttempt?: { id: string, userAttemptId: string, accuracy?: number | null, starsEarned?: number | null } | null };

export type ExamStartAttemptMutationMutationVariables = Exact<{
  input: ExamStartAttemptInput;
}>;


export type ExamStartAttemptMutationMutation = { examStartAttempt: { attemptId?: string | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type ExamSubmitPartAttemptMutationMutationVariables = Exact<{
  input: ExamSubmitPartAttemptInput;
}>;


export type ExamSubmitPartAttemptMutationMutation = { examSubmitPartAttempt: { userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type ExamEndAttemptMutationMutationVariables = Exact<{
  input: ExamEndAttemptInput;
}>;


export type ExamEndAttemptMutationMutation = { examEndAttempt: { userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type ExamNextStructureMutationMutationVariables = Exact<{
  input: ExamNextStructureInput;
}>;


export type ExamNextStructureMutationMutation = { examNextStructure: { userErrors: Array<{ message: string, code: UserErrorCode, field?: Array<string> | null, param: { value?: string | null } }> } };

export type ChallengeCheckPointsQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
}>;


export type ChallengeCheckPointsQueryQuery = { checkPoints: { edges: Array<{ cursor: string, node: { name: string, nameEn?: string | null, type: string, id: string } }>, pageInfo: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null, endCursor?: string | null } } };

export type TestLevelChallengeQueryVariables = Exact<{
  filterBy?: InputMaybe<TestLevelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TestLevelChallengeQuery = { testLevels: { nodes: Array<{ id: string, name: string, slug: string }> } };

export type ExamStartAttemptMobilePlacementTestMutationMutationVariables = Exact<{
  input: ExamStartAttemptInput;
}>;


export type ExamStartAttemptMobilePlacementTestMutationMutation = { examStartAttempt: { attemptId?: string | null, resumableAttempt?: { currentSectionExpiresAt: string } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type ExamMobilePlacementTestNextStructureMutationMutationVariables = Exact<{
  input: ExamNextStructureInput;
}>;


export type ExamMobilePlacementTestNextStructureMutationMutation = { examNextStructure: { userErrors: Array<{ message: string, code: UserErrorCode, field?: Array<string> | null, param: { value?: string | null } }> } };

export type GetCurrentRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentRoleQuery = { viewerCurrentSchoolRole?: { id: string, value: string, partnerRolePermissions: Array<{ active: boolean, node: { id: string, value: string, description?: string | null, descriptionEn?: string | null } }> } | null };

export type TestLevelListQueryVariables = Exact<{
  filterBy?: InputMaybe<TestLevelFilter>;
}>;


export type TestLevelListQuery = { testLevels: { nodes: Array<{ levels: Array<CefrLevel>, name: string, slug: string, description?: string | null, descriptionEn?: string | null, id: string }> } };

export type GetInfoChallengeByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetInfoChallengeByCodeQuery = { challengeByCode?: { id: string, challengeId: string, code: string, name: string, isHiddenName: boolean, isLimit: boolean, isMixed: boolean, isEnableSound: boolean, startAt?: string | null, endAt?: string | null, viewerCanStart: boolean, learnerProfile?: { id: string, learnerProfileId: string, displayName: string } | null, players: { edges: Array<{ node: { id: string, learnerProfile: { id: string, learnerProfileId: string }, attempt?: { id: string } | null } }> }, checkPoint: { id: string, checkPointId: string, viewerCanAccess: boolean, isPremium: boolean, name: string, nameEn?: string | null, testLevel?: { id: string, name: string, slug: string } | null, examStructures?: Array<{ totalMarks: number, time: string, maxScore: number, structureType: { value: ExamStructureType, name: string } }> | null } } | null };

export type GetDataChallengeByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetDataChallengeByCodeQuery = { challengeByCode?: { id: string, challengeId: string, code: string, name: string, isHiddenName: boolean, isLimit: boolean, isMixed: boolean, isEnableSound: boolean, startAt?: string | null, endAt?: string | null, viewerCanStart: boolean, challengeInfo?: { accuracy?: number | null, answerCorrect?: number | null, answerWrong?: number | null, totalQuestion?: number | null, totalStudent?: number | null } | null, checkPoint: { id: string, checkPointId: string, viewerCanAccess: boolean, isPremium: boolean, name: string, nameEn?: string | null, testCount: number, testLevel?: { id: string, name: string, slug: string } | null, examStructures?: Array<{ totalMarks: number, time: string, maxScore: number, structureType: { value: ExamStructureType, name: string }, parts: Array<{ order: number, node: { id: string, partType: ExamPartType, questions: Array<{ id: string, isExample: boolean, details: Array<{ id: string }> }> } }> }> | null }, learnerProfile?: { id: string, learnerProfileId: string, displayName: string } | null } | null };

export type LearnerChallengeRanksQueryVariables = Exact<{
  challengeCode: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type LearnerChallengeRanksQuery = { learnerChallengeRanks: { totalCount?: number | null, edges: Array<{ cursor: string, node: { id: string, learnerChallengeRankId: string, grade?: number | null, rank: number, score?: number | null, learnerProfile: { id: string, displayName: string, avatarUrl?: string | null, frameImage?: { id: string, url: string } | null }, attemptInfo?: { answerWrong?: number | null, answerCorrect?: number | null, percentAnswer?: number | null, totalQuestion?: number | null } | null, userAttempt?: { id: string, grade?: number | null, submittedAt?: string | null, examStructureAttempts: Array<{ totalScore: number, totalCorrectMarks: number, totalIncorrectMarks: number, totalMarks: number, partAttempts: Array<{ id: string, questionDetailAttempts: Array<{ id: string, isCorrect: boolean, answer?: { isSelected?: boolean | null, value?: Array<string> | null, formattedValue?: { text: string } | null } | null, questionDetail: { id: string } }> }> }> } | null } }>, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null } } };

export type ViewerAdviceCreateMutationVariables = Exact<{
  input: ViewerAdviceCreateInput;
}>;


export type ViewerAdviceCreateMutation = { viewerAdviceCreate: { advice?: { id: string, adviceId: string, status?: AdviceStatus | null } | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type GetCheckPointsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
}>;


export type GetCheckPointsQuery = { checkPoints: { edges: Array<{ node: { checkPointId: string, name: string, nameEn?: string | null, type: string, key: string } }>, pageInfo: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null, endCursor?: string | null } } };

export type TestLevelQueryVariables = Exact<{
  filterBy?: InputMaybe<TestLevelFilter>;
}>;


export type TestLevelQuery = { testLevels: { nodes: Array<{ name: string, slug: string, id: string }> } };

export type IeltsSpeakingCheckPointsQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type IeltsSpeakingCheckPointsQueryQuery = { ieltsSpeakingCheckPoints: { edges: Array<{ cursor: string, node: { name: string, nameEn?: string | null, time?: string | null, viewerCanAccess: boolean, viewerIeltsCompleted?: boolean | null, viewerIeltsStar?: number | null, isBoss: boolean, position: number, id: string, checkPointIeltsSpeakingParts: Array<{ node: { id: string, order: number, ieltsSpeakingPartQuestions: Array<{ node: { id: string } }> } }> } }>, pageInfo: { startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type IeltsSpeakingEndAttemptMutationMutationVariables = Exact<{
  input: IeltsSpeakingEndAttemptInput;
}>;


export type IeltsSpeakingEndAttemptMutationMutation = { ieltsSpeakingEndAttempt: { userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type IeltsSpeakingSubmitQuestionAttemptMutationMutationVariables = Exact<{
  input: IeltsSpeakingSubmitQuestionAttemptInput;
}>;


export type IeltsSpeakingSubmitQuestionAttemptMutationMutation = { ieltsSpeakingSubmitQuestionAttempt: { userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type IeltsSpeakingStartAttemptMutationMutationVariables = Exact<{
  input: IeltsSpeakingStartAttemptInput;
}>;


export type IeltsSpeakingStartAttemptMutationMutation = { ieltsSpeakingStartAttempt: { attemptId?: string | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type TeacherProfileQueryVariables = Exact<{
  teacherProfileId: Scalars['ID']['input'];
}>;


export type TeacherProfileQuery = { teacherProfile?: { avatarUrl?: string | null, displayName: string, id: string } | null };

export type GetTeacherProfileDetailQueryVariables = Exact<{
  teacherProfileId: Scalars['ID']['input'];
}>;


export type GetTeacherProfileDetailQuery = { teacherProfile?: { avatarUrl?: string | null, displayName: string, id: string } | null };

export type ViewerInProgressAssignedTestsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterBy?: InputMaybe<AssignTestProfileFilter>;
}>;


export type ViewerInProgressAssignedTestsQuery = { viewerInProgressAssignedTestsV2: { edges: Array<{ node: { id: string, assignTestProfileId: string, redoing: boolean, submitted: boolean, assignTest: { createdAt: string, startDate?: string | null, endDate?: string | null, id: string, checkPoint: { name: string, nameEn?: string | null, viewerCanAccess: boolean, viewerIsSubscribing: boolean, isPremium: boolean, imageUrl?: string | null, time?: string | null, type: string, id: string, image?: { id: string, url: string } | null, testLevel?: { id: string, slug: string, name: string } | null, partTypesInfo: Array<{ name: string } | { name: string }> }, teacherProfile: { id: string, displayName: string } } } }>, pageInfo: { endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type ViewerAssignedTestUserAttemptsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type ViewerAssignedTestUserAttemptsQuery = { viewerAssignedTestUserAttempts: { edges: Array<{ node: { id: string, assignTest?: { createdAt: string, startDate?: string | null, endDate?: string | null, id: string, teacherProfile: { id: string, displayName: string } } | null, checkPoint?: { name: string, nameEn?: string | null, viewerCanAccess: boolean, viewerIsSubscribing: boolean, isPremium: boolean, imageUrl?: string | null, time?: string | null, type: string, id: string, image?: { id: string, url: string } | null, testLevel?: { id: string, slug: string, name: string } | null, partTypesInfo: Array<{ name: string } | { name: string }> } | null } }>, pageInfo: { endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type TestCardItemCheckPointFragmentFragment = { name: string, nameEn?: string | null, viewerCanAccess: boolean, viewerIsSubscribing: boolean, isPremium: boolean, imageUrl?: string | null, time?: string | null, type: string, id: string, image?: { id: string, url: string } | null, testLevel?: { id: string, slug: string, name: string } | null, partTypesInfo: Array<{ name: string } | { name: string }> };

export type TestCardItemAssignTestFragmentFragment = { createdAt: string, startDate?: string | null, endDate?: string | null, id: string, teacherProfile: { id: string, displayName: string } };

export type TestContentCheckPointsByCefrLevelOverviewQueryQueryVariables = Exact<{
  limitPerLevel: Scalars['Int']['input'];
  filterBy?: InputMaybe<CheckPointFilter>;
  testLevelFilterBy?: InputMaybe<TestLevelFilter>;
}>;


export type TestContentCheckPointsByCefrLevelOverviewQueryQuery = { checkPointsByCefrLevelOverview: Array<{ totalCount: number, cefrLevelInfo: { value: CefrLevel, name: string, star: number }, testLevels: Array<{ slug: string, name: string }>, checkPoints: Array<{ name: string, nameEn?: string | null, viewerCanAccess: boolean, viewerIsSubscribing: boolean, isPremium: boolean, imageUrl?: string | null, time?: string | null, type: string, key: string, id: string, image?: { id: string, url: string } | null, testLevel?: { id: string, slug: string, name: string } | null, partTypesInfo: Array<{ name: string } | { name: string }> }> }> };

export type TestContentCheckPointsQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<CheckPointFilter>;
}>;


export type TestContentCheckPointsQueryQuery = { checkPoints: { edges: Array<{ node: { name: string, nameEn?: string | null, viewerCanAccess: boolean, viewerIsSubscribing: boolean, isPremium: boolean, imageUrl?: string | null, time?: string | null, type: string, key: string, id: string, image?: { id: string, url: string } | null, testLevel?: { id: string, slug: string, name: string } | null, partTypesInfo: Array<{ name: string } | { name: string }> } }>, pageInfo: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null, endCursor?: string | null } } };

export type ViewerActiveCodeMutationVariables = Exact<{
  input: ViewerActiveCodeInput;
}>;


export type ViewerActiveCodeMutation = { viewerActiveCode: { userErrors: Array<{ message: string, code: UserErrorCode, field?: Array<string> | null }> } };

export type DailyRewardsQueryVariables = Exact<{ [key: string]: never; }>;


export type DailyRewardsQuery = { dailyRewards: Array<{ coin?: number | null, dailyRewardId: string, dayNumber: number, diamond?: number | null, id: string, viewerClaimed: boolean }> };

export type ViewerDailyRewardClaimMutationVariables = Exact<{ [key: string]: never; }>;


export type ViewerDailyRewardClaimMutation = { viewerDailyRewardClaim?: { userErrors: Array<{ code: UserErrorCode, message: string }>, user?: { diamond: number, id: string } | null, dailyReward?: { id: string, viewerClaimed: boolean } | null, learnerProfile?: { coin: number, canClaimDailyReward: boolean, id: string } | null } | null };

export type ViewerExamFloatNotificationQueryQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<NotificationFilter>;
}>;


export type ViewerExamFloatNotificationQueryQuery = { viewerExamNotifications: { edges: Array<{ cursor: string, node: { id: string, description?: string | null, descriptionEn?: string | null, title?: string | null, titleEn?: string | null, image?: string | null, seen: boolean, type: NotificationType, source: NotificationSource, createdAt: string, meta: { linkExam?: string | null, attemptID?: string | null, challengeCode?: string | null, teacherInvitation?: { invitationId: string } | null }, assignTest?: { id: string, checkPoint: { type: string, cpType: CheckPointType, skills?: Array<EnglishSkillV1> | null, id: string, testLevel?: { slug: string, name: string, id: string } | null } } | null } }> } };

export type ViewerExamSeenNotificationMutationMutationVariables = Exact<{
  input: ViewerExamSeenNotificationInput;
}>;


export type ViewerExamSeenNotificationMutationMutation = { viewerExamSeenNotification: { notification?: { id: string } | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type CountNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type CountNotificationQuery = { viewerUnreadNotificationsCount?: { floatSeen?: number | null, partner: number, flyer: number } | null };

export type ViewerExamNotificationQueryQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<NotificationFilter>;
}>;


export type ViewerExamNotificationQueryQuery = { viewerExamNotifications: { edges: Array<{ cursor: string, node: { id: string, description?: string | null, descriptionEn?: string | null, title?: string | null, titleEn?: string | null, image?: string | null, seen: boolean, type: NotificationType, source: NotificationSource, createdAt: string, typeNotification: NotificationTypeNotification, meta: { linkExam?: string | null, attemptID?: string | null, challengeCode?: string | null, teacherInvitation?: { invitationId: string } | null }, assignTest?: { id: string, checkPoint: { type: string, cpType: CheckPointType, skills?: Array<EnglishSkillV1> | null, id: string, testLevel?: { slug: string, name: string, id: string } | null } } | null } }>, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null } } };

export type ViewerExamSeenNotificationMutationVariables = Exact<{
  input: ViewerExamSeenNotificationInput;
}>;


export type ViewerExamSeenNotificationMutation = { viewerExamSeenNotification: { notification?: { id: string, description?: string | null, descriptionEn?: string | null, title?: string | null, titleEn?: string | null, image?: string | null, seen: boolean, type: NotificationType, source: NotificationSource, createdAt: string, meta: { linkExam?: string | null, attemptID?: string | null } } | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type ViewerUnreadNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerUnreadNotificationsCountQuery = { viewerUnreadNotificationsCount?: { flyer: number, partner: number } | null };

export type GetAudioUrlFromTextQueryVariables = Exact<{
  input?: InputMaybe<TextToSpeakInput>;
}>;


export type GetAudioUrlFromTextQuery = { textToSpeak: { url?: string | null, userErrors: Array<{ code: UserErrorCode }> } };

export type DictionaryQueryVariables = Exact<{
  word: Scalars['String']['input'];
}>;


export type DictionaryQuery = { dictionary?: { full?: string | null } | null };

export type ViewerMistakeWordRecordScoreMutationVariables = Exact<{
  input: ViewerMistakeWordRecordScoreInput;
}>;


export type ViewerMistakeWordRecordScoreMutation = { viewerMistakeWordRecordScore: { learnerMistakeWord?: { id: string, isLastScore: boolean, learnerMistakeWordId: string, recordUrl?: string | null, recordScore?: { audioUrl?: string | null, decision: WordDecision, endIndex?: number | null, ipa: string, nativenessScore: number, text: string, phonemes: Array<{ text: string, nativenessScore: number, decision: WordDecision, ipa: string }> } | null, word: { id: string, phonetics: string, text: string, vocabWordId: string } } | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type ViewerMistakeWordsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterBy?: InputMaybe<LearnerMistakeWordFilter>;
}>;


export type ViewerMistakeWordsQuery = { viewerMistakeWords: { totalCount?: number | null, edges: Array<{ node: { id: string, isLastScore: boolean, learnerMistakeWordId: string, recordUrl?: string | null, key: string, recordScore?: { audioUrl?: string | null, decision: WordDecision, endIndex?: number | null, ipa: string, nativenessScore: number, text: string, phonemes: Array<{ text: string, nativenessScore: number, decision: WordDecision, ipa: string }> } | null, word: { id: string, phonetics: string, text: string, vocabWordId: string } } }>, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null } } };

export type ViewerScoreMistakeWordQuotaQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerScoreMistakeWordQuotaQuery = { viewerScoreMistakeWordQuota: { total: number, used: number, remaining: number } };

export type ViewerMistakeWordUpdateMutationVariables = Exact<{
  input: ViewerMistakeWordUpdateInput;
}>;


export type ViewerMistakeWordUpdateMutation = { viewerMistakeWordUpdate: { learnerMistakeWord?: { id: string, isLastScore: boolean, learnerMistakeWordId: string, recordUrl?: string | null, recordScore?: { audioUrl?: string | null, decision: WordDecision, endIndex?: number | null, ipa: string, nativenessScore: number, text: string, phonemes: Array<{ text: string, nativenessScore: number, decision: WordDecision, ipa: string }> } | null, word: { id: string, phonetics: string, text: string, vocabWordId: string } } | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type PracticeStartAttemptMutationVariables = Exact<{
  input: PracticeStartAttemptInput;
}>;


export type PracticeStartAttemptMutation = { practiceStartAttempt: { attemptId?: string | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type PracticeSubmitPartAttemptMutationVariables = Exact<{
  input: PracticeSubmitPartAttemptInput;
}>;


export type PracticeSubmitPartAttemptMutation = { practiceSubmitPartAttempt: { answers?: Array<{ correctOptionIDs?: Array<string> | null, detailId: string, optionIds?: Array<string> | null, text?: string | null }> | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type PracticeEndAttemptMutationVariables = Exact<{
  input: PracticeEndAttemptInput;
}>;


export type PracticeEndAttemptMutation = { practiceEndAttempt: { userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type PracticeUserAttemptQueryVariables = Exact<{
  userAttemptId: Scalars['ID']['input'];
}>;


export type PracticeUserAttemptQuery = { userAttempt?: { id: string, userAttemptId: string, totalMaxScore?: number | null, totalScore?: number | null, executionTime?: string | null, starsEarned?: number | null, accuracy?: number | null, checkPoint?: { id: string, checkPointId: string, name: string, nameEn?: string | null, time?: string | null, practiceParts: Array<{ id: string, practicePartId: string, title?: string | null, answerExplanationHtml?: string | null, answerExplanationHtmlEn?: string | null, mark: number, body: { details: Array<{ id: string, multipleCorrectAnswers: boolean, options: Array<{ id: string, correctAnswer: boolean, text?: string | null, image?: { id: string } | null }> }> } }> } | null, practicePartAttempts: Array<{ id: string, practicePartAttemptId: string, correctMark: number, detailAnswers: Array<{ detailId: string, optionIds?: Array<string> | null, text?: string | null, correctOptionIDs?: Array<string> | null }>, part: { id: string, practicePartId: string } }> } | null };

export type ViewerAiConversationSessionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AiConversationSessionFilter>;
  orderBy?: InputMaybe<AiConversationSessionOrder>;
}>;


export type ViewerAiConversationSessionsQuery = { viewerAiConversationSessions: { totalCount?: number | null, pageInfo: { startCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ cursor: string, node: { id: string, messageCount?: number | null, createdAt: string, totalDuration?: number | null, aiConversationSessionId: string } }> } };

export type ViewerAiConversationSessionCreateMutationVariables = Exact<{
  input: ViewerAiConversationSessionCreateInput;
}>;


export type ViewerAiConversationSessionCreateMutation = { viewerAIConversationSessionCreate: { sessionId?: string | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type ViewerAiConversationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type ViewerAiConversationsQuery = { viewerAIConversations: { pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null }, nodes: Array<{ id: string, message: string, role: AiConversationRole, createdAt: string, aiConversationId: string, learnerProfile: { id: string, learnerProfileId: string } }> } };

export type GetResultReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetResultReportQuery = { userAttempt?: { id: string, userAttemptId: string, submittedAt?: string | null, vocabMistakeResults: Array<string>, executionTime?: string | null, checkPoint?: { id: string, examStructures?: Array<{ structureType: { value: ExamStructureType, name: string }, parts: Array<{ order: number, miniCheckPointId?: string | null, node: { id: string, title: string, maxScore: number } }> }> | null } | null, learnerProfile?: { learnerProfileId: string, displayName: string, avatarUrl?: string | null, frameImage?: { id: string, url: string } | null } | null, testLevel?: { id: string, name: string, slug: string, typeTestLevel?: TypeExamTestLevel | null } | null, examTypeScores?: Array<{ examType: string, totalScore: number, certification?: number | null, totalMaxScore: number }> | null, examStructureAttempts: Array<{ structureType: { name: string, value: ExamStructureType }, partAttempts: Array<{ id: string, maxScore: number, score: number, part: { id: string, examPartId: string } }> }>, resultStatementStructures: Array<{ titleType: { value: ResultStatementTitleType }, statements: Array<{ id: string, comment: { id: string, content: string, contentEn: string } }> }> } | null };

export type CheckPointQueryVariables = Exact<{
  checkPointId: Scalars['ID']['input'];
}>;


export type CheckPointQuery = { checkPoint?: { id: string, checkPointId: string, name: string, nameEn?: string | null, type: string, diamond?: number | null, viewerCanAccess: boolean, testLevel?: { id: string, name: string } | null, speakingParts?: Array<{ id: string, speakingPartId: string, name: string, title: string, partType: SpeakingPartType, position: number, questions: Array<{ id: string, timeToSpeak?: string | null, audioSubtitle?: string | null, audio: { id: string, url: string }, body?: { contentImageId?: string | null, contentHtml?: string | null, images?: Array<{ imageId: string }> | null } | null, bingoAudio?: { id: string, url: string } | null }>, body?: { contentHtml?: string | null, contentImageId?: string | null, images?: Array<{ imageId: string }> | null } | null }> | null } | null };

export type SubmitQuestionAttemptMutationVariables = Exact<{
  input: SpeakingSubmitQuestionAttemptInput;
}>;


export type SubmitQuestionAttemptMutation = { speakingSubmitQuestionAttempt: { __typename: 'SpeakingSubmitQuestionAttemptPayload', userErrors: Array<{ __typename: 'UserError', code: UserErrorCode, message: string }> } };

export type SpeakingEndAttemptMutationVariables = Exact<{
  input: SpeakingEndAttemptInput;
}>;


export type SpeakingEndAttemptMutation = { speakingEndAttempt: { __typename: 'SpeakingEndAttemptPayload', userErrors: Array<{ __typename: 'UserError', code: UserErrorCode, message: string }> } };

export type SpeakingSubmitDiscussionQuestionAttemptMutationVariables = Exact<{
  input: SpeakingSubmitDiscussionQuestionAttemptInput;
}>;


export type SpeakingSubmitDiscussionQuestionAttemptMutation = { speakingSubmitDiscussionQuestionAttempt: { data?: { isEnd: boolean, bingoAudio?: { id: string, url: string } | null } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type SpeakingStartAttemptMutationVariables = Exact<{
  input: SpeakingStartAttemptInput;
}>;


export type SpeakingStartAttemptMutation = { speakingStartAttempt: { attemptId?: string | null, userErrors: Array<{ message: string, field?: Array<string> | null, code: UserErrorCode, param: { value?: string | null } }> } };

export type GetAudioUrlQueryVariables = Exact<{
  input?: InputMaybe<TextToSpeakInput>;
}>;


export type GetAudioUrlQuery = { textToSpeak: { url?: string | null, userErrors: Array<{ code: UserErrorCode }> } };

export type GetStatementResultAttemptQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetStatementResultAttemptQuery = { userAttempt?: { typeAttempt: TypeAttempt, skills?: Array<EnglishSkillV1> | null, vocabMistakeResults: Array<string>, submittedAt?: string | null, requestReview?: RequestReview | null, totalMaxScore?: number | null, totalScore?: number | null, speakingCertification?: number | null, grade?: number | null, maxGrade?: number | null, id: string, learnerProfile?: { learnerProfileId: string, displayName: string, avatarUrl?: string | null, isAnonymous: boolean, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, studentID: string } | null } | null, examStructureAttempts: Array<{ structureType: { name: string, value: ExamStructureType }, ketPetScore?: { overallScore: number, gradeCert?: KetPetGradeCert | null, certLevelInfo?: { name: string, star: number, value: CefrLevel } | null } | null }>, ketPetScore?: { gradeCert?: KetPetGradeCert | null, overallScore: number, certLevelInfo?: { name: string, star: number, value: CefrLevel } | null } | null, testLevel?: { id: string, name: string, testLevelId: string } | null, checkPoint?: { checkPointId: string, id: string, name: string, nameEn?: string | null, type: string } | null } | null };

export type PartnerAssignTestSubmitWritingUpdateMutationVariables = Exact<{
  input: PartnerAssignTestSubmitUpdateInput;
}>;


export type PartnerAssignTestSubmitWritingUpdateMutation = { partnerAssignTestSubmitUpdate: { userErrors: Array<{ code: UserErrorCode }> } };

export type GetScoreWritingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetScoreWritingQuery = { userAttempt?: { requestReview?: RequestReview | null, totalMaxScore?: number | null, totalScore?: number | null, id: string, grade?: number | null, maxGrade?: number | null, learnerProfile?: { displayName: string, avatarUrl?: string | null, isAnonymous: boolean, frameImage?: { id: string, url: string } | null } | null, testLevel?: { id: string, name: string, testLevelId: string, slug: string } | null, checkPoint?: { checkPointId: string, id: string, name: string, nameEn?: string | null, type: string } | null } | null };

export type WritingSubmitPartAttemptMutationVariables = Exact<{
  input: WritingSubmitPartAttemptInput;
}>;


export type WritingSubmitPartAttemptMutation = { writingSubmitPartAttempt: { userErrors: Array<{ message: string, code: UserErrorCode }> } };

export type WritingEndAttemptMutationVariables = Exact<{
  input: WritingEndAttemptInput;
}>;


export type WritingEndAttemptMutation = { writingEndAttempt: { userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type WritingCheckpointQueryVariables = Exact<{
  checkPointId: Scalars['ID']['input'];
}>;


export type WritingCheckpointQuery = { checkPoint?: { id: string, checkPointId: string, viewerCanAccess: boolean, name: string, nameEn?: string | null, time?: string | null, diamond?: number | null, testLevel?: { id: string, name: string, slug: string } | null, writingParts: Array<{ id: string, writingPartId: string, name: string, title?: string | null, time?: string | null, body?: { questionChoices: Array<{ id: string, title: string, position: number, highlightText?: string | null, titleContentHtml?: string | null, contentHtml?: string | null, sampleAnswerHtml?: string | null, images?: Array<{ imageId: string, position: number }> | null }> } | null }> } | null };

export type WritingStartAttemptMutationVariables = Exact<{
  input: WritingStartAttemptInput;
}>;


export type WritingStartAttemptMutation = { writingStartAttempt: { attemptId?: string | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type GetScoreWritingOverviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetScoreWritingOverviewQuery = { userAttempt?: { requestReview?: RequestReview | null, totalMaxScore?: number | null, totalScore?: number | null, id: string, grade?: number | null, maxGrade?: number | null, teacherGrade?: number | null, learnerProfile?: { displayName: string, avatarUrl?: string | null, isAnonymous: boolean, frameImage?: { id: string, url: string } | null } | null, writingKetPetScore?: { gradeCert?: KetPetGradeCert | null, overallScore: number, certLevelInfo?: { name: string, star: number, value: CefrLevel } | null } | null, testLevel?: { id: string, name: string, testLevelId: string, slug: string } | null, checkPoint?: { checkPointId: string, id: string, name: string, nameEn?: string | null, type: string } | null, meta?: { placementTestLevel?: CefrLevel | null } | null } | null };

export type WritingResultCheckpointQueryVariables = Exact<{
  checkPointId: Scalars['ID']['input'];
}>;


export type WritingResultCheckpointQuery = { checkPoint?: { id: string, checkPointId: string, viewerCanAccess: boolean, name: string, nameEn?: string | null, time?: string | null, writingParts: Array<{ id: string, writingPartId: string, name: string, title?: string | null, time?: string | null, body?: { questionChoices: Array<{ id: string, title: string, position: number, highlightText?: string | null, titleContentHtml?: string | null, contentHtml?: string | null, sampleAnswerHtml?: string | null, images?: Array<{ imageId: string, position: number }> | null }> } | null }> } | null };

export type WritingUserAttemptQueryVariables = Exact<{
  userAttemptId: Scalars['ID']['input'];
}>;


export type WritingUserAttemptQuery = { userAttempt?: { id: string, userAttemptId: string, learnerProfile?: { displayName: string, id: string } | null, checkPoint?: { id: string, checkPointId: string, name: string, nameEn?: string | null } | null, writingPartAttempts: Array<{ id: string, answer: string, questionChoiceId?: string | null, wordCount: number, writingPartAttemptId: string, part: { id: string, writingPartId: string } }> } | null };

export type UserAttemptQueryVariables = Exact<{
  userAttemptId: Scalars['ID']['input'];
}>;


export type UserAttemptQuery = { userAttempt?: { id: string, userAttemptId: string, teacherComment?: string | null, submittedAt?: string | null, requestReview?: RequestReview | null, grade?: number | null, maxGrade?: number | null, teacherGrade?: number | null, ketPetScore?: { gradeCert?: KetPetGradeCert | null, overallScore: number, certLevelInfo?: { name: string, star: number, value: CefrLevel } | null } | null, writingPartAttempts: Array<{ id: string, answer: string, writingPartAttemptId: string, wordCount: number, teacherWordCount?: number | null, teacherFixedAnswer?: unknown | null, questionChoiceId?: string | null, markingCriteria?: Array<{ band?: number | null, commentary?: string | null, criteria?: WritingCriteria | null }> | null, markingOverall?: { commentary?: string | null, mistakes?: string | null, score?: number | null, suggestions?: string | null } | null, teacherCommentsAnswer?: Array<{ content: string, id: string, quote: string }> | null, part: { id: string, writingPartId: string, title?: string | null, name: string, body?: { questionChoices: Array<{ id: string, title: string, titleContentHtml?: string | null, sampleAnswerHtml?: string | null, highlightText?: string | null, contentHtml?: string | null, position: number, images?: Array<{ imageId: string }> | null }> } | null } }>, checkPoint?: { id: string, checkPointId: string, name: string, nameEn?: string | null, writingParts: Array<{ id: string, writingPartId: string, title?: string | null, body?: { questionChoices: Array<{ id: string, contentHtml?: string | null, highlightText?: string | null, sampleAnswerHtml?: string | null, title: string, titleContentHtml?: string | null, images?: Array<{ imageId: string }> | null }> } | null }> } | null, learnerProfile?: { displayName: string, id: string, avatarUrl?: string | null, classStudent?: { classID: string, class?: { id: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null } | null, testLevel?: { id: string, name: string, slug: string } | null } | null };

export type PartnerDomainQueryQueryVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type PartnerDomainQueryQuery = { partnerDomain?: { id: string } | null };

export type CheckoutBankListPaymentCreateVnpUrlMutationVariables = Exact<{
  input: PaymentCreateVnpUrlInput;
}>;


export type CheckoutBankListPaymentCreateVnpUrlMutation = { paymentCreateVNPUrl: { url?: string | null } };

export type TeacherReferralCodeExistsQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type TeacherReferralCodeExistsQuery = { teacherReferralCodeExists: boolean };

export type CheckDiscountQueryQueryVariables = Exact<{
  amount: Scalars['Float']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckDiscountQueryQuery = { discount?: { price?: number | null, discount?: { id: string, discountId: string, discountType: DiscountDiscountType, maxDiscount?: number | null, status: DiscountStatus, amount: number, code: string } | null } | null };

export type PartnerPackagesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PartnerPackagesQuery = { partnerPackages: { edges: Array<{ node: { amount: number, amountDeposit: number, enabled: boolean, id: string, isShowing: boolean, name: string, partnerPackageId: string, title: string, titleEn: string } }> } };

export type ViewerAiConversationCompleteMutationVariables = Exact<{
  input: ViewerAiConversationCompleteInput;
}>;


export type ViewerAiConversationCompleteMutation = { viewerAIConversationComplete: { systemText?: string | null, systemAudio?: string | null, userMessageId?: string | null, visemes?: Array<{ endTime?: number | null, phoneme?: string | null, startTime?: number | null, types?: Array<number> | null } | null> | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type ConversationTextToSpeakQueryVariables = Exact<{
  input?: InputMaybe<TextToSpeakInput>;
}>;


export type ConversationTextToSpeakQuery = { textToSpeak: { url?: string | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type ViewerAiConversationUpdateMutationVariables = Exact<{
  input: ViewerAiConversationUpdateInput;
}>;


export type ViewerAiConversationUpdateMutation = { viewerAIConversationUpdate: { aiConversation?: { id: string } | null, userErrors: Array<{ code: UserErrorCode, message: string }> } };

export type CheckoutBankListPaymentListBankVnpQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckoutBankListPaymentListBankVnpQuery = { paymentListBankVNP: { data?: Array<{ bankCode?: string | null, bankName?: string | null, logoLink?: string | null, bankType?: number | null, displayOrder?: number | null } | null> | null } };

export type GetVnpayPaymentQueryVariables = Exact<{
  txnRef: Scalars['ID']['input'];
}>;


export type GetVnpayPaymentQuery = { vnpayPayment?: { txnRef: string, status: VnpayPaymentStatus, id: string, userName?: string | null } | null };

export type ViewerUserAttemptsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterBy?: InputMaybe<UserAttemptFilter>;
}>;


export type ViewerUserAttemptsQuery = { viewerUserAttempts: { totalCount?: number | null, edges: Array<{ cursor: string, node: { id: string, userAttemptId: string, submittedAt?: string | null, skills?: Array<EnglishSkillV1> | null, grade?: number | null, teacherGrade?: number | null, partAttemptsCount: number, maxGrade?: number | null, executionTime?: string | null, typeAttempt: TypeAttempt, totalScore?: number | null, totalMaxScore?: number | null, cefrLevelInfo?: { name: string, value: CefrLevel } | null, challenge?: { id: string, code: string } | null, checkPoint?: { id: string, checkPointId: string, name: string, nameEn?: string | null, partsCount: number, type: string } | null, testLevel?: { id: string, name: string, typeTestLevel?: TypeExamTestLevel | null, slug: string } | null } }>, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null } } };

export type PageInfoFragment = { endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null };

export type ViewerUserAttemptsForReportQueryVariables = Exact<{
  filterBy?: InputMaybe<UserAttemptFilter>;
}>;


export type ViewerUserAttemptsForReportQuery = { viewerUserAttemptsForReport: { nodes: Array<{ id: string, userAttemptId: string, submittedAt?: string | null, checkPoint?: { id: string, name: string, nameEn?: string | null } | null, testLevel?: { id: string, name: string, slug: string } | null }> } };

export type ViewerGetVersionNotificationUpdateQueryVariables = Exact<{
  appType: AppTypeMobile;
}>;


export type ViewerGetVersionNotificationUpdateQuery = { versionNotification?: { appType: AppTypeMobile, contentHTML: string, contentHTMLEn: string, id: string, status: Status, version: string, versionNotificationId: string, videoId?: string | null, image?: { id: string, url: string } | null } | null };

export type ViewerRemindTaskQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerRemindTaskQuery = { viewerRemindTask?: { totalRedoTask: number, totalUnfinishTask: number, checkPoint?: { type: string, cpType: CheckPointType, skills?: Array<EnglishSkillV1> | null, id: string, testLevel?: { slug: string, name: string, id: string } | null } | null, assignTest?: { id: string, checkPoint: { type: string, cpType: CheckPointType, skills?: Array<EnglishSkillV1> | null, id: string, testLevel?: { slug: string, name: string, id: string } | null } } | null } | null };

export type IeltsUserAttemptSpeakingReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IeltsUserAttemptSpeakingReportQuery = { userAttempt?: { id: string, userAttemptId: string, grade?: number | null, teacherGrade?: number | null, teacherComment?: string | null, requestReview?: RequestReview | null, submittedAt?: string | null, teacherCommentAudio?: { id: string, url: string } | null, checkPoint?: { id: string, name: string, nameEn?: string | null, levels: Array<CefrLevel>, position: number, checkPointIeltsSpeakingParts: Array<{ node: { id: string, info: { id: string, title: string }, ieltsSpeakingPartQuestions: Array<{ position: number, node: { id: string, title: string, contentHtml: string, sampleAnswerHtml: string, audio: { id: string, url: string }, sampleAnswerAudio?: { id: string, url: string } | null } }> } }> } | null, ieltsSpeakingRecordScore?: { coherence: number, fluency: number, grammar: number, overall: number, pronunciation: number, transcript?: string | null, vocab: number, fluencyDecision: WordDecision, pronunciationDecision: WordDecision, grammarDecision: WordDecision, vocabDecision: WordDecision } | null, ieltsSpeakingPartAttempts?: Array<{ id: string, part: { id: string }, questionAttempts: Array<{ transcriptionRecord?: string | null, teacherComment?: unknown | null, id: string, teacherCommentDetails: Array<{ content: string, quote: string, id: string }>, teacherCommentAudio?: { id: string, url: string } | null, recordScore?: { coherence: number, fluency: number, grammar: number, overall: number, pronunciation: number, transcript?: string | null, vocab: number, fluencyDecision: WordDecision, pronunciationDecision: WordDecision, grammarDecision: WordDecision, vocabDecision: WordDecision, highlightWords?: Array<{ text: string, decision: WordDecision, ipa: string, nativenessScore: number, audioUrl?: string | null, startIndex?: number | null, endIndex?: number | null, phonemes: Array<{ text: string, ipa: string, decision: WordDecision, audioUrl?: string | null, nativenessScore: number, startIndex?: number | null, endIndex?: number | null, phonemes: Array<{ text: string, ipa: string, decision: WordDecision, audioUrl?: string | null, nativenessScore: number }> }> }> | null } | null, record: { id: string, url: string }, question: { id: string } }> }> | null, learnerProfile?: { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null } | null };

export type PronunciationWordFragment = { text: string, decision: WordDecision, ipa: string, nativenessScore: number, audioUrl?: string | null, startIndex?: number | null, endIndex?: number | null, phonemes: Array<{ text: string, ipa: string, decision: WordDecision, audioUrl?: string | null, nativenessScore: number }> };

export type IeltsUserAttemptQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IeltsUserAttemptQueryQuery = { userAttempt?: { id: string, grade?: number | null, userAttemptId: string, requestReview?: RequestReview | null, totalScore?: number | null, learnerProfile?: { id: string, displayName: string } | null, checkPoint?: { id: string, name: string, nameEn?: string | null, checkPointId: string } | null } | null };

export type StudyStartAttemptMutationVariables = Exact<{
  input: DuolingoStartAttemptInput;
}>;


export type StudyStartAttemptMutation = { duolingoStartAttempt: { attemptId?: string | null, userErrors: Array<{ code: UserErrorCode, message: string, field?: Array<string> | null, param: { value?: string | null } }> } };

export type LessonCheckPointTestLevelQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LessonCheckPointTestLevelQueryQuery = { checkPoint?: { id: string, name: string, checkPointId: string, testLevel?: { id: string, name: string, slug: string } | null } | null };

export type GetScoreSpeakingAiQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetScoreSpeakingAiQuery = { userAttempt?: { requestReview?: RequestReview | null, totalMaxScore?: number | null, totalScore?: number | null, speakingCertification?: number | null, id: string, grade?: number | null, maxGrade?: number | null, learnerProfile?: { displayName: string, avatarUrl?: string | null, isAnonymous: boolean, frameImage?: { id: string, url: string } | null } | null, meta?: { placementTestLevel?: CefrLevel | null, speakingKetPetScore?: { gradeCert?: KetPetGradeCert | null, overallScore: number, certLevelInfo?: { name: string } | null } | null } | null, testLevel?: { id: string, name: string, testLevelId: string, slug: string } | null, checkPoint?: { checkPointId: string, id: string, name: string, nameEn?: string | null, type: string } | null } | null };

export type SpeakingAttemptResultQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SpeakingAttemptResultQuery = { userAttempt?: { id: string, userAttemptId: string, speakingCertification?: number | null, grade?: number | null, maxGrade?: number | null, totalScore?: number | null, totalMaxScore?: number | null, requestReview?: RequestReview | null, teacherComment?: string | null, teacherGrade?: number | null, submittedAt?: string | null, teacherCommentAudio?: { id: string, url: string } | null, learnerProfile?: { avatarUrl?: string | null, displayName: string, learnerProfileId: string, frameImage?: { id: string, url: string } | null } | null, testLevel?: { id: string, testLevelId: string, name: string, slug: string } | null, checkPoint?: { id: string, checkPointId: string, name: string, nameEn?: string | null, type: string, checkPointSpeakingParts: Array<{ order: number, position: number, node: { id: string, speakingPartId: string, name: string, title: string, partType: SpeakingPartType, position: number, body?: { contentImageId?: string | null, candidateImageId?: string | null, examinerImageId?: string | null, candidateSheet?: { title: string, sheets: Array<{ title: string, value: string, position: number }> } | null, examinerSheet?: { title: string, sheets: Array<{ title: string, value: string, position: number }> } | null, images?: Array<{ imageId: string, position: number, top?: string | null, left?: string | null, width?: string | null, height?: string | null }> | null, placeholders?: Array<{ id: string, imageId?: string | null, position: number, top: string, left: string, width: string, height: string }> | null, points?: Array<{ id: string, left: string, top: string, position: number }> | null } | null, questions: Array<{ bingoAudioSubtitle?: string | null, id: string, audioSubtitle?: string | null, needsScore: boolean, answerImageId?: string | null, answerPlaceholderId?: string | null, groupPosition?: number | null, position: number, bingoAudio?: { id: string, url: string } | null, audio: { id: string }, body?: { contentHtml?: string | null, contentImageId?: string | null, images?: Array<{ imageId: string, position: number }> | null } | null }> } }> } | null, speakingRecordScore?: { pronunciationScore: number, vocabularyGrammarScore: number, interactionScore: number, overallScore: number, vocabularyGrammarScorePercent: number, interactionScorePercent: number, coherenceScore: number, vocabulary: { answerKeyScore: number, score: number, decision: WordDecision, cefrScore?: number | null, cefrDistribution?: Array<{ cefrLevel: string, score: number }> | null, highlightKeywords?: Array<{ startIndex: number, endIndex: number, keyword: string }> | null }, grammar: { messages?: Array<string> | null, score: number, decision: WordDecision, highlightItems?: Array<{ suggestion: string, startIndex: number, original: string, endIndex: number }> | null }, pronunciation: { generalScore?: number | null, intonationScore?: number | null, score: number, decision: WordDecision, highlightWords?: Array<{ startIndex?: number | null, endIndex?: number | null, text: string, ipa: string, nativenessScore: number, decision: WordDecision, audioUrl?: string | null, phonemes: Array<{ startIndex?: number | null, endIndex?: number | null, text: string, ipa: string, nativenessScore: number, decision: WordDecision }> }> | null }, interaction: { receptionResponding: number, fluencyPromptness: number, fluencyDecision: WordDecision, receptionDecision: WordDecision, fluency: { wordsPerMinute?: number | null } }, coherence?: { decision: WordDecision, score: number } | null } | null, speakingAzureScore?: { vocabularyScore?: number | null, vocabularyGrammarTotalScore?: number | null, vocabularyGrammarScore?: number | null, totalScore?: number | null, prosodyScore?: number | null, pronunciationScore?: number | null, pronScore?: number | null, interactionScore?: number | null, grammarScore?: number | null, fluencyScore?: number | null, wordPerMinute?: number | null } | null, speakingQuestionAttempts: Array<{ id: string, placeholderId?: string | null, isCorrect?: boolean | null, transcriptionRecord?: string | null, teacherComment?: string | null, question: { id: string }, part: { id: string, speakingPartId: string }, record?: { id: string } | null, image?: { id: string } | null, teacherAudioAnswer?: { url: string } | null, discussions: Array<{ id: string, audioSubtitle?: string | null, role: SpeakingQuestionDiscussionAttemptRole, speakingQuestionAttemptDiscussionId: string, audio: { id: string, url: string }, recordScore?: { transcript?: string | null, vocabularyGrammarScore: number, pronunciationScore: number, interactionScore: number, vocabularyGrammarScorePercent: number, vocabularyGrammarDecision: WordDecision, interactionScorePercent: number, overallScore: number, coherenceScore: number, suggestions?: Array<{ audioId?: string | null, id: string, text: string }> | null, coherence?: { decision: WordDecision, score: number } | null, vocabulary: { answerKeyScore: number, score: number, decision: WordDecision, cefrScore?: number | null, cefrDistribution?: Array<{ cefrLevel: string, score: number }> | null, highlightKeywords?: Array<{ startIndex: number, endIndex: number, keyword: string }> | null }, grammar: { score: number, decision: WordDecision, highlightItems?: Array<{ startIndex: number, endIndex: number, original: string, suggestion: string }> | null }, pronunciation: { generalScore?: number | null, intonationScore?: number | null, score: number, decision: WordDecision, highlightWords?: Array<{ startIndex?: number | null, endIndex?: number | null, text: string, ipa: string, nativenessScore: number, decision: WordDecision, audioUrl?: string | null, phonemes: Array<{ startIndex?: number | null, endIndex?: number | null, text: string, ipa: string, nativenessScore: number, decision: WordDecision }> }> | null }, interaction: { receptionResponding: number, fluencyPromptness: number, receptionDecision: WordDecision, fluencyDecision: WordDecision, fluency: { wordsPerMinute?: number | null } } } | null }>, azureRecordScore?: { microsoftScore?: { displayText?: string | null, duration?: number | null, recognitionStatus?: string | null, offset?: number | null, nBest?: Array<{ itn?: string | null, lexical?: string | null, pronunciationAssessment?: { accuracyScore?: number | null, pronScore?: number | null, prosodyScore?: number | null, fluencyScore?: number | null } | null, words?: Array<{ word?: string | null, confidence?: number | null, duration?: number | null, decision?: WordDecision | null, phonemes?: Array<{ duration?: number | null, decision?: WordDecision | null, phoneme?: string | null, pronunciationAssessment?: { accuracyScore?: number | null } | null } | null> | null } | null> | null } | null> | null } | null, cambridgeAssessment?: { grammarScore?: number | null, vocabularyScore?: number | null, mistakesEn?: Array<string | null> | null, mistakesVi?: Array<string | null> | null, suggestions?: Array<string | null> | null } | null } | null, recordScore?: { transcript?: string | null, vocabularyGrammarScore: number, pronunciationScore: number, interactionScore: number, vocabularyGrammarScorePercent: number, vocabularyGrammarDecision: WordDecision, interactionScorePercent: number, overallScore: number, coherenceScore: number, suggestions?: Array<{ audioId?: string | null, id: string, text: string }> | null, coherence?: { decision: WordDecision, score: number } | null, vocabulary: { answerKeyScore: number, score: number, decision: WordDecision, cefrScore?: number | null, cefrDistribution?: Array<{ cefrLevel: string, score: number }> | null, highlightKeywords?: Array<{ startIndex: number, endIndex: number, keyword: string }> | null }, grammar: { score: number, decision: WordDecision, highlightItems?: Array<{ startIndex: number, endIndex: number, original: string, suggestion: string }> | null }, pronunciation: { generalScore?: number | null, intonationScore?: number | null, score: number, decision: WordDecision, highlightWords?: Array<{ startIndex?: number | null, endIndex?: number | null, text: string, ipa: string, nativenessScore: number, decision: WordDecision, audioUrl?: string | null, phonemes: Array<{ startIndex?: number | null, endIndex?: number | null, text: string, ipa: string, nativenessScore: number, decision: WordDecision }> }> | null }, interaction: { receptionResponding: number, fluencyPromptness: number, receptionDecision: WordDecision, fluencyDecision: WordDecision, fluency: { wordsPerMinute?: number | null } } } | null }> } | null };

export type GetResultCheckPointQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetResultCheckPointQuery = { userAttempt?: { id: string, totalMaxScore?: number | null, totalScore?: number | null, userAttemptId: string, submittedAt?: string | null, executionTime?: string | null, higherScorePercent: number, learnerSeenReward: boolean, coinsEarned?: number | null, starsEarned?: number | null, learnerProfile?: { id: string, learnerProfileId: string, displayName: string, isAnonymous: boolean, streakData?: { currentStreak?: { endDate: string, startDate: string, count: number } | null } | null } | null, ketPetScore?: { overallScore: number } | null, cefrLevelInfo?: { name: string, value: CefrLevel } | null, challenge?: { id: string, code: string } | null, testLevel?: { id: string, testLevelId: string, typeTestLevel?: TypeExamTestLevel | null, name: string, slug: string } | null, examTypeScores?: Array<{ examType: string, totalScore: number, certification?: number | null, totalMaxScore: number }> | null, checkPoint?: { id: string, checkPointId: string, name: string, nameEn?: string | null, type: string } | null } | null };

export type ViewerUserAttemptSeenRewardMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewerUserAttemptSeenRewardMutationMutation = { viewerUserAttemptSeenReward: { userAttempt?: { id: string, learnerSeenReward: boolean } | null, userErrors: Array<{ code: UserErrorCode, field?: Array<string> | null, message: string, param: { value?: string | null } }> } };

export type AuthProviderCreateAnonymousLearnerProfileMutationMutationVariables = Exact<{
  input: ViewerCreateLearnerProfileInput;
}>;


export type AuthProviderCreateAnonymousLearnerProfileMutationMutation = { viewerCreateLearnerProfile: { learnerProfile?: { id: string } | null, userErrors: Array<{ message: string, code: UserErrorCode, field?: Array<string> | null, param: { value?: string | null } }> } };

export type AuthProviderUpdateAnonymousLearnerProfileMutationMutationVariables = Exact<{
  input: ViewerUpdateLearnerProfileInput;
}>;


export type AuthProviderUpdateAnonymousLearnerProfileMutationMutation = { viewerUpdateLearnerProfile: { learnerProfile?: { id: string } | null, userErrors: Array<{ message: string, code: UserErrorCode, field?: Array<string> | null, param: { value?: string | null } }> } };

export type LearnerProfileFragment = { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null };

export type ViewerFragment = { email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, countryCode: string, adminRole?: UserAdminRole | null, id: string, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, id: string, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } };

export type AuthProviderViewerSessionQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthProviderViewerSessionQueryQuery = { viewerSession: { viewer?: { email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, countryCode: string, adminRole?: UserAdminRole | null, id: string, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, id: string, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } } | null, loginSession?: { active: boolean, createdAt: string, id: string, userAgent: { summary: string }, deactivatedBySession?: { active: boolean, createdAt: string, id: string, userAgent: { summary: string } } | null } | null } };

export type AuthProviderViewerLogOutMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type AuthProviderViewerLogOutMutationMutation = { viewerLogOut: { userErrors: Array<{ code: UserErrorCode }> } };

export type AuthProviderViewerSwitchLearnerProfileMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AuthProviderViewerSwitchLearnerProfileMutationMutation = { viewerSwitchLearnerProfile: { viewer?: { email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, countryCode: string, adminRole?: UserAdminRole | null, id: string, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, lang?: string | null, coin: number, star: number, placementLevel?: CefrLevel | null, id: string, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string, school: { id: string, schoolId: string } } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean, disabledStudentChangeName?: boolean | null }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, lastPlacementTest?: { id: string, userAttemptId: string, grade?: number | null, checkPoint?: { id: string, checkPointId: string, name: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, id: string, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } } | null, userErrors: Array<{ code: UserErrorCode }> } };

export type AuthProviderViewerSessionEventSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AuthProviderViewerSessionEventSubscription = { viewerSessionEvent: { event: ViewerSessionEventType } };

export type CheckIpQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckIpQuery = { checkIp?: { ip?: string | null, country?: string | null, countryCode?: string | null, timezone?: string | null } | null };

export type AuthProviderViewerInProgressAssignedTestsV2QueryVariables = Exact<{ [key: string]: never; }>;


export type AuthProviderViewerInProgressAssignedTestsV2Query = { viewerInProgressAssignedTestsV2: { totalCount?: number | null } };

export const UserErrorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UserErrorFragment, unknown>;
export const TestLevelCheckPointFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestLevelCheckPoint"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPoint"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewerCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"isPremium"}},{"kind":"Field","name":{"kind":"Name","value":"partsCount"}},{"kind":"Field","name":{"kind":"Name","value":"testCount"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"viewerIsSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"speakingParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"speakingPartId"}},{"kind":"Field","name":{"kind":"Name","value":"partType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<TestLevelCheckPointFragment, unknown>;
export const RecordScoreGrammarFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecordScoreGrammar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordScoreGrammar"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messages"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"highlightItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestion"}},{"kind":"Field","name":{"kind":"Name","value":"startIndex"}},{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}}]}}]}}]} as unknown as DocumentNode<RecordScoreGrammarFragment, unknown>;
export const RecordScoreVocabularyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecordScoreVocabulary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordScoreVocabulary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerKeyScore"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"cefrScore"}},{"kind":"Field","name":{"kind":"Name","value":"cefrDistribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cefrLevel"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}},{"kind":"Field","name":{"kind":"Name","value":"highlightKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startIndex"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"keyword"}}]}}]}}]} as unknown as DocumentNode<RecordScoreVocabularyFragment, unknown>;
export const RecordScorePronunciationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecordScorePronunciation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordScorePronunciation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalScore"}},{"kind":"Field","name":{"kind":"Name","value":"intonationScore"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"highlightWords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startIndex"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phonemes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startIndex"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}}]}}]}}]}}]} as unknown as DocumentNode<RecordScorePronunciationFragment, unknown>;
export const RecordScoreAttemptFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecordScoreAttemptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordScore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audioId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vocabularyGrammarScore"}},{"kind":"Field","name":{"kind":"Name","value":"pronunciationScore"}},{"kind":"Field","name":{"kind":"Name","value":"interactionScore"}},{"kind":"Field","name":{"kind":"Name","value":"vocabularyGrammarScorePercent"}},{"kind":"Field","name":{"kind":"Name","value":"vocabularyGrammarDecision"}},{"kind":"Field","name":{"kind":"Name","value":"interactionScorePercent"}},{"kind":"Field","name":{"kind":"Name","value":"pronunciationScore"}},{"kind":"Field","name":{"kind":"Name","value":"interactionScore"}},{"kind":"Field","name":{"kind":"Name","value":"overallScore"}},{"kind":"Field","name":{"kind":"Name","value":"coherence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coherenceScore"}},{"kind":"Field","name":{"kind":"Name","value":"vocabulary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RecordScoreVocabulary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grammar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"highlightItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startIndex"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"suggestion"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pronunciation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RecordScorePronunciation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"interaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receptionResponding"}},{"kind":"Field","name":{"kind":"Name","value":"fluencyPromptness"}},{"kind":"Field","name":{"kind":"Name","value":"receptionDecision"}},{"kind":"Field","name":{"kind":"Name","value":"fluencyDecision"}},{"kind":"Field","name":{"kind":"Name","value":"fluency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wordsPerMinute"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecordScoreVocabulary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordScoreVocabulary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerKeyScore"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"cefrScore"}},{"kind":"Field","name":{"kind":"Name","value":"cefrDistribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cefrLevel"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}},{"kind":"Field","name":{"kind":"Name","value":"highlightKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startIndex"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"keyword"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecordScorePronunciation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordScorePronunciation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalScore"}},{"kind":"Field","name":{"kind":"Name","value":"intonationScore"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"highlightWords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startIndex"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phonemes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startIndex"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}}]}}]}}]}}]} as unknown as DocumentNode<RecordScoreAttemptFragmentFragment, unknown>;
export const AzureRecordScoreFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AzureRecordScoreFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AzureRecordScore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"microsoftScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"nBest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pronunciationAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accuracyScore"}},{"kind":"Field","name":{"kind":"Name","value":"pronScore"}},{"kind":"Field","name":{"kind":"Name","value":"prosodyScore"}},{"kind":"Field","name":{"kind":"Name","value":"fluencyScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itn"}},{"kind":"Field","name":{"kind":"Name","value":"lexical"}},{"kind":"Field","name":{"kind":"Name","value":"words"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"word"}},{"kind":"Field","name":{"kind":"Name","value":"confidence"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"phonemes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"phoneme"}},{"kind":"Field","name":{"kind":"Name","value":"pronunciationAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accuracyScore"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recognitionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cambridgeAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grammarScore"}},{"kind":"Field","name":{"kind":"Name","value":"vocabularyScore"}},{"kind":"Field","name":{"kind":"Name","value":"mistakesEn"}},{"kind":"Field","name":{"kind":"Name","value":"mistakesVi"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions"}}]}}]}}]} as unknown as DocumentNode<AzureRecordScoreFragmentFragment, unknown>;
export const IeltsSpeakingQuestionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IeltsSpeakingQuestion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IeltsSpeakingQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sampleAnswerHtml"}},{"kind":"Field","name":{"kind":"Name","value":"sampleAnswerAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeToSpeak"}},{"kind":"Field","name":{"kind":"Name","value":"timeToThink"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentHtml"}},{"kind":"Field","name":{"kind":"Name","value":"ieltsSpeakingQuestionId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<IeltsSpeakingQuestionFragment, unknown>;
export const TestLevelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestLevel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TestLevel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistId"}},{"kind":"Field","name":{"kind":"Name","value":"typeTestLevel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TestLevelFragment, unknown>;
export const ExamCheckPointFullFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExamCheckPointFull"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPoint"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"cpType"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listeningTime"}},{"kind":"Field","name":{"kind":"Name","value":"speakingTime"}},{"kind":"Field","name":{"kind":"Name","value":"writingTime"}},{"kind":"Field","name":{"kind":"Name","value":"readingTime"}},{"kind":"Field","name":{"kind":"Name","value":"examStructures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"structureType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"examPartId"}},{"kind":"Field","name":{"kind":"Name","value":"totalMarks"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHTML"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHTMLEn"}},{"kind":"Field","name":{"kind":"Name","value":"partType"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentImageId"}},{"kind":"Field","name":{"kind":"Name","value":"contentImagePrompt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isExample"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHTML"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHTMLEn"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"audioId"}},{"kind":"Field","name":{"kind":"Name","value":"point"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"left"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"top"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audioSubtitle"}},{"kind":"Field","name":{"kind":"Name","value":"videoPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"exampleAnswers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labelOrder"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textIndexes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"left"}},{"kind":"Field","name":{"kind":"Name","value":"top"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"titlePrefix"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"detailPrefix"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"choices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"structureType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"miniCheckPointId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalMarks"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionCheckPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentStructureType"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"parentPartOrder"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestLevel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TestLevel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistId"}},{"kind":"Field","name":{"kind":"Name","value":"typeTestLevel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExamCheckPointFullFragment, unknown>;
export const ExamPartAttemptFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExamPartAttempt"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExamPartAttempt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"examPartAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"part"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"examPartId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partType"}},{"kind":"Field","name":{"kind":"Name","value":"structureType"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"questionDetailAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"examQuestionDetailAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}}]}}]}}]}}]} as unknown as DocumentNode<ExamPartAttemptFragment, unknown>;
export const ExamStructureAttemptsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExamStructureAttempts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExamStructureAttempt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCorrectMarks"}},{"kind":"Field","name":{"kind":"Name","value":"structureType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExamPartAttempt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExamPartAttempt"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExamPartAttempt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"examPartAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"part"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"examPartId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partType"}},{"kind":"Field","name":{"kind":"Name","value":"structureType"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"questionDetailAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"examQuestionDetailAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}}]}}]}}]}}]} as unknown as DocumentNode<ExamStructureAttemptsFragment, unknown>;
export const PracticePartFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PracticePartFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PracticePart"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"practicePartId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHtml"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHtmlEn"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentHtml"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"multipleCorrectAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"correctAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PracticePartFragmentFragment, unknown>;
export const TestCardItemCheckPointFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestCardItemCheckPointFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPoint"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"viewerIsSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"isPremium"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partTypesInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExamPartTypeInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpeakingPartTypeInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<TestCardItemCheckPointFragmentFragment, unknown>;
export const TestCardItemAssignTestFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestCardItemAssignTestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssignTest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"assignTestId"}},{"kind":"Field","name":{"kind":"Name","value":"teacherProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]} as unknown as DocumentNode<TestCardItemAssignTestFragmentFragment, unknown>;
export const PageInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]} as unknown as DocumentNode<PageInfoFragment, unknown>;
export const PronunciationWordFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PronunciationWord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PronunciationWord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"startIndex"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"phonemes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}}]}}]}}]} as unknown as DocumentNode<PronunciationWordFragment, unknown>;
export const LearnerProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<LearnerProfileFragment, unknown>;
export const ViewerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerFragment, unknown>;
export const TestLevelBySlugQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TestLevelBySlugQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testLevelBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestLevel"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestLevel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TestLevel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistId"}},{"kind":"Field","name":{"kind":"Name","value":"typeTestLevel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TestLevelBySlugQueryQuery, TestLevelBySlugQueryQueryVariables>;
export const TestLevelQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TestLevelQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}}]}}]}}]} as unknown as DocumentNode<TestLevelQueryQuery, TestLevelQueryQueryVariables>;
export const GetListThemesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListThemes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ThemeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"themes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"themeId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"bookOneId"}},{"kind":"Field","name":{"kind":"Name","value":"bookTwoId"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundId"}},{"kind":"Field","name":{"kind":"Name","value":"bingoId"}},{"kind":"Field","name":{"kind":"Name","value":"progressId"}},{"kind":"Field","name":{"kind":"Name","value":"iconLeftId"}},{"kind":"Field","name":{"kind":"Name","value":"iconRightId"}},{"kind":"Field","name":{"kind":"Name","value":"blockLeft"}},{"kind":"Field","name":{"kind":"Name","value":"blockRight"}},{"kind":"Field","name":{"kind":"Name","value":"progressColor"}},{"kind":"Field","name":{"kind":"Name","value":"iconPrevId"}},{"kind":"Field","name":{"kind":"Name","value":"iconNextId"}},{"kind":"Field","name":{"kind":"Name","value":"borderProgress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"imagePreviewId"}},{"kind":"Field","name":{"kind":"Name","value":"imageTitleId"}},{"kind":"Field","name":{"kind":"Name","value":"iconZoomId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetListThemesQuery, GetListThemesQueryVariables>;
export const CheckPointsFullQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckPointsFullQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPointFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"checkPoints"},"name":{"kind":"Name","value":"checkPointsFull"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"EnumValue","value":"TEST_LEVEL_ORDER"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestLevelCheckPoint"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestLevelCheckPoint"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPoint"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewerCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"isPremium"}},{"kind":"Field","name":{"kind":"Name","value":"partsCount"}},{"kind":"Field","name":{"kind":"Name","value":"testCount"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"viewerIsSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"speakingParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"speakingPartId"}},{"kind":"Field","name":{"kind":"Name","value":"partType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<CheckPointsFullQueryQuery, CheckPointsFullQueryQueryVariables>;
export const MoreInfoCheckPointQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MoreInfoCheckPointQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"cpType"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"examStructures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"structureType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionCheckPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentStructureType"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"parentPartOrder"}}]}}]}}]}}]} as unknown as DocumentNode<MoreInfoCheckPointQueryQuery, MoreInfoCheckPointQueryQueryVariables>;
export const CheckPointIeltsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckPointIeltsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"cpType"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"sectionCheckPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentStructureType"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"parentPartOrder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkPointIeltsSpeakingParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expiredTime"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"defaultShowQuestionContents"}},{"kind":"Field","name":{"kind":"Name","value":"info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"introductionAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"introductionText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ieltsSpeakingPartQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IeltsSpeakingQuestion"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IeltsSpeakingQuestion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IeltsSpeakingQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sampleAnswerHtml"}},{"kind":"Field","name":{"kind":"Name","value":"sampleAnswerAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeToSpeak"}},{"kind":"Field","name":{"kind":"Name","value":"timeToThink"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentHtml"}},{"kind":"Field","name":{"kind":"Name","value":"ieltsSpeakingQuestionId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<CheckPointIeltsQueryQuery, CheckPointIeltsQueryQueryVariables>;
export const TestLevelsWithFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TestLevelsWithFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TestLevelFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testLevels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestLevel"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestLevel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TestLevel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistId"}},{"kind":"Field","name":{"kind":"Name","value":"typeTestLevel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TestLevelsWithFilterQuery, TestLevelsWithFilterQueryVariables>;
export const SubmitExamQuestionDetailMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitExamQuestionDetailMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExamSubmitPartAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"examSubmitPartAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<SubmitExamQuestionDetailMutationMutation, SubmitExamQuestionDetailMutationMutationVariables>;
export const SignUpViewSignUpMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignUpViewSignUpMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerSignUpInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerSignUp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Viewer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}}]} as unknown as DocumentNode<SignUpViewSignUpMutationMutation, SignUpViewSignUpMutationMutationVariables>;
export const ViewerXpSummariesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerXpSummaries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerXpFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerXpSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerXpId"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerXpSummariesQuery, ViewerXpSummariesQueryVariables>;
export const GetPlayersInfoChallengeByCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlayersInfoChallengeByCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"challengeByCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"challengeId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"players"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"250"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"challengePlayerId"}},{"kind":"Field","name":{"kind":"Name","value":"joinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attempt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPlayersInfoChallengeByCodeQuery, GetPlayersInfoChallengeByCodeQueryVariables>;
export const ViewerAchievementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerAchievements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerAchievements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerAchievementId"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seen"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"dateReceived"}},{"kind":"Field","name":{"kind":"Name","value":"nextLevelValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxLevel"}}]}}]}}]} as unknown as DocumentNode<ViewerAchievementsQuery, ViewerAchievementsQueryVariables>;
export const ViewerSeenAchievementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerSeenAchievements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerSeenAchievementInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerSeenAchievements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerSeenAchievementsMutation, ViewerSeenAchievementsMutationVariables>;
export const ExamDomainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExamDomain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerDomain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domain"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureTitle"}},{"kind":"Field","name":{"kind":"Name","value":"featureDescription"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loginTitle"}},{"kind":"Field","name":{"kind":"Name","value":"logoImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"examBackgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"examLogoImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExamDomainQuery, ExamDomainQueryVariables>;
export const ChallengeEndDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChallengeEnd"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChallengeEndInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"challengeEnd"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ChallengeEndMutation, ChallengeEndMutationVariables>;
export const GetInfoCheckpointDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInfoCheckpointDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"challengeCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"challengeCodeResume"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isChallengeMode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExamCheckPointFull"}},{"kind":"Field","name":{"kind":"Name","value":"viewerLatestResumableAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"challengeCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"challengeCodeResume"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentExamPart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"examPartId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentStructure"}},{"kind":"Field","name":{"kind":"Name","value":"currentSectionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"examStructureAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExamStructureAttempts"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"challengeByCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"challengeCode"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isChallengeMode"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"challengeId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isLimit"}},{"kind":"Field","name":{"kind":"Name","value":"isHiddenName"}},{"kind":"Field","name":{"kind":"Name","value":"endAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestLevel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TestLevel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistId"}},{"kind":"Field","name":{"kind":"Name","value":"typeTestLevel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExamPartAttempt"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExamPartAttempt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"examPartAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"part"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"examPartId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partType"}},{"kind":"Field","name":{"kind":"Name","value":"structureType"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"questionDetailAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"examQuestionDetailAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExamCheckPointFull"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPoint"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"cpType"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listeningTime"}},{"kind":"Field","name":{"kind":"Name","value":"speakingTime"}},{"kind":"Field","name":{"kind":"Name","value":"writingTime"}},{"kind":"Field","name":{"kind":"Name","value":"readingTime"}},{"kind":"Field","name":{"kind":"Name","value":"examStructures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"structureType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"examPartId"}},{"kind":"Field","name":{"kind":"Name","value":"totalMarks"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHTML"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHTMLEn"}},{"kind":"Field","name":{"kind":"Name","value":"partType"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentImageId"}},{"kind":"Field","name":{"kind":"Name","value":"contentImagePrompt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isExample"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHTML"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHTMLEn"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"audioId"}},{"kind":"Field","name":{"kind":"Name","value":"point"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"left"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"top"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audioSubtitle"}},{"kind":"Field","name":{"kind":"Name","value":"videoPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"exampleAnswers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labelOrder"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textIndexes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"left"}},{"kind":"Field","name":{"kind":"Name","value":"top"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"titlePrefix"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"detailPrefix"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"choices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"structureType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"miniCheckPointId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalMarks"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionCheckPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentStructureType"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"parentPartOrder"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExamStructureAttempts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExamStructureAttempt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCorrectMarks"}},{"kind":"Field","name":{"kind":"Name","value":"structureType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExamPartAttempt"}}]}}]}}]} as unknown as DocumentNode<GetInfoCheckpointDetailQuery, GetInfoCheckpointDetailQueryVariables>;
export const GetResultUserAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResultUserAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExamCheckPointFull"}}]}},{"kind":"Field","name":{"kind":"Name","value":"examStructureAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExamStructureAttempts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestLevel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TestLevel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistId"}},{"kind":"Field","name":{"kind":"Name","value":"typeTestLevel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExamPartAttempt"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExamPartAttempt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"examPartAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"part"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"examPartId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partType"}},{"kind":"Field","name":{"kind":"Name","value":"structureType"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"questionDetailAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"examQuestionDetailAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExamCheckPointFull"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPoint"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"cpType"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listeningTime"}},{"kind":"Field","name":{"kind":"Name","value":"speakingTime"}},{"kind":"Field","name":{"kind":"Name","value":"writingTime"}},{"kind":"Field","name":{"kind":"Name","value":"readingTime"}},{"kind":"Field","name":{"kind":"Name","value":"examStructures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"structureType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"examPartId"}},{"kind":"Field","name":{"kind":"Name","value":"totalMarks"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHTML"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHTMLEn"}},{"kind":"Field","name":{"kind":"Name","value":"partType"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentImageId"}},{"kind":"Field","name":{"kind":"Name","value":"contentImagePrompt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isExample"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHTML"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHTMLEn"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"audioId"}},{"kind":"Field","name":{"kind":"Name","value":"point"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"left"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"top"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audioSubtitle"}},{"kind":"Field","name":{"kind":"Name","value":"videoPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"exampleAnswers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labelOrder"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textIndexes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"left"}},{"kind":"Field","name":{"kind":"Name","value":"top"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"titlePrefix"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"detailPrefix"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"choices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metadataText"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"structureType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"miniCheckPointId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalMarks"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionCheckPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentStructureType"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"parentPartOrder"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExamStructureAttempts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExamStructureAttempt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCorrectMarks"}},{"kind":"Field","name":{"kind":"Name","value":"structureType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExamPartAttempt"}}]}}]}}]} as unknown as DocumentNode<GetResultUserAttemptQuery, GetResultUserAttemptQueryVariables>;
export const ExamEndMobilePlacementestMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExamEndMobilePlacementestMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExamEndAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"examEndAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExamEndMobilePlacementestMutationMutation, ExamEndMobilePlacementestMutationMutationVariables>;
export const PracticeCheckPointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PracticeCheckPoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checkPointId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checkPointId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"skills"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"practiceParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PracticePartFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PracticePartFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PracticePart"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"practicePartId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHtml"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHtmlEn"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentHtml"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"multipleCorrectAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"correctAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PracticeCheckPointQuery, PracticeCheckPointQueryVariables>;
export const PracticeAttemptReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PracticeAttemptReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttemptId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttemptId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"totalMaxScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"skills"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"practiceParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PracticePartFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practicePartAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"part"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"practicePartId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practicePartAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"correctMark"}},{"kind":"Field","name":{"kind":"Name","value":"detailAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"optionIds"}},{"kind":"Field","name":{"kind":"Name","value":"detailId"}},{"kind":"Field","name":{"kind":"Name","value":"correctOptionIDs"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PracticePartFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PracticePart"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"practicePartId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHtml"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHtmlEn"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentHtml"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"multipleCorrectAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"correctAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PracticeAttemptReviewQuery, PracticeAttemptReviewQueryVariables>;
export const ViewerAiConversationSessionDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerAiConversationSessionDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aiConversationSessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AIConversationFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AIConversationOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerAiConversationSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"aiConversationSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aiConversationSessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiConversationSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"messageCount"}},{"kind":"Field","name":{"kind":"Name","value":"aiConversations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiConversationId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ViewerAiConversationSessionDetailQuery, ViewerAiConversationSessionDetailQueryVariables>;
export const GetInfoCheckpointDetailSeoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInfoCheckpointDetailSEO"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetInfoCheckpointDetailSeoQuery, GetInfoCheckpointDetailSeoQueryVariables>;
export const LearnerProfileCreateLearnerProfileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LearnerProfileCreateLearnerProfileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerCreateLearnerProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerCreateLearnerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"switchProfile"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Viewer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}}]} as unknown as DocumentNode<LearnerProfileCreateLearnerProfileMutationMutation, LearnerProfileCreateLearnerProfileMutationMutationVariables>;
export const ChangePasswordModalUpdatePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePasswordModalUpdatePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerUpdatePasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerUpdatePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangePasswordModalUpdatePasswordMutation, ChangePasswordModalUpdatePasswordMutationVariables>;
export const ViewerRecoverPasswordMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerRecoverPasswordMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerRecoverPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerRecoverPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}},{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ViewerRecoverPasswordMutationMutation, ViewerRecoverPasswordMutationMutationVariables>;
export const AuthTokenValidQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthTokenValidQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifierType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IdentifierType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authTokenValid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"identifierType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifierType"}}},{"kind":"Argument","name":{"kind":"Name","value":"tokenType"},"value":{"kind":"EnumValue","value":"FIREBASE"}}]}]}}]} as unknown as DocumentNode<AuthTokenValidQueryQuery, AuthTokenValidQueryQueryVariables>;
export const ViewerUpdateEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerUpdateEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerUpdateEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerUpdateEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Viewer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}}]} as unknown as DocumentNode<ViewerUpdateEmailMutation, ViewerUpdateEmailMutationVariables>;
export const ProfileFormUpdateLearnerProfileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProfileFormUpdateLearnerProfileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerUpdateLearnerProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerUpdateLearnerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Viewer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}}]} as unknown as DocumentNode<ProfileFormUpdateLearnerProfileMutationMutation, ProfileFormUpdateLearnerProfileMutationMutationVariables>;
export const ViewerLearnerProfileStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerLearnerProfileStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerLearnerProfileStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accuracy"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"timeRemainingToCompleteLevel"}},{"kind":"Field","name":{"kind":"Name","value":"studyStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"today"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedTests"}},{"kind":"Field","name":{"kind":"Name","value":"studyTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"last7days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedTests"}},{"kind":"Field","name":{"kind":"Name","value":"studyTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"last30days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedTests"}},{"kind":"Field","name":{"kind":"Name","value":"studyTime"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ViewerLearnerProfileStatsQuery, ViewerLearnerProfileStatsQueryVariables>;
export const LearnerProfileFormViewCreateLearnerProfileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LearnerProfileFormViewCreateLearnerProfileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerCreateLearnerProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerCreateLearnerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"switchProfile"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Viewer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}}]} as unknown as DocumentNode<LearnerProfileFormViewCreateLearnerProfileMutationMutation, LearnerProfileFormViewCreateLearnerProfileMutationMutationVariables>;
export const LearnerProfileFormViewUpdateLearnerProfileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LearnerProfileFormViewUpdateLearnerProfileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerUpdateLearnerProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerUpdateLearnerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Viewer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}}]} as unknown as DocumentNode<LearnerProfileFormViewUpdateLearnerProfileMutationMutation, LearnerProfileFormViewUpdateLearnerProfileMutationMutationVariables>;
export const ViewerJoinClassDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerJoinClass"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerJoinClassInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerJoinClass"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerJoinClassMutation, ViewerJoinClassMutationVariables>;
export const ViewerLeftClassDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerLeftClass"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"classId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerLeftClass"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"classId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"classId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classStudentId"}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerLeftClassMutation, ViewerLeftClassMutationVariables>;
export const LoginViewLogInWithPasswordMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginViewLogInWithPasswordMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerLogInWithPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerLogIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"withPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Viewer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}}]} as unknown as DocumentNode<LoginViewLogInWithPasswordMutationMutation, LoginViewLogInWithPasswordMutationMutationVariables>;
export const RecoverViewRecoverPasswordMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecoverViewRecoverPasswordMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerRecoverPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerRecoverPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Viewer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}}]} as unknown as DocumentNode<RecoverViewRecoverPasswordMutationMutation, RecoverViewRecoverPasswordMutationMutationVariables>;
export const VerifyAccountViewVerifyOwnerByEmailTokenMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyAccountViewVerifyOwnerByEmailTokenMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerVerifyOwnerByEmailToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tokenType"},"value":{"kind":"EnumValue","value":"FIREBASE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"identifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Viewer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}}]} as unknown as DocumentNode<VerifyAccountViewVerifyOwnerByEmailTokenMutationMutation, VerifyAccountViewVerifyOwnerByEmailTokenMutationMutationVariables>;
export const VerifyAccountViewForceLogInByEmailTokenMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyAccountViewForceLogInByEmailTokenMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerForceLogInByEmailTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerForceLogInByEmailToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Viewer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}}]} as unknown as DocumentNode<VerifyAccountViewForceLogInByEmailTokenMutationMutation, VerifyAccountViewForceLogInByEmailTokenMutationMutationVariables>;
export const GoogleLoginButtonLoginMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GoogleLoginButtonLoginMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerLogInWithFirebaseEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerLogIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"withFirebaseEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Viewer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"providerInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isFirstLogin"}},{"kind":"Field","name":{"kind":"Name","value":"needEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"associatedPhoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}}]} as unknown as DocumentNode<GoogleLoginButtonLoginMutationMutation, GoogleLoginButtonLoginMutationMutationVariables>;
export const OtpInputSendOtpMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OtpInputSendOtpMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerSendOtpInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerSendOtp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OtpInputSendOtpMutationMutation, OtpInputSendOtpMutationMutationVariables>;
export const OtpInputIdentifierExistsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OtpInputIdentifierExistsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifierExists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"identifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}}}]}]}}]} as unknown as DocumentNode<OtpInputIdentifierExistsQueryQuery, OtpInputIdentifierExistsQueryQueryVariables>;
export const PhoneInputCountryCodesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PhoneInputCountryCodesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"isoCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCodeId"}}]}}]}}]} as unknown as DocumentNode<PhoneInputCountryCodesQueryQuery, PhoneInputCountryCodesQueryQueryVariables>;
export const PartnerAssignTestSubmitUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"partnerAssignTestSubmitUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PartnerAssignTestSubmitUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerAssignTestSubmitUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<PartnerAssignTestSubmitUpdateMutation, PartnerAssignTestSubmitUpdateMutationVariables>;
export const AvatarFramesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvatarFrames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AvatarFrameFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAvatarFramesFirst2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAvatarFramesFilterBy2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserAvatarFrameFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarFrames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"avatarFrameId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"userAvatarFrames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAvatarFramesFirst2"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAvatarFramesFilterBy2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarFrame"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AvatarFramesQuery, AvatarFramesQueryVariables>;
export const AvatarFrameUpdateLearnerProfileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AvatarFrameUpdateLearnerProfileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerUpdateLearnerProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerUpdateLearnerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AvatarFrameUpdateLearnerProfileMutationMutation, AvatarFrameUpdateLearnerProfileMutationMutationVariables>;
export const ViewerBuyAvatarFrameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerBuyAvatarFrame"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerBuyAvatarFrameInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerBuyAvatarFrame"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarFrame"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarFrameId"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerBuyAvatarFrameMutation, ViewerBuyAvatarFrameMutationVariables>;
export const ViewerTeacherInvitationAcceptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerTeacherInvitationAccept"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerTeacherInvitationAcceptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerTeacherInvitationAccept"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerTeacherInvitationAcceptMutation, ViewerTeacherInvitationAcceptMutationVariables>;
export const TeacherInvitedLearnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeacherInvitedLearner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teacherInvitedLearnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teacherInvitedLearner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teacherInvitedLearnerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invitedClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerAcceptedInvitation"}},{"kind":"Field","name":{"kind":"Name","value":"teacher"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TeacherInvitedLearnerQuery, TeacherInvitedLearnerQueryVariables>;
export const ViewerJoinClassModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerJoinClassModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerJoinClassInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerJoinClass"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerJoinClassModalMutation, ViewerJoinClassModalMutationVariables>;
export const ViewerGetClassNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerGetClassName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"classCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerGetClassName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"classCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"classCode"}}}]}]}}]} as unknown as DocumentNode<ViewerGetClassNameQuery, ViewerGetClassNameQueryVariables>;
export const CheckPointsPlacementTestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckPointsPlacementTest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPointFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPointOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"domains"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CheckPointsPlacementTestQuery, CheckPointsPlacementTestQueryVariables>;
export const PlacementTestGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlacementTestGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placementTestGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"domains"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<PlacementTestGroupsQuery, PlacementTestGroupsQueryVariables>;
export const LessonCheckPointQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LessonCheckPointQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointDuolingoParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"duolingoPartId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"expiredTime"}},{"kind":"Field","name":{"kind":"Name","value":"challenge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"choices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"audioId"}},{"kind":"Field","name":{"kind":"Name","value":"correctPlaceholderId"}},{"kind":"Field","name":{"kind":"Name","value":"unselectable"}},{"kind":"Field","name":{"kind":"Name","value":"top"}},{"kind":"Field","name":{"kind":"Name","value":"left"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"correctPlaceholderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pairs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"prompts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slowAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showCharacter"}},{"kind":"Field","name":{"kind":"Name","value":"tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isBlank"}},{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hint"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"imagePlaceholders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"top"}},{"kind":"Field","name":{"kind":"Name","value":"left"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zoomedImageId"}},{"kind":"Field","name":{"kind":"Name","value":"imageAudioId"}},{"kind":"Field","name":{"kind":"Name","value":"imageContent"}},{"kind":"Field","name":{"kind":"Name","value":"imageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"textSolutions"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"story"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"elements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showCharacter"}},{"kind":"Field","name":{"kind":"Name","value":"tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isBlank"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hint"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"textSolutions"}},{"kind":"Field","name":{"kind":"Name","value":"choices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unselectable"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]} as unknown as DocumentNode<LessonCheckPointQueryQuery, LessonCheckPointQueryQueryVariables>;
export const DuolingoSubmitPartAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuolingoSubmitPartAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DuolingoSubmitPartAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duolingoSubmitPartAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"challenge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"choice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correctPlaceholderId"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"choices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correctPlaceholderId"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DuolingoSubmitPartAttemptMutation, DuolingoSubmitPartAttemptMutationVariables>;
export const DuolingoEndAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuolingoEndAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DuolingoEndAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duolingoEndAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DuolingoEndAttemptMutation, DuolingoEndAttemptMutationVariables>;
export const ViewerDuolingoPathsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerDuolingoPaths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerDuolingoPaths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"totalLevels"}},{"kind":"Field","name":{"kind":"Name","value":"completedLevels"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"units"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextCheckPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"totalSessions"}},{"kind":"Field","name":{"kind":"Name","value":"completedSessions"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ViewerDuolingoPathsQuery, ViewerDuolingoPathsQueryVariables>;
export const UserAttemptLessonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserAttemptLesson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttemptId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttemptId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"accuracy"}},{"kind":"Field","name":{"kind":"Name","value":"starsEarned"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"testLevelId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cpType"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duolingoPartAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"part"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"duolingoPartId"}},{"kind":"Field","name":{"kind":"Name","value":"challenge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textSolutions"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"pairs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"choices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prompts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showCharacter"}},{"kind":"Field","name":{"kind":"Name","value":"tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isBlank"}},{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hint"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"duolingoPartAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"isFirstScore"}},{"kind":"Field","name":{"kind":"Name","value":"challengeAnswer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}},{"kind":"Field","name":{"kind":"Name","value":"pair"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audioId"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audioId"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"choice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserAttemptLessonQuery, UserAttemptLessonQueryVariables>;
export const GetAttemptLessonStudyModeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAttemptLessonStudyMode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttemptId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttemptId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"accuracy"}},{"kind":"Field","name":{"kind":"Name","value":"starsEarned"}}]}}]}}]} as unknown as DocumentNode<GetAttemptLessonStudyModeQuery, GetAttemptLessonStudyModeQueryVariables>;
export const ExamStartAttemptMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExamStartAttemptMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExamStartAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"examStartAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attemptId"}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExamStartAttemptMutationMutation, ExamStartAttemptMutationMutationVariables>;
export const ExamSubmitPartAttemptMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExamSubmitPartAttemptMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExamSubmitPartAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"examSubmitPartAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExamSubmitPartAttemptMutationMutation, ExamSubmitPartAttemptMutationMutationVariables>;
export const ExamEndAttemptMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExamEndAttemptMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExamEndAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"examEndAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExamEndAttemptMutationMutation, ExamEndAttemptMutationMutationVariables>;
export const ExamNextStructureMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExamNextStructureMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExamNextStructureInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"examNextStructure"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ExamNextStructureMutationMutation, ExamNextStructureMutationMutationVariables>;
export const ChallengeCheckPointsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChallengeCheckPointsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPointFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"EnumValue","value":"TYPE_POSITION"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<ChallengeCheckPointsQueryQuery, ChallengeCheckPointsQueryQueryVariables>;
export const TestLevelChallengeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"testLevelChallenge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TestLevelFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testLevels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<TestLevelChallengeQuery, TestLevelChallengeQueryVariables>;
export const ExamStartAttemptMobilePlacementTestMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExamStartAttemptMobilePlacementTestMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExamStartAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"examStartAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attemptId"}},{"kind":"Field","name":{"kind":"Name","value":"resumableAttempt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentSectionExpiresAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExamStartAttemptMobilePlacementTestMutationMutation, ExamStartAttemptMobilePlacementTestMutationMutationVariables>;
export const ExamMobilePlacementTestNextStructureMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExamMobilePlacementTestNextStructureMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExamNextStructureInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"examNextStructure"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ExamMobilePlacementTestNextStructureMutationMutation, ExamMobilePlacementTestNextStructureMutationMutationVariables>;
export const GetCurrentRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerCurrentSchoolRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"partnerRolePermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentRoleQuery, GetCurrentRoleQueryVariables>;
export const TestLevelListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TestLevelList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TestLevelFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testLevels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"levels"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}}]}}]}}]}}]} as unknown as DocumentNode<TestLevelListQuery, TestLevelListQueryVariables>;
export const GetInfoChallengeByCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInfoChallengeByCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"challengeByCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"challengeId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isHiddenName"}},{"kind":"Field","name":{"kind":"Name","value":"isLimit"}},{"kind":"Field","name":{"kind":"Name","value":"isMixed"}},{"kind":"Field","name":{"kind":"Name","value":"isEnableSound"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"endAt"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanStart"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"players"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attempt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"isPremium"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"examStructures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalMarks"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"structureType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInfoChallengeByCodeQuery, GetInfoChallengeByCodeQueryVariables>;
export const GetDataChallengeByCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDataChallengeByCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"challengeByCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"challengeId"}},{"kind":"Field","name":{"kind":"Name","value":"challengeInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accuracy"}},{"kind":"Field","name":{"kind":"Name","value":"answerCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"answerWrong"}},{"kind":"Field","name":{"kind":"Name","value":"totalQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"totalStudent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isHiddenName"}},{"kind":"Field","name":{"kind":"Name","value":"isLimit"}},{"kind":"Field","name":{"kind":"Name","value":"isMixed"}},{"kind":"Field","name":{"kind":"Name","value":"isEnableSound"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"endAt"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanStart"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"isPremium"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"testCount"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"examStructures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalMarks"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"structureType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partType"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isExample"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<GetDataChallengeByCodeQuery, GetDataChallengeByCodeQueryVariables>;
export const LearnerChallengeRanksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LearnerChallengeRanks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"challengeCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerChallengeRanks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"challengeCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"challengeCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerChallengeRankId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attemptInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerWrong"}},{"kind":"Field","name":{"kind":"Name","value":"answerCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"percentAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"totalQuestion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"examStructureAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalCorrectMarks"}},{"kind":"Field","name":{"kind":"Name","value":"totalIncorrectMarks"}},{"kind":"Field","name":{"kind":"Name","value":"totalMarks"}},{"kind":"Field","name":{"kind":"Name","value":"partAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questionDetailAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]}}]}}]} as unknown as DocumentNode<LearnerChallengeRanksQuery, LearnerChallengeRanksQueryVariables>;
export const ViewerAdviceCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerAdviceCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerAdviceCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerAdviceCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adviceId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerAdviceCreateMutation, ViewerAdviceCreateMutationVariables>;
export const GetCheckPointsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCheckPoints"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPointFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"key"},"name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<GetCheckPointsQuery, GetCheckPointsQueryVariables>;
export const TestLevelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TestLevel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TestLevelFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testLevels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<TestLevelQuery, TestLevelQueryVariables>;
export const IeltsSpeakingCheckPointsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IeltsSpeakingCheckPointsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ieltsSpeakingCheckPoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointIeltsSpeakingParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"ieltsSpeakingPartQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"viewerIeltsCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"viewerIeltsStar"}},{"kind":"Field","name":{"kind":"Name","value":"isBoss"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<IeltsSpeakingCheckPointsQueryQuery, IeltsSpeakingCheckPointsQueryQueryVariables>;
export const IeltsSpeakingEndAttemptMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IeltsSpeakingEndAttemptMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IeltsSpeakingEndAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ieltsSpeakingEndAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IeltsSpeakingEndAttemptMutationMutation, IeltsSpeakingEndAttemptMutationMutationVariables>;
export const IeltsSpeakingSubmitQuestionAttemptMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IeltsSpeakingSubmitQuestionAttemptMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IeltsSpeakingSubmitQuestionAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ieltsSpeakingSubmitQuestionAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IeltsSpeakingSubmitQuestionAttemptMutationMutation, IeltsSpeakingSubmitQuestionAttemptMutationMutationVariables>;
export const IeltsSpeakingStartAttemptMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IeltsSpeakingStartAttemptMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IeltsSpeakingStartAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ieltsSpeakingStartAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attemptId"}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IeltsSpeakingStartAttemptMutationMutation, IeltsSpeakingStartAttemptMutationMutationVariables>;
export const TeacherProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeacherProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teacherProfileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teacherProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teacherProfileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<TeacherProfileQuery, TeacherProfileQueryVariables>;
export const GetTeacherProfileDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeacherProfileDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teacherProfileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teacherProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teacherProfileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetTeacherProfileDetailQuery, GetTeacherProfileDetailQueryVariables>;
export const ViewerInProgressAssignedTestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerInProgressAssignedTests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignTestProfileFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerInProgressAssignedTestsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignTestProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"redoing"}},{"kind":"Field","name":{"kind":"Name","value":"submitted"}},{"kind":"Field","name":{"kind":"Name","value":"assignTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestCardItemAssignTestFragment"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestCardItemCheckPointFragment"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestCardItemAssignTestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssignTest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"assignTestId"}},{"kind":"Field","name":{"kind":"Name","value":"teacherProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestCardItemCheckPointFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPoint"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"viewerIsSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"isPremium"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partTypesInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExamPartTypeInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpeakingPartTypeInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerInProgressAssignedTestsQuery, ViewerInProgressAssignedTestsQueryVariables>;
export const ViewerAssignedTestUserAttemptsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerAssignedTestUserAttempts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerAssignedTestUserAttempts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestCardItemAssignTestFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestCardItemCheckPointFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestCardItemAssignTestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssignTest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"assignTestId"}},{"kind":"Field","name":{"kind":"Name","value":"teacherProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestCardItemCheckPointFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPoint"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"viewerIsSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"isPremium"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partTypesInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExamPartTypeInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpeakingPartTypeInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerAssignedTestUserAttemptsQuery, ViewerAssignedTestUserAttemptsQueryVariables>;
export const TestContentCheckPointsByCefrLevelOverviewQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TestContentCheckPointsByCefrLevelOverviewQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limitPerLevel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPointFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"testLevelFilterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TestLevelFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPointsByCefrLevelOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limitPerLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limitPerLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"testLevelFilterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"testLevelFilterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cefrLevelInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"star"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"testLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"key"},"name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestCardItemCheckPointFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestCardItemCheckPointFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPoint"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"viewerIsSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"isPremium"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partTypesInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExamPartTypeInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpeakingPartTypeInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<TestContentCheckPointsByCefrLevelOverviewQueryQuery, TestContentCheckPointsByCefrLevelOverviewQueryQueryVariables>;
export const TestContentCheckPointsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TestContentCheckPointsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPointFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"key"},"name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestCardItemCheckPointFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestCardItemCheckPointFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPoint"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"viewerIsSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"isPremium"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partTypesInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExamPartTypeInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpeakingPartTypeInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<TestContentCheckPointsQueryQuery, TestContentCheckPointsQueryQueryVariables>;
export const ViewerActiveCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerActiveCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerActiveCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerActiveCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerActiveCodeMutation, ViewerActiveCodeMutationVariables>;
export const DailyRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DailyRewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dailyRewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"dailyRewardId"}},{"kind":"Field","name":{"kind":"Name","value":"dayNumber"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewerClaimed"}}]}}]}}]} as unknown as DocumentNode<DailyRewardsQuery, DailyRewardsQueryVariables>;
export const ViewerDailyRewardClaimDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerDailyRewardClaim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerDailyRewardClaim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dailyReward"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewerClaimed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerDailyRewardClaimMutation, ViewerDailyRewardClaimMutationVariables>;
export const ViewerExamFloatNotificationQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerExamFloatNotificationQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerExamNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkExam"}},{"kind":"Field","name":{"kind":"Name","value":"attemptID"}},{"kind":"Field","name":{"kind":"Name","value":"challengeCode"}},{"kind":"Field","name":{"kind":"Name","value":"teacherInvitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invitationId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"assignTestId"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cpType"}},{"kind":"Field","name":{"kind":"Name","value":"skills"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"seen"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ViewerExamFloatNotificationQueryQuery, ViewerExamFloatNotificationQueryQueryVariables>;
export const ViewerExamSeenNotificationMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerExamSeenNotificationMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerExamSeenNotificationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerExamSeenNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerExamSeenNotificationMutationMutation, ViewerExamSeenNotificationMutationMutationVariables>;
export const CountNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerUnreadNotificationsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"floatSeen"}},{"kind":"Field","name":{"kind":"Name","value":"partner"}},{"kind":"Field","name":{"kind":"Name","value":"flyer"}}]}}]}}]} as unknown as DocumentNode<CountNotificationQuery, CountNotificationQueryVariables>;
export const ViewerExamNotificationQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerExamNotificationQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerExamNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkExam"}},{"kind":"Field","name":{"kind":"Name","value":"attemptID"}},{"kind":"Field","name":{"kind":"Name","value":"challengeCode"}},{"kind":"Field","name":{"kind":"Name","value":"teacherInvitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invitationId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"seen"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"assignTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"assignTestId"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cpType"}},{"kind":"Field","name":{"kind":"Name","value":"skills"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"typeNotification"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerExamNotificationQueryQuery, ViewerExamNotificationQueryQueryVariables>;
export const ViewerExamSeenNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerExamSeenNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerExamSeenNotificationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerExamSeenNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkExam"}},{"kind":"Field","name":{"kind":"Name","value":"attemptID"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"seen"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerExamSeenNotificationMutation, ViewerExamSeenNotificationMutationVariables>;
export const ViewerUnreadNotificationsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerUnreadNotificationsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerUnreadNotificationsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyer"}},{"kind":"Field","name":{"kind":"Name","value":"partner"}}]}}]}}]} as unknown as DocumentNode<ViewerUnreadNotificationsCountQuery, ViewerUnreadNotificationsCountQueryVariables>;
export const GetAudioUrlFromTextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAudioUrlFromText"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TextToSpeakInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textToSpeak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetAudioUrlFromTextQuery, GetAudioUrlFromTextQueryVariables>;
export const DictionaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Dictionary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"word"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"word"},"value":{"kind":"Variable","name":{"kind":"Name","value":"word"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full"}}]}}]}}]} as unknown as DocumentNode<DictionaryQuery, DictionaryQueryVariables>;
export const ViewerMistakeWordRecordScoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerMistakeWordRecordScore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerMistakeWordRecordScoreInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerMistakeWordRecordScore"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerMistakeWord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLastScore"}},{"kind":"Field","name":{"kind":"Name","value":"recordScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"phonemes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerMistakeWordId"}},{"kind":"Field","name":{"kind":"Name","value":"recordUrl"}},{"kind":"Field","name":{"kind":"Name","value":"word"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phonetics"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"vocabWordId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerMistakeWordRecordScoreMutation, ViewerMistakeWordRecordScoreMutationVariables>;
export const ViewerMistakeWordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"viewerMistakeWords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerMistakeWordFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerMistakeWords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"key"},"name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLastScore"}},{"kind":"Field","name":{"kind":"Name","value":"recordScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"phonemes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerMistakeWordId"}},{"kind":"Field","name":{"kind":"Name","value":"recordUrl"}},{"kind":"Field","name":{"kind":"Name","value":"word"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phonetics"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"vocabWordId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ViewerMistakeWordsQuery, ViewerMistakeWordsQueryVariables>;
export const ViewerScoreMistakeWordQuotaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerScoreMistakeWordQuota"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerScoreMistakeWordQuota"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"used"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}}]}}]}}]} as unknown as DocumentNode<ViewerScoreMistakeWordQuotaQuery, ViewerScoreMistakeWordQuotaQueryVariables>;
export const ViewerMistakeWordUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerMistakeWordUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerMistakeWordUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerMistakeWordUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerMistakeWord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLastScore"}},{"kind":"Field","name":{"kind":"Name","value":"recordScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"phonemes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerMistakeWordId"}},{"kind":"Field","name":{"kind":"Name","value":"recordUrl"}},{"kind":"Field","name":{"kind":"Name","value":"word"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phonetics"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"vocabWordId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerMistakeWordUpdateMutation, ViewerMistakeWordUpdateMutationVariables>;
export const PracticeStartAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PracticeStartAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PracticeStartAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"practiceStartAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attemptId"}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PracticeStartAttemptMutation, PracticeStartAttemptMutationVariables>;
export const PracticeSubmitPartAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PracticeSubmitPartAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PracticeSubmitPartAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"practiceSubmitPartAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correctOptionIDs"}},{"kind":"Field","name":{"kind":"Name","value":"detailId"}},{"kind":"Field","name":{"kind":"Name","value":"optionIds"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PracticeSubmitPartAttemptMutation, PracticeSubmitPartAttemptMutationVariables>;
export const PracticeEndAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PracticeEndAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PracticeEndAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"practiceEndAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PracticeEndAttemptMutation, PracticeEndAttemptMutationVariables>;
export const PracticeUserAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PracticeUserAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttemptId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttemptId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"practiceParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"practicePartId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHtml"}},{"kind":"Field","name":{"kind":"Name","value":"answerExplanationHtmlEn"}},{"kind":"Field","name":{"kind":"Name","value":"mark"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"multipleCorrectAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"correctAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practicePartAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"practicePartAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"correctMark"}},{"kind":"Field","name":{"kind":"Name","value":"detailAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"detailId"}},{"kind":"Field","name":{"kind":"Name","value":"optionIds"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"correctOptionIDs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"part"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"practicePartId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalMaxScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"executionTime"}},{"kind":"Field","name":{"kind":"Name","value":"starsEarned"}},{"kind":"Field","name":{"kind":"Name","value":"accuracy"}}]}}]}}]} as unknown as DocumentNode<PracticeUserAttemptQuery, PracticeUserAttemptQueryVariables>;
export const ViewerAiConversationSessionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerAiConversationSessions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AIConversationSessionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AIConversationSessionOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerAiConversationSessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messageCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalDuration"}},{"kind":"Field","name":{"kind":"Name","value":"aiConversationSessionId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ViewerAiConversationSessionsQuery, ViewerAiConversationSessionsQueryVariables>;
export const ViewerAiConversationSessionCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerAIConversationSessionCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerAIConversationSessionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerAIConversationSessionCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerAiConversationSessionCreateMutation, ViewerAiConversationSessionCreateMutationVariables>;
export const ViewerAiConversationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerAIConversations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerAIConversations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"aiConversationId"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerAiConversationsQuery, ViewerAiConversationsQueryVariables>;
export const GetResultReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResultReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"examStructures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"structureType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"miniCheckPointId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vocabMistakeResults"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"typeTestLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"executionTime"}},{"kind":"Field","name":{"kind":"Name","value":"examTypeScores"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"examType"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"certification"}},{"kind":"Field","name":{"kind":"Name","value":"totalMaxScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"examStructureAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"structureType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"maxScore"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"part"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"examPartId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"resultStatementStructures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"contentEn"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetResultReportQuery, GetResultReportQueryVariables>;
export const CheckPointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checkPoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checkPointId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checkPointId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"speakingParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"speakingPartId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partType"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeToSpeak"}},{"kind":"Field","name":{"kind":"Name","value":"audioSubtitle"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentImageId"}},{"kind":"Field","name":{"kind":"Name","value":"contentHtml"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bingoAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentHtml"}},{"kind":"Field","name":{"kind":"Name","value":"contentImageId"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]} as unknown as DocumentNode<CheckPointQuery, CheckPointQueryVariables>;
export const SubmitQuestionAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"submitQuestionAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpeakingSubmitQuestionAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"speakingSubmitQuestionAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<SubmitQuestionAttemptMutation, SubmitQuestionAttemptMutationVariables>;
export const SpeakingEndAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"speakingEndAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpeakingEndAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"speakingEndAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<SpeakingEndAttemptMutation, SpeakingEndAttemptMutationVariables>;
export const SpeakingSubmitDiscussionQuestionAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"speakingSubmitDiscussionQuestionAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpeakingSubmitDiscussionQuestionAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"speakingSubmitDiscussionQuestionAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bingoAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isEnd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SpeakingSubmitDiscussionQuestionAttemptMutation, SpeakingSubmitDiscussionQuestionAttemptMutationVariables>;
export const SpeakingStartAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SpeakingStartAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpeakingStartAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"speakingStartAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attemptId"}}]}}]}}]} as unknown as DocumentNode<SpeakingStartAttemptMutation, SpeakingStartAttemptMutationVariables>;
export const GetAudioUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAudioUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TextToSpeakInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textToSpeak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetAudioUrlQuery, GetAudioUrlQueryVariables>;
export const GetStatementResultAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStatementResultAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"studentID"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"examStructureAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"structureType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ketPetScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overallScore"}},{"kind":"Field","name":{"kind":"Name","value":"certLevelInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gradeCert"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"typeAttempt"}},{"kind":"Field","name":{"kind":"Name","value":"skills"}},{"kind":"Field","name":{"kind":"Name","value":"vocabMistakeResults"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"requestReview"}},{"kind":"Field","name":{"kind":"Name","value":"totalMaxScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"ketPetScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"certLevelInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gradeCert"}},{"kind":"Field","name":{"kind":"Name","value":"overallScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"speakingCertification"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"testLevelId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}}]}}]}}]} as unknown as DocumentNode<GetStatementResultAttemptQuery, GetStatementResultAttemptQueryVariables>;
export const PartnerAssignTestSubmitWritingUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"partnerAssignTestSubmitWritingUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PartnerAssignTestSubmitUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerAssignTestSubmitUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<PartnerAssignTestSubmitWritingUpdateMutation, PartnerAssignTestSubmitWritingUpdateMutationVariables>;
export const GetScoreWritingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScoreWriting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestReview"}},{"kind":"Field","name":{"kind":"Name","value":"totalMaxScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}}]}}]}}]} as unknown as DocumentNode<GetScoreWritingQuery, GetScoreWritingQueryVariables>;
export const WritingSubmitPartAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WritingSubmitPartAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WritingSubmitPartAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"writingSubmitPartAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<WritingSubmitPartAttemptMutation, WritingSubmitPartAttemptMutationVariables>;
export const WritingEndAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WritingEndAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WritingEndAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"writingEndAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<WritingEndAttemptMutation, WritingEndAttemptMutationVariables>;
export const WritingCheckpointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WritingCheckpoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checkPointId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checkPointId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"writingParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"writingPartId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionChoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"highlightText"}},{"kind":"Field","name":{"kind":"Name","value":"titleContentHtml"}},{"kind":"Field","name":{"kind":"Name","value":"contentHtml"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sampleAnswerHtml"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<WritingCheckpointQuery, WritingCheckpointQueryVariables>;
export const WritingStartAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WritingStartAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WritingStartAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"writingStartAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attemptId"}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<WritingStartAttemptMutation, WritingStartAttemptMutationVariables>;
export const GetScoreWritingOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScoreWritingOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"writingKetPetScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"certLevelInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gradeCert"}},{"kind":"Field","name":{"kind":"Name","value":"overallScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestReview"}},{"kind":"Field","name":{"kind":"Name","value":"totalMaxScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"teacherGrade"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placementTestLevel"}}]}}]}}]}}]} as unknown as DocumentNode<GetScoreWritingOverviewQuery, GetScoreWritingOverviewQueryVariables>;
export const WritingResultCheckpointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WritingResultCheckpoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checkPointId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checkPointId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCanAccess"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"writingParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"writingPartId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionChoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"highlightText"}},{"kind":"Field","name":{"kind":"Name","value":"titleContentHtml"}},{"kind":"Field","name":{"kind":"Name","value":"contentHtml"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sampleAnswerHtml"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<WritingResultCheckpointQuery, WritingResultCheckpointQueryVariables>;
export const WritingUserAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WritingUserAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttemptId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttemptId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"writingPartAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"questionChoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"wordCount"}},{"kind":"Field","name":{"kind":"Name","value":"writingPartAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"part"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"writingPartId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<WritingUserAttemptQuery, WritingUserAttemptQueryVariables>;
export const UserAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttemptId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttemptId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"teacherComment"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"requestReview"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"teacherGrade"}},{"kind":"Field","name":{"kind":"Name","value":"ketPetScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"certLevelInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gradeCert"}},{"kind":"Field","name":{"kind":"Name","value":"overallScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"writingPartAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"markingCriteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"band"}},{"kind":"Field","name":{"kind":"Name","value":"commentary"}},{"kind":"Field","name":{"kind":"Name","value":"criteria"}}]}},{"kind":"Field","name":{"kind":"Name","value":"writingPartAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"wordCount"}},{"kind":"Field","name":{"kind":"Name","value":"teacherWordCount"}},{"kind":"Field","name":{"kind":"Name","value":"teacherFixedAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"questionChoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"markingOverall"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commentary"}},{"kind":"Field","name":{"kind":"Name","value":"mistakes"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teacherCommentsAnswer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quote"}}]}},{"kind":"Field","name":{"kind":"Name","value":"part"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"writingPartId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionChoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleContentHtml"}},{"kind":"Field","name":{"kind":"Name","value":"sampleAnswerHtml"}},{"kind":"Field","name":{"kind":"Name","value":"highlightText"}},{"kind":"Field","name":{"kind":"Name","value":"contentHtml"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"writingParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"writingPartId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionChoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentHtml"}},{"kind":"Field","name":{"kind":"Name","value":"highlightText"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sampleAnswerHtml"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleContentHtml"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classID"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<UserAttemptQuery, UserAttemptQueryVariables>;
export const PartnerDomainQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDomainQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerDomain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domain"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PartnerDomainQueryQuery, PartnerDomainQueryQueryVariables>;
export const CheckoutBankListPaymentCreateVnpUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutBankListPaymentCreateVNPUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentCreateVNPUrlInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentCreateVNPUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<CheckoutBankListPaymentCreateVnpUrlMutation, CheckoutBankListPaymentCreateVnpUrlMutationVariables>;
export const TeacherReferralCodeExistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeacherReferralCodeExists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teacherReferralCodeExists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}]}]}}]} as unknown as DocumentNode<TeacherReferralCodeExistsQuery, TeacherReferralCodeExistsQueryVariables>;
export const CheckDiscountQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckDiscountQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"userID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountId"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"maxDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<CheckDiscountQueryQuery, CheckDiscountQueryQueryVariables>;
export const PartnerPackagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerPackages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerPackages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountDeposit"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isShowing"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"partnerPackageId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerPackagesQuery, PartnerPackagesQueryVariables>;
export const ViewerAiConversationCompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerAIConversationComplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerAIConversationCompleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerAIConversationComplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemText"}},{"kind":"Field","name":{"kind":"Name","value":"systemAudio"}},{"kind":"Field","name":{"kind":"Name","value":"userMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"visemes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"phoneme"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"types"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerAiConversationCompleteMutation, ViewerAiConversationCompleteMutationVariables>;
export const ConversationTextToSpeakDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConversationTextToSpeak"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TextToSpeakInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textToSpeak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ConversationTextToSpeakQuery, ConversationTextToSpeakQueryVariables>;
export const ViewerAiConversationUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerAIConversationUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerAIConversationUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerAIConversationUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiConversation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerAiConversationUpdateMutation, ViewerAiConversationUpdateMutationVariables>;
export const CheckoutBankListPaymentListBankVnpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckoutBankListPaymentListBankVNP"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentListBankVNP"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankCode"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"logoLink"}},{"kind":"Field","name":{"kind":"Name","value":"bankType"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrder"}}]}}]}}]}}]} as unknown as DocumentNode<CheckoutBankListPaymentListBankVnpQuery, CheckoutBankListPaymentListBankVnpQueryVariables>;
export const GetVnpayPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVnpayPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"txnRef"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vnpayPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"txnRef"},"value":{"kind":"Variable","name":{"kind":"Name","value":"txnRef"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"txnRef"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}}]}}]} as unknown as DocumentNode<GetVnpayPaymentQuery, GetVnpayPaymentQueryVariables>;
export const ViewerUserAttemptsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerUserAttempts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserAttemptFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerUserAttempts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"skills"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"cefrLevelInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teacherGrade"}},{"kind":"Field","name":{"kind":"Name","value":"partAttemptsCount"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"executionTime"}},{"kind":"Field","name":{"kind":"Name","value":"typeAttempt"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalMaxScore"}},{"kind":"Field","name":{"kind":"Name","value":"challenge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"partsCount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"typeTestLevel"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageInfo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]} as unknown as DocumentNode<ViewerUserAttemptsQuery, ViewerUserAttemptsQueryVariables>;
export const ViewerUserAttemptsForReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerUserAttemptsForReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserAttemptFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"viewerUserAttemptsForReport"},"name":{"kind":"Name","value":"viewerUserAttempts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ViewerUserAttemptsForReportQuery, ViewerUserAttemptsForReportQueryVariables>;
export const ViewerGetVersionNotificationUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerGetVersionNotificationUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppTypeMobile"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"versionNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appType"}},{"kind":"Field","name":{"kind":"Name","value":"contentHTML"}},{"kind":"Field","name":{"kind":"Name","value":"contentHTMLEn"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"versionNotificationId"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}}]}}]} as unknown as DocumentNode<ViewerGetVersionNotificationUpdateQuery, ViewerGetVersionNotificationUpdateQueryVariables>;
export const ViewerRemindTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerRemindTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerRemindTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cpType"}},{"kind":"Field","name":{"kind":"Name","value":"skills"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalRedoTask"}},{"kind":"Field","name":{"kind":"Name","value":"totalUnfinishTask"}},{"kind":"Field","name":{"kind":"Name","value":"assignTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"assignTestId"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cpType"}},{"kind":"Field","name":{"kind":"Name","value":"skills"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ViewerRemindTaskQuery, ViewerRemindTaskQueryVariables>;
export const IeltsUserAttemptSpeakingReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IeltsUserAttemptSpeakingReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"teacherGrade"}},{"kind":"Field","name":{"kind":"Name","value":"teacherComment"}},{"kind":"Field","name":{"kind":"Name","value":"teacherCommentAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestReview"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"levels"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointIeltsSpeakingParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ieltsSpeakingPartQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"contentHtml"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sampleAnswerAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sampleAnswerHtml"}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ieltsSpeakingRecordScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coherence"}},{"kind":"Field","name":{"kind":"Name","value":"fluency"}},{"kind":"Field","name":{"kind":"Name","value":"grammar"}},{"kind":"Field","name":{"kind":"Name","value":"overall"}},{"kind":"Field","name":{"kind":"Name","value":"pronunciation"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"vocab"}},{"kind":"Field","name":{"kind":"Name","value":"fluencyDecision"}},{"kind":"Field","name":{"kind":"Name","value":"pronunciationDecision"}},{"kind":"Field","name":{"kind":"Name","value":"grammarDecision"}},{"kind":"Field","name":{"kind":"Name","value":"vocabDecision"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ieltsSpeakingPartAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"part"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcriptionRecord"}},{"kind":"Field","name":{"kind":"Name","value":"teacherComment"}},{"kind":"Field","name":{"kind":"Name","value":"teacherCommentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"quote"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teacherCommentAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recordScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coherence"}},{"kind":"Field","name":{"kind":"Name","value":"fluency"}},{"kind":"Field","name":{"kind":"Name","value":"grammar"}},{"kind":"Field","name":{"kind":"Name","value":"overall"}},{"kind":"Field","name":{"kind":"Name","value":"pronunciation"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"vocab"}},{"kind":"Field","name":{"kind":"Name","value":"fluencyDecision"}},{"kind":"Field","name":{"kind":"Name","value":"pronunciationDecision"}},{"kind":"Field","name":{"kind":"Name","value":"grammarDecision"}},{"kind":"Field","name":{"kind":"Name","value":"vocabDecision"}},{"kind":"Field","name":{"kind":"Name","value":"highlightWords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PronunciationWord"}},{"kind":"Field","name":{"kind":"Name","value":"phonemes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PronunciationWord"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PronunciationWord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PronunciationWord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"startIndex"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"phonemes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<IeltsUserAttemptSpeakingReportQuery, IeltsUserAttemptSpeakingReportQueryVariables>;
export const IeltsUserAttemptQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IeltsUserAttemptQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestReview"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}}]}}]}}]}}]} as unknown as DocumentNode<IeltsUserAttemptQueryQuery, IeltsUserAttemptQueryQueryVariables>;
export const StudyStartAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StudyStartAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DuolingoStartAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duolingoStartAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attemptId"}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StudyStartAttemptMutation, StudyStartAttemptMutationVariables>;
export const LessonCheckPointTestLevelQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LessonCheckPointTestLevelQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<LessonCheckPointTestLevelQueryQuery, LessonCheckPointTestLevelQueryQueryVariables>;
export const GetScoreSpeakingAiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getScoreSpeakingAi"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestReview"}},{"kind":"Field","name":{"kind":"Name","value":"totalMaxScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placementTestLevel"}},{"kind":"Field","name":{"kind":"Name","value":"speakingKetPetScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gradeCert"}},{"kind":"Field","name":{"kind":"Name","value":"overallScore"}},{"kind":"Field","name":{"kind":"Name","value":"certLevelInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"speakingCertification"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}}]}}]}}]} as unknown as DocumentNode<GetScoreSpeakingAiQuery, GetScoreSpeakingAiQueryVariables>;
export const SpeakingAttemptResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SpeakingAttemptResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"speakingCertification"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalMaxScore"}},{"kind":"Field","name":{"kind":"Name","value":"requestReview"}},{"kind":"Field","name":{"kind":"Name","value":"teacherComment"}},{"kind":"Field","name":{"kind":"Name","value":"teacherGrade"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"teacherCommentAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointSpeakingParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"speakingPartId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partType"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentImageId"}},{"kind":"Field","name":{"kind":"Name","value":"candidateImageId"}},{"kind":"Field","name":{"kind":"Name","value":"examinerImageId"}},{"kind":"Field","name":{"kind":"Name","value":"candidateSheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sheets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"examinerSheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sheets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"top"}},{"kind":"Field","name":{"kind":"Name","value":"left"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"placeholders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"top"}},{"kind":"Field","name":{"kind":"Name","value":"left"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"left"}},{"kind":"Field","name":{"kind":"Name","value":"top"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bingoAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bingoAudioSubtitle"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audioSubtitle"}},{"kind":"Field","name":{"kind":"Name","value":"needsScore"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"answerImageId"}},{"kind":"Field","name":{"kind":"Name","value":"answerPlaceholderId"}},{"kind":"Field","name":{"kind":"Name","value":"groupPosition"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentHtml"}},{"kind":"Field","name":{"kind":"Name","value":"contentImageId"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"speakingRecordScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pronunciationScore"}},{"kind":"Field","name":{"kind":"Name","value":"vocabularyGrammarScore"}},{"kind":"Field","name":{"kind":"Name","value":"interactionScore"}},{"kind":"Field","name":{"kind":"Name","value":"overallScore"}},{"kind":"Field","name":{"kind":"Name","value":"vocabularyGrammarScorePercent"}},{"kind":"Field","name":{"kind":"Name","value":"interactionScorePercent"}},{"kind":"Field","name":{"kind":"Name","value":"overallScore"}},{"kind":"Field","name":{"kind":"Name","value":"coherenceScore"}},{"kind":"Field","name":{"kind":"Name","value":"overallScore"}},{"kind":"Field","name":{"kind":"Name","value":"vocabulary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RecordScoreVocabulary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grammar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RecordScoreGrammar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pronunciation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RecordScorePronunciation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"interaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receptionResponding"}},{"kind":"Field","name":{"kind":"Name","value":"fluencyPromptness"}},{"kind":"Field","name":{"kind":"Name","value":"fluencyDecision"}},{"kind":"Field","name":{"kind":"Name","value":"receptionDecision"}},{"kind":"Field","name":{"kind":"Name","value":"fluency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wordsPerMinute"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coherence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"speakingAzureScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vocabularyScore"}},{"kind":"Field","name":{"kind":"Name","value":"vocabularyGrammarTotalScore"}},{"kind":"Field","name":{"kind":"Name","value":"vocabularyGrammarScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"prosodyScore"}},{"kind":"Field","name":{"kind":"Name","value":"pronunciationScore"}},{"kind":"Field","name":{"kind":"Name","value":"pronScore"}},{"kind":"Field","name":{"kind":"Name","value":"interactionScore"}},{"kind":"Field","name":{"kind":"Name","value":"grammarScore"}},{"kind":"Field","name":{"kind":"Name","value":"fluencyScore"}},{"kind":"Field","name":{"kind":"Name","value":"wordPerMinute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"speakingQuestionAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"part"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"speakingPartId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"placeholderId"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptionRecord"}},{"kind":"Field","name":{"kind":"Name","value":"teacherComment"}},{"kind":"Field","name":{"kind":"Name","value":"teacherAudioAnswer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discussions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audioSubtitle"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"speakingQuestionAttemptDiscussionId"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RecordScoreAttemptFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"azureRecordScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AzureRecordScoreFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RecordScoreAttemptFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecordScoreVocabulary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordScoreVocabulary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerKeyScore"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"cefrScore"}},{"kind":"Field","name":{"kind":"Name","value":"cefrDistribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cefrLevel"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}},{"kind":"Field","name":{"kind":"Name","value":"highlightKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startIndex"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"keyword"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecordScorePronunciation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordScorePronunciation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalScore"}},{"kind":"Field","name":{"kind":"Name","value":"intonationScore"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"highlightWords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startIndex"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phonemes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startIndex"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ipa"}},{"kind":"Field","name":{"kind":"Name","value":"nativenessScore"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecordScoreGrammar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordScoreGrammar"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messages"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"highlightItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestion"}},{"kind":"Field","name":{"kind":"Name","value":"startIndex"}},{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecordScoreAttemptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordScore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audioId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vocabularyGrammarScore"}},{"kind":"Field","name":{"kind":"Name","value":"pronunciationScore"}},{"kind":"Field","name":{"kind":"Name","value":"interactionScore"}},{"kind":"Field","name":{"kind":"Name","value":"vocabularyGrammarScorePercent"}},{"kind":"Field","name":{"kind":"Name","value":"vocabularyGrammarDecision"}},{"kind":"Field","name":{"kind":"Name","value":"interactionScorePercent"}},{"kind":"Field","name":{"kind":"Name","value":"pronunciationScore"}},{"kind":"Field","name":{"kind":"Name","value":"interactionScore"}},{"kind":"Field","name":{"kind":"Name","value":"overallScore"}},{"kind":"Field","name":{"kind":"Name","value":"coherence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coherenceScore"}},{"kind":"Field","name":{"kind":"Name","value":"vocabulary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RecordScoreVocabulary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grammar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"highlightItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startIndex"}},{"kind":"Field","name":{"kind":"Name","value":"endIndex"}},{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"suggestion"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pronunciation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RecordScorePronunciation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"interaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receptionResponding"}},{"kind":"Field","name":{"kind":"Name","value":"fluencyPromptness"}},{"kind":"Field","name":{"kind":"Name","value":"receptionDecision"}},{"kind":"Field","name":{"kind":"Name","value":"fluencyDecision"}},{"kind":"Field","name":{"kind":"Name","value":"fluency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wordsPerMinute"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AzureRecordScoreFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AzureRecordScore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"microsoftScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"nBest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pronunciationAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accuracyScore"}},{"kind":"Field","name":{"kind":"Name","value":"pronScore"}},{"kind":"Field","name":{"kind":"Name","value":"prosodyScore"}},{"kind":"Field","name":{"kind":"Name","value":"fluencyScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itn"}},{"kind":"Field","name":{"kind":"Name","value":"lexical"}},{"kind":"Field","name":{"kind":"Name","value":"words"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"word"}},{"kind":"Field","name":{"kind":"Name","value":"confidence"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"phonemes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"decision"}},{"kind":"Field","name":{"kind":"Name","value":"phoneme"}},{"kind":"Field","name":{"kind":"Name","value":"pronunciationAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accuracyScore"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recognitionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cambridgeAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grammarScore"}},{"kind":"Field","name":{"kind":"Name","value":"vocabularyScore"}},{"kind":"Field","name":{"kind":"Name","value":"mistakesEn"}},{"kind":"Field","name":{"kind":"Name","value":"mistakesVi"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions"}}]}}]}}]} as unknown as DocumentNode<SpeakingAttemptResultQuery, SpeakingAttemptResultQueryVariables>;
export const GetResultCheckPointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResultCheckPoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalMaxScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ketPetScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overallScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cefrLevelInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"challenge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"typeTestLevel"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"executionTime"}},{"kind":"Field","name":{"kind":"Name","value":"higherScorePercent"}},{"kind":"Field","name":{"kind":"Name","value":"examTypeScores"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"examType"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"certification"}},{"kind":"Field","name":{"kind":"Name","value":"totalMaxScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerSeenReward"}},{"kind":"Field","name":{"kind":"Name","value":"coinsEarned"}},{"kind":"Field","name":{"kind":"Name","value":"starsEarned"}}]}}]}}]} as unknown as DocumentNode<GetResultCheckPointQuery, GetResultCheckPointQueryVariables>;
export const ViewerUserAttemptSeenRewardMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerUserAttemptSeenRewardMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerUserAttemptSeenReward"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAttempt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerSeenReward"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ViewerUserAttemptSeenRewardMutationMutation, ViewerUserAttemptSeenRewardMutationMutationVariables>;
export const AuthProviderCreateAnonymousLearnerProfileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthProviderCreateAnonymousLearnerProfileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerCreateLearnerProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerCreateLearnerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<AuthProviderCreateAnonymousLearnerProfileMutationMutation, AuthProviderCreateAnonymousLearnerProfileMutationMutationVariables>;
export const AuthProviderUpdateAnonymousLearnerProfileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthProviderUpdateAnonymousLearnerProfileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerUpdateLearnerProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerUpdateLearnerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<AuthProviderUpdateAnonymousLearnerProfileMutationMutation, AuthProviderUpdateAnonymousLearnerProfileMutationMutationVariables>;
export const AuthProviderViewerSessionQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthProviderViewerSessionQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Viewer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loginSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedBySession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}}]} as unknown as DocumentNode<AuthProviderViewerSessionQueryQuery, AuthProviderViewerSessionQueryQueryVariables>;
export const AuthProviderViewerLogOutMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthProviderViewerLogOutMutation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerLogOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<AuthProviderViewerLogOutMutationMutation, AuthProviderViewerLogOutMutationMutationVariables>;
export const AuthProviderViewerSwitchLearnerProfileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthProviderViewerSwitchLearnerProfileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerSwitchLearnerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"learnerProfileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Viewer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}},{"kind":"Field","name":{"kind":"Name","value":"disabledStudentChangeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlacementTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAttemptId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkPointId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}}]} as unknown as DocumentNode<AuthProviderViewerSwitchLearnerProfileMutationMutation, AuthProviderViewerSwitchLearnerProfileMutationMutationVariables>;
export const AuthProviderViewerSessionEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AuthProviderViewerSessionEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerSessionEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}}]}}]}}]} as unknown as DocumentNode<AuthProviderViewerSessionEventSubscription, AuthProviderViewerSessionEventSubscriptionVariables>;
export const CheckIpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckIp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkIp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]} as unknown as DocumentNode<CheckIpQuery, CheckIpQueryVariables>;
export const AuthProviderViewerInProgressAssignedTestsV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthProviderViewerInProgressAssignedTestsV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerInProgressAssignedTestsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AuthProviderViewerInProgressAssignedTestsV2Query, AuthProviderViewerInProgressAssignedTestsV2QueryVariables>;